export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  JSON: any
}

export type Query = {
  __typename?: 'Query'
  activeFilter?: Maybe<SavedFilter>
  activeIncidentCountsForAffectedFacilities?: Maybe<FacilityIncidentCountConnection>
  aiOperatorDeviceConfiguration: AiOperatorDeviceConfiguration
  aiOperatorFields?: Maybe<AiOperatorFieldConnection>
  aiOperatorModels: AiOperatorModelConnection
  aiOperatorProcessedIncidentCount?: Maybe<Scalars['Int']>
  /**
   * Generate a text report for AI Operator criteria evaluations within a date range.
   * Returns markdown-formatted report text.
   */
  aiOperatorReport: Scalars['String']
  aiOperatorRuleEvaluations?: Maybe<AiOperatorRuleEvaluationConnection>
  aiOperatorSettingsHistory?: Maybe<AiOperatorSettingsHistoryConnection>
  aiOperatorSettingsHistoryItem?: Maybe<AiOperatorSettingsHistory>
  alarms?: Maybe<AlarmConnection>
  alerts?: Maybe<AlertConnection>
  audioClips?: Maybe<AudioClipConnection>
  audioMessages?: Maybe<AudioMessageConnection>
  camera?: Maybe<Camera>
  cameraLiveFeedDetail?: Maybe<CameraLiveFeedDetail>
  cameraLiveFeedDetails?: Maybe<CameraLiveFeedDetailConnection>
  camerasForDevice: Array<Maybe<CameraWithEdgeDevice>>
  case?: Maybe<Case>
  cases?: Maybe<CaseConnection>
  charges?: Maybe<ChargeConnection>
  checkedInUsers?: Maybe<UserConnection>
  checkpointTasks?: Maybe<CheckpointTaskConnection>
  contributingEvents?: Maybe<EventConnection>
  /** Organization of authenticated user. */
  currentOrganization?: Maybe<Organization>
  customerSecretProvider?: Maybe<CustomerSecretProvider>
  customerSecretProviderEntities: EntitySecretProviderConnection
  customerSecretProviders?: Maybe<CustomerSecretProviderConnection>
  customForm?: Maybe<CustomForm>
  customForms: CustomFormConnection
  defaultAiOperatorModel?: Maybe<DefaultAiOperatorModelPayload>
  device?: Maybe<Device>
  deviceGroups?: Maybe<DeviceGroupConnection>
  deviceLogItems?: Maybe<DeviceLogConnection>
  devices?: Maybe<DeviceConnection>
  door?: Maybe<Door>
  edgeDevice?: Maybe<EdgeDevice>
  edgeDevices?: Maybe<EdgeDeviceConnection>
  emailSource?: Maybe<EmailSource>
  /**
   * Resolves an Ingest Address to its Email Source, for the Email Worker. Null when no source currently has the address,
   * including rotated-away addresses. Disabled sources still resolve; check `enabled`.
   */
  emailSourceByIngestAddress?: Maybe<EmailSourceResolution>
  emailSources?: Maybe<EmailSourceConnection>
  emergencyCall?: Maybe<EmergencyCall>
  emergencyCallIncidentCategory: ManualIncidentCategory
  emergencyCallingAccessToken?: Maybe<EmergencyCallingAccessToken>
  emergencyCalls?: Maybe<EmergencyCallConnection>
  enabledAiOperatorModels: AiOperatorModelConnection
  eventPresentations?: Maybe<EventPresentationConnection>
  events?: Maybe<EventConnection>
  externalAccount?: Maybe<ExternalAccount>
  externalAccountApiKey?: Maybe<ExternalAccountApiKey>
  externalAccountApiKeys?: Maybe<ExternalAccountApiKeyConnection>
  externalAccountIdp?: Maybe<ExternalAccountIdp>
  externalAccountProperties?: Maybe<ExternalAccountProperties>
  externalAccountPropertyDefinitions: Array<ExternalAccountPropertyDefinition>
  externalAccounts?: Maybe<ExternalAccountConnection>
  facilities?: Maybe<FacilityConnection>
  facility?: Maybe<Facility>
  featureFlag?: Maybe<FeatureFlag>
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>
  floor?: Maybe<Floor>
  floorGroups?: Maybe<FloorGroupConnection>
  floorPlan?: Maybe<FloorPlan>
  floorPlans?: Maybe<FloorPlanConnection>
  floors?: Maybe<FloorConnection>
  getSopAssistantResponse: GetSopAssistantResponsePayload
  globalFacilities?: Maybe<GlobalFacilityConnection>
  gridAnalysisJob?: Maybe<GridAnalysisJob>
  /**
   * Per-guard daily activity report for one facility. `date` is a calendar day (YYYY-MM-DD) interpreted in the
   * facility's own time zone. Only guards with a clock in or clock out that day are returned.
   */
  guardDailyActivityReport?: Maybe<Array<GuardDailyActivity>>
  guardTour: GuardTour
  guardTours: GuardTourConnection
  hivewatchAwsAccountId: Scalars['String']
  incident?: Maybe<Incident>
  incidentAction?: Maybe<IncidentAction>
  /**
   * See the counts at the bottom right of
   * <https://projects.invisionapp.com/d/main/default/#/console/21014207/451074845/preview>.
   */
  incidentCounts?: Maybe<IncidentCountMap>
  incidentDeviceMedia?: Maybe<IncidentDeviceMediaConnection>
  incidentGroups?: Maybe<IncidentGroupConnection>
  incidentNotes?: Maybe<IncidentNoteConnection>
  incidents?: Maybe<IncidentConnection>
  /**
   * The Incidents table's dedicated query: the same rows as `incidents`, without the total count.
   * Identical filtering, ordering and node shape, but backed by a `Slice` rather than a `Page`, so no
   * `COUNT` is issued over the filtered set. Pagination is driven by `pageInfo.hasNextPage` and
   * `pageInfo.hasPreviousPage` rather than a page count. `first` is the zero-based page number and
   * `last` is the page size, matching `incidents`; unlike `incidents`, an omitted `last` yields a
   * bounded default page rather than an unbounded one, and oversized pages are capped.
   */
  incidentsTable?: Maybe<IncidentTableConnection>
  incidentTimePeriodStats?: Maybe<IncidentTimePeriodStats>
  /** Lookup a single incident type by ID. Stubbed from IncidentType enum until DB table exists. */
  incidentType?: Maybe<IncidentTypeDefinition>
  /** Lookup a single incident type by slug from the database. */
  incidentTypeBySlug?: Maybe<IncidentTypeDefinition>
  /** List incident types, optionally filtered by archived. Stubbed from IncidentType enum until DB table exists. */
  incidentTypes: IncidentTypeDefinitionListPayload
  /** Fetch a single IncidentWorkflow by versionId. */
  incidentWorkflow?: Maybe<IncidentWorkflow>
  /** Fetch all workflow actions for an incident, ordered by actionTimestamp ascending. */
  incidentWorkflowActions: Array<IncidentWorkflowAction>
  /** List IncidentWorkflows. Excludes ARCHIVED by default. */
  incidentWorkflows: Array<IncidentWorkflow>
  integrationFieldMappings: Array<IntegrationFieldMapping>
  integrationQuestionMappings: Array<IntegrationQuestionMapping>
  kpi?: Maybe<Kpi>
  lastDatabaseReset?: Maybe<DatabaseReset>
  manualIncidentCategories?: Maybe<ManualIncidentCategoryConnection>
  matchedRule?: Maybe<Rule>
  me: User
  messages?: Maybe<SubscriberMessageConnection>
  mySetting: UserSetting
  nearestFacility?: Maybe<Facility>
  outstandingIncidents?: Maybe<IncidentConnection>
  pacsSourceInstance?: Maybe<PacsSourceInstance>
  pacsSourceInstances?: Maybe<PacsSourceInstanceConnection>
  pacsSources?: Maybe<PacsSourceConnection>
  partialCreditCard?: Maybe<PartialCreditCard>
  /**
   * Returns users with pending invitations (users who haven't completed onboarding).
   * Filter by invite status: ALL (default), EXPIRED, or ACTIVE.
   */
  pendingInvites: Array<User>
  personOfInterest?: Maybe<PersonOfInterest>
  personsOfInterest?: Maybe<PersonOfInterestConnection>
  /**
   * Preview of what archiveFloor would do to guard tour plans, for the archive
   * confirmation dialog. Read-only.
   */
  previewArchiveFloor: ArchiveFloorPreview
  /** Dry-run of sending an incident to an integration: same structure as a real send minus externalId, writes nothing */
  previewIntegrationSend: IntegrationSendResult
  productMessages: Array<ProductMessage>
  /** Counts per status for tab badges. Returns all statuses in one call. */
  programRecommendationCounts?: Maybe<ProgramRecommendationCounts>
  programRecommendations?: Maybe<ProgramRecommendationConnection>
  /** Get all published forms available for submissions */
  publishedCustomForms: Array<CustomForm>
  /** Not used directly by GraphQL clients. */
  pushedMessage?: Maybe<SubscriberMessage>
  quickReport?: Maybe<QuickReport>
  quickReportCode?: Maybe<QuickReportCode>
  quickReportCodes?: Maybe<QuickReportCodeConnection>
  recipient?: Maybe<EmailRecipient>
  recipients?: Maybe<EmailRecipientConnection>
  roles?: Maybe<RoleConnection>
  rule?: Maybe<Rule>
  ruleLogics?: Maybe<RuleLogicConnection>
  rules?: Maybe<RuleConnection>
  savedFilter?: Maybe<SavedFilter>
  savedFilters: SavedFilterConnection
  savedPayload?: Maybe<SavedPayload>
  savedPayloads?: Maybe<SavedPayloadConnection>
  session?: Maybe<Session>
  /**
   * Counts of non-resolved stale incidents grouped by attributed user (COALESCE(ownerId, guardId)),
   * ordered by incidentCount descending. A null user represents the Unassigned bucket.
   * first = page index (0-based), last = page size. Computed via SQL GROUP BY, not entity hydration.
   */
  staleIncidentGroups?: Maybe<StaleIncidentGroupConnection>
  standardOperatingProcedure?: Maybe<StandardOperatingProcedure>
  standardOperatingProcedures?: Maybe<StandardOperatingProcedureConnection>
  streamingUrlWrapper?: Maybe<StreamingUrlWrapperInterface>
  tags: TagConnection
  tailgateGrid?: Maybe<TailgateGrid>
  tailgateGridTestJob?: Maybe<TailgateGridTestJob>
  technician?: Maybe<Technician>
  technicians?: Maybe<TechnicianConnection>
  testRules: Array<Rule>
  tourPlan: TourPlan
  tourPlans: TourPlanConnection
  user?: Maybe<User>
  users?: Maybe<UserConnection>
  viewedFeatures?: Maybe<Array<UserViewedFeature>>
  webhook?: Maybe<Webhook>
  webhooks?: Maybe<WebhookConnection>
  whitelistedUsersForIncidentCategory?: Maybe<UserConnection>
}

export type QueryActiveFilterArgs = {
  context?: InputMaybe<FilterContext>
}

export type QueryAiOperatorDeviceConfigurationArgs = {
  deviceId: Scalars['ID']
}

export type QueryAiOperatorFieldsArgs = {
  filter?: InputMaybe<AiOperatorFieldFilterInput>
}

export type QueryAiOperatorModelsArgs = {
  filter?: InputMaybe<AiOperatorModelFilterInput>
}

export type QueryAiOperatorReportArgs = {
  input: AiOperatorReportInput
}

export type QueryAiOperatorRuleEvaluationsArgs = {
  filter?: InputMaybe<AiOperatorRuleEvaluationFilterInput>
  orderBy?: InputMaybe<Array<AiOperatorRuleEvaluationOrderInput>>
}

export type QueryAiOperatorSettingsHistoryArgs = {
  filter?: InputMaybe<AiOperatorSettingsHistoryFilterInput>
  page?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type QueryAiOperatorSettingsHistoryItemArgs = {
  id: Scalars['ID']
}

export type QueryAlarmsArgs = {
  filter?: InputMaybe<AlarmFilterInput>
}

export type QueryAlertsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<AlertFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<AlertOrderInput>>>
}

export type QueryAudioClipsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<AudioClipFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<AudioClipOrderInput>>>
}

export type QueryAudioMessagesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<AudioMessageFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<AudioMessageOrderInput>>>
}

export type QueryCameraArgs = {
  externalId: Scalars['String']
}

export type QueryCameraLiveFeedDetailArgs = {
  id: Scalars['ID']
}

export type QueryCameraLiveFeedDetailsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CameraLiveFeedDetailFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<CameraLiveFeedDetailOrderInput>>>
}

export type QueryCamerasForDeviceArgs = {
  externalId: Scalars['ID']
}

export type QueryCaseArgs = {
  id: Scalars['ID']
}

export type QueryCasesArgs = {
  filter?: InputMaybe<CaseFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryChargesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ChargeFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<ChargeOrderInput>>>
}

export type QueryCheckedInUsersArgs = {
  facilityId: Scalars['ID']
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>>>
}

export type QueryCheckpointTasksArgs = {
  checkpointId: Scalars['ID']
}

export type QueryContributingEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EventFilterInput>
  first?: InputMaybe<Scalars['Int']>
  incidentId: Scalars['ID']
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EventOrderInput>>>
}

export type QueryCustomerSecretProviderArgs = {
  id: Scalars['ID']
}

export type QueryCustomerSecretProviderEntitiesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  customerSecretProviderId: Scalars['ID']
  filter?: InputMaybe<EntitySecretProviderFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryCustomerSecretProvidersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CustomerSecretProviderFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<CustomerSecretProviderOrderInput>>>
}

export type QueryCustomFormArgs = {
  id: Scalars['ID']
}

export type QueryCustomFormsArgs = {
  status?: InputMaybe<CustomFormStatus>
}

export type QueryDeviceArgs = {
  id: Scalars['ID']
}

export type QueryDeviceGroupsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<DeviceFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<DeviceOrderInput>>>
}

export type QueryDeviceLogItemsArgs = {
  deviceId: Scalars['ID']
  orderBy?: InputMaybe<Array<InputMaybe<DeviceLogOrderInput>>>
}

export type QueryDevicesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<DeviceFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<DeviceOrderInput>>>
}

export type QueryDoorArgs = {
  externalId: Scalars['ID']
}

export type QueryEdgeDeviceArgs = {
  id: Scalars['ID']
}

export type QueryEdgeDevicesArgs = {
  filter?: InputMaybe<EdgeDeviceFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EdgeDeviceOrderInput>>>
}

export type QueryEmailSourceArgs = {
  id: Scalars['ID']
}

export type QueryEmailSourceByIngestAddressArgs = {
  address: Scalars['String']
}

export type QueryEmergencyCallArgs = {
  id: Scalars['ID']
}

export type QueryEmergencyCallsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EmergencyCallFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EmergencyCallOrderInput>>>
}

export type QueryEventPresentationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EventFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EventOrderInput>>>
}

export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EventFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EventOrderInput>>>
}

export type QueryExternalAccountArgs = {
  id: Scalars['ID']
}

export type QueryExternalAccountApiKeyArgs = {
  id: Scalars['ID']
}

export type QueryExternalAccountApiKeysArgs = {
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryExternalAccountIdpArgs = {
  id: Scalars['ID']
}

export type QueryExternalAccountPropertiesArgs = {
  id: Scalars['ID']
}

export type QueryExternalAccountPropertyDefinitionsArgs = {
  externalSystemType: ExternalSystemType
}

export type QueryFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<FacilityFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<FacilityOrderInput>>>
}

export type QueryFacilityArgs = {
  id: Scalars['ID']
}

export type QueryFeatureFlagArgs = {
  name: Scalars['String']
}

export type QueryFloorArgs = {
  id: Scalars['ID']
}

export type QueryFloorGroupsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<FloorFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<FloorOrderInput>>>
}

export type QueryFloorPlanArgs = {
  id: Scalars['ID']
}

export type QueryFloorPlansArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<FloorPlanFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<FloorPlanOrderInput>>>
}

export type QueryFloorsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<FloorFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<FloorOrderInput>>>
}

export type QueryGetSopAssistantResponseArgs = {
  input: GetSopAssistantResponseInput
}

export type QueryGridAnalysisJobArgs = {
  id: Scalars['ID']
}

export type QueryGuardDailyActivityReportArgs = {
  date: Scalars['String']
  facilityId: Scalars['ID']
}

export type QueryGuardTourArgs = {
  id: Scalars['ID']
}

export type QueryGuardToursArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<GuardTourFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<GuardTourOrderInput>>>
}

export type QueryIncidentArgs = {
  id: Scalars['ID']
}

export type QueryIncidentActionArgs = {
  id: Scalars['ID']
}

export type QueryIncidentDeviceMediaArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentDeviceMediaFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentDeviceMediaOrderInput>>>
}

export type QueryIncidentGroupsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

export type QueryIncidentNotesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentNoteFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentNoteOrderInput>>>
}

export type QueryIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

export type QueryIncidentsTableArgs = {
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

export type QueryIncidentTimePeriodStatsArgs = {
  endTime: Scalars['String']
  startTime: Scalars['String']
}

export type QueryIncidentTypeArgs = {
  id: Scalars['ID']
}

export type QueryIncidentTypeBySlugArgs = {
  slug: Scalars['String']
}

export type QueryIncidentTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  manual?: InputMaybe<Scalars['Boolean']>
}

export type QueryIncidentWorkflowArgs = {
  versionId: Scalars['ID']
}

export type QueryIncidentWorkflowActionsArgs = {
  incidentId: Scalars['ID']
}

export type QueryIncidentWorkflowsArgs = {
  filter?: InputMaybe<IncidentWorkflowFilterInput>
}

export type QueryIntegrationFieldMappingsArgs = {
  integrationId: Scalars['ID']
}

export type QueryIntegrationQuestionMappingsArgs = {
  formId: Scalars['ID']
  integrationId: Scalars['ID']
}

export type QueryManualIncidentCategoriesArgs = {
  input?: InputMaybe<ManualIncidentCategoryFilterInput>
}

export type QueryMatchedRuleArgs = {
  incidentId: Scalars['ID']
}

export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SubscriberMessageFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<SubscriberMessageOrderInput>>>
  since?: InputMaybe<Scalars['String']>
}

export type QueryNearestFacilityArgs = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
}

export type QueryOutstandingIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

export type QueryPacsSourceInstanceArgs = {
  id: Scalars['ID']
}

export type QueryPendingInvitesArgs = {
  status?: InputMaybe<InviteStatus>
}

export type QueryPersonOfInterestArgs = {
  id: Scalars['ID']
}

export type QueryPersonsOfInterestArgs = {
  filter?: InputMaybe<PersonOfInterestFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PersonOfInterestOrderInput>>
}

export type QueryPreviewArchiveFloorArgs = {
  id: Scalars['ID']
}

export type QueryPreviewIntegrationSendArgs = {
  incidentId: Scalars['ID']
  integrationId: Scalars['ID']
}

export type QueryProductMessagesArgs = {
  filter?: InputMaybe<ProductMessageFilterInput>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryProgramRecommendationsArgs = {
  filter?: InputMaybe<ProgramRecommendationFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<ProgramRecommendationOrderInput>>>
}

export type QueryQuickReportCodeArgs = {
  id: Scalars['ID']
}

export type QueryQuickReportCodesArgs = {
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<QuickReportCodeOrderInput>>>
}

export type QueryRecipientArgs = {
  email: Scalars['String']
}

export type QueryRecipientsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EmailRecipientFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EmailRecipientOrderInput>>>
}

export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<RoleFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<RoleOrderInput>>>
}

export type QueryRuleArgs = {
  id: Scalars['ID']
}

export type QueryRuleLogicsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<RuleLogicFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<RuleLogicOrderInput>>>
}

export type QueryRulesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<RuleFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<RuleOrderInput>>>
}

export type QuerySavedFilterArgs = {
  id: Scalars['ID']
}

export type QuerySavedPayloadArgs = {
  id: Scalars['ID']
}

export type QueryStaleIncidentGroupsArgs = {
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryStandardOperatingProcedureArgs = {
  id: Scalars['ID']
}

export type QueryStandardOperatingProceduresArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<StandardOperatingProcedureFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<StandardOperatingProcedureOrderInput>>>
}

export type QueryStreamingUrlWrapperArgs = {
  deviceId: Scalars['ID']
  interval?: InputMaybe<IntervalInput>
}

export type QueryTagsArgs = {
  filter?: InputMaybe<TagFilterInput>
  limit?: InputMaybe<Scalars['Int']>
}

export type QueryTailgateGridArgs = {
  cameraId: Scalars['ID']
  doorId: Scalars['ID']
}

export type QueryTailgateGridTestJobArgs = {
  id: Scalars['ID']
}

export type QueryTechnicianArgs = {
  id: Scalars['ID']
}

export type QueryTechniciansArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<TechnicianFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<TechnicianOrderInput>>>
}

export type QueryTestRulesArgs = {
  displayId?: InputMaybe<Scalars['String']>
  incidentId?: InputMaybe<Scalars['ID']>
}

export type QueryTourPlanArgs = {
  id: Scalars['ID']
}

export type QueryTourPlansArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<TourPlanFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<TourPlanOrderInput>>>
}

export type QueryUserArgs = {
  id: Scalars['ID']
}

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<UserFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>>>
}

export type QueryWebhookArgs = {
  id: Scalars['ID']
}

export type QueryWhitelistedUsersForIncidentCategoryArgs = {
  incidentCategoryId: Scalars['ID']
}

export enum FilterContext {
  Incident = 'INCIDENT',
}

export type SavedFilter = {
  __typename?: 'SavedFilter'
  context: FilterContext
  createdAt: Scalars['String']
  filterCriteria: FilterCriteria
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  name: Scalars['String']
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

export type FilterCriteria = {
  __typename?: 'FilterCriteria'
  incident?: Maybe<IncidentFilterCriteria>
}

export type IncidentFilterCriteria = {
  __typename?: 'IncidentFilterCriteria'
  aiOperatorState?: Maybe<AiOperatorIncidentState>
  aiOperatorStateIn?: Maybe<Array<AiOperatorIncidentState>>
  AND?: Maybe<Array<Maybe<IncidentFilterCriteria>>>
  createdAtGte?: Maybe<Scalars['String']>
  createdAtGteInterval?: Maybe<Scalars['Int']>
  createdAtLte?: Maybe<Scalars['String']>
  deviceIdIn?: Maybe<Array<Scalars['ID']>>
  deviceTypeIn?: Maybe<Array<DeviceType>>
  facilityIdIn?: Maybe<Array<Scalars['ID']>>
  floorIdIn?: Maybe<Array<Scalars['ID']>>
  hasVideoClip?: Maybe<Scalars['Boolean']>
  manualIncidentCategoryIdIn?: Maybe<Array<Scalars['ID']>>
  mutedStatus?: Maybe<MutedStatus>
  OR?: Maybe<Array<IncidentFilterCriteria>>
  ownerId?: Maybe<Scalars['ID']>
  priorityIn?: Maybe<Array<NullableIncidentPriorityFilterCriteria>>
  sourceIn?: Maybe<Array<IncidentSource>>
  statusIn?: Maybe<Array<IncidentStatus>>
  typeIn?: Maybe<Array<IncidentType>>
}

export enum AiOperatorIncidentState {
  /** Incidents commented on by AIO. */
  Commented = 'COMMENTED',
  /** Incidents flagged by AIO. */
  Flagged = 'FLAGGED',
  /** Incidents resolved by AIO. */
  Resolved = 'RESOLVED',
}

/** Probably incomplete. */
export enum DeviceType {
  Alarm = 'ALARM',
  Camera = 'CAMERA',
  Checkpoint = 'CHECKPOINT',
  Door = 'DOOR',
}

export enum MutedStatus {
  All = 'ALL',
  Muted = 'MUTED',
  NotMuted = 'NOT_MUTED',
}

export type NullableIncidentPriorityFilterCriteria = {
  __typename?: 'NullableIncidentPriorityFilterCriteria'
  value?: Maybe<IncidentPriority>
}

export enum IncidentPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum IncidentSource {
  /**
   * The source of the incident is a Custom Quick Report (Custom Form submission).
   *
   * These incidents are submitted via the Custom Form Builder feature.
   */
  CustomQuickReport = 'CUSTOM_QUICK_REPORT',
  /** The source of the incident is an email sent to an Email Source's Ingest Address. */
  Email = 'EMAIL',
  Employee = 'EMPLOYEE',
  Guard = 'GUARD',
  /**
   * The source of the incident is an email from the Honeywell Mass Comms
   * fire alarm system.
   */
  HoneywellMassComms = 'HONEYWELL_MASS_COMMS',
  /**
   * The source of the incident is the HiveWatch software itself.
   *
   * This value should not be exposed to a user in the
   * ["Incident Source"](https://hivewatch.atlassian.net/browse/PRODUCT-224)
   * field
   * in the "Create Incident" form.
   */
  Internal = 'INTERNAL',
  /**
   * The source of the incident is QuickReport application.
   *
   * These incidents are submitted by external users.
   */
  QuickReport = 'QUICK_REPORT',
  /**
   * The source of the incident is an email from the SensoScientific
   * temperature monitoring system.
   */
  Sensoscientific = 'SENSOSCIENTIFIC',
}

export enum IncidentStatus {
  /**
   * See the
   * [glossary](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Terms+Glossary#Active-incident).
   */
  Active = 'ACTIVE',
  /**
   * See the
   * [glossary](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Terms+Glossary#In-progress-incident).
   */
  InProgress = 'IN_PROGRESS',
  Resolved = 'RESOLVED',
}

export enum IncidentType {
  Alarm = 'ALARM',
  DeviceHealth = 'DEVICE_HEALTH',
  DeviceOffline = 'DEVICE_OFFLINE',
  DoorHeldClose = 'DOOR_HELD_CLOSE',
  DoorHeldOpen = 'DOOR_HELD_OPEN',
  ForcedEntry = 'FORCED_ENTRY',
  LineCrossing = 'LINE_CROSSING',
  Tailgating = 'TAILGATING',
}

export type User = {
  __typename?: 'User'
  /** A small photo, suitable for use as an avatar. */
  avatar?: Maybe<FlexibleContent>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  /**
   * Implements the following requirement in
   * [ENG-971](https://hivewatch.atlassian.net/browse/ENG-971):
   *
   * > The facility they [the user] are typically located at [...].
   * > This is also the facility that should be displayed on
   * > the settings page.
   */
  designatedFacility?: Maybe<Facility>
  /** The ID for `designatedFacility`. */
  designatedFacilityId?: Maybe<Scalars['ID']>
  email?: Maybe<Scalars['String']>
  /**
   * The facility that the user is currently checked into
   * (if there is such a facility).
   */
  facility?: Maybe<Facility>
  /**
   * The ID of the facility that the user is currently checked into
   * (if there is such a facility).
   */
  facilityId?: Maybe<Scalars['ID']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** Timestamp of the last invitation email sent (for resent invites). Null if never resent. */
  lastInviteSentAt?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  /** May be unavailable for users other than guards. */
  onDuty?: Maybe<Scalars['Boolean']>
  photo?: Maybe<FlexibleContent>
  role?: Maybe<Role>
  /**
   * *For background on why `null` is allowed, see
   * [this Jira comment](https://hivewatch.atlassian.net/browse/ENG-975?focusedCommentId=13226)
   * from 2022-03-11.*
   */
  roleName?: Maybe<Scalars['String']>
  /** All roles assigned to the user. */
  roles: Array<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  username: Scalars['String']
}

/**
 * This union exists to model data which might be provided as a URL
 * or might be sent directly by the GraphQL web service.
 */
export type FlexibleContent = MimeTypedObject | UrlContent

export type MimeTypedObject = {
  __typename?: 'MimeTypedObject'
  /**
   * The object's data, encoded with
   * [base64](https://datatracker.ietf.org/doc/html/rfc4648#section-4) encoding.
   */
  base64Content?: Maybe<Scalars['String']>
  /**
   * The [Mime type](https://en.wikipedia.org/wiki/Media_type)
   * of the object.
   */
  mimeType?: Maybe<Scalars['String']>
}

export type UrlContent = {
  __typename?: 'UrlContent'
  /**
   * The URL is valid until at least this time.
   *
   * If this field is `null`, then the URL has no expiry time.
   */
  minExpiryTime?: Maybe<Scalars['String']>
  url: Scalars['String']
}

export type Facility = {
  __typename?: 'Facility'
  /** The street address */
  address?: Maybe<Array<Scalars['String']>>
  /** *Automatically generated.* */
  archived?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['String']
  defaultFloorId?: Maybe<Scalars['ID']>
  devices?: Maybe<DeviceConnection>
  /** Optional feature which is created/edited via a different API. */
  emergencyCalling?: Maybe<EmergencyCalling>
  emergencyNumber: Scalars['String']
  floors?: Maybe<FloorConnection>
  /** Count of guards currently checked into the facility. */
  guardCount?: Maybe<Scalars['Int']>
  guardTours?: Maybe<GuardTourConnection>
  id: Scalars['ID']
  incidents?: Maybe<IncidentConnection>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  /**
   * For 2 examples, see
   * [this Invision mock-up](https://projects.invisionapp.com/d/main/default/#/console/21014207/447586943/preview).
   * (The examples are the strings "GHQ" and "WH", each inside a
   * circle on the map.)
   *
   * Minimum length: 3 characters. \
   * Maximum length: 5 characters.
   */
  shortName?: Maybe<Scalars['String']>
  siteSnapshot?: Maybe<FlexibleContent>
  /** This time zone should match entries in the IANA Time Zone Database e.g. America/Los_Angeles. */
  timeZone?: Maybe<Scalars['String']>
  tourPlans?: Maybe<TourPlanConnection>
  type?: Maybe<FacilityType>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  /** The users currently checked into the facility. */
  users?: Maybe<UserConnection>
}

export type FacilityDevicesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<DeviceFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<DeviceOrderInput>>>
}

export type FacilityFloorsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<FloorFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<FloorOrderInput>>>
}

export type FacilityGuardToursArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<GuardTourFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<GuardTourOrderInput>>>
}

export type FacilityIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

export type FacilityTourPlansArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<TourPlanFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<TourPlanOrderInput>>>
}

export type FacilityUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<UserFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>>>
}

/** *Automatically generated.* */
export type DeviceFilterInput = {
  /** Filter devices by tag IDs. Returns devices that have all of the specified tags (AND logic). An empty list is ignored. */
  allTagIds?: InputMaybe<Array<Scalars['ID']>>
  AND?: InputMaybe<Array<DeviceFilterInput>>
  archived?: InputMaybe<Scalars['Boolean']>
  associationStatusIn?: InputMaybe<Array<DeviceAssociationStatus>>
  associationStatusNotIn?: InputMaybe<Array<DeviceAssociationStatus>>
  bearing?: InputMaybe<Scalars['Float']>
  bearingGt?: InputMaybe<Scalars['Float']>
  bearingGte?: InputMaybe<Scalars['Float']>
  bearingIn?: InputMaybe<Array<Scalars['Float']>>
  bearingLike?: InputMaybe<Scalars['Float']>
  bearingLt?: InputMaybe<Scalars['Float']>
  bearingLte?: InputMaybe<Scalars['Float']>
  bearingNot?: InputMaybe<Scalars['Float']>
  bearingNotIn?: InputMaybe<Array<Scalars['Float']>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  edgeDeviceName?: InputMaybe<Scalars['String']>
  externalAccountIdIn?: InputMaybe<Array<Scalars['ID']>>
  externalId?: InputMaybe<Scalars['String']>
  /** *Not implemented.* */
  externalIdIn?: InputMaybe<Array<Scalars['String']>>
  /** *Not implemented.* */
  externalIdNot?: InputMaybe<Scalars['String']>
  /** *Not implemented.* */
  externalIdNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  fieldOfView?: InputMaybe<Scalars['Float']>
  fieldOfViewGt?: InputMaybe<Scalars['Float']>
  fieldOfViewGte?: InputMaybe<Scalars['Float']>
  fieldOfViewIn?: InputMaybe<Array<Scalars['Float']>>
  fieldOfViewLike?: InputMaybe<Scalars['Float']>
  fieldOfViewLt?: InputMaybe<Scalars['Float']>
  fieldOfViewLte?: InputMaybe<Scalars['Float']>
  fieldOfViewNot?: InputMaybe<Scalars['Float']>
  fieldOfViewNotIn?: InputMaybe<Array<Scalars['Float']>>
  floorId?: InputMaybe<Scalars['ID']>
  floorIdIn?: InputMaybe<Array<Scalars['ID']>>
  floorIdNot?: InputMaybe<Scalars['ID']>
  floorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  floorPlanId?: InputMaybe<Scalars['ID']>
  floorPlanIdIn?: InputMaybe<Array<Scalars['ID']>>
  floorPlanIdNot?: InputMaybe<Scalars['ID']>
  floorPlanIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  gatewayId?: InputMaybe<Scalars['ID']>
  gatewayIdIn?: InputMaybe<Array<Scalars['ID']>>
  gatewayIdNot?: InputMaybe<Scalars['ID']>
  gatewayIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  hasActiveIncidents?: InputMaybe<Scalars['Boolean']>
  hasEdgeDevice?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  isPlaced?: InputMaybe<Scalars['Boolean']>
  macAddress?: InputMaybe<Scalars['String']>
  macAddressGt?: InputMaybe<Scalars['String']>
  macAddressGte?: InputMaybe<Scalars['String']>
  macAddressIn?: InputMaybe<Array<Scalars['String']>>
  macAddressLike?: InputMaybe<Scalars['String']>
  macAddressLt?: InputMaybe<Scalars['String']>
  macAddressLte?: InputMaybe<Scalars['String']>
  macAddressNot?: InputMaybe<Scalars['String']>
  macAddressNotIn?: InputMaybe<Array<Scalars['String']>>
  manufacturerName?: InputMaybe<Scalars['String']>
  manufacturerNameGt?: InputMaybe<Scalars['String']>
  manufacturerNameGte?: InputMaybe<Scalars['String']>
  manufacturerNameIn?: InputMaybe<Array<Scalars['String']>>
  manufacturerNameLike?: InputMaybe<Scalars['String']>
  manufacturerNameLt?: InputMaybe<Scalars['String']>
  manufacturerNameLte?: InputMaybe<Scalars['String']>
  manufacturerNameNot?: InputMaybe<Scalars['String']>
  manufacturerNameNotIn?: InputMaybe<Array<Scalars['String']>>
  modelName?: InputMaybe<Scalars['String']>
  modelNameGt?: InputMaybe<Scalars['String']>
  modelNameGte?: InputMaybe<Scalars['String']>
  modelNameIn?: InputMaybe<Array<Scalars['String']>>
  modelNameLike?: InputMaybe<Scalars['String']>
  modelNameLt?: InputMaybe<Scalars['String']>
  modelNameLte?: InputMaybe<Scalars['String']>
  modelNameNot?: InputMaybe<Scalars['String']>
  modelNameNotIn?: InputMaybe<Array<Scalars['String']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<DeviceFilterInput>>
  status?: InputMaybe<DeviceStatus>
  statusIn?: InputMaybe<Array<DeviceStatus>>
  statusNot?: InputMaybe<DeviceStatus>
  statusNotIn?: InputMaybe<Array<DeviceStatus>>
  streamingType?: InputMaybe<StreamingType>
  streamingTypeIn?: InputMaybe<Array<StreamingType>>
  streamingTypeNot?: InputMaybe<StreamingType>
  streamingTypeNotIn?: InputMaybe<Array<StreamingType>>
  /** Filter devices by tag IDs. Returns devices that have any of the specified tags (OR logic). */
  tagIds?: InputMaybe<Array<Scalars['ID']>>
  type?: InputMaybe<DeviceType>
  typeIn?: InputMaybe<Array<DeviceType>>
  typeNot?: InputMaybe<DeviceType>
  typeNotIn?: InputMaybe<Array<DeviceType>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  visibilityRange?: InputMaybe<Scalars['Float']>
  visibilityRangeGt?: InputMaybe<Scalars['Float']>
  visibilityRangeGte?: InputMaybe<Scalars['Float']>
  visibilityRangeIn?: InputMaybe<Array<Scalars['Float']>>
  visibilityRangeLike?: InputMaybe<Scalars['Float']>
  visibilityRangeLt?: InputMaybe<Scalars['Float']>
  visibilityRangeLte?: InputMaybe<Scalars['Float']>
  visibilityRangeNot?: InputMaybe<Scalars['Float']>
  visibilityRangeNotIn?: InputMaybe<Array<Scalars['Float']>>
  x?: InputMaybe<Scalars['Float']>
  xGt?: InputMaybe<Scalars['Float']>
  xGte?: InputMaybe<Scalars['Float']>
  xIn?: InputMaybe<Array<Scalars['Float']>>
  xLike?: InputMaybe<Scalars['Float']>
  xLt?: InputMaybe<Scalars['Float']>
  xLte?: InputMaybe<Scalars['Float']>
  xNot?: InputMaybe<Scalars['Float']>
  xNotIn?: InputMaybe<Array<Scalars['Float']>>
  y?: InputMaybe<Scalars['Float']>
  yGt?: InputMaybe<Scalars['Float']>
  yGte?: InputMaybe<Scalars['Float']>
  yIn?: InputMaybe<Array<Scalars['Float']>>
  yLike?: InputMaybe<Scalars['Float']>
  yLt?: InputMaybe<Scalars['Float']>
  yLte?: InputMaybe<Scalars['Float']>
  yNot?: InputMaybe<Scalars['Float']>
  yNotIn?: InputMaybe<Array<Scalars['Float']>>
}

export enum DeviceAssociationStatus {
  Associated = 'ASSOCIATED',
  GridDrawn = 'GRID_DRAWN',
  TailgateEnabled = 'TAILGATE_ENABLED',
  Unassociated = 'UNASSOCIATED',
}

export enum DeviceStatus {
  Healthy = 'HEALTHY',
  Unhealthy = 'UNHEALTHY',
}

export enum StreamingType {
  ArculesCloud = 'ARCULES_CLOUD',
  AvaCloud = 'AVA_CLOUD',
  AvigilonCloud = 'AVIGILON_CLOUD',
  ExacqvisionOnprem = 'EXACQVISION_ONPREM',
  LumanaCloud = 'LUMANA_CLOUD',
  OnPremise = 'ON_PREMISE',
  VerkadaCloud = 'VERKADA_CLOUD',
}

/** *Automatically generated.* */
export type DeviceOrderInput = {
  direction: OrderDirection
  field: DeviceOrderField
}

/** *Automatically generated.* */
export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** *Automatically generated.* */
export enum DeviceOrderField {
  Bearing = 'BEARING',
  CreatedAt = 'CREATED_AT',
  FacilityId = 'FACILITY_ID',
  FacilityName = 'FACILITY_NAME',
  FieldOfView = 'FIELD_OF_VIEW',
  FloorId = 'FLOOR_ID',
  FloorName = 'FLOOR_NAME',
  FloorPlanId = 'FLOOR_PLAN_ID',
  GatewayId = 'GATEWAY_ID',
  Id = 'ID',
  IsPlaced = 'IS_PLACED',
  MacAddress = 'MAC_ADDRESS',
  ManufacturerName = 'MANUFACTURER_NAME',
  ModelName = 'MODEL_NAME',
  Name = 'NAME',
  Status = 'STATUS',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  VisibilityRange = 'VISIBILITY_RANGE',
  X = 'X',
  Y = 'Y',
}

/** *Automatically generated.* */
export type DeviceConnection = {
  __typename?: 'DeviceConnection'
  edges?: Maybe<Array<Maybe<DeviceEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type DeviceEdge = {
  __typename?: 'DeviceEdge'
  cursor: Scalars['String']
  node?: Maybe<Device>
}

export type Device = {
  __typename?: 'Device'
  alarm?: Maybe<Alarm>
  archived?: Maybe<Scalars['Boolean']>
  /**
   * The direction in which the device is "looking".
   *
   * Not applicable to all device types.
   *
   * The unit is the
   * [degree](https://en.wikipedia.org/wiki/Degree_(angle)).
   * 0 is north, 90 is east.
   */
  bearing?: Maybe<Scalars['Float']>
  camera?: Maybe<Camera>
  checkpoint?: Maybe<Checkpoint>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  door?: Maybe<Door>
  edgeDevice?: Maybe<EdgeDevice>
  edgeDeviceId?: Maybe<Scalars['ID']>
  facility?: Maybe<Facility>
  facilityId?: Maybe<Scalars['ID']>
  /**
   * Not applicable to all device types.
   * Added to this GraphQL type with cameras in mind.
   *
   * The unit is the
   * [degree](https://en.wikipedia.org/wiki/Degree_(angle)).
   */
  fieldOfView?: Maybe<Scalars['Float']>
  floor?: Maybe<Floor>
  floorId?: Maybe<Scalars['ID']>
  floorPlan?: Maybe<FloorPlan>
  floorPlanId?: Maybe<Scalars['ID']>
  gateway?: Maybe<Gateway>
  gatewayId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  incidents?: Maybe<IncidentConnection>
  isPlaced?: Maybe<Scalars['Boolean']>
  macAddress?: Maybe<Scalars['String']>
  manufacturerName?: Maybe<Scalars['String']>
  modelName?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  status?: Maybe<DeviceStatus>
  tags: TagConnection
  tailgateConns?: Maybe<TailgateConnConnection>
  thumbnail?: Maybe<FlexibleContent>
  type?: Maybe<DeviceType>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  /**
   * How far the device can see.
   *
   * Not applicable to all device types.
   *
   * Can vary according to location.  May be an Operator's
   * subjective estimate.
   *
   * The unit is the meter.
   *
   * Called 'distance' in some sources.
   */
  visibilityRange?: Maybe<Scalars['Float']>
  /**
   * The x-coordinate of the device relative
   * to the top left corner of
   * the floor plan (see the `floorPlan` attribute).
   *
   * The unit is the meter.
   */
  x?: Maybe<Scalars['Float']>
  /**
   * The y-coordinate of the device relative
   * to the top left corner of
   * the floor plan (see the `floorPlan` attribute).
   *
   * The unit is the meter.
   */
  y?: Maybe<Scalars['Float']>
}

export type DeviceIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

export type DeviceTailgateConnsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<TailgateConnFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<TailgateConnOrderInput>>>
}

export type Alarm = {
  __typename?: 'Alarm'
  alarmType?: Maybe<IncidentTypeDefinition>
  alarmTypeId?: Maybe<Scalars['ID']>
  createdAt: Scalars['String']
  device?: Maybe<Device>
  externalId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  updatedAt: Scalars['String']
}

/** Incident type definition with metadata. Stubbed from IncidentType enum until DB table exists. */
export type IncidentTypeDefinition = {
  __typename?: 'IncidentTypeDefinition'
  /**
   * AiOperatorField ids allowed as AI Operator response-rule criteria for this type (the same ids
   * updateAiOperatorResponseRules accepts as fieldId). An empty list means the type is not
   * AIO-eligible. Read-only: values are seeded by migration and cannot be set through any mutation.
   */
  aioAllowedCriteria: Array<Scalars['ID']>
  archived: Scalars['Boolean']
  defaultPriority?: Maybe<IncidentPriority>
  displayName: Scalars['String']
  icon?: Maybe<Scalars['String']>
  id: Scalars['ID']
  manual: Scalars['Boolean']
  mutable: Scalars['Boolean']
  quickReport: Scalars['Boolean']
  slug: Scalars['String']
}

export type Camera = {
  __typename?: 'Camera'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  customerSecretProvider?: Maybe<CustomerSecretProviderLinkEdge>
  defaultExternalAccount?: Maybe<ExternalAccount>
  device?: Maybe<Device>
  externalAccount?: Maybe<ExternalAccount>
  externalAccountId?: Maybe<Scalars['ID']>
  externalId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isAssociated?: Maybe<Scalars['Boolean']>
  requiresAuthentication?: Maybe<Scalars['Boolean']>
  rtspIp?: Maybe<Scalars['String']>
  /** Always null. */
  rtspPassword?: Maybe<Scalars['String']>
  rtspPath?: Maybe<Scalars['String']>
  rtspPort?: Maybe<Scalars['Int']>
  /** Orthogonal to Customer Secret Providers. */
  rtspUsername?: Maybe<Scalars['String']>
  streamingProtocol?: Maybe<StreamingProtocol>
  streamingResolutionHeight?: Maybe<Scalars['Int']>
  streamingResolutionWidth?: Maybe<Scalars['Int']>
  streamingType?: Maybe<StreamingType>
  tailgateGrids?: Maybe<Array<Maybe<TailgateGrid>>>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type CustomerSecretProviderLinkEdge = {
  __typename?: 'CustomerSecretProviderLinkEdge'
  node: CustomerSecretProvider
  secretArn?: Maybe<Scalars['String']>
}

export type CustomerSecretProvider = {
  __typename?: 'CustomerSecretProvider'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  entities: EntitySecretProviderConnection
  id: Scalars['ID']
  kmsAlias?: Maybe<Scalars['String']>
  kmsKeyId?: Maybe<Scalars['String']>
  kmsRegion?: Maybe<Scalars['String']>
  organization?: Maybe<Organization>
  organizationId: Scalars['ID']
  providerAccountId: Scalars['String']
  providerName: Scalars['String']
  providerRegion: Scalars['String']
  providerType: SecretProviderType
  secretNamespace?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type CustomerSecretProviderEntitiesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EntitySecretProviderFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type EntitySecretProviderFilterInput = {
  entityType?: InputMaybe<CredentialLinkEntityType>
}

export enum CredentialLinkEntityType {
  Camera = 'CAMERA',
  ExternalAccountApiKey = 'EXTERNAL_ACCOUNT_API_KEY',
  PacsSourceInstance = 'PACS_SOURCE_INSTANCE',
}

export type EntitySecretProviderConnection = {
  __typename?: 'EntitySecretProviderConnection'
  edges?: Maybe<Array<Maybe<EntitySecretProviderEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type EntitySecretProviderEdge = {
  __typename?: 'EntitySecretProviderEdge'
  cursor: Scalars['String']
  entityId: Scalars['ID']
  entityType: CredentialLinkEntityType
  node?: Maybe<CredentialLinkEntity>
  secretArn?: Maybe<Scalars['String']>
}

export type CredentialLinkEntity =
  | Camera
  | ExternalAccountApiKey
  | PacsSourceInstance

export type ExternalAccountApiKey = {
  __typename?: 'ExternalAccountApiKey'
  createdAt: Scalars['String']
  customerSecretProvider?: Maybe<CustomerSecretProviderLinkEdge>
  externalAccount?: Maybe<ExternalAccount>
  externalAccountId: Scalars['ID']
  id: Scalars['ID']
  permissionName: ApiKeyPermission
  secretName: Scalars['String']
  updatedAt: Scalars['String']
}

export type ExternalAccount = {
  __typename?: 'ExternalAccount'
  accountId: Scalars['String']
  accountName: Scalars['String']
  apiKeyIds: Array<Scalars['ID']>
  apiKeys: Array<ExternalAccountApiKey>
  createdAt: Scalars['String']
  defaultAccount: Scalars['Boolean']
  externalSystemType?: Maybe<ExternalSystemType>
  id: Scalars['ID']
  idp?: Maybe<ExternalAccountIdp>
  idpId?: Maybe<Scalars['ID']>
  properties?: Maybe<ExternalAccountProperties>
  propertiesId?: Maybe<Scalars['ID']>
  updatedAt: Scalars['String']
}

export enum ExternalSystemType {
  Arcules = 'ARCULES',
  Ava = 'AVA',
  Avigilon = 'AVIGILON',
  ExacqvisionOnprem = 'EXACQVISION_ONPREM',
  Lumana = 'LUMANA',
  Verkada = 'VERKADA',
}

export type ExternalAccountIdp = {
  __typename?: 'ExternalAccountIdp'
  config?: Maybe<Scalars['JSON']>
  createdAt: Scalars['String']
  externalAccount?: Maybe<ExternalAccount>
  externalAccountId: Scalars['ID']
  id: Scalars['ID']
  type: IdpType
  updatedAt: Scalars['String']
}

export enum IdpType {
  Azure = 'AZURE',
  Google = 'GOOGLE',
}

export type ExternalAccountProperties = {
  __typename?: 'ExternalAccountProperties'
  createdAt: Scalars['String']
  data?: Maybe<Scalars['JSON']>
  externalAccount?: Maybe<ExternalAccount>
  externalAccountId: Scalars['ID']
  id: Scalars['ID']
  updatedAt: Scalars['String']
}

export enum ApiKeyPermission {
  StreamingHistorical = 'STREAMING_HISTORICAL',
  StreamingLive = 'STREAMING_LIVE',
}

export type PacsSourceInstance = {
  __typename?: 'PacsSourceInstance'
  createdAt: Scalars['String']
  customerSecretProvider?: Maybe<CustomerSecretProviderLinkEdge>
  fields?: Maybe<Array<Maybe<PacsSourceFieldInstance>>>
  id: Scalars['ID']
  name: Scalars['String']
  pacsSource?: Maybe<PacsSource>
  updatedAt: Scalars['String']
}

export type PacsSourceFieldInstance = {
  __typename?: 'PacsSourceFieldInstance'
  createdAt: Scalars['String']
  id: Scalars['ID']
  pacsSourceField?: Maybe<PacsSourceField>
  updatedAt: Scalars['String']
  value: Scalars['String']
}

export type PacsSourceField = {
  __typename?: 'PacsSourceField'
  createdAt: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
  secure?: Maybe<Scalars['Boolean']>
  updatedAt: Scalars['String']
}

export type PacsSource = {
  __typename?: 'PacsSource'
  createdAt: Scalars['String']
  fields?: Maybe<Array<Maybe<PacsSourceField>>>
  id: Scalars['ID']
  name: Scalars['String']
  updatedAt: Scalars['String']
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor?: Maybe<Scalars['String']>
  hasNextPage?: Maybe<Scalars['Boolean']>
  hasPreviousPage?: Maybe<Scalars['Boolean']>
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  startCursor?: Maybe<Scalars['String']>
}

export type Organization = {
  __typename?: 'Organization'
  aiOperatorSettings?: Maybe<AiOperatorSettings>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  defaultCustomerSecretProviderId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  /**
   * Short-lived presigned URL for the organization's logo, sourced from the
   * Quick Report configuration (deployment-global, so only the default
   * organization carries it). Null when no Quick Report logo exists or the
   * organization is not the default one. The expiry is config-driven
   * (s3assets.quick-report-image-config.duration-min — minutes, not hours):
   * fetch this at time of use rather than caching it.
   */
  logoUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  organizationSettings?: Maybe<OrganizationSettings>
  /**
   * The organization's rules for when incident sounds play for all of its users.
   * Readable by every role; changed with `updateOrganizationSoundPolicy`.
   */
  soundPolicy?: Maybe<OrganizationSoundPolicy>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type AiOperatorSettings = {
  __typename?: 'AiOperatorSettings'
  accessGrantedTimeThresholdDefault: Scalars['Float']
  doorCloseTimeThresholdDefault: Scalars['Float']
  doorForcedBounceTimeThresholdDefault: Scalars['Float']
  id: Scalars['ID']
  monthlyIncidentLimit: Scalars['Int']
}

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings'
  cameraOfflineDurationUnit: DurationUnit
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  emailReplyToAddress?: Maybe<Scalars['String']>
  emailReplyToName?: Maybe<Scalars['String']>
  emailSenderName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** The phone number used by an organization to receive calls. */
  inboundPhoneNumber?: Maybe<Scalars['String']>
  minimumCameraOfflineDuration: Scalars['Int']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export enum DurationUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Second = 'SECOND',
}

/**
 * When incident sounds play for everyone in an organization, whatever each
 * user's own audio settings say. Its id is the organization's. An organization
 * that never changed a policy has every field at its default.
 */
export type OrganizationSoundPolicy = {
  __typename?: 'OrganizationSoundPolicy'
  /**
   * When true, a newly arrived Critical incident plays its sound for every
   * logged-in operator, even one who has turned off audio alerts or muted the
   * Active Incidents bell. Other priorities still follow each operator's own
   * settings. Defaults to false.
   */
  alwaysPlayCriticalIncidentSound: Scalars['Boolean']
  id: Scalars['ID']
}

export enum SecretProviderType {
  Aws = 'AWS',
}

export enum StreamingProtocol {
  Rtsp = 'RTSP',
  Rtsps = 'RTSPS',
}

export type TailgateGrid = {
  __typename?: 'TailgateGrid'
  camera?: Maybe<Device>
  door?: Maybe<Device>
  inBox?: Maybe<Box>
  isTailgateEnabled?: Maybe<Scalars['Boolean']>
  outBox?: Maybe<Box>
}

export type Box = {
  __typename?: 'Box'
  bottomLeft: Point
  bottomRight: Point
  topLeft: Point
  topRight: Point
}

export type Point = {
  __typename?: 'Point'
  x: Scalars['Float']
  y: Scalars['Float']
}

export type Checkpoint = {
  __typename?: 'Checkpoint'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  device?: Maybe<Device>
  displayId: Scalars['String']
  id: Scalars['ID']
  isPhotoRequired?: Maybe<Scalars['Boolean']>
  tasks?: Maybe<Array<CheckpointTask>>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type CheckpointTask = {
  __typename?: 'CheckpointTask'
  checkpoint?: Maybe<Checkpoint>
  description: Scalars['String']
  id: Scalars['ID']
  isRequired: Scalars['Boolean']
}

export type Door = {
  __typename?: 'Door'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  device?: Maybe<Device>
  externalId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  tailgateGrids?: Maybe<Array<Maybe<TailgateGrid>>>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type EdgeDevice = {
  __typename?: 'EdgeDevice'
  devices?: Maybe<DeviceConnection>
  id: Scalars['ID']
  name: Scalars['String']
}

export type Floor = {
  __typename?: 'Floor'
  archived?: Maybe<Scalars['Boolean']>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  devices?: Maybe<DeviceConnection>
  displayOrder?: Maybe<Scalars['Int']>
  facility?: Maybe<Facility>
  facilityId: Scalars['ID']
  floorPlan?: Maybe<FloorPlan>
  floorPlanId: Scalars['ID']
  id: Scalars['ID']
  incidents?: Maybe<IncidentConnection>
  name?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type FloorDevicesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<DeviceFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<DeviceOrderInput>>>
}

export type FloorIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentOrderInput>>>
}

/**
 * **Data modelling thoughts**
 *
 * A Floor Plan can exist independently of any Floors.
 *
 * A Floor will ordinarily have a Floor Plan, but might not
 * if the Floor has recently been created.
 *
 * A Floor Plan might be used by many Floors, quite possibly
 * in different Facilities.
 *
 * A Device ordinarily has a Floor, but might not if the Device has
 * recently been created.
 *
 * If a Device has been "placed", it has a Floor Plan;
 * otherwise, it doesn't.
 *
 * The physical layout of a Floor could change, in which case
 * the security staff will probably want to associate it with a new Floor Plan.
 * After this happens, there will be an interim period during which
 * Devices are associated with the old Floor Plan.
 *
 * **To be decided**
 *
 * How this type actually represents a Floor Plan.
 */
export type FloorPlan = {
  __typename?: 'FloorPlan'
  archived?: Maybe<Scalars['Boolean']>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  floorId: Scalars['ID']
  id: Scalars['ID']
  image?: Maybe<FlexibleContent>
  name: Scalars['String']
  s3Key?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type IncidentFilterInput = {
  actionTypeIn?: InputMaybe<Array<IncidentActionType>>
  actionUpdatedAtLte?: InputMaybe<Scalars['String']>
  aiOperatorState?: InputMaybe<AiOperatorIncidentState>
  aiOperatorStateIn?: InputMaybe<Array<AiOperatorIncidentState>>
  AND?: InputMaybe<Array<IncidentFilterInput>>
  /**
   * Matches incidents whose attributed user (COALESCE(ownerId, guardId)) is in the list.
   * An empty list matches no incidents.
   */
  attributedToIdIn?: InputMaybe<Array<Scalars['ID']>>
  /** true matches only unattributed incidents (no owner and no guard); false matches the complement. */
  attributedToIsNull?: InputMaybe<Scalars['Boolean']>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtGteInterval?: InputMaybe<Scalars['Int']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  description?: InputMaybe<Scalars['String']>
  descriptionGt?: InputMaybe<Scalars['String']>
  descriptionGte?: InputMaybe<Scalars['String']>
  descriptionIn?: InputMaybe<Array<Scalars['String']>>
  descriptionLt?: InputMaybe<Scalars['String']>
  descriptionLte?: InputMaybe<Scalars['String']>
  descriptionNot?: InputMaybe<Scalars['String']>
  descriptionNotIn?: InputMaybe<Array<Scalars['String']>>
  deviceIdIn?: InputMaybe<Array<Scalars['ID']>>
  deviceTypeIn?: InputMaybe<Array<DeviceType>>
  deviceTypesContain?: InputMaybe<DeviceType>
  deviceTypesDoNotContain?: InputMaybe<DeviceType>
  deviceTypesNull?: InputMaybe<Scalars['Boolean']>
  dispatched?: InputMaybe<Scalars['Boolean']>
  dispatchedTo?: InputMaybe<DispatchTargetType>
  displayId?: InputMaybe<Scalars['String']>
  displayIdIn?: InputMaybe<Array<Scalars['ID']>>
  displayIdLike?: InputMaybe<Scalars['String']>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  facilityType?: InputMaybe<FacilityType>
  facilityTypeIn?: InputMaybe<Array<FacilityType>>
  facilityTypeNot?: InputMaybe<FacilityType>
  facilityTypeNotIn?: InputMaybe<Array<FacilityType>>
  floorId?: InputMaybe<Scalars['ID']>
  floorIdIn?: InputMaybe<Array<Scalars['ID']>>
  floorIdNot?: InputMaybe<Scalars['ID']>
  floorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  guardId?: InputMaybe<Scalars['ID']>
  guardIdIn?: InputMaybe<Array<Scalars['ID']>>
  guardIdNot?: InputMaybe<Scalars['ID']>
  guardIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  hasAudioMessages?: InputMaybe<Scalars['Boolean']>
  hasVideoClip?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentTypeDefinitionIdIn?: InputMaybe<Array<Scalars['ID']>>
  manualIncidentCategoryIdIn?: InputMaybe<Array<Scalars['ID']>>
  mutedStatus?: InputMaybe<MutedStatus>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentFilterInput>>
  ownerId?: InputMaybe<Scalars['ID']>
  ownerIdIn?: InputMaybe<Array<Scalars['ID']>>
  ownerIdNot?: InputMaybe<Scalars['ID']>
  ownerIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  priority?: InputMaybe<IncidentPriority>
  priorityIn?: InputMaybe<Array<NullableIncidentPriority>>
  priorityNot?: InputMaybe<IncidentPriority>
  priorityNotIn?: InputMaybe<Array<IncidentPriority>>
  query?: InputMaybe<Scalars['String']>
  real?: InputMaybe<Scalars['Boolean']>
  source?: InputMaybe<IncidentSource>
  /**
   * Matches incidents whose ORIGINAL video clip was recorded by one of the given cameras, PLUS
   * incidents whose clip carries no recorded camera at all. The null-tolerance is part of the
   * field's contract, not a caller's choice: `device_event.source_camera_id` is only written for
   * clips appended after ENG-34211 and is unrecoverable for anything older (there is no backfill,
   * by design), so a strict IN would hide the entire pre-existing backlog.
   * An empty list is filter-ignored, matching the shared `in` helper rather than attributedToIdIn.
   * Matching implies a VIDEO_CLIP exists, so this is redundant with `hasVideoClip: true`.
   */
  sourceCameraIdInOrNull?: InputMaybe<Array<Scalars['ID']>>
  sourceIn?: InputMaybe<Array<IncidentSource>>
  sourceNot?: InputMaybe<IncidentSource>
  sourceNotIn?: InputMaybe<Array<IncidentSource>>
  status?: InputMaybe<IncidentStatus>
  statusIn?: InputMaybe<Array<IncidentStatus>>
  statusNot?: InputMaybe<IncidentStatus>
  statusNotIn?: InputMaybe<Array<IncidentStatus>>
  type?: InputMaybe<IncidentType>
  typeIn?: InputMaybe<Array<IncidentType>>
  typeNot?: InputMaybe<IncidentType>
  typeNotIn?: InputMaybe<Array<IncidentType>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

export enum IncidentActionType {
  /**
   * A guard
   * [acknowledges](https://hivewatch.atlassian.net/browse/HM-355) an
   * incident.
   */
  AcknowledgementByGuard = 'ACKNOWLEDGEMENT_BY_GUARD',
  /**
   * An operator
   * [acknowledges an incident](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Glossary#Acknowledge-an-Incident).
   */
  AcknowledgementByOperator = 'ACKNOWLEDGEMENT_BY_OPERATOR',
  /**
   * A guard declares that an
   * [incident is cleared](https://hivewatch.atlassian.net/browse/HM-355).
   */
  Cleared = 'CLEARED',
  /** An operator/program manager has dispatched an incident to a facility's guards. */
  Dispatch = 'DISPATCH',
  /** An operator/program manager has ended an emergency call for an incident. */
  EndEmergencyCall = 'END_EMERGENCY_CALL',
  /** AI Operator flagged incident for further review and analysis. */
  Flag = 'FLAG',
  /** The Rules Engine muted the incident via a matched mute rule. System-created only. */
  Mute = 'MUTE',
  /**
   * A guard declares that he is [on the
   * scene](https://hivewatch.atlassian.net/browse/HM-355) of an
   * incident.
   */
  OnScene = 'ON_SCENE',
  /** An operator orders a device repair. */
  OrderDeviceRepair = 'ORDER_DEVICE_REPAIR',
  /** An operator/program manager changed the incident priority. */
  PriorityChange = 'PRIORITY_CHANGE',
  /** A guard releases an incident. */
  ReleaseByGuard = 'RELEASE_BY_GUARD',
  /**
   * An operator releases an incident.
   * (More information: [ENG-746](https://hivewatch.atlassian.net/browse/ENG-746).)
   */
  ReleaseByOperator = 'RELEASE_BY_OPERATOR',
  /**
   * An operator resolves an incident.
   * (Example:
   * [screenshot](https://hivewatch.atlassian.net/wiki/pages/viewpage.action?pageId=775979012&pageVersion=9&preview=/775979012/775323662/IncidentTimeline.png#ImageC)
   * from web app,
   * showing green box containing "Alert resolved by Adam West".)
   */
  Resolved = 'RESOLVED',
  /** The Rules Engine sent an email notification via a matched email rule. System-created only. */
  SendEmail = 'SEND_EMAIL',
  /**
   * An operator/program manager has sent the incident to ontic's external system
   * [ENG-18121](https://hivewatch.atlassian.net/browse/ENG-18121)
   */
  SendToOntic = 'SEND_TO_ONTIC',
  /** An operator marks the incident as false. */
  SetRealToFalse = 'SET_REAL_TO_FALSE',
  /** An operator marks the incident as real. */
  SetRealToTrue = 'SET_REAL_TO_TRUE',
  /** An operator/program manager has started an emergency call for an incident. */
  StartEmergencyCall = 'START_EMERGENCY_CALL',
  /** The system assigned a priority based on the incident category's default priority. */
  SystemPriorityAssignment = 'SYSTEM_PRIORITY_ASSIGNMENT',
  /** A Guard need to be able to take over ownership to get to a resolution. */
  TakeoverByGuard = 'TAKEOVER_BY_GUARD',
}

export enum DispatchTargetType {
  /** Incidents dispatched to all guards */
  Broadcast = 'BROADCAST',
  /** Incidents dispatched to a user making request and not all guards */
  SpecificOnly = 'SPECIFIC_ONLY',
  /** Incidents dispatched to a user making request or all guards */
  SpecificOrBroadcast = 'SPECIFIC_OR_BROADCAST',
}

export enum FacilityType {
  Market = 'MARKET',
  Normal = 'NORMAL',
}

export type NullableIncidentPriority = {
  value?: InputMaybe<IncidentPriority>
}

/** *Automatically generated.* */
export type IncidentOrderInput = {
  direction: OrderDirection
  field: IncidentOrderField
}

export enum IncidentOrderField {
  Acknowledged = 'ACKNOWLEDGED',
  ActionType = 'ACTION_TYPE',
  ActionUpdatedAt = 'ACTION_UPDATED_AT',
  ConcernStartTime = 'CONCERN_START_TIME',
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  Description = 'DESCRIPTION',
  Dispatched = 'DISPATCHED',
  DisplayId = 'DISPLAY_ID',
  FacilityId = 'FACILITY_ID',
  FacilityName = 'FACILITY_NAME',
  FacilityType = 'FACILITY_TYPE',
  FloorId = 'FLOOR_ID',
  FloorName = 'FLOOR_NAME',
  GuardId = 'GUARD_ID',
  HasAudioMessages = 'HAS_AUDIO_MESSAGES',
  Id = 'ID',
  InformationSolicited = 'INFORMATION_SOLICITED',
  Latitude = 'LATITUDE',
  Longitude = 'LONGITUDE',
  MatchedRule = 'MATCHED_RULE',
  Muted = 'MUTED',
  Name = 'NAME',
  NextPossibleGuardAction = 'NEXT_POSSIBLE_GUARD_ACTION',
  Offered = 'OFFERED',
  OwnerId = 'OWNER_ID',
  Priority = 'PRIORITY',
  Real = 'REAL',
  Sensor = 'SENSOR',
  Source = 'SOURCE',
  Status = 'STATUS',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type IncidentConnection = {
  __typename?: 'IncidentConnection'
  edges?: Maybe<Array<Maybe<IncidentEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type IncidentEdge = {
  __typename?: 'IncidentEdge'
  cursor: Scalars['String']
  node?: Maybe<Incident>
}

export type Incident = SubscriberMessage & {
  __typename?: 'Incident'
  /**
   * Whether the incident has been
   * [acknowledged](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Glossary#Acknowledge-an-Incident)
   * by a guard (not an Operator).
   */
  acknowledged?: Maybe<Scalars['Boolean']>
  actions?: Maybe<Array<Maybe<IncidentAction>>>
  /**
   * Introduced for filtering outstanding incidents (OI) defined in https://hivewatch.atlassian.net/browse/ENG-4629
   * used to filter by requested incident action types.
   */
  actionType?: Maybe<IncidentActionType>
  /**
   * Introduced for filtering outstanding incidents (OI) defined in https://hivewatch.atlassian.net/browse/ENG-4629
   * to received not updated incidents for requested time.
   */
  actionUpdatedAt?: Maybe<Scalars['String']>
  /** The street address */
  address?: Maybe<Array<Scalars['String']>>
  aiOperatorFeedback?: Maybe<Array<Maybe<AiOperatorFeedback>>>
  aiOperatorLatestFeedback?: Maybe<AiOperatorFeedback>
  aiOperatorReasoningTrail?: Maybe<AiOperatorReasoningTrail>
  aiOperatorRuleEvaluations?: Maybe<Array<AiOperatorRuleEvaluation>>
  audioMessages?: Maybe<AudioMessageConnection>
  /**
   * The video clips associated with this incident: at least one `ORIGINAL` clip and,
   * when applicable, one `EXTENDED` clip per source device.
   */
  clips?: Maybe<IncidentClipConnection>
  /**
   * This field is applicable when the incident results from a worrying
   * condition that has persisted long enough to justify an incident.
   *
   * We can't use `createdAt`, because that is the time when the
   * Incident was created, which is later than the time at which the
   * worrying condition appeared.
   *
   * Here is an example of when this field is useful. Suppose that a
   * camera goes offline. We don't create an incident immediately,
   * because that policy would probably result in lots of trivial
   * incidents.
   *
   * If the incident persists long enough, however, we do create an
   * incident - and when we do, we are interested in knowing when the
   * camera went offline, which we can get from the `concernStartTime`
   * field.
   */
  concernStartTime?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId?: Maybe<Scalars['ID']>
  currentWorkflowStep?: Maybe<Scalars['ID']>
  customFormSubmissionDetail?: Maybe<CustomFormSubmissionDetail>
  description?: Maybe<Scalars['String']>
  /**
   * Corresponds to detectedAt for the raw PACS event associated with
   * the incident.
   */
  detectedAt: Scalars['String']
  deviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>
  devices?: Maybe<Array<Maybe<Device>>>
  deviceTypes?: Maybe<Array<Maybe<DeviceType>>>
  dispatched?: Maybe<Scalars['Boolean']>
  dispatchedGuardIds?: Maybe<Array<Scalars['ID']>>
  dispatchedGuards?: Maybe<UserConnection>
  /** Human-readable incident identifier. */
  displayId: Scalars['String']
  /** The email the incident was created from. Null unless source is EMAIL. */
  email?: Maybe<IncidentEmail>
  emergencyCalls?: Maybe<EmergencyCallConnection>
  /** List of external IDs from the underlying events associated with this incident. */
  eventExternalIds?: Maybe<Array<Scalars['ID']>>
  events?: Maybe<Array<Maybe<IncidentEvent>>>
  externalIncidentAdditionalDetail?: Maybe<ExternalIncidentAdditionalDetail>
  facility?: Maybe<Facility>
  facilityId?: Maybe<Scalars['ID']>
  facilityName?: Maybe<Scalars['String']>
  facilityType?: Maybe<FacilityType>
  floor?: Maybe<Floor>
  floorId?: Maybe<Scalars['ID']>
  floorName?: Maybe<Scalars['String']>
  guard?: Maybe<User>
  guardId?: Maybe<Scalars['ID']>
  hasAudioMessages?: Maybe<Scalars['Boolean']>
  hasVideoClip?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  /**
   * Whether information has been solicited on this incident.
   * (For more information, see the section headed
   * "Sharing" in
   * [this comment](https://hivewatch.atlassian.net/browse/HM-306?focusedCommentId=10467).)
   */
  imageUrls?: Maybe<Array<Scalars['String']>>
  /** Incident type definition with metadata. Use this instead of type. */
  incidentType?: Maybe<IncidentTypeDefinition>
  incidentTypeDefinitionId?: Maybe<Scalars['ID']>
  informationSolicited?: Maybe<Scalars['Boolean']>
  /**
   * An incident is considered flagged after the AI Operator performs the FLAG operation but before a real Operator
   * acknowledges the flagged incident. Flagged incidents are marked for review by real Operators.
   */
  isFlagged?: Maybe<Scalars['Boolean']>
  isSentToOntic?: Maybe<Scalars['Boolean']>
  lastIncidentDispatchType?: Maybe<LastIncidentDispatchType>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  manualIncidentCategory?: Maybe<ManualIncidentCategory>
  manualIncidentCategoryId?: Maybe<Scalars['ID']>
  matchedRule?: Maybe<Scalars['ID']>
  muted: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
  /**
   * *Design note: this field is unnecessary, because its value can
   * be inferred from other fields of this type — but it makes life
   * easier for the developer of the Patrol app.*
   */
  nextPossibleGuardAction?: Maybe<IncidentGuardActionType>
  notes?: Maybe<IncidentNoteConnection>
  occurrencesWithJudgement?: Maybe<IncidentOccurrenceWithJudgementConnection>
  /**
   * Whether this incident has been offered to an Operator.
   * (For more information, see the section headed
   * "Transfer of Responsibility" in
   * [this comment](https://hivewatch.atlassian.net/browse/HM-306?focusedCommentId=10467).)
   */
  offered?: Maybe<Scalars['Boolean']>
  /** The Operator who is in charge of the incident. */
  owner?: Maybe<User>
  ownerId?: Maybe<Scalars['ID']>
  pendingWorkflow?: Maybe<IncidentWorkflow>
  priority?: Maybe<IncidentPriority>
  /**
   * Quick Report details with pre-formatted answers for display.
   * Returns data for CUSTOM_QUICK_REPORT source, null for other sources.
   * For QUICK_REPORT (canned), use externalIncidentAdditionalDetail instead.
   */
  quickReportDetails?: Maybe<QuickReportDetails>
  /**
   * If this is false, the incident
   * is not a real incident and should
   * not have been created.
   *
   * Note: operators may toggle this any number
   * of times, as their judgement changes.
   */
  real?: Maybe<Scalars['Boolean']>
  sensor?: Maybe<DeviceType>
  source?: Maybe<IncidentSource>
  status?: Maybe<IncidentStatus>
  systemActions?: Maybe<Array<Maybe<SystemAction>>>
  /** @deprecated Use incidentType instead. Will be removed when incident types are fully migrated to DB. */
  type?: Maybe<IncidentType>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  video?: Maybe<StreamingUrlWrapperInterface>
  wasProcessedByAiOperator?: Maybe<Scalars['Boolean']>
  workflowEndTime?: Maybe<Scalars['String']>
  workflowId?: Maybe<Scalars['ID']>
  workflowStartedTime?: Maybe<Scalars['String']>
  workflowStatus?: Maybe<IncidentWorkflowStatus>
}

export type IncidentAudioMessagesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<AudioMessageFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<AudioMessageOrderInput>>>
}

export type IncidentEmergencyCallsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<EmergencyCallFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<EmergencyCallOrderInput>>>
}

export type IncidentNotesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentNoteFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<IncidentNoteOrderInput>>>
}

export type IncidentOccurrencesWithJudgementArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<IncidentOccurrenceWithJudgementFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<
    Array<InputMaybe<IncidentOccurrenceWithJudgementOrderInput>>
  >
}

export type IncidentVideoArgs = {
  offsetAfter?: InputMaybe<Scalars['Float']>
  offsetBefore?: InputMaybe<Scalars['Float']>
}

export type SubscriberMessage = {
  createdAt: Scalars['String']
  id: Scalars['ID']
}

export type IncidentAction = IncidentEvent &
  IncidentOccurrence &
  SubscriberMessage & {
    __typename?: 'IncidentAction'
    audioClipId?: Maybe<Scalars['ID']>
    audioMessage?: Maybe<AudioMessage>
    audioMessageId?: Maybe<Scalars['ID']>
    bulkOperationId?: Maybe<Scalars['ID']>
    /** *Automatically generated.* */
    createdAt: Scalars['String']
    creator?: Maybe<User>
    creatorId?: Maybe<Scalars['ID']>
    deviceRepairOrder?: Maybe<DeviceRepairOrder>
    dispatchedGuardIds: Array<Scalars['ID']>
    dispatchedGuards: Array<User>
    /**
     * Email recipients notified by this rule action.
     * Returns all recipients configured on the matched rule.
     * Only non-null when action type is `SEND_EMAIL`.
     */
    emailRecipients?: Maybe<Array<EmailRecipient>>
    /**
     * History of the change. Only populated for action types that track changes
     * (e.g., PRIORITY_CHANGE).
     */
    history?: Maybe<IncidentHistory>
    id: Scalars['ID']
    incident?: Maybe<Incident>
    incidentId: Scalars['ID']
    incidentNote?: Maybe<IncidentNote>
    incidentNoteId?: Maybe<Scalars['ID']>
    /** Whether this action was performed by the Rules Engine. */
    isRuleAction: Scalars['Boolean']
    /**
     * Implements the following requirement in
     * [ENG-687](https://hivewatch.atlassian.net/browse/ENG-687):
     *
     * > Must have [...] some text in the "Order Repair"
     * > textbox to be able to press the "Send Request" Button
     */
    message?: Maybe<Scalars['String']>
    resolutionContent?: Maybe<ResolutionContent>
    /** The type of rule action (MUTE, SEND_EMAIL, etc.). Null for non-rule actions. */
    ruleActionType?: Maybe<Action>
    /** The ID of the rule that triggered this action. Null for non-rule actions. */
    ruleId?: Maybe<Scalars['ID']>
    /**
     * `null`, unless `type` is `ORDER_DEVICE_REPAIR`,
     * in which case it is the ID of the technician doing the repair.
     */
    technicianId?: Maybe<Scalars['ID']>
    type: IncidentActionType
    /** *Automatically generated.* */
    updatedAt: Scalars['String']
  }

export type IncidentEvent = {
  createdAt: Scalars['String']
  updatedAt: Scalars['String']
}

export type IncidentOccurrence = {
  createdAt: Scalars['String']
  id: Scalars['ID']
}

export type AudioMessage = IncidentEvent &
  SubscriberMessage & {
    __typename?: 'AudioMessage'
    acknowledged?: Maybe<Scalars['Boolean']>
    acknowledgements?: Maybe<Array<Maybe<Acknowledgement>>>
    audioClip?: Maybe<AudioClip>
    audioClipId: Scalars['ID']
    /** *Automatically generated.* */
    createdAt: Scalars['String']
    creator?: Maybe<User>
    creatorId?: Maybe<Scalars['ID']>
    facility?: Maybe<Facility>
    facilityId?: Maybe<Scalars['ID']>
    id: Scalars['ID']
    incident?: Maybe<Incident>
    incidentId?: Maybe<Scalars['ID']>
    incidentOwner?: Maybe<User>
    incidentOwnerId?: Maybe<Scalars['ID']>
    source?: Maybe<AudioMessageSource>
    target?: Maybe<MessageTarget>
    /** *Automatically generated.* */
    updatedAt: Scalars['String']
  }

export type Acknowledgement = {
  __typename?: 'Acknowledgement'
  audioClip?: Maybe<AudioClip>
  audioClipId?: Maybe<Scalars['ID']>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId: Scalars['ID']
  id: Scalars['ID']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** To *send* a message, use `AudioMessage`. */
export type AudioClip = {
  __typename?: 'AudioClip'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId?: Maybe<Scalars['ID']>
  /**
   * The time at which the recording of the audio clip ended.
   * Example: 2021-10-29T08:05:47.978Z.
   */
  endTime: Scalars['String']
  /**
   * The client creates the voice message with some external
   * service, receiving a unique ID, then uses that ID for this
   * field.
   */
  externalId: Scalars['String']
  facility?: Maybe<Facility>
  facilityId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  incident?: Maybe<Incident>
  incidentId?: Maybe<Scalars['ID']>
  /**
   * The time at which the recording of the audio clip started.
   * Example: 2021-10-29T08:05:47.978Z.
   */
  startTime: Scalars['String']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  /** A file in a format such as MP3. */
  url?: Maybe<Scalars['String']>
}

export enum AudioMessageSource {
  Mobile = 'MOBILE',
  Web = 'WEB',
}

export type MessageTarget = {
  __typename?: 'MessageTarget'
  AND?: Maybe<Array<MessageTarget>>
  facilityId?: Maybe<Scalars['ID']>
  incidentId?: Maybe<Scalars['ID']>
  onShift?: Maybe<Scalars['Boolean']>
  OR?: Maybe<Array<MessageTarget>>
  recipientIds?: Maybe<Array<Scalars['ID']>>
}

export type DeviceRepairOrder = {
  __typename?: 'DeviceRepairOrder'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  id: Scalars['ID']
  message: Scalars['String']
  technician?: Maybe<Technician>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type Technician = {
  __typename?: 'Technician'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  /** The device types that the technician supports */
  deviceTypes?: Maybe<Array<Maybe<DeviceType>>>
  email?: Maybe<Scalars['String']>
  /** The facilities that the technician is associated with */
  facilities?: Maybe<Array<Maybe<Facility>>>
  facilityIds?: Maybe<Array<Maybe<Scalars['ID']>>>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type EmailRecipient = {
  __typename?: 'EmailRecipient'
  createdAt: Scalars['String']
  email: Scalars['String']
  id: Scalars['ID']
  status: EmailRecipientStatus
  updatedAt: Scalars['String']
  userId?: Maybe<Scalars['ID']>
}

export enum EmailRecipientStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

/**
 * Records the history of a tracked change on an incident action.
 * Only populated for action types that involve tracked changes (e.g., PRIORITY_CHANGE).
 */
export type IncidentHistory = {
  __typename?: 'IncidentHistory'
  /** The incident action type that triggered this history record. */
  incidentActionType: IncidentActionType
  /** The new value after the change. */
  newValue?: Maybe<Scalars['String']>
  /** The previous value before the change. Null if no previous value existed. */
  oldValue?: Maybe<Scalars['String']>
}

export type IncidentNote = {
  __typename?: 'IncidentNote'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  incident?: Maybe<Incident>
  incidentId: Scalars['ID']
  media: Array<IncidentNoteMedia>
  mediaIds: Array<Scalars['ID']>
  message: Scalars['String']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type IncidentNoteMedia = {
  __typename?: 'IncidentNoteMedia'
  id: Scalars['ID']
  incidentNoteId?: Maybe<Scalars['ID']>
  mimeType?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type ResolutionContent = {
  __typename?: 'ResolutionContent'
  /** Concatenated plain-text rendering of all segments. */
  plainText: Scalars['String']
  segments: Array<ResolutionSegment>
}

export type ResolutionSegment = {
  __typename?: 'ResolutionSegment'
  detectedAt?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['String']>
  segmentType: ResolutionSegmentType
  text: Scalars['String']
}

export enum ResolutionSegmentType {
  EventRef = 'EVENT_REF',
  Text = 'TEXT',
}

export enum Action {
  EnableAiOperator = 'ENABLE_AI_OPERATOR',
  Mute = 'MUTE',
  SendEmail = 'SEND_EMAIL',
  SetPriority = 'SET_PRIORITY',
}

export type AiOperatorFeedback = {
  __typename?: 'AiOperatorFeedback'
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId: Scalars['ID']
  id: Scalars['ID']
  incident?: Maybe<Incident>
  incidentId: Scalars['ID']
  isPositive: Scalars['Boolean']
  message?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
}

export type AiOperatorReasoningTrail = {
  __typename?: 'AiOperatorReasoningTrail'
  outcome: AiOperatorReasoningOutcome
  steps: Array<AiOperatorReasoningStep>
}

export type AiOperatorReasoningOutcome = {
  __typename?: 'AiOperatorReasoningOutcome'
  description: Scalars['String']
  kind: IncidentActionType
  title: Scalars['String']
}

export type AiOperatorReasoningStep = {
  __typename?: 'AiOperatorReasoningStep'
  description: Scalars['String']
  fieldId: Scalars['ID']
  isDecisive: Scalars['Boolean']
  label: Scalars['String']
  metadataCard?: Maybe<AiOperatorReasoningMetadataCard>
  result: AiOperatorReasoningResult
  sourceType: AiOperatorFieldSourceType
  traceLogLink?: Maybe<AiOperatorReasoningTraceLogLink>
}

export type AiOperatorReasoningMetadataCard = {
  __typename?: 'AiOperatorReasoningMetadataCard'
  rows: Array<AiOperatorReasoningMetadataRow>
  title: Scalars['String']
}

export type AiOperatorReasoningMetadataRow = {
  __typename?: 'AiOperatorReasoningMetadataRow'
  label: Scalars['String']
  value: Scalars['String']
}

export enum AiOperatorReasoningResult {
  No = 'NO',
  NotRequired = 'NOT_REQUIRED',
  Yes = 'YES',
}

export enum AiOperatorFieldSourceType {
  AcsEvent = 'ACS_EVENT',
  Prompt = 'PROMPT',
  Yolo = 'YOLO',
}

export type AiOperatorReasoningTraceLogLink = {
  __typename?: 'AiOperatorReasoningTraceLogLink'
  deviceId: Scalars['ID']
  highlightedEvent?: Maybe<AiOperatorReasoningEventRef>
}

export type AiOperatorReasoningEventRef = {
  __typename?: 'AiOperatorReasoningEventRef'
  detectedAt: Scalars['String']
  externalId: Scalars['String']
}

export type AiOperatorRuleEvaluation = {
  __typename?: 'AiOperatorRuleEvaluation'
  createdAt: Scalars['String']
  description?: Maybe<Scalars['String']>
  /** AI evaluation result. null indicates placeholder evaluation (rule not evaluated by AIO). */
  evalIsTrue?: Maybe<Scalars['Boolean']>
  evalPayload?: Maybe<Scalars['JSON']>
  grid?: Maybe<EvaluationGrid>
  /** Determines whether human label exists for this evaluation */
  hasHumanLabel: Scalars['Boolean']
  /** Associated human label */
  humanLabel?: Maybe<AiOperatorHumanLabel>
  id: Scalars['ID']
  incident?: Maybe<Incident>
  incidentId: Scalars['ID']
  model?: Maybe<AiOperatorModel>
  modelId?: Maybe<Scalars['ID']>
  processingTimeSeconds?: Maybe<Scalars['Float']>
  responseRule?: Maybe<AiOperatorResponseRule>
  responseRuleId: Scalars['ID']
  updatedAt: Scalars['String']
  videoClipS3Key?: Maybe<Scalars['String']>
  wasDryRun: Scalars['Boolean']
}

export type EvaluationGrid = {
  __typename?: 'EvaluationGrid'
  inBox?: Maybe<Box>
  outBox?: Maybe<Box>
}

export type AiOperatorHumanLabel = {
  __typename?: 'AiOperatorHumanLabel'
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId: Scalars['ID']
  field?: Maybe<AiOperatorField>
  fieldId: Scalars['ID']
  humanValue?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  incident?: Maybe<Incident>
  incidentId: Scalars['ID']
  updatedAt: Scalars['String']
}

export type AiOperatorField = {
  __typename?: 'AiOperatorField'
  createdAt: Scalars['String']
  description?: Maybe<Scalars['String']>
  displayOrder?: Maybe<Scalars['Int']>
  enabled: Scalars['Boolean']
  humanInstructions?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  prompt?: Maybe<AiOperatorPrompt>
  referenceId?: Maybe<Scalars['ID']>
  sourceType: AiOperatorFieldSourceType
  type: AiOperatorFieldType
  updatedAt: Scalars['String']
}

export type AiOperatorPrompt = {
  __typename?: 'AiOperatorPrompt'
  createdAt: Scalars['String']
  descriptionField?: Maybe<AiOperatorField>
  enabled: Scalars['Boolean']
  id: Scalars['ID']
  jsonSchema: Scalars['String']
  name?: Maybe<Scalars['String']>
  responseFields?: Maybe<Array<AiOperatorField>>
  systemText?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
  userText: Scalars['String']
}

export enum AiOperatorFieldType {
  BooleanLabel = 'BOOLEAN_LABEL',
  Description = 'DESCRIPTION',
}

export type AiOperatorModel = {
  __typename?: 'AiOperatorModel'
  canonicalName: Scalars['String']
  createdAt: Scalars['String']
  default: Scalars['Boolean']
  enabled: Scalars['Boolean']
  id: Scalars['ID']
  identifier: Scalars['String']
  provider: AiOperatorModelProvider
  updatedAt: Scalars['String']
}

export enum AiOperatorModelProvider {
  Anthropic = 'ANTHROPIC',
  Google = 'GOOGLE',
}

export type AiOperatorResponseRule = {
  __typename?: 'AiOperatorResponseRule'
  action: AiOperatorActionType
  aiOperatorRuleDetails?: Maybe<AiOperatorRuleDetails>
  comparator: Scalars['String']
  createdAt: Scalars['String']
  defaultModel?: Maybe<AiOperatorModel>
  field?: Maybe<AiOperatorField>
  fieldId: Scalars['ID']
  id: Scalars['ID']
  model?: Maybe<AiOperatorModel>
  modelId?: Maybe<Scalars['ID']>
  priority?: Maybe<Scalars['Int']>
  updatedAt: Scalars['String']
  value: Scalars['String']
}

export enum AiOperatorActionType {
  FlagAndRelease = 'FLAG_AND_RELEASE',
  ResolveAndMarkAsFalse = 'RESOLVE_AND_MARK_AS_FALSE',
}

export type AiOperatorRuleDetails = {
  __typename?: 'AiOperatorRuleDetails'
  createdAt?: Maybe<Scalars['String']>
  defaultAction?: Maybe<AiOperatorActionType>
  id?: Maybe<Scalars['ID']>
  isDryRun: Scalars['Boolean']
  updatedAt?: Maybe<Scalars['String']>
}

/** *Automatically generated.* */
export type AudioMessageFilterInput = {
  acknowledged?: InputMaybe<Scalars['Boolean']>
  AND?: InputMaybe<Array<AudioMessageFilterInput>>
  audioClipId?: InputMaybe<Scalars['ID']>
  audioClipIdIn?: InputMaybe<Array<Scalars['ID']>>
  audioClipIdNot?: InputMaybe<Scalars['ID']>
  audioClipIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentOwnerId?: InputMaybe<Scalars['ID']>
  incidentOwnerIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentOwnerIdNot?: InputMaybe<Scalars['ID']>
  incidentOwnerIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<AudioMessageFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type AudioMessageOrderInput = {
  direction: OrderDirection
  field: AudioMessageOrderField
}

/** *Automatically generated.* */
export enum AudioMessageOrderField {
  Acknowledged = 'ACKNOWLEDGED',
  AudioClipId = 'AUDIO_CLIP_ID',
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  FacilityId = 'FACILITY_ID',
  Id = 'ID',
  IncidentId = 'INCIDENT_ID',
  IncidentOwnerId = 'INCIDENT_OWNER_ID',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type AudioMessageConnection = {
  __typename?: 'AudioMessageConnection'
  edges?: Maybe<Array<Maybe<AudioMessageEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type AudioMessageEdge = {
  __typename?: 'AudioMessageEdge'
  cursor: Scalars['String']
  node?: Maybe<AudioMessage>
}

export type IncidentClipConnection = {
  __typename?: 'IncidentClipConnection'
  edges?: Maybe<Array<Maybe<IncidentClipEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type IncidentClipEdge = {
  __typename?: 'IncidentClipEdge'
  cursor: Scalars['String']
  node?: Maybe<IncidentClip>
}

/** A video clip associated with an incident, captured from a single source device. */
export type IncidentClip = {
  __typename?: 'IncidentClip'
  /** The id of the camera that captured this clip. */
  cameraId: Scalars['ID']
  /** ISO-8601 clip end. Example: 2021-10-29T08:05:47.978Z. */
  endTime: Scalars['String']
  kind: ClipKind
  /** The S3 key locating the clip object. */
  s3Key: Scalars['String']
  /** ISO-8601 clip start. Example: 2021-10-29T08:05:47.978Z. */
  startTime: Scalars['String']
  /** Presigned playback URL for the clip. */
  video?: Maybe<StreamingUrlWrapperInterface>
}

export enum ClipKind {
  /** A full-res clip produced by extending the original clip's time range (human/forensic). */
  Extended = 'EXTENDED',
  /** The clip captured at incident creation — the original/default clip (low-res machine input). */
  Original = 'ORIGINAL',
}

/**
 * *TODO: check that this allows the client to initially fill
 * the video content area with a still of the first frame.*
 */
export type StreamingUrlWrapperInterface = {
  /**
   * The time at which the URL will be invalid
   * and needs to be requested again.
   * Example: 2021-10-29T08:05:47.978Z.
   */
  expiryTime?: Maybe<Scalars['String']>
  headers?: Maybe<Array<HttpHeader>>
  url: Scalars['String']
}

export type HttpHeader = {
  __typename?: 'HttpHeader'
  key: Scalars['String']
  value: Scalars['String']
}

export type CustomFormSubmissionDetail = {
  __typename?: 'CustomFormSubmissionDetail'
  answers: Array<CustomFormAnswer>
  form?: Maybe<CustomForm>
  formId: Scalars['ID']
  formVersion: Scalars['Int']
}

export type CustomFormAnswer = {
  __typename?: 'CustomFormAnswer'
  answerType: CustomFormAnswerType
  question?: Maybe<CustomFormQuestion>
  questionId: Scalars['ID']
  /** The question label at the time of submission (for historical reference) */
  questionLabel?: Maybe<Scalars['String']>
  /** The selected option labels for SELECT/RADIO/MULTI_SELECT answers (for historical reference) */
  selectedOptionLabels?: Maybe<Array<Scalars['String']>>
  value: Scalars['String']
}

export enum CustomFormAnswerType {
  DateTime = 'DATE_TIME',
  Email = 'EMAIL',
  FileUpload = 'FILE_UPLOAD',
  Location = 'LOCATION',
  LongText = 'LONG_TEXT',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Radio = 'RADIO',
  ShortText = 'SHORT_TEXT',
  SingleSelect = 'SINGLE_SELECT',
  Static = 'STATIC',
  YesNo = 'YES_NO',
}

export type CustomFormQuestion = {
  __typename?: 'CustomFormQuestion'
  answerType: CustomFormAnswerType
  createdAt: Scalars['String']
  /** The predefined value for STATIC question types */
  defaultValue?: Maybe<Scalars['String']>
  helpText?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** The answer to this question becomes the created incident's name (TITLE) or description (DESCRIPTION) */
  incidentRole?: Maybe<CustomFormIncidentRole>
  label: Scalars['String']
  options: Array<CustomFormQuestionOption>
  order: Scalars['Int']
  required: Scalars['Boolean']
  sectionId: Scalars['ID']
  updatedAt: Scalars['String']
  visibleWhen?: Maybe<VisibilityRule>
}

/** Designates the question whose answer becomes the created incident's name (TITLE) or description (DESCRIPTION); at most one of each per form (setting a role moves it from its previous holder) */
export enum CustomFormIncidentRole {
  Description = 'DESCRIPTION',
  Title = 'TITLE',
}

export type CustomFormQuestionOption = {
  __typename?: 'CustomFormQuestionOption'
  id: Scalars['ID']
  label: Scalars['String']
  order: Scalars['Int']
  questionId: Scalars['ID']
}

/**
 * Visibility rule using OR-of-AND-groups logic.
 * A section/question is visible if ANY group matches (where ALL conditions in a group must match).
 */
export type VisibilityRule = {
  __typename?: 'VisibilityRule'
  anyOf: Array<ConditionGroup>
}

export type ConditionGroup = {
  __typename?: 'ConditionGroup'
  allOf: Array<VisibilityCondition>
}

export type VisibilityCondition = {
  __typename?: 'VisibilityCondition'
  operator: ConditionOperator
  questionId: Scalars['ID']
  value?: Maybe<Scalars['String']>
}

export enum ConditionOperator {
  Equals = 'EQUALS',
}

export type CustomForm = {
  __typename?: 'CustomForm'
  createdAt: Scalars['String']
  createdBy?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  publishedAt?: Maybe<Scalars['String']>
  sections: Array<CustomFormSection>
  status: CustomFormStatus
  updatedAt: Scalars['String']
  version: Scalars['Int']
}

export type CustomFormSection = {
  __typename?: 'CustomFormSection'
  createdAt: Scalars['String']
  description?: Maybe<Scalars['String']>
  formId: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
  questions: Array<CustomFormQuestion>
  updatedAt: Scalars['String']
}

export enum CustomFormStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

/** *Automatically generated.* */
export type UserConnection = {
  __typename?: 'UserConnection'
  edges?: Maybe<Array<Maybe<UserEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type UserEdge = {
  __typename?: 'UserEdge'
  cursor: Scalars['String']
  node?: Maybe<User>
}

/** The email an EMAIL incident was created from. */
export type IncidentEmail = {
  __typename?: 'IncidentEmail'
  authSummary: EmailAuthSummary
  /**
   * The email's body as plain text, read from the preserved received email: its text/plain part, otherwise its HTML as
   * text, with each link shown as `text <href>`. Show it as plain text. At most 64 KB (see bodyTruncated). Null when
   * the email wasn't preserved, its virus scan found it infected, or it can't be read.
   */
  bodyText?: Maybe<Scalars['String']>
  /** Whether bodyText was cut at 64 KB. The full email is in the download. */
  bodyTruncated: Scalars['Boolean']
  /**
   * Presigned download of the received email as an .eml file. Null when it wasn't preserved, or when its virus scan
   * found it infected.
   */
  downloadUrl?: Maybe<Scalars['String']>
  emailSourceId: Scalars['ID']
  /** The Email Source's current name. */
  emailSourceName: Scalars['String']
  from: Scalars['String']
  /** When SES received the email, in ISO-8601. */
  receivedAt: Scalars['String']
  subject: Scalars['String']
}

/** SES authentication verdicts of an email. Spam and virus are left out: accepted emails always pass them. */
export type EmailAuthSummary = {
  __typename?: 'EmailAuthSummary'
  dkim: EmailAuthVerdict
  dmarc: EmailAuthVerdict
  spf: EmailAuthVerdict
}

/** An SES verdict, as in the receipt notification's spfVerdict, dkimVerdict and dmarcVerdict. */
export enum EmailAuthVerdict {
  Disabled = 'DISABLED',
  Fail = 'FAIL',
  Gray = 'GRAY',
  Pass = 'PASS',
  ProcessingFailed = 'PROCESSING_FAILED',
  /** A stored verdict this version doesn't know, e.g. one a newer version added. SES never sends it. */
  Unknown = 'UNKNOWN',
}

/** *Automatically generated.* */
export type EmergencyCallFilterInput = {
  AND?: InputMaybe<Array<EmergencyCallFilterInput>>
  callDuration?: InputMaybe<Scalars['String']>
  callDurationGt?: InputMaybe<Scalars['String']>
  callDurationGte?: InputMaybe<Scalars['String']>
  callDurationIn?: InputMaybe<Array<Scalars['String']>>
  callDurationLike?: InputMaybe<Scalars['String']>
  callDurationLt?: InputMaybe<Scalars['String']>
  callDurationLte?: InputMaybe<Scalars['String']>
  callDurationNot?: InputMaybe<Scalars['String']>
  callDurationNotIn?: InputMaybe<Array<Scalars['String']>>
  callEndTime?: InputMaybe<Scalars['String']>
  callEndTimeGt?: InputMaybe<Scalars['String']>
  callEndTimeGte?: InputMaybe<Scalars['String']>
  callEndTimeIn?: InputMaybe<Array<Scalars['String']>>
  callEndTimeLike?: InputMaybe<Scalars['String']>
  callEndTimeLt?: InputMaybe<Scalars['String']>
  callEndTimeLte?: InputMaybe<Scalars['String']>
  callEndTimeNot?: InputMaybe<Scalars['String']>
  callEndTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  callStartTime?: InputMaybe<Scalars['String']>
  callStartTimeGt?: InputMaybe<Scalars['String']>
  callStartTimeGte?: InputMaybe<Scalars['String']>
  callStartTimeIn?: InputMaybe<Array<Scalars['String']>>
  callStartTimeLike?: InputMaybe<Scalars['String']>
  callStartTimeLt?: InputMaybe<Scalars['String']>
  callStartTimeLte?: InputMaybe<Scalars['String']>
  callStartTimeNot?: InputMaybe<Scalars['String']>
  callStartTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  externalCallId?: InputMaybe<Scalars['String']>
  externalCallIdGt?: InputMaybe<Scalars['String']>
  externalCallIdGte?: InputMaybe<Scalars['String']>
  externalCallIdIn?: InputMaybe<Array<Scalars['String']>>
  externalCallIdLike?: InputMaybe<Scalars['String']>
  externalCallIdLt?: InputMaybe<Scalars['String']>
  externalCallIdLte?: InputMaybe<Scalars['String']>
  externalCallIdNot?: InputMaybe<Scalars['String']>
  externalCallIdNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityName?: InputMaybe<Scalars['String']>
  facilityNameGt?: InputMaybe<Scalars['String']>
  facilityNameGte?: InputMaybe<Scalars['String']>
  facilityNameIn?: InputMaybe<Array<Scalars['String']>>
  facilityNameLike?: InputMaybe<Scalars['String']>
  facilityNameLt?: InputMaybe<Scalars['String']>
  facilityNameLte?: InputMaybe<Scalars['String']>
  facilityNameNot?: InputMaybe<Scalars['String']>
  facilityNameNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentDisplayId?: InputMaybe<Scalars['String']>
  incidentDisplayIdGt?: InputMaybe<Scalars['String']>
  incidentDisplayIdGte?: InputMaybe<Scalars['String']>
  incidentDisplayIdIn?: InputMaybe<Array<Scalars['String']>>
  incidentDisplayIdLike?: InputMaybe<Scalars['String']>
  incidentDisplayIdLt?: InputMaybe<Scalars['String']>
  incidentDisplayIdLte?: InputMaybe<Scalars['String']>
  incidentDisplayIdNot?: InputMaybe<Scalars['String']>
  incidentDisplayIdNotIn?: InputMaybe<Array<Scalars['String']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<EmergencyCallFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  userId?: InputMaybe<Scalars['ID']>
  userIdIn?: InputMaybe<Array<Scalars['ID']>>
  userIdNot?: InputMaybe<Scalars['ID']>
  userIdNotIn?: InputMaybe<Array<Scalars['ID']>>
}

/** *Automatically generated.* */
export type EmergencyCallOrderInput = {
  direction: OrderDirection
  field: EmergencyCallOrderField
}

/** *Automatically generated.* */
export enum EmergencyCallOrderField {
  CallDuration = 'CALL_DURATION',
  CallEndTime = 'CALL_END_TIME',
  CallStartTime = 'CALL_START_TIME',
  CreatedAt = 'CREATED_AT',
  ExternalCallId = 'EXTERNAL_CALL_ID',
  FacilityName = 'FACILITY_NAME',
  Id = 'ID',
  IncidentDisplayId = 'INCIDENT_DISPLAY_ID',
  IncidentId = 'INCIDENT_ID',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID',
}

/** *Automatically generated.* */
export type EmergencyCallConnection = {
  __typename?: 'EmergencyCallConnection'
  edges?: Maybe<Array<Maybe<EmergencyCallEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type EmergencyCallEdge = {
  __typename?: 'EmergencyCallEdge'
  cursor: Scalars['String']
  node?: Maybe<EmergencyCall>
}

export type EmergencyCall = {
  __typename?: 'EmergencyCall'
  callDuration?: Maybe<Scalars['String']>
  callEndTime?: Maybe<Scalars['String']>
  callStartTime: Scalars['String']
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  externalCallId?: Maybe<Scalars['String']>
  /** Used to allow for nested filtering. */
  facilityName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  incident?: Maybe<Incident>
  /** Used to allow for nested filtering. */
  incidentDisplayId?: Maybe<Scalars['String']>
  incidentId: Scalars['ID']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

export type ExternalIncidentAdditionalDetail = {
  __typename?: 'ExternalIncidentAdditionalDetail'
  additionalContactInformation?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  locationOfConcern?: Maybe<Scalars['String']>
  partiesInvolved?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  timeReported: Scalars['String']
}

export enum LastIncidentDispatchType {
  Broadcast = 'BROADCAST',
  NotYetDispatched = 'NOT_YET_DISPATCHED',
  Specific = 'SPECIFIC',
}

export type ManualIncidentCategory = {
  __typename?: 'ManualIncidentCategory'
  archived: Scalars['Boolean']
  creatorId?: Maybe<Scalars['ID']>
  customForm?: Maybe<CustomForm>
  defaultPriority?: Maybe<IncidentPriority>
  id: Scalars['ID']
  isQuickReportCategory: Scalars['Boolean']
  name: Scalars['String']
}

/**
 * The same as `IncidentActionType`, except that
 * all enum values which don't apply to guards have been
 * removed.
 */
export enum IncidentGuardActionType {
  /**
   * A guard
   * [acknowledges](https://hivewatch.atlassian.net/browse/HM-355) an
   * incident.
   */
  AcknowledgementByGuard = 'ACKNOWLEDGEMENT_BY_GUARD',
  /**
   * A guard declares that an
   * [incident is cleared](https://hivewatch.atlassian.net/browse/HM-355).
   */
  Cleared = 'CLEARED',
  /**
   * No actions are possible (probably because the incident has
   * been cleared already).
   */
  None = 'NONE',
  /**
   * A guard declares that he is [on the
   * scene](https://hivewatch.atlassian.net/browse/HM-355) of an
   * incident.
   */
  OnScene = 'ON_SCENE',
}

/** *Automatically generated.* */
export type IncidentNoteFilterInput = {
  AND?: InputMaybe<Array<IncidentNoteFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  message?: InputMaybe<Scalars['String']>
  messageGt?: InputMaybe<Scalars['String']>
  messageGte?: InputMaybe<Scalars['String']>
  messageIn?: InputMaybe<Array<Scalars['String']>>
  messageLike?: InputMaybe<Scalars['String']>
  messageLt?: InputMaybe<Scalars['String']>
  messageLte?: InputMaybe<Scalars['String']>
  messageNot?: InputMaybe<Scalars['String']>
  messageNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentNoteFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentNoteOrderInput = {
  direction: OrderDirection
  field: IncidentNoteOrderField
}

/** *Automatically generated.* */
export enum IncidentNoteOrderField {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  Id = 'ID',
  IncidentId = 'INCIDENT_ID',
  Message = 'MESSAGE',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type IncidentNoteConnection = {
  __typename?: 'IncidentNoteConnection'
  edges?: Maybe<Array<Maybe<IncidentNoteEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type IncidentNoteEdge = {
  __typename?: 'IncidentNoteEdge'
  cursor: Scalars['String']
  node?: Maybe<IncidentNote>
}

/** *Automatically generated.* */
export type IncidentOccurrenceWithJudgementFilterInput = {
  AND?: InputMaybe<Array<IncidentOccurrenceWithJudgementFilterInput>>
  judgement?: InputMaybe<IncidentOccurrenceJudgement>
  judgementIn?: InputMaybe<Array<IncidentOccurrenceJudgement>>
  judgementNot?: InputMaybe<IncidentOccurrenceJudgement>
  judgementNotIn?: InputMaybe<Array<IncidentOccurrenceJudgement>>
  OR?: InputMaybe<Array<IncidentOccurrenceWithJudgementFilterInput>>
}

export enum IncidentOccurrenceJudgement {
  Bad = 'BAD',
  Good = 'GOOD',
  Neutral = 'NEUTRAL',
}

/** *Automatically generated.* */
export type IncidentOccurrenceWithJudgementOrderInput = {
  direction: OrderDirection
  field: IncidentOccurrenceWithJudgementOrderField
}

/** *Automatically generated.* */
export enum IncidentOccurrenceWithJudgementOrderField {
  Judgement = 'JUDGEMENT',
}

/** *Automatically generated.* */
export type IncidentOccurrenceWithJudgementConnection = {
  __typename?: 'IncidentOccurrenceWithJudgementConnection'
  edges?: Maybe<Array<Maybe<IncidentOccurrenceWithJudgementEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type IncidentOccurrenceWithJudgementEdge = {
  __typename?: 'IncidentOccurrenceWithJudgementEdge'
  cursor: Scalars['String']
  node?: Maybe<IncidentOccurrenceWithJudgement>
}

export type IncidentOccurrenceWithJudgement = {
  __typename?: 'IncidentOccurrenceWithJudgement'
  judgement?: Maybe<IncidentOccurrenceJudgement>
  occurrence?: Maybe<IncidentOccurrence>
}

export type IncidentWorkflow = {
  __typename?: 'IncidentWorkflow'
  actions: Array<IncidentWorkflowAction>
  createTime: Scalars['String']
  creator?: Maybe<User>
  creatorId: Scalars['ID']
  incidentTypeDefinitionId?: Maybe<Scalars['ID']>
  manualIncidentCategoryId?: Maybe<Scalars['ID']>
  name: Scalars['String']
  startingStep: Scalars['ID']
  state: WorkflowState
  steps: Array<IncidentWorkflowStep>
  updateTime: Scalars['String']
  versionId: Scalars['ID']
  workflowId: Scalars['ID']
}

export type IncidentWorkflowAction = {
  __typename?: 'IncidentWorkflowAction'
  actionTimestamp: Scalars['String']
  id: Scalars['ID']
  incidentId: Scalars['ID']
  outcomeValue: Scalars['String']
  sourceNodeId: Scalars['ID']
  targetNodeId?: Maybe<Scalars['ID']>
  type: WorkflowActionType
  userId: Scalars['ID']
}

export enum WorkflowActionType {
  End = 'END',
  Start = 'START',
  Step = 'STEP',
}

export enum WorkflowState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type IncidentWorkflowStep = {
  __typename?: 'IncidentWorkflowStep'
  edges: Array<IncidentWorkflowEdge>
  id: Scalars['ID']
  prompt: Scalars['String']
  stepType: WorkflowStepType
}

export type IncidentWorkflowEdge = {
  __typename?: 'IncidentWorkflowEdge'
  condition?: Maybe<Scalars['JSON']>
  label: Scalars['String']
  toStepId?: Maybe<Scalars['ID']>
}

export enum WorkflowStepType {
  ActionConfirmation = 'ACTION_CONFIRMATION',
  BinaryDecision = 'BINARY_DECISION',
  SingleSelect = 'SINGLE_SELECT',
}

/**
 * Quick Report submission details with pre-formatted answers for display.
 * Currently only returns data for CUSTOM_QUICK_REPORT incidents.
 */
export type QuickReportDetails = {
  __typename?: 'QuickReportDetails'
  /** Pre-formatted answers ready for display, sorted by section and question order */
  displayAnswers: Array<QuickReportDisplayAnswer>
  /** The type of quick report: CANNED or CUSTOM */
  reportType: QuickReportType
}

/** A single answer from a Quick Report submission, pre-formatted for display */
export type QuickReportDisplayAnswer = {
  __typename?: 'QuickReportDisplayAnswer'
  /** Answer type for UI rendering hints (only for CUSTOM, null for CANNED) */
  answerType?: Maybe<CustomFormAnswerType>
  /** Human-readable answer value, pre-formatted based on answer type */
  displayValue: Scalars['String']
  /** For FILE_UPLOAD answers: list of presigned file URLs */
  fileUrls?: Maybe<Array<Scalars['String']>>
  /** The question label (e.g. 'What is your name?') */
  label: Scalars['String']
  /** Sort order for display (section order * 1000 + question order) */
  order: Scalars['Int']
  /** Original question ID for reference */
  questionId: Scalars['ID']
  /** Section name for grouping (only for CUSTOM, null for CANNED) */
  sectionName?: Maybe<Scalars['String']>
}

/** The type of Quick Report form to display */
export enum QuickReportType {
  /** Use the hardcoded canned form flow (default) */
  Canned = 'CANNED',
  /** Use the dynamic custom form from customForms */
  Custom = 'CUSTOM',
}

export type SystemAction = IncidentEvent & {
  __typename?: 'SystemAction'
  createdAt: Scalars['String']
  systemMessage?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
}

export enum IncidentWorkflowStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotAssigned = 'NOT_ASSIGNED',
}

/**
 * Quoting [HM-248](https://hivewatch.atlassian.net/browse/HM-248):
 * this type represents a "physical device" or Virtual Machine:
 *
 * > that can be deployed into customers' data centers
 * > for connecting and processing video camera and access control data
 *
 * Customers get VMs from us.  (See
 * [HM-270](https://hivewatch.atlassian.net/browse/HM-270), which
 * refers to "Secure portal for customer specific downloads" and
 * says: "I want to ensure that we are properly tracking VM downloads
 * and associations for each customer's environment".)
 *
 * *To get `Device` objects for a `Gateway`,
 * use `Query.devices`, filtering by `gatewayId`.*
 */
export type Gateway = {
  __typename?: 'Gateway'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  /**
   * [HM-345](https://hivewatch.atlassian.net/browse/HM-345) calls
   * for "the ability to associate an organization's gateways with
   * facilities".
   */
  facilities?: Maybe<Array<Maybe<Facility>>>
  facilityIds?: Maybe<Array<Scalars['ID']>>
  floorIds?: Maybe<Array<Scalars['ID']>>
  /**
   * [HM-345](https://hivewatch.atlassian.net/browse/HM-345) calls
   * for "the ability to associate an organization's gateways with
   * [...] floors".
   */
  floors?: Maybe<Array<Maybe<Floor>>>
  id: Scalars['ID']
  /**
   * * `true` if the gateway is a physical device.
   * * `false` if the gateway is a Virtual Machine.
   */
  physical: Scalars['Boolean']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type TagConnection = {
  __typename?: 'TagConnection'
  edges: Array<TagEdge>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type TagEdge = {
  __typename?: 'TagEdge'
  cursor: Scalars['String']
  node: Tag
}

export type Tag = {
  __typename?: 'Tag'
  archived: Scalars['Boolean']
  createdAt: Scalars['String']
  createdBy: Scalars['ID']
  deviceCount: Scalars['Int']
  enabled: Scalars['Boolean']
  id: Scalars['ID']
  name: Scalars['String']
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type TailgateConnFilterInput = {
  AND?: InputMaybe<Array<TailgateConnFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<TailgateConnFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type TailgateConnOrderInput = {
  direction: OrderDirection
  field: TailgateConnOrderField
}

/** *Automatically generated.* */
export enum TailgateConnOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type TailgateConnConnection = {
  __typename?: 'TailgateConnConnection'
  edges?: Maybe<Array<Maybe<TailgateConnEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type TailgateConnEdge = {
  __typename?: 'TailgateConnEdge'
  cursor: Scalars['String']
  node?: Maybe<TailgateConn>
}

/**
 * *We can't call it `TailgateConnection`, because
 * that would make it a Connection Type, as defined by the
 * [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm).*
 */
export type TailgateConn = {
  __typename?: 'TailgateConn'
  cameras: DeviceConnection
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  /** The device connected to cameras, not necessarily a door. */
  door: Device
  id: Scalars['ID']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/**
 * *We can't call it `TailgateConnection`, because
 * that would make it a Connection Type, as defined by the
 * [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm).*
 */
export type TailgateConnCamerasArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<DeviceFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<DeviceOrderInput>>>
}

export type EmergencyCalling = {
  __typename?: 'EmergencyCalling'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  facility: Facility
  facilityId: Scalars['ID']
  /** Should match the id of the facility it belongs to. */
  id: Scalars['ID']
  outboundPhoneNumber: Scalars['String']
  outboundPhoneNumberSid: Scalars['String']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type FloorFilterInput = {
  AND?: InputMaybe<Array<FloorFilterInput>>
  archived?: InputMaybe<Scalars['Boolean']>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  floorPlanId?: InputMaybe<Scalars['ID']>
  floorPlanIdIn?: InputMaybe<Array<Scalars['ID']>>
  floorPlanIdNot?: InputMaybe<Scalars['ID']>
  floorPlanIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<FloorFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type FloorOrderInput = {
  direction: OrderDirection
  field: FloorOrderField
}

/** *Automatically generated.* */
export enum FloorOrderField {
  CreatedAt = 'CREATED_AT',
  DisplayOrder = 'DISPLAY_ORDER',
  FacilityId = 'FACILITY_ID',
  FloorPlanId = 'FLOOR_PLAN_ID',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type FloorConnection = {
  __typename?: 'FloorConnection'
  edges?: Maybe<Array<Maybe<FloorEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type FloorEdge = {
  __typename?: 'FloorEdge'
  cursor: Scalars['String']
  node?: Maybe<Floor>
}

/** *Automatically generated.* */
export type GuardTourFilterInput = {
  AND?: InputMaybe<Array<GuardTourFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  guardId?: InputMaybe<Scalars['ID']>
  guardIdIn?: InputMaybe<Array<Scalars['ID']>>
  guardIdNot?: InputMaybe<Scalars['ID']>
  guardIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<GuardTourFilterInput>>
  status?: InputMaybe<GuardTourStatus>
  statusIn?: InputMaybe<Array<GuardTourStatus>>
  statusNot?: InputMaybe<GuardTourStatus>
  statusNotIn?: InputMaybe<Array<GuardTourStatus>>
  submittedAtGte?: InputMaybe<Scalars['String']>
  submittedAtLte?: InputMaybe<Scalars['String']>
  tourPlanId?: InputMaybe<Scalars['ID']>
  tourPlanIdIn?: InputMaybe<Array<Scalars['ID']>>
  tourPlanIdNot?: InputMaybe<Scalars['ID']>
  tourPlanIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  tourPlanName?: InputMaybe<Scalars['String']>
  tourPlanNameGt?: InputMaybe<Scalars['String']>
  tourPlanNameGte?: InputMaybe<Scalars['String']>
  tourPlanNameIn?: InputMaybe<Array<Scalars['String']>>
  tourPlanNameLike?: InputMaybe<Scalars['String']>
  tourPlanNameLt?: InputMaybe<Scalars['String']>
  tourPlanNameLte?: InputMaybe<Scalars['String']>
  tourPlanNameNot?: InputMaybe<Scalars['String']>
  tourPlanNameNotIn?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

export enum GuardTourStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Incomplete = 'INCOMPLETE',
}

/** *Automatically generated.* */
export type GuardTourOrderInput = {
  direction: OrderDirection
  field: GuardTourOrderField
}

/** *Automatically generated.* */
export enum GuardTourOrderField {
  CreatedAt = 'CREATED_AT',
  GuardId = 'GUARD_ID',
  Id = 'ID',
  Status = 'STATUS',
  TourPlanId = 'TOUR_PLAN_ID',
  TourPlanName = 'TOUR_PLAN_NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type GuardTourConnection = {
  __typename?: 'GuardTourConnection'
  edges?: Maybe<Array<Maybe<GuardTourEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type GuardTourEdge = {
  __typename?: 'GuardTourEdge'
  cursor: Scalars['String']
  node?: Maybe<GuardTour>
}

export type GuardTour = {
  __typename?: 'GuardTour'
  completedCheckpoints?: Maybe<GuardTourCompletedCheckpointConnection>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  guard?: Maybe<User>
  guardId: Scalars['ID']
  id: Scalars['ID']
  status: GuardTourStatus
  submittedAt?: Maybe<Scalars['String']>
  summary?: Maybe<GuardTourSummary>
  totalCheckpointsAtCreation?: Maybe<Scalars['Int']>
  tourPlan?: Maybe<TourPlan>
  tourPlanId: Scalars['ID']
  tourPlanName?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type GuardTourCompletedCheckpointsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<GuardTourCompletedCheckpointFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<
    Array<InputMaybe<GuardTourCompletedCheckpointOrderInput>>
  >
}

/** *Automatically generated.* */
export type GuardTourCompletedCheckpointFilterInput = {
  AND?: InputMaybe<Array<GuardTourCompletedCheckpointFilterInput>>
  OR?: InputMaybe<Array<GuardTourCompletedCheckpointFilterInput>>
  scannedAt?: InputMaybe<Scalars['String']>
  scannedAtGt?: InputMaybe<Scalars['String']>
  scannedAtGte?: InputMaybe<Scalars['String']>
  scannedAtIn?: InputMaybe<Array<Scalars['String']>>
  scannedAtLike?: InputMaybe<Scalars['String']>
  scannedAtLt?: InputMaybe<Scalars['String']>
  scannedAtLte?: InputMaybe<Scalars['String']>
  scannedAtNot?: InputMaybe<Scalars['String']>
  scannedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type GuardTourCompletedCheckpointOrderInput = {
  direction: OrderDirection
  field: GuardTourCompletedCheckpointOrderField
}

/** *Automatically generated.* */
export enum GuardTourCompletedCheckpointOrderField {
  ScannedAt = 'SCANNED_AT',
}

/** *Automatically generated.* */
export type GuardTourCompletedCheckpointConnection = {
  __typename?: 'GuardTourCompletedCheckpointConnection'
  edges?: Maybe<Array<Maybe<GuardTourCompletedCheckpointEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type GuardTourCompletedCheckpointEdge = {
  __typename?: 'GuardTourCompletedCheckpointEdge'
  cursor: Scalars['String']
  node?: Maybe<GuardTourCompletedCheckpoint>
}

export type GuardTourCompletedCheckpoint = {
  __typename?: 'GuardTourCompletedCheckpoint'
  checkpoint: Checkpoint
  checkpointId: Scalars['ID']
  checkpointPhoto?: Maybe<FlexibleContent>
  checkpointPhotoId?: Maybe<Scalars['ID']>
  guardTourId: Scalars['ID']
  note?: Maybe<Scalars['String']>
  scannedAt: Scalars['String']
  status?: Maybe<GuardTourCompletedCheckpointStatus>
  summary?: Maybe<GuardTourCompletedCheckpointSummary>
  tasks?: Maybe<CheckpointCompletedTaskConnection>
}

export type GuardTourCompletedCheckpointTasksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export enum GuardTourCompletedCheckpointStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  NotStarted = 'NOT_STARTED',
}

export type GuardTourCompletedCheckpointSummary = {
  __typename?: 'GuardTourCompletedCheckpointSummary'
  percentComplete?: Maybe<Scalars['Int']>
  timeSpentInMinutes: Scalars['Int']
}

export type CheckpointCompletedTaskConnection = {
  __typename?: 'CheckpointCompletedTaskConnection'
  edges?: Maybe<Array<Maybe<CheckpointCompletedTaskEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CheckpointCompletedTaskEdge = {
  __typename?: 'CheckpointCompletedTaskEdge'
  cursor: Scalars['String']
  node?: Maybe<CheckpointCompletedTask>
}

export type CheckpointCompletedTask = {
  __typename?: 'CheckpointCompletedTask'
  checkpoint?: Maybe<Checkpoint>
  completedAt: Scalars['String']
  completedCheckpoint?: Maybe<GuardTourCompletedCheckpoint>
  description: Scalars['String']
  id: Scalars['ID']
  isCompleted: Scalars['Boolean']
  isRequired: Scalars['Boolean']
}

export type GuardTourSummary = {
  __typename?: 'GuardTourSummary'
  checklistItemSummary: GuardChecklistItemSummary
  checkpointSummary: GuardTourCheckpointSummary
  totalTimeSpentInMinutes: Scalars['Int']
}

export type GuardChecklistItemSummary = {
  __typename?: 'GuardChecklistItemSummary'
  completed: Scalars['Int']
  percentComplete: Scalars['Int']
  total: Scalars['Int']
}

export type GuardTourCheckpointSummary = {
  __typename?: 'GuardTourCheckpointSummary'
  percentComplete?: Maybe<Scalars['Int']>
  total?: Maybe<Scalars['Int']>
  visited: Scalars['Int']
}

export type TourPlan = {
  __typename?: 'TourPlan'
  checkpointIds: Array<Scalars['ID']>
  checkpoints?: Maybe<CheckpointConnection>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  facility?: Maybe<Facility>
  facilityId: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type TourPlanCheckpointsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CheckpointFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<CheckpointOrderInput>>>
}

/** *Automatically generated.* */
export type CheckpointFilterInput = {
  AND?: InputMaybe<Array<CheckpointFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  displayId?: InputMaybe<Scalars['String']>
  displayIdGt?: InputMaybe<Scalars['String']>
  displayIdGte?: InputMaybe<Scalars['String']>
  displayIdIn?: InputMaybe<Array<Scalars['String']>>
  displayIdLike?: InputMaybe<Scalars['String']>
  displayIdLt?: InputMaybe<Scalars['String']>
  displayIdLte?: InputMaybe<Scalars['String']>
  displayIdNot?: InputMaybe<Scalars['String']>
  displayIdNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<CheckpointFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type CheckpointOrderInput = {
  direction: OrderDirection
  field: CheckpointOrderField
}

/** *Automatically generated.* */
export enum CheckpointOrderField {
  CreatedAt = 'CREATED_AT',
  DisplayId = 'DISPLAY_ID',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type CheckpointConnection = {
  __typename?: 'CheckpointConnection'
  edges?: Maybe<Array<Maybe<CheckpointEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type CheckpointEdge = {
  __typename?: 'CheckpointEdge'
  cursor: Scalars['String']
  node?: Maybe<Checkpoint>
}

/** *Automatically generated.* */
export type TourPlanFilterInput = {
  AND?: InputMaybe<Array<TourPlanFilterInput>>
  checkpointIdsContain?: InputMaybe<Scalars['ID']>
  checkpointIdsDoNotContain?: InputMaybe<Scalars['ID']>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<TourPlanFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type TourPlanOrderInput = {
  direction: OrderDirection
  field: TourPlanOrderField
}

/** *Automatically generated.* */
export enum TourPlanOrderField {
  CreatedAt = 'CREATED_AT',
  FacilityId = 'FACILITY_ID',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type TourPlanConnection = {
  __typename?: 'TourPlanConnection'
  edges?: Maybe<Array<Maybe<TourPlanEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type TourPlanEdge = {
  __typename?: 'TourPlanEdge'
  cursor: Scalars['String']
  node?: Maybe<TourPlan>
}

/** *Automatically generated.* */
export type UserFilterInput = {
  AND?: InputMaybe<Array<UserFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  designatedFacilityId?: InputMaybe<Scalars['ID']>
  designatedFacilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  designatedFacilityIdNot?: InputMaybe<Scalars['ID']>
  designatedFacilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  email?: InputMaybe<Scalars['String']>
  emailGt?: InputMaybe<Scalars['String']>
  emailGte?: InputMaybe<Scalars['String']>
  emailIn?: InputMaybe<Array<Scalars['String']>>
  emailLike?: InputMaybe<Scalars['String']>
  emailLt?: InputMaybe<Scalars['String']>
  emailLte?: InputMaybe<Scalars['String']>
  emailNot?: InputMaybe<Scalars['String']>
  emailNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  firstName?: InputMaybe<Scalars['String']>
  firstNameGt?: InputMaybe<Scalars['String']>
  firstNameGte?: InputMaybe<Scalars['String']>
  firstNameIn?: InputMaybe<Array<Scalars['String']>>
  firstNameLike?: InputMaybe<Scalars['String']>
  firstNameLt?: InputMaybe<Scalars['String']>
  firstNameLte?: InputMaybe<Scalars['String']>
  firstNameNot?: InputMaybe<Scalars['String']>
  firstNameNotIn?: InputMaybe<Array<Scalars['String']>>
  fullNameLike?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  lastName?: InputMaybe<Scalars['String']>
  lastNameGt?: InputMaybe<Scalars['String']>
  lastNameGte?: InputMaybe<Scalars['String']>
  lastNameIn?: InputMaybe<Array<Scalars['String']>>
  lastNameLike?: InputMaybe<Scalars['String']>
  lastNameLt?: InputMaybe<Scalars['String']>
  lastNameLte?: InputMaybe<Scalars['String']>
  lastNameNot?: InputMaybe<Scalars['String']>
  lastNameNotIn?: InputMaybe<Array<Scalars['String']>>
  onDuty?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<UserFilterInput>>
  roleName?: InputMaybe<Scalars['String']>
  roleNameGt?: InputMaybe<Scalars['String']>
  roleNameGte?: InputMaybe<Scalars['String']>
  roleNameIn?: InputMaybe<Array<Scalars['String']>>
  roleNameLike?: InputMaybe<Scalars['String']>
  roleNameLt?: InputMaybe<Scalars['String']>
  roleNameLte?: InputMaybe<Scalars['String']>
  roleNameNot?: InputMaybe<Scalars['String']>
  roleNameNotIn?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  usernameLike?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UserOrderInput = {
  direction: OrderDirection
  field: UserOrderField
}

/** *Automatically generated.* */
export enum UserOrderField {
  CreatedAt = 'CREATED_AT',
  DesignatedFacilityId = 'DESIGNATED_FACILITY_ID',
  Email = 'EMAIL',
  FacilityId = 'FACILITY_ID',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  OnDuty = 'ON_DUTY',
  RoleName = 'ROLE_NAME',
  UpdatedAt = 'UPDATED_AT',
}

export type Role = {
  __typename?: 'Role'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id: Scalars['ID']
  /**
   * Possible values, showing the format for this field:
   *
   * * `GUARD`
   * * `OPERATOR`
   * * `PROGRAM_MANAGER`
   */
  name?: Maybe<Scalars['String']>
  permissions?: Maybe<Array<Maybe<Permission>>>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type Permission = {
  __typename?: 'Permission'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type FacilityIncidentCountConnection = {
  __typename?: 'FacilityIncidentCountConnection'
  edges?: Maybe<Array<FacilityIncidentCountEdge>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type FacilityIncidentCountEdge = {
  __typename?: 'FacilityIncidentCountEdge'
  cursor: Scalars['String']
  node?: Maybe<FacilityIncidentCount>
}

export type FacilityIncidentCount = {
  __typename?: 'FacilityIncidentCount'
  id: Scalars['ID']
  incidents: TotalCount
}

export type TotalCount = {
  __typename?: 'TotalCount'
  totalCount: Scalars['Int']
}

export type AiOperatorDeviceConfiguration = {
  __typename?: 'AiOperatorDeviceConfiguration'
  accessGrantedTimeThreshold: Scalars['Float']
  createdAt?: Maybe<Scalars['String']>
  deviceId: Scalars['ID']
  doorCloseTimeThreshold: Scalars['Float']
  doorForcedBounceTimeThreshold: Scalars['Float']
  id?: Maybe<Scalars['ID']>
  isDefault: Scalars['Boolean']
  updatedAt?: Maybe<Scalars['String']>
}

export type AiOperatorFieldFilterInput = {
  AND?: InputMaybe<Array<AiOperatorFieldFilterInput>>
  enabled?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<AiOperatorFieldFilterInput>>
  sourceType?: InputMaybe<AiOperatorFieldSourceType>
  type?: InputMaybe<AiOperatorFieldType>
}

export type AiOperatorFieldConnection = {
  __typename?: 'AiOperatorFieldConnection'
  edges?: Maybe<Array<Maybe<AiOperatorFieldEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type AiOperatorFieldEdge = {
  __typename?: 'AiOperatorFieldEdge'
  cursor: Scalars['String']
  node?: Maybe<AiOperatorField>
}

export type AiOperatorModelFilterInput = {
  AND?: InputMaybe<Array<AiOperatorModelFilterInput>>
  default?: InputMaybe<Scalars['Boolean']>
  enabled?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<AiOperatorModelFilterInput>>
  provider?: InputMaybe<AiOperatorModelProvider>
  providerIn?: InputMaybe<Array<AiOperatorModelProvider>>
}

export type AiOperatorModelConnection = {
  __typename?: 'AiOperatorModelConnection'
  edges?: Maybe<Array<Maybe<AiOperatorModelEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type AiOperatorModelEdge = {
  __typename?: 'AiOperatorModelEdge'
  cursor: Scalars['String']
  node: AiOperatorModel
}

export type AiOperatorReportInput = {
  /** End date (ISO 8601 date format: YYYY-MM-DD). Inclusive. */
  endDate?: InputMaybe<Scalars['String']>
  /** Optional: Specific field ID. If null, generates aggregated report for all criteria. */
  fieldId?: InputMaybe<Scalars['ID']>
  /** Filter scope for report generation. Defaults to ALL_RULES if not provided. */
  scope?: AiOperatorReportScope
  /** Start date (ISO 8601 date format: YYYY-MM-DD). Inclusive. */
  startDate?: InputMaybe<Scalars['String']>
}

export enum AiOperatorReportScope {
  /** Include all evaluations (default) */
  AllRules = 'ALL_RULES',
  /** Include only evaluations where wasDryRun = true */
  DryRunOnly = 'DRY_RUN_ONLY',
}

export type AiOperatorRuleEvaluationFilterInput = {
  AND?: InputMaybe<Array<AiOperatorRuleEvaluationFilterInput>>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  /** Filter by evaluation result. true = only resolutions (eval_is_true = true), false = only flags (eval_is_true = false). */
  evalIsTrue?: InputMaybe<Scalars['Boolean']>
  fieldId?: InputMaybe<Scalars['ID']>
  fieldIdIn?: InputMaybe<Array<Scalars['ID']>>
  hasHumanLabel?: InputMaybe<Scalars['Boolean']>
  /** Filter by video clip presence. true = only evaluations with a video clip attached, false = only evaluations without. */
  hasVideoClip?: InputMaybe<Scalars['Boolean']>
  /** Filter for synthetic/placeholder evaluations. true = only placeholders (evalIsTrue is null), false = only actual AI evaluations (evalIsTrue is not null) */
  isSynthetic?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<AiOperatorRuleEvaluationFilterInput>>
}

export type AiOperatorRuleEvaluationOrderInput = {
  direction: OrderDirection
  field: AiOperatorRuleEvaluationOrderField
}

export enum AiOperatorRuleEvaluationOrderField {
  CreatedAt = 'CREATED_AT',
}

export type AiOperatorRuleEvaluationConnection = {
  __typename?: 'AiOperatorRuleEvaluationConnection'
  edges?: Maybe<Array<AiOperatorRuleEvaluationEdge>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type AiOperatorRuleEvaluationEdge = {
  __typename?: 'AiOperatorRuleEvaluationEdge'
  cursor: Scalars['String']
  node?: Maybe<AiOperatorRuleEvaluation>
}

export type AiOperatorSettingsHistoryFilterInput = {
  AND?: InputMaybe<Array<AiOperatorSettingsHistoryFilterInput>>
  OR?: InputMaybe<Array<AiOperatorSettingsHistoryFilterInput>>
  settingKey?: InputMaybe<AiOperatorSettingKey>
  userId?: InputMaybe<Scalars['ID']>
}

export enum AiOperatorSettingKey {
  AccessGrantedTimeThreshold = 'ACCESS_GRANTED_TIME_THRESHOLD',
  DoorCloseTimeThreshold = 'DOOR_CLOSE_TIME_THRESHOLD',
  DoorForcedBounceTimeThreshold = 'DOOR_FORCED_BOUNCE_TIME_THRESHOLD',
  Enabled = 'ENABLED',
  MonthlyLimit = 'MONTHLY_LIMIT',
}

export type AiOperatorSettingsHistoryConnection = {
  __typename?: 'AiOperatorSettingsHistoryConnection'
  edges?: Maybe<Array<Maybe<AiOperatorSettingsHistory>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type AiOperatorSettingsHistory = {
  __typename?: 'AiOperatorSettingsHistory'
  createdAt: Scalars['String']
  id: Scalars['ID']
  newValue: Scalars['String']
  oldValue?: Maybe<Scalars['String']>
  settingKey: AiOperatorSettingKey
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type AlarmFilterInput = {
  alarmTypeId?: InputMaybe<Scalars['ID']>
}

export type AlarmConnection = {
  __typename?: 'AlarmConnection'
  edges?: Maybe<Array<Maybe<AlarmEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type AlarmEdge = {
  __typename?: 'AlarmEdge'
  cursor: Scalars['String']
  node?: Maybe<Alarm>
}

/** *Automatically generated.* */
export type AlertFilterInput = {
  AND?: InputMaybe<Array<AlertFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<AlertFilterInput>>
  priority?: InputMaybe<AlertPriority>
  priorityIn?: InputMaybe<Array<AlertPriority>>
  priorityNot?: InputMaybe<AlertPriority>
  priorityNotIn?: InputMaybe<Array<AlertPriority>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

export enum AlertPriority {
  Placeholder = 'PLACEHOLDER',
}

/** *Automatically generated.* */
export type AlertOrderInput = {
  direction: OrderDirection
  field: AlertOrderField
}

/** *Automatically generated.* */
export enum AlertOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Incident = 'INCIDENT',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type AlertConnection = {
  __typename?: 'AlertConnection'
  edges?: Maybe<Array<Maybe<AlertEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type AlertEdge = {
  __typename?: 'AlertEdge'
  cursor: Scalars['String']
  node?: Maybe<Alert>
}

export type Alert = {
  __typename?: 'Alert'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id: Scalars['ID']
  incidentId: Scalars['ID']
  priority?: Maybe<AlertPriority>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type AudioClipFilterInput = {
  AND?: InputMaybe<Array<AudioClipFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  endTime?: InputMaybe<Scalars['String']>
  endTimeGt?: InputMaybe<Scalars['String']>
  endTimeGte?: InputMaybe<Scalars['String']>
  endTimeIn?: InputMaybe<Array<Scalars['String']>>
  endTimeLike?: InputMaybe<Scalars['String']>
  endTimeLt?: InputMaybe<Scalars['String']>
  endTimeLte?: InputMaybe<Scalars['String']>
  endTimeNot?: InputMaybe<Scalars['String']>
  endTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  externalId?: InputMaybe<Scalars['String']>
  externalIdGt?: InputMaybe<Scalars['String']>
  externalIdGte?: InputMaybe<Scalars['String']>
  externalIdIn?: InputMaybe<Array<Scalars['String']>>
  externalIdLike?: InputMaybe<Scalars['String']>
  externalIdLt?: InputMaybe<Scalars['String']>
  externalIdLte?: InputMaybe<Scalars['String']>
  externalIdNot?: InputMaybe<Scalars['String']>
  externalIdNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<AudioClipFilterInput>>
  startTime?: InputMaybe<Scalars['String']>
  startTimeGt?: InputMaybe<Scalars['String']>
  startTimeGte?: InputMaybe<Scalars['String']>
  startTimeIn?: InputMaybe<Array<Scalars['String']>>
  startTimeLike?: InputMaybe<Scalars['String']>
  startTimeLt?: InputMaybe<Scalars['String']>
  startTimeLte?: InputMaybe<Scalars['String']>
  startTimeNot?: InputMaybe<Scalars['String']>
  startTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  url?: InputMaybe<Scalars['String']>
  urlGt?: InputMaybe<Scalars['String']>
  urlGte?: InputMaybe<Scalars['String']>
  urlIn?: InputMaybe<Array<Scalars['String']>>
  urlLike?: InputMaybe<Scalars['String']>
  urlLt?: InputMaybe<Scalars['String']>
  urlLte?: InputMaybe<Scalars['String']>
  urlNot?: InputMaybe<Scalars['String']>
  urlNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type AudioClipOrderInput = {
  direction: OrderDirection
  field: AudioClipOrderField
}

/** *Automatically generated.* */
export enum AudioClipOrderField {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  EndTime = 'END_TIME',
  ExternalId = 'EXTERNAL_ID',
  FacilityId = 'FACILITY_ID',
  Id = 'ID',
  IncidentId = 'INCIDENT_ID',
  StartTime = 'START_TIME',
  UpdatedAt = 'UPDATED_AT',
  Url = 'URL',
}

/** *Automatically generated.* */
export type AudioClipConnection = {
  __typename?: 'AudioClipConnection'
  edges?: Maybe<Array<Maybe<AudioClipEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type AudioClipEdge = {
  __typename?: 'AudioClipEdge'
  cursor: Scalars['String']
  node?: Maybe<AudioClip>
}

export type CameraLiveFeedDetail = {
  __typename?: 'CameraLiveFeedDetail'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  externalId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  rtspIp?: Maybe<Scalars['String']>
  rtspPath?: Maybe<Scalars['String']>
  rtspPort?: Maybe<Scalars['Int']>
  streamingProtocol?: Maybe<StreamingProtocol>
  streamingResolutionHeight?: Maybe<Scalars['Int']>
  streamingResolutionWidth?: Maybe<Scalars['Int']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type CameraLiveFeedDetailFilterInput = {
  AND?: InputMaybe<Array<CameraLiveFeedDetailFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  externalId?: InputMaybe<Scalars['String']>
  externalIdGt?: InputMaybe<Scalars['String']>
  externalIdGte?: InputMaybe<Scalars['String']>
  externalIdIn?: InputMaybe<Array<Scalars['String']>>
  externalIdLike?: InputMaybe<Scalars['String']>
  externalIdLt?: InputMaybe<Scalars['String']>
  externalIdLte?: InputMaybe<Scalars['String']>
  externalIdNot?: InputMaybe<Scalars['String']>
  externalIdNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<CameraLiveFeedDetailFilterInput>>
  rtspIp?: InputMaybe<Scalars['String']>
  rtspIpGt?: InputMaybe<Scalars['String']>
  rtspIpGte?: InputMaybe<Scalars['String']>
  rtspIpIn?: InputMaybe<Array<Scalars['String']>>
  rtspIpLike?: InputMaybe<Scalars['String']>
  rtspIpLt?: InputMaybe<Scalars['String']>
  rtspIpLte?: InputMaybe<Scalars['String']>
  rtspIpNot?: InputMaybe<Scalars['String']>
  rtspIpNotIn?: InputMaybe<Array<Scalars['String']>>
  rtspPath?: InputMaybe<Scalars['String']>
  rtspPathGt?: InputMaybe<Scalars['String']>
  rtspPathGte?: InputMaybe<Scalars['String']>
  rtspPathIn?: InputMaybe<Array<Scalars['String']>>
  rtspPathLike?: InputMaybe<Scalars['String']>
  rtspPathLt?: InputMaybe<Scalars['String']>
  rtspPathLte?: InputMaybe<Scalars['String']>
  rtspPathNot?: InputMaybe<Scalars['String']>
  rtspPathNotIn?: InputMaybe<Array<Scalars['String']>>
  rtspPort?: InputMaybe<Scalars['Int']>
  rtspPortGt?: InputMaybe<Scalars['Int']>
  rtspPortGte?: InputMaybe<Scalars['Int']>
  rtspPortIn?: InputMaybe<Array<Scalars['Int']>>
  rtspPortLike?: InputMaybe<Scalars['Int']>
  rtspPortLt?: InputMaybe<Scalars['Int']>
  rtspPortLte?: InputMaybe<Scalars['Int']>
  rtspPortNot?: InputMaybe<Scalars['Int']>
  rtspPortNotIn?: InputMaybe<Array<Scalars['Int']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type CameraLiveFeedDetailOrderInput = {
  direction: OrderDirection
  field: CameraLiveFeedDetailOrderField
}

/** *Automatically generated.* */
export enum CameraLiveFeedDetailOrderField {
  CreatedAt = 'CREATED_AT',
  ExternalId = 'EXTERNAL_ID',
  Id = 'ID',
  RtspIp = 'RTSP_IP',
  RtspPath = 'RTSP_PATH',
  RtspPort = 'RTSP_PORT',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type CameraLiveFeedDetailConnection = {
  __typename?: 'CameraLiveFeedDetailConnection'
  edges?: Maybe<Array<Maybe<CameraLiveFeedDetailEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type CameraLiveFeedDetailEdge = {
  __typename?: 'CameraLiveFeedDetailEdge'
  cursor: Scalars['String']
  node?: Maybe<CameraLiveFeedDetail>
}

export type CameraWithEdgeDevice = {
  __typename?: 'CameraWithEdgeDevice'
  camera: Camera
  edgeDevice?: Maybe<EdgeDevice>
  tailgateGrid?: Maybe<TailgateGrid>
}

export type Case = {
  __typename?: 'Case'
  actions?: Maybe<CaseActionConnection>
  createdAt: Scalars['String']
  createdBy: Scalars['ID']
  description: Scalars['String']
  detailedReport?: Maybe<Scalars['String']>
  displayId: Scalars['String']
  facilities: Array<Facility>
  facilityIds?: Maybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  incidentIds?: Maybe<Array<Scalars['ID']>>
  incidents?: Maybe<IncidentConnection>
  name: Scalars['String']
  owner?: Maybe<User>
  ownerId: Scalars['ID']
  personsOfInterest?: Maybe<CaseAssociatedPersonOfInterestConnection>
  personsOfInterestIds?: Maybe<Array<Scalars['ID']>>
  status: CaseStatus
  updatedAt?: Maybe<Scalars['String']>
  updatedBy?: Maybe<Scalars['ID']>
}

export type CaseActionsArgs = {
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type CaseIncidentsArgs = {
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type CasePersonsOfInterestArgs = {
  filter?: InputMaybe<PersonOfInterestFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PersonOfInterestOrderInput>>
}

export type CaseActionConnection = {
  __typename?: 'CaseActionConnection'
  edges?: Maybe<Array<Maybe<CaseActionEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CaseActionEdge = {
  __typename?: 'CaseActionEdge'
  cursor: Scalars['String']
  node?: Maybe<CaseAction>
}

export type CaseAction = {
  __typename?: 'CaseAction'
  caseId: Scalars['ID']
  comment?: Maybe<CaseComment>
  createdAt: Scalars['String']
  createdBy: Scalars['ID']
  creator?: Maybe<User>
  id: Scalars['ID']
  personOfInterestRoleUpdateDetail?: Maybe<CaseActionPersonOfInterestUpdate>
  referenceId: Array<Scalars['ID']>
  type: CaseActionType
  updatedAt: Scalars['String']
  updatedBy?: Maybe<Scalars['ID']>
}

export type CaseComment = {
  __typename?: 'CaseComment'
  caseId: Scalars['ID']
  createdAt: Scalars['String']
  createdBy: Scalars['ID']
  id: Scalars['ID']
  message: Scalars['String']
  updatedAt: Scalars['String']
  updatedBy?: Maybe<Scalars['ID']>
}

export type CaseActionPersonOfInterestUpdate = {
  __typename?: 'CaseActionPersonOfInterestUpdate'
  caseAction?: Maybe<CaseAction>
  id: Scalars['ID']
  newRole?: Maybe<CaseRole>
  newRoleCustomDescription?: Maybe<Scalars['String']>
  oldRole?: Maybe<CaseRole>
  oldRoleCustomDescription?: Maybe<Scalars['String']>
  personOfInterest?: Maybe<PersonOfInterest>
}

export enum CaseRole {
  Other = 'OTHER',
  Reporter = 'REPORTER',
  Subject = 'SUBJECT',
  Victim = 'VICTIM',
  Witness = 'WITNESS',
}

export type PersonOfInterest = {
  __typename?: 'PersonOfInterest'
  address?: Maybe<Array<Scalars['String']>>
  caseIds?: Maybe<Array<Scalars['ID']>>
  cases?: Maybe<PersonOfInterestAssociatedCaseConnection>
  companyAffiliation: CompanyAffiliation
  createdAt: Scalars['String']
  customCompanyAffiliationDescription?: Maybe<Scalars['String']>
  dateOfBirth?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  id: Scalars['ID']
  lastName: Scalars['String']
  phoneNumber?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
}

export type PersonOfInterestAssociatedCaseConnection = {
  __typename?: 'PersonOfInterestAssociatedCaseConnection'
  edges?: Maybe<Array<PersonOfInterestAssociatedCaseEdge>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PersonOfInterestAssociatedCaseEdge = {
  __typename?: 'PersonOfInterestAssociatedCaseEdge'
  cursor: Scalars['String']
  node?: Maybe<PersonOfInterestAssociatedCase>
}

export type PersonOfInterestAssociatedCase = {
  __typename?: 'PersonOfInterestAssociatedCase'
  case: Case
  caseRole: CaseRole
  customCaseRoleDescription?: Maybe<Scalars['String']>
}

export enum CompanyAffiliation {
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE',
  Guest = 'GUEST',
  Other = 'OTHER',
}

export enum CaseActionType {
  AddComment = 'ADD_COMMENT',
  AddFile = 'ADD_FILE',
  AssignOwner = 'ASSIGN_OWNER',
  AssociateIncident = 'ASSOCIATE_INCIDENT',
  AssociatePerson = 'ASSOCIATE_PERSON',
  Close = 'CLOSE',
  DisassociateIncident = 'DISASSOCIATE_INCIDENT',
  DisassociatePerson = 'DISASSOCIATE_PERSON',
  Open = 'OPEN',
  UpdatePersonOfInterestRole = 'UPDATE_PERSON_OF_INTEREST_ROLE',
}

export type PersonOfInterestFilterInput = {
  AND?: InputMaybe<Array<PersonOfInterestFilterInput>>
  caseId?: InputMaybe<Scalars['ID']>
  caseIdNot?: InputMaybe<Scalars['ID']>
  emailLike?: InputMaybe<Scalars['String']>
  nameLike?: InputMaybe<Scalars['String']>
  OR?: InputMaybe<Array<PersonOfInterestFilterInput>>
}

export type PersonOfInterestOrderInput = {
  direction: OrderDirection
  field: PersonOfInterestOrderField
}

export enum PersonOfInterestOrderField {
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
}

export type CaseAssociatedPersonOfInterestConnection = {
  __typename?: 'CaseAssociatedPersonOfInterestConnection'
  edges?: Maybe<Array<CaseAssociatedPersonOfInterestEdge>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CaseAssociatedPersonOfInterestEdge = {
  __typename?: 'CaseAssociatedPersonOfInterestEdge'
  cursor: Scalars['String']
  node?: Maybe<CaseAssociatedPersonOfInterest>
}

export type CaseAssociatedPersonOfInterest = {
  __typename?: 'CaseAssociatedPersonOfInterest'
  caseRole: CaseRole
  customCaseRoleDescription?: Maybe<Scalars['String']>
  personOfInterest: PersonOfInterest
}

export enum CaseStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
}

export type CaseFilterInput = {
  AND?: InputMaybe<Array<CaseFilterInput>>
  displayId?: InputMaybe<Scalars['String']>
  displayIdLike?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<CaseFilterInput>>
  ownerId?: InputMaybe<Scalars['ID']>
  ownerIdIn?: InputMaybe<Array<Scalars['ID']>>
  ownerIdNot?: InputMaybe<Scalars['ID']>
  ownerIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<CaseStatus>
  statusIn?: InputMaybe<Array<CaseStatus>>
  statusNot?: InputMaybe<CaseStatus>
  statusNotIn?: InputMaybe<Array<CaseStatus>>
}

export type CaseConnection = {
  __typename?: 'CaseConnection'
  edges?: Maybe<Array<Maybe<CaseEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CaseEdge = {
  __typename?: 'CaseEdge'
  cursor: Scalars['String']
  node?: Maybe<Case>
}

/** *Automatically generated.* */
export type ChargeFilterInput = {
  amount?: InputMaybe<Scalars['Int']>
  amountGt?: InputMaybe<Scalars['Int']>
  amountGte?: InputMaybe<Scalars['Int']>
  amountIn?: InputMaybe<Array<Scalars['Int']>>
  amountLike?: InputMaybe<Scalars['Int']>
  amountLt?: InputMaybe<Scalars['Int']>
  amountLte?: InputMaybe<Scalars['Int']>
  amountNot?: InputMaybe<Scalars['Int']>
  amountNotIn?: InputMaybe<Array<Scalars['Int']>>
  AND?: InputMaybe<Array<ChargeFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<ChargeFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type ChargeOrderInput = {
  direction: OrderDirection
  field: ChargeOrderField
}

/** *Automatically generated.* */
export enum ChargeOrderField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type ChargeConnection = {
  __typename?: 'ChargeConnection'
  edges?: Maybe<Array<Maybe<ChargeEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type ChargeEdge = {
  __typename?: 'ChargeEdge'
  cursor: Scalars['String']
  node?: Maybe<Charge>
}

export type Charge = {
  __typename?: 'Charge'
  /** The unit is the cent. */
  amount?: Maybe<Scalars['Int']>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id?: Maybe<Scalars['ID']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type CheckpointTaskConnection = {
  __typename?: 'CheckpointTaskConnection'
  edges?: Maybe<Array<Maybe<CheckpointTaskEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CheckpointTaskEdge = {
  __typename?: 'CheckpointTaskEdge'
  cursor: Scalars['String']
  node?: Maybe<CheckpointTask>
}

export type EventFilterInput = {
  AND?: InputMaybe<Array<EventFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  detectedAt?: InputMaybe<Scalars['String']>
  detectedAtGt?: InputMaybe<Scalars['String']>
  detectedAtGte?: InputMaybe<Scalars['String']>
  detectedAtLt?: InputMaybe<Scalars['String']>
  detectedAtLte?: InputMaybe<Scalars['String']>
  deviceId?: InputMaybe<Scalars['ID']>
  facilityId?: InputMaybe<Scalars['ID']>
  OR?: InputMaybe<Array<EventFilterInput>>
  type?: InputMaybe<EventType>
  typeIn?: InputMaybe<Array<EventType>>
  typeNot?: InputMaybe<EventType>
  typeNotIn?: InputMaybe<Array<EventType>>
}

export enum EventType {
  Alarm = 'ALARM',
  DeviceHealth = 'DEVICE_HEALTH',
  DeviceOffline = 'DEVICE_OFFLINE',
  DoorHeldClose = 'DOOR_HELD_CLOSE',
  DoorHeldOpen = 'DOOR_HELD_OPEN',
  DoorOpenAlarm = 'DOOR_OPEN_ALARM',
  /**
   * Represents normalized door-unlocked/access-granted event from various ACS
   * [ENG-21426](https://hivewatch.atlassian.net/browse/ENG-21426)
   */
  DoorUnlocked = 'DOOR_UNLOCKED',
  ForcedEntry = 'FORCED_ENTRY',
  LineCrossing = 'LINE_CROSSING',
  NonTailgating = 'NON_TAILGATING',
  /**
   * Represents other ACS-specific event types that are not normalized in HiveWatch system
   * [ENG-21426](https://hivewatch.atlassian.net/browse/ENG-21426)
   */
  Other = 'OTHER',
  Tailgating = 'TAILGATING',
}

export type EventOrderInput = {
  direction: OrderDirection
  field: EventOrderField
}

export enum EventOrderField {
  DetectedAt = 'DETECTED_AT',
}

/** *Automatically generated.* */
export type EventConnection = {
  __typename?: 'EventConnection'
  edges?: Maybe<Array<Maybe<EventEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type EventEdge = {
  __typename?: 'EventEdge'
  cursor: Scalars['String']
  node?: Maybe<Event>
}

/**
 * An observation by a computer system.
 * Includes an observation of a fault,
 * security threat, intrusion attempt, or security breach.
 * Also includes harmless observations such as temperature readings.
 *
 * *Some HiveWatch writings give a much broader
 * definition to the word 'event'.
 * (See the
 * [definition](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Glossary?pageVersion=23#Event)
 * in the glossary.)
 * It is possible that this type will be renamed,
 * or have its meaning broadened.*
 */
export type Event = {
  __typename?: 'Event'
  acsEventType?: Maybe<Scalars['String']>
  badgeNumber?: Maybe<Scalars['String']>
  cardHolderName?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  /** A JSON object. */
  details?: Maybe<Scalars['String']>
  detectedAt: Scalars['String']
  /**
   * There is always at least one device.
   *
   * A tailgate event is
   * an example of an event with more than one
   * device.
   */
  deviceIds: Array<Scalars['ID']>
  devices?: Maybe<Array<Maybe<Device>>>
  eventFeatures?: Maybe<Array<Scalars['String']>>
  externalId?: Maybe<Scalars['ID']>
  facility?: Maybe<Facility>
  facilityId: Scalars['ID']
  floor?: Maybe<Floor>
  floorId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  incident?: Maybe<Incident>
  incidentId?: Maybe<Scalars['ID']>
  normalizedType?: Maybe<Scalars['String']>
  type?: Maybe<EventType>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  video?: Maybe<StreamingUrlWrapperInterface>
}

/**
 * An observation by a computer system.
 * Includes an observation of a fault,
 * security threat, intrusion attempt, or security breach.
 * Also includes harmless observations such as temperature readings.
 *
 * *Some HiveWatch writings give a much broader
 * definition to the word 'event'.
 * (See the
 * [definition](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Glossary?pageVersion=23#Event)
 * in the glossary.)
 * It is possible that this type will be renamed,
 * or have its meaning broadened.*
 */
export type EventVideoArgs = {
  offsetAfter?: InputMaybe<Scalars['Float']>
  offsetBefore?: InputMaybe<Scalars['Float']>
}

export type CustomerSecretProviderFilterInput = {
  providerAccountId?: InputMaybe<Scalars['String']>
  providerRegion?: InputMaybe<Scalars['String']>
}

export type CustomerSecretProviderOrderInput = {
  direction: OrderDirection
  field: CustomerSecretProviderOrderField
}

export enum CustomerSecretProviderOrderField {
  CreatedAt = 'CREATED_AT',
  ProviderAccountId = 'PROVIDER_ACCOUNT_ID',
  ProviderRegion = 'PROVIDER_REGION',
}

export type CustomerSecretProviderConnection = {
  __typename?: 'CustomerSecretProviderConnection'
  edges?: Maybe<Array<Maybe<CustomerSecretProviderEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CustomerSecretProviderEdge = {
  __typename?: 'CustomerSecretProviderEdge'
  cursor: Scalars['String']
  node?: Maybe<CustomerSecretProvider>
}

export type CustomFormConnection = {
  __typename?: 'CustomFormConnection'
  edges: Array<CustomFormEdge>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type CustomFormEdge = {
  __typename?: 'CustomFormEdge'
  cursor: Scalars['String']
  node: CustomForm
}

export type DefaultAiOperatorModelPayload = {
  __typename?: 'DefaultAiOperatorModelPayload'
  aiOperatorModel?: Maybe<AiOperatorModel>
}

/** *Automatically generated.* */
export type DeviceGroupConnection = {
  __typename?: 'DeviceGroupConnection'
  edges?: Maybe<Array<Maybe<DeviceGroupEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type DeviceGroupEdge = {
  __typename?: 'DeviceGroupEdge'
  cursor: Scalars['String']
  node?: Maybe<DeviceGroupNode>
}

/** *Automatically generated.* */
export type DeviceGroupNode = {
  __typename?: 'DeviceGroupNode'
  avg?: Maybe<DeviceGroupAvg>
  count?: Maybe<Scalars['Int']>
  dimensions?: Maybe<DeviceGroupDimension>
  sum?: Maybe<DeviceGroupSum>
  uniq?: Maybe<DeviceGroupUniq>
}

/** *Automatically generated.* */
export type DeviceGroupAvg = {
  __typename?: 'DeviceGroupAvg'
  bearing?: Maybe<Scalars['Float']>
  fieldOfView?: Maybe<Scalars['Float']>
  visibilityRange?: Maybe<Scalars['Float']>
  x?: Maybe<Scalars['Float']>
  y?: Maybe<Scalars['Float']>
}

/**
 * *Automatically generated.*
 *
 * Any fields selected on this type will be used for aggregation.
 * (This is like `GROUP BY` in SQL.)
 */
export type DeviceGroupDimension = {
  __typename?: 'DeviceGroupDimension'
  bearing?: Maybe<Scalars['Float']>
  createdAt?: Maybe<Scalars['String']>
  facilityId?: Maybe<Scalars['ID']>
  fieldOfView?: Maybe<Scalars['Float']>
  floorId?: Maybe<Scalars['ID']>
  floorPlanId?: Maybe<Scalars['ID']>
  gatewayId?: Maybe<Scalars['ID']>
  isPlaced?: Maybe<Scalars['Boolean']>
  macAddress?: Maybe<Scalars['String']>
  manufacturerName?: Maybe<Scalars['String']>
  modelName?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  status?: Maybe<DeviceStatus>
  type?: Maybe<DeviceType>
  updatedAt?: Maybe<Scalars['String']>
  visibilityRange?: Maybe<Scalars['Float']>
  x?: Maybe<Scalars['Float']>
  y?: Maybe<Scalars['Float']>
}

/** *Automatically generated.* */
export type DeviceGroupSum = {
  __typename?: 'DeviceGroupSum'
  bearing?: Maybe<Scalars['Float']>
  fieldOfView?: Maybe<Scalars['Float']>
  visibilityRange?: Maybe<Scalars['Float']>
  x?: Maybe<Scalars['Float']>
  y?: Maybe<Scalars['Float']>
}

/**
 * *Automatically generated.*
 *
 * Each field of this type is a count of the number of distinct
 * values of another field: a field of the same name on the
 * generating type.
 */
export type DeviceGroupUniq = {
  __typename?: 'DeviceGroupUniq'
  bearing?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['Int']>
  facilityId?: Maybe<Scalars['Int']>
  fieldOfView?: Maybe<Scalars['Int']>
  floorId?: Maybe<Scalars['Int']>
  floorPlanId?: Maybe<Scalars['Int']>
  gatewayId?: Maybe<Scalars['Int']>
  isPlaced?: Maybe<Scalars['Int']>
  macAddress?: Maybe<Scalars['Int']>
  manufacturerName?: Maybe<Scalars['Int']>
  modelName?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['Int']>
  status?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['Int']>
  updatedAt?: Maybe<Scalars['Int']>
  visibilityRange?: Maybe<Scalars['Int']>
  x?: Maybe<Scalars['Int']>
  y?: Maybe<Scalars['Int']>
}

export type DeviceLogOrderInput = {
  direction: OrderDirection
  field: DeviceLogOrderField
}

export enum DeviceLogOrderField {
  CreatedAt = 'CREATED_AT',
}

export type DeviceLogConnection = {
  __typename?: 'DeviceLogConnection'
  edges?: Maybe<Array<Maybe<DeviceLogEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type DeviceLogEdge = {
  __typename?: 'DeviceLogEdge'
  cursor: Scalars['String']
  node?: Maybe<DeviceLog>
}

export type DeviceLog = {
  createdAt: Scalars['String']
  device?: Maybe<Device>
  deviceId: Scalars['ID']
  id: Scalars['ID']
  message: Scalars['String']
  type: DeviceLogItemType
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

export enum DeviceLogItemType {
  ConfigurationChange = 'CONFIGURATION_CHANGE',
  Note = 'NOTE',
}

export type EdgeDeviceFilterInput = {
  nameLike?: InputMaybe<Scalars['String']>
}

export type EdgeDeviceOrderInput = {
  direction: OrderDirection
  field: EdgeDeviceOrderField
}

export enum EdgeDeviceOrderField {
  Name = 'NAME',
}

export type EdgeDeviceConnection = {
  __typename?: 'EdgeDeviceConnection'
  edges?: Maybe<Array<Maybe<EdgeDeviceEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type EdgeDeviceEdge = {
  __typename?: 'EdgeDeviceEdge'
  cursor: Scalars['String']
  node?: Maybe<EdgeDevice>
}

/** An alarm system that sends email. Emails sent to its Ingest Address are attributed to its Facility. */
export type EmailSource = {
  __typename?: 'EmailSource'
  /**
   * Senders allowed to create incidents through this source, trimmed and lowercased. Each is an exact address
   * (panel@alarm-vendor.com) or a whole domain (@alarm-vendor.com). Compare a sender's address against these
   * case-insensitively.
   */
  allowedSenders: Array<Scalars['String']>
  createdAt: Scalars['String']
  /** A disabled source keeps its Ingest Address, but its emails don't create incidents. */
  enabled: Scalars['Boolean']
  facility?: Maybe<Facility>
  facilityId: Scalars['ID']
  id: Scalars['ID']
  /** Generated, non-guessable address the alarm system sends email to. Treat it as a secret. */
  ingestAddress: Scalars['String']
  name: Scalars['String']
  updatedAt: Scalars['String']
}

/** The parts of an Email Source the Email Worker needs to route an email. */
export type EmailSourceResolution = {
  __typename?: 'EmailSourceResolution'
  /** Exact addresses or whole @domains, trimmed, lowercased and sorted. */
  allowedSenders: Array<Scalars['String']>
  enabled: Scalars['Boolean']
  id: Scalars['ID']
}

export type EmailSourceConnection = {
  __typename?: 'EmailSourceConnection'
  edges?: Maybe<Array<Maybe<EmailSourceEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type EmailSourceEdge = {
  __typename?: 'EmailSourceEdge'
  cursor: Scalars['String']
  node?: Maybe<EmailSource>
}

/** Short-lived token used to authenticate Emergency Calling SDKs. */
export type EmergencyCallingAccessToken = {
  __typename?: 'EmergencyCallingAccessToken'
  token: Scalars['String']
}

/** *Automatically generated.* */
export type EventPresentationConnection = {
  __typename?: 'EventPresentationConnection'
  edges?: Maybe<Array<Maybe<EventPresentationEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type EventPresentationEdge = {
  __typename?: 'EventPresentationEdge'
  cursor: Scalars['String']
  node?: Maybe<EventPresentation>
}

export type EventPresentation = {
  __typename?: 'EventPresentation'
  acsEventType?: Maybe<Scalars['String']>
  badgeNumber?: Maybe<Scalars['String']>
  cardHolderName?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  detectedAt: Scalars['String']
  deviceId?: Maybe<Scalars['ID']>
  deviceName?: Maybe<Scalars['String']>
  deviceType?: Maybe<DeviceType>
  eventFeatures?: Maybe<Array<Scalars['String']>>
  externalId?: Maybe<Scalars['String']>
  facilityId: Scalars['ID']
  normalizedType?: Maybe<Scalars['String']>
  type?: Maybe<EventType>
  updatedAt: Scalars['String']
}

export type ExternalAccountApiKeyConnection = {
  __typename?: 'ExternalAccountApiKeyConnection'
  edges?: Maybe<Array<Maybe<ExternalAccountApiKeyEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type ExternalAccountApiKeyEdge = {
  __typename?: 'ExternalAccountApiKeyEdge'
  cursor: Scalars['String']
  node?: Maybe<ExternalAccountApiKey>
}

export type ExternalAccountPropertyDefinition = {
  __typename?: 'ExternalAccountPropertyDefinition'
  allowedValues: Array<ExternalAccountPropertyValueOption>
  defaultValue?: Maybe<Scalars['String']>
  description: Scalars['String']
  key: Scalars['String']
  valueType: ExternalAccountPropertyValueType
}

export type ExternalAccountPropertyValueOption = {
  __typename?: 'ExternalAccountPropertyValueOption'
  label: Scalars['String']
  value: Scalars['String']
}

export enum ExternalAccountPropertyValueType {
  String = 'STRING',
}

export type ExternalAccountConnection = {
  __typename?: 'ExternalAccountConnection'
  edges?: Maybe<Array<Maybe<ExternalAccountEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type ExternalAccountEdge = {
  __typename?: 'ExternalAccountEdge'
  cursor: Scalars['String']
  node?: Maybe<ExternalAccount>
}

/** *Automatically generated.* */
export type FacilityFilterInput = {
  addressContain?: InputMaybe<Scalars['String']>
  addressDoNotContain?: InputMaybe<Scalars['String']>
  addressLike?: InputMaybe<Scalars['String']>
  addressNull?: InputMaybe<Scalars['Boolean']>
  AND?: InputMaybe<Array<FacilityFilterInput>>
  archived?: InputMaybe<Scalars['Boolean']>
  box?: InputMaybe<GeoFenceBoxInput>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  includeArchived?: InputMaybe<Scalars['Boolean']>
  latitude?: InputMaybe<Scalars['Float']>
  latitudeGt?: InputMaybe<Scalars['Float']>
  latitudeGte?: InputMaybe<Scalars['Float']>
  latitudeIn?: InputMaybe<Array<Scalars['Float']>>
  latitudeLike?: InputMaybe<Scalars['Float']>
  latitudeLt?: InputMaybe<Scalars['Float']>
  latitudeLte?: InputMaybe<Scalars['Float']>
  latitudeNot?: InputMaybe<Scalars['Float']>
  latitudeNotIn?: InputMaybe<Array<Scalars['Float']>>
  longitude?: InputMaybe<Scalars['Float']>
  longitudeGt?: InputMaybe<Scalars['Float']>
  longitudeGte?: InputMaybe<Scalars['Float']>
  longitudeIn?: InputMaybe<Array<Scalars['Float']>>
  longitudeLike?: InputMaybe<Scalars['Float']>
  longitudeLt?: InputMaybe<Scalars['Float']>
  longitudeLte?: InputMaybe<Scalars['Float']>
  longitudeNot?: InputMaybe<Scalars['Float']>
  longitudeNotIn?: InputMaybe<Array<Scalars['Float']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<FacilityFilterInput>>
  shortName?: InputMaybe<Scalars['String']>
  shortNameGt?: InputMaybe<Scalars['String']>
  shortNameGte?: InputMaybe<Scalars['String']>
  shortNameIn?: InputMaybe<Array<Scalars['String']>>
  shortNameLike?: InputMaybe<Scalars['String']>
  shortNameLt?: InputMaybe<Scalars['String']>
  shortNameLte?: InputMaybe<Scalars['String']>
  shortNameNot?: InputMaybe<Scalars['String']>
  shortNameNotIn?: InputMaybe<Array<Scalars['String']>>
  timeZone?: InputMaybe<Scalars['String']>
  type?: InputMaybe<FacilityType>
  typeIn?: InputMaybe<Array<FacilityType>>
  typeNot?: InputMaybe<FacilityType>
  typeNotIn?: InputMaybe<Array<FacilityType>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

export type GeoFenceBoxInput = {
  northEastLatitude: Scalars['Float']
  northEastLongitude: Scalars['Float']
  southWestLatitude: Scalars['Float']
  southWestLongitude: Scalars['Float']
}

/** *Automatically generated.* */
export type FacilityOrderInput = {
  direction: OrderDirection
  field: FacilityOrderField
}

/** *Automatically generated.* */
export enum FacilityOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Latitude = 'LATITUDE',
  Longitude = 'LONGITUDE',
  Name = 'NAME',
  ShortName = 'SHORT_NAME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type FacilityConnection = {
  __typename?: 'FacilityConnection'
  edges?: Maybe<Array<Maybe<FacilityEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type FacilityEdge = {
  __typename?: 'FacilityEdge'
  cursor: Scalars['String']
  node?: Maybe<Facility>
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  name?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

/** *Automatically generated.* */
export type FloorGroupConnection = {
  __typename?: 'FloorGroupConnection'
  edges?: Maybe<Array<Maybe<FloorGroupEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type FloorGroupEdge = {
  __typename?: 'FloorGroupEdge'
  cursor: Scalars['String']
  node?: Maybe<FloorGroupNode>
}

/** *Automatically generated.* */
export type FloorGroupNode = {
  __typename?: 'FloorGroupNode'
  count?: Maybe<Scalars['Int']>
  dimensions?: Maybe<FloorGroupDimension>
  uniq?: Maybe<FloorGroupUniq>
}

/**
 * *Automatically generated.*
 *
 * Any fields selected on this type will be used for aggregation.
 * (This is like `GROUP BY` in SQL.)
 */
export type FloorGroupDimension = {
  __typename?: 'FloorGroupDimension'
  createdAt?: Maybe<Scalars['String']>
  facilityId?: Maybe<Scalars['ID']>
  floorPlanId?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
}

/**
 * *Automatically generated.*
 *
 * Each field of this type is a count of the number of distinct
 * values of another field: a field of the same name on the
 * generating type.
 */
export type FloorGroupUniq = {
  __typename?: 'FloorGroupUniq'
  createdAt?: Maybe<Scalars['Int']>
  facilityId?: Maybe<Scalars['Int']>
  floorPlanId?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['Int']>
  updatedAt?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type FloorPlanFilterInput = {
  AND?: InputMaybe<Array<FloorPlanFilterInput>>
  archived?: InputMaybe<Scalars['Boolean']>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  floorId?: InputMaybe<Scalars['ID']>
  floorIdIn?: InputMaybe<Array<Scalars['ID']>>
  floorIdNot?: InputMaybe<Scalars['ID']>
  floorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<FloorPlanFilterInput>>
  s3Key?: InputMaybe<Scalars['String']>
  s3KeyGt?: InputMaybe<Scalars['String']>
  s3KeyGte?: InputMaybe<Scalars['String']>
  s3KeyIn?: InputMaybe<Array<Scalars['String']>>
  s3KeyLike?: InputMaybe<Scalars['String']>
  s3KeyLt?: InputMaybe<Scalars['String']>
  s3KeyLte?: InputMaybe<Scalars['String']>
  s3KeyNot?: InputMaybe<Scalars['String']>
  s3KeyNotIn?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type FloorPlanOrderInput = {
  direction: OrderDirection
  field: FloorPlanOrderField
}

/** *Automatically generated.* */
export enum FloorPlanOrderField {
  CreatedAt = 'CREATED_AT',
  FloorId = 'FLOOR_ID',
  Id = 'ID',
  Name = 'NAME',
  S3Key = 'S3_KEY',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type FloorPlanConnection = {
  __typename?: 'FloorPlanConnection'
  edges?: Maybe<Array<Maybe<FloorPlanEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type FloorPlanEdge = {
  __typename?: 'FloorPlanEdge'
  cursor: Scalars['String']
  node?: Maybe<FloorPlan>
}

export type GetSopAssistantResponseInput = {
  incidentId: Scalars['ID']
  question: Scalars['String']
}

export type GetSopAssistantResponsePayload = {
  __typename?: 'GetSopAssistantResponsePayload'
  answer: Scalars['String']
  suggestedQuestions: Array<Scalars['String']>
}

export type GlobalFacilityConnection = {
  __typename?: 'GlobalFacilityConnection'
  edges?: Maybe<Array<GlobalFacilityEdge>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type GlobalFacilityEdge = {
  __typename?: 'GlobalFacilityEdge'
  node: GlobalFacility
}

export type GlobalFacility = {
  __typename?: 'GlobalFacility'
  defaultFloorId?: Maybe<Scalars['String']>
  id: Scalars['String']
  lat?: Maybe<Scalars['Float']>
  lon?: Maybe<Scalars['Float']>
  shortName?: Maybe<Scalars['String']>
}

/** AI Operator grid analysis job for tuning grids. */
export type GridAnalysisJob = {
  __typename?: 'GridAnalysisJob'
  /** Presigned URL for the annotated video with bounding box overlays, populated on COMPLETED */
  annotatedVideoUrl?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  id: Scalars['ID']
  inBox: Box
  incidentId: Scalars['ID']
  /** Number of people labeled as entering the restricted area */
  labeledIn: Scalars['Int']
  /** Number of people labeled as exiting the the restricted area */
  labeledOut: Scalars['Int']
  outBox: Box
  status: GridAnalysisJobStatus
  /** Resolution height of the camera stream at the time the job was created, in pixels */
  streamingResolutionHeight?: Maybe<Scalars['Int']>
  /** Resolution width of the camera stream at the time the job was created, in pixels */
  streamingResolutionWidth?: Maybe<Scalars['Int']>
  transitions: Array<GridAnalysisTransition>
  updatedAt: Scalars['String']
}

export enum GridAnalysisJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

/**
 * A single person transition event detected during grid analysis.
 * Represents one person entering or exiting the restricted area.
 */
export type GridAnalysisTransition = {
  __typename?: 'GridAnalysisTransition'
  direction: TransitionDirection
  /** YOLO identifier for the detected person */
  personId: Scalars['Int']
  /** Timestamp of the transition in seconds relative to video onset */
  timestamp: Scalars['Float']
}

export enum TransitionDirection {
  In = 'IN',
  Out = 'OUT',
}

/** One guard's activity at a single facility during one local calendar day. */
export type GuardDailyActivity = {
  __typename?: 'GuardDailyActivity'
  /** Clock in/out events that fall within the facility-local day, oldest first. */
  clockEvents?: Maybe<Array<GuardClockEvent>>
  guard?: Maybe<User>
  /** Incidents at this facility the guard created, was dispatched to, acknowledged, reported on scene for, or cleared that day. */
  incidents?: Maybe<Array<GuardDailyIncident>>
  /** Guard tours at this facility started or ended that day. */
  tours?: Maybe<Array<GuardTour>>
}

export type GuardClockEvent = {
  __typename?: 'GuardClockEvent'
  /** Instant of the clock event (ISO-8601 UTC). */
  at: Scalars['String']
  type: GuardClockEventType
}

export enum GuardClockEventType {
  ClockIn = 'CLOCK_IN',
  ClockOut = 'CLOCK_OUT',
}

export type GuardDailyIncident = {
  __typename?: 'GuardDailyIncident'
  incident?: Maybe<Incident>
  involvement?: Maybe<Array<GuardIncidentInvolvement>>
}

export enum GuardIncidentInvolvement {
  Acknowledged = 'ACKNOWLEDGED',
  Cleared = 'CLEARED',
  Created = 'CREATED',
  Dispatched = 'DISPATCHED',
  OnScene = 'ON_SCENE',
}

export type IncidentCountMap = {
  __typename?: 'IncidentCountMap'
  camera?: Maybe<Scalars['Int']>
  door?: Maybe<Scalars['Int']>
  health?: Maybe<Scalars['Int']>
  overall?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type IncidentDeviceMediaFilterInput = {
  AND?: InputMaybe<Array<IncidentDeviceMediaFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  deviceId?: InputMaybe<Scalars['ID']>
  deviceIdIn?: InputMaybe<Array<Scalars['ID']>>
  deviceIdNot?: InputMaybe<Scalars['ID']>
  deviceIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<IncidentDeviceMediaFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentDeviceMediaOrderInput = {
  direction: OrderDirection
  field: IncidentDeviceMediaOrderField
}

/** *Automatically generated.* */
export enum IncidentDeviceMediaOrderField {
  CreatedAt = 'CREATED_AT',
  DeviceId = 'DEVICE_ID',
  Id = 'ID',
  IncidentId = 'INCIDENT_ID',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type IncidentDeviceMediaConnection = {
  __typename?: 'IncidentDeviceMediaConnection'
  edges?: Maybe<Array<Maybe<IncidentDeviceMediaEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type IncidentDeviceMediaEdge = {
  __typename?: 'IncidentDeviceMediaEdge'
  cursor: Scalars['String']
  node?: Maybe<IncidentDeviceMedia>
}

/**
 * Associates an incident with:
 * * a device (in this case a camera)
 * * a list of intervals which record when relevant
 * footage was recorded on that camera.
 */
export type IncidentDeviceMedia = {
  __typename?: 'IncidentDeviceMedia'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  device?: Maybe<Device>
  deviceId: Scalars['ID']
  id: Scalars['ID']
  incidentId: Scalars['ID']
  intervals?: Maybe<Array<Maybe<Interval>>>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type Interval = {
  __typename?: 'Interval'
  endTime?: Maybe<Scalars['String']>
  startTime?: Maybe<Scalars['String']>
}

/** *Automatically generated.* */
export type IncidentGroupConnection = {
  __typename?: 'IncidentGroupConnection'
  edges?: Maybe<Array<Maybe<IncidentGroupEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type IncidentGroupEdge = {
  __typename?: 'IncidentGroupEdge'
  cursor: Scalars['String']
  node?: Maybe<IncidentGroupNode>
}

/** *Automatically generated.* */
export type IncidentGroupNode = {
  __typename?: 'IncidentGroupNode'
  avg?: Maybe<IncidentGroupAvg>
  count?: Maybe<Scalars['Int']>
  dimensions?: Maybe<IncidentGroupDimension>
  sum?: Maybe<IncidentGroupSum>
  uniq?: Maybe<IncidentGroupUniq>
}

/** *Automatically generated.* */
export type IncidentGroupAvg = {
  __typename?: 'IncidentGroupAvg'
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
}

/**
 * *Automatically generated.*
 *
 * Any fields selected on this type will be used for aggregation.
 * (This is like `GROUP BY` in SQL.)
 */
export type IncidentGroupDimension = {
  __typename?: 'IncidentGroupDimension'
  acknowledged?: Maybe<Scalars['Boolean']>
  actionType?: Maybe<IncidentActionType>
  actionUpdatedAt?: Maybe<Scalars['String']>
  concernStartTime?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['String']>
  creatorId?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  dispatched?: Maybe<Scalars['Boolean']>
  displayId?: Maybe<Scalars['String']>
  facilityId?: Maybe<Scalars['ID']>
  facilityName?: Maybe<Scalars['String']>
  facilityType?: Maybe<FacilityType>
  floorId?: Maybe<Scalars['ID']>
  floorName?: Maybe<Scalars['String']>
  guardId?: Maybe<Scalars['ID']>
  hasAudioMessages?: Maybe<Scalars['Boolean']>
  informationSolicited?: Maybe<Scalars['Boolean']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  nextPossibleGuardAction?: Maybe<IncidentGuardActionType>
  offered?: Maybe<Scalars['Boolean']>
  ownerId?: Maybe<Scalars['ID']>
  priority?: Maybe<IncidentPriority>
  real?: Maybe<Scalars['Boolean']>
  sensor?: Maybe<DeviceType>
  source?: Maybe<IncidentSource>
  status?: Maybe<IncidentStatus>
  type?: Maybe<IncidentType>
  updatedAt?: Maybe<Scalars['String']>
}

/** *Automatically generated.* */
export type IncidentGroupSum = {
  __typename?: 'IncidentGroupSum'
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
}

/**
 * *Automatically generated.*
 *
 * Each field of this type is a count of the number of distinct
 * values of another field: a field of the same name on the
 * generating type.
 */
export type IncidentGroupUniq = {
  __typename?: 'IncidentGroupUniq'
  acknowledged?: Maybe<Scalars['Int']>
  actionType?: Maybe<Scalars['Int']>
  actionUpdatedAt?: Maybe<Scalars['Int']>
  concernStartTime?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['Int']>
  creatorId?: Maybe<Scalars['Int']>
  description?: Maybe<Scalars['Int']>
  dispatched?: Maybe<Scalars['Int']>
  displayId?: Maybe<Scalars['Int']>
  facilityId?: Maybe<Scalars['Int']>
  facilityName?: Maybe<Scalars['Int']>
  facilityType?: Maybe<Scalars['Int']>
  floorId?: Maybe<Scalars['Int']>
  floorName?: Maybe<Scalars['Int']>
  guardId?: Maybe<Scalars['Int']>
  hasAudioMessages?: Maybe<Scalars['Int']>
  informationSolicited?: Maybe<Scalars['Int']>
  latitude?: Maybe<Scalars['Int']>
  longitude?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['Int']>
  nextPossibleGuardAction?: Maybe<Scalars['Int']>
  offered?: Maybe<Scalars['Int']>
  ownerId?: Maybe<Scalars['Int']>
  priority?: Maybe<Scalars['Int']>
  real?: Maybe<Scalars['Int']>
  sensor?: Maybe<Scalars['Int']>
  source?: Maybe<Scalars['Int']>
  status?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['Int']>
  updatedAt?: Maybe<Scalars['Int']>
}

/**
 * A page of Incidents for the Incidents table, deliberately without a total count.
 *
 * `IncidentConnection.totalCount` is a constructor argument computed from `Page.totalElements`,
 * so it is paid for on every request regardless of whether the client selects it. Serving the
 * table from a type that has no count field at all is what lets the backing query run as a
 * `Slice` and skip the `COUNT` entirely, and it keeps the cost from being reintroduced later,
 * because there is nothing to select.
 *
 * Use `pageInfo.hasNextPage` / `pageInfo.hasPreviousPage` to drive pagination. Callers that
 * genuinely need a total should keep using `incidents`.
 */
export type IncidentTableConnection = {
  __typename?: 'IncidentTableConnection'
  edges?: Maybe<Array<Maybe<IncidentEdge>>>
  pageInfo: PageInfo
}

/**
 * A collection of statistics about incidents in a time window.
 *
 * Unless the documentation of a field states otherwise,
 * the time window is a closed interval (i.e. it contains its
 * start time and end time).
 */
export type IncidentTimePeriodStats = {
  __typename?: 'IncidentTimePeriodStats'
  /**
   * For incidents acknowledged in the time window,
   * the average time between
   * creation of the incident
   * and
   * acknowledgement of the incident.
   *
   *
   *
   * i>
   *
   * In case it's not obvious:
   *
   * * Included in the count are incidents
   * created before the time window
   * and
   * acknowledged during the time window.
   * * Excluded from the count are incidents
   * created during the time window
   * and
   * acknowledged after the time window.
   *
   * </i>
   */
  avgTimeToAcknowledge?: Maybe<Scalars['Float']>
  /**
   * For incidents resolved in the time window
   * (i.e. incidents whose `status` became `RESOLVED`
   * during the time window),
   * the average time between
   * creation of the incident
   * and
   * resolution of the incident.
   *
   * <i>
   *
   * In case it's not obvious:
   * * Included in the count are incidents
   * created before the time window
   * and
   * resolved during the time window.
   * * Excluded from the count are incidents
   * created during the time window
   * and
   * resolved after the time window.
   *
   * </i>
   */
  avgTimeToResolve?: Maybe<Scalars['Float']>
  /**
   * *F*, given the following definitions.
   *
   * | Variable | Definition |
   * | --- | --- |
   * | *C_0* | The number of unresolved incidents at the start of the time range. |
   * | *C_1* | The number of incidents created during the time range. |
   * | *C_2* | The number of incidents resolved during the time range. |
   * | *F* | *C_2 / (C_0 + C_1)* |
   */
  fractionResolved?: Maybe<Scalars['Float']>
  /**
   * The total number of incidents which were unresolved
   * at some point in the time interval.
   * ('Unresolved' means: `status` was something other than `RESOLVED`.)
   *
   * *This is the sum of 2 numbers:
   * the number of incidents unresolved
   * at the start of the time window
   * and
   * the number of incidents created
   * during the time window.
   * The second number is included in the sum because
   * every incident is unresolved at the instant
   * of creation.*
   *
   * *'numUnresolved' is not a good name, because
   * it tends to suggest a count at a *point* in time.
   * Suggestions for a better name are welcome.*
   */
  numUnresolved?: Maybe<Scalars['Int']>
}

export type IncidentTypeDefinitionListPayload = {
  __typename?: 'IncidentTypeDefinitionListPayload'
  items: Array<IncidentTypeDefinition>
  totalCount: Scalars['Int']
}

export type IncidentWorkflowFilterInput = {
  incidentTypeDefinitionId?: InputMaybe<Scalars['ID']>
  includeArchived?: InputMaybe<Scalars['Boolean']>
  manualIncidentCategoryId?: InputMaybe<Scalars['ID']>
  state?: InputMaybe<WorkflowState>
}

/** Maps one built-in incident field to an integration-side field */
export type IntegrationFieldMapping = {
  __typename?: 'IntegrationFieldMapping'
  createdAt: Scalars['String']
  id: Scalars['ID']
  integrationId: Scalars['ID']
  optionMappings: Array<IntegrationFieldOptionMapping>
  sourceField: IntegrationSourceField
  targetFieldId?: Maybe<Scalars['String']>
  targetFieldName?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
}

/** Value-to-option child of a field mapping; presence of children makes the field a dropdown. `id` is not stable across saves: an upsert clears and re-inserts all children, so key rows by `sourceValue`, never by `id`. */
export type IntegrationFieldOptionMapping = {
  __typename?: 'IntegrationFieldOptionMapping'
  fieldMappingId: Scalars['ID']
  id: Scalars['ID']
  sourceValue: Scalars['String']
  targetOptionId: Scalars['String']
}

/** Built-in incident fields that can be mapped to an integration field */
export enum IntegrationSourceField {
  AssignedGuard = 'ASSIGNED_GUARD',
  Clip = 'CLIP',
  Dispatched = 'DISPATCHED',
  FacilityAddress = 'FACILITY_ADDRESS',
  FacilityId = 'FACILITY_ID',
  FacilityName = 'FACILITY_NAME',
  IncidentCreatedAt = 'INCIDENT_CREATED_AT',
  IncidentDescription = 'INCIDENT_DESCRIPTION',
  IncidentId = 'INCIDENT_ID',
  IncidentName = 'INCIDENT_NAME',
  IncidentType = 'INCIDENT_TYPE',
  ManualCategory = 'MANUAL_CATEGORY',
  MiscNotes = 'MISC_NOTES',
  Real = 'REAL',
  ResolutionNotes = 'RESOLUTION_NOTES',
  Source = 'SOURCE',
}

/** One row per mapped Custom Quick Report question */
export type IntegrationQuestionMapping = {
  __typename?: 'IntegrationQuestionMapping'
  choiceMappings: Array<IntegrationQuestionChoiceMapping>
  createdAt: Scalars['String']
  id: Scalars['ID']
  integrationId: Scalars['ID']
  questionId: Scalars['ID']
  targetFieldId: Scalars['String']
  targetFieldName?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
}

/** Per-answer-choice mapping of a mapped question; YES_NO questions map through a synthetic true/false choice. `id` is not stable across saves: an upsert clears and re-inserts all children, so key rows by `optionId`/`syntheticChoice`, never by `id`. */
export type IntegrationQuestionChoiceMapping = {
  __typename?: 'IntegrationQuestionChoiceMapping'
  id: Scalars['ID']
  optionId?: Maybe<Scalars['ID']>
  questionMappingId: Scalars['ID']
  syntheticChoice?: Maybe<Scalars['String']>
  targetOptionId: Scalars['String']
}

export type Kpi = {
  __typename?: 'Kpi'
  averageGuardAcknowledgmentTime?: Maybe<KpiQueryResult>
  averageGuardOnScene?: Maybe<KpiQueryResult>
  averageGuardToClear?: Maybe<KpiQueryResult>
  averageOperatorTimeToAcknowledge?: Maybe<KpiQueryResult>
  averageOperatorTimeToResolve?: Maybe<KpiQueryResult>
  averageTimeToAcknowledgeByFacility?: Maybe<
    Array<Maybe<KpiAggregateQueryResult>>
  >
  averageTimeToResolveByFacility?: Maybe<Array<Maybe<KpiAggregateQueryResult>>>
  countIncidentsByFacility?: Maybe<Array<Maybe<KpiAggregateQueryResult>>>
  countIncidentsByTypeBetweenDates?: Maybe<IncidentsByTypeBetweenDateResult>
  incidentResolutionRate?: Maybe<Scalars['Float']>
  medianOperatorTimeToAcknowledge?: Maybe<KpiQueryResult>
  medianOperatorTimeToResolve?: Maybe<KpiQueryResult>
  medianTimeToAcknowledgeByFacility?: Maybe<
    Array<Maybe<KpiAggregateQueryResult>>
  >
  medianTimeToResolveByFacility?: Maybe<Array<Maybe<KpiAggregateQueryResult>>>
  totalActiveIncidents?: Maybe<KpiQueryResult>
  totalEnrolledDevices?: Maybe<Scalars['Int']>
  totalIncidents?: Maybe<KpiQueryResult>
}

export type KpiAverageGuardAcknowledgmentTimeArgs = {
  guards?: InputMaybe<Array<Scalars['ID']>>
  hours: Scalars['Int']
}

export type KpiAverageGuardOnSceneArgs = {
  guards?: InputMaybe<Array<Scalars['ID']>>
  hours: Scalars['Int']
}

export type KpiAverageGuardToClearArgs = {
  guards?: InputMaybe<Array<Scalars['ID']>>
  hours: Scalars['Int']
}

export type KpiAverageOperatorTimeToAcknowledgeArgs = {
  hours: Scalars['Int']
  owners?: InputMaybe<Array<Scalars['ID']>>
}

export type KpiAverageOperatorTimeToResolveArgs = {
  hours: Scalars['Int']
  owners?: InputMaybe<Array<Scalars['ID']>>
}

export type KpiAverageTimeToAcknowledgeByFacilityArgs = {
  hours: Scalars['Int']
}

export type KpiAverageTimeToResolveByFacilityArgs = {
  hours: Scalars['Int']
}

export type KpiCountIncidentsByFacilityArgs = {
  hours: Scalars['Int']
}

export type KpiCountIncidentsByTypeBetweenDatesArgs = {
  endDate?: InputMaybe<Scalars['String']>
  real?: InputMaybe<Scalars['Boolean']>
  startDate?: InputMaybe<Scalars['String']>
  types?: InputMaybe<Array<InputMaybe<IncidentType>>>
}

export type KpiIncidentResolutionRateArgs = {
  hours: Scalars['Int']
}

export type KpiMedianOperatorTimeToAcknowledgeArgs = {
  hours: Scalars['Int']
  owners?: InputMaybe<Array<Scalars['ID']>>
}

export type KpiMedianOperatorTimeToResolveArgs = {
  hours: Scalars['Int']
  owners?: InputMaybe<Array<Scalars['ID']>>
}

export type KpiMedianTimeToAcknowledgeByFacilityArgs = {
  hours: Scalars['Int']
}

export type KpiMedianTimeToResolveByFacilityArgs = {
  hours: Scalars['Int']
}

export type KpiTotalActiveIncidentsArgs = {
  hours: Scalars['Int']
}

export type KpiTotalEnrolledDevicesArgs = {
  hours: Scalars['Int']
  type?: InputMaybe<DeviceType>
}

export type KpiTotalIncidentsArgs = {
  hours: Scalars['Int']
}

export type KpiQueryResult = {
  __typename?: 'KpiQueryResult'
  current?: Maybe<Scalars['Int']>
  past?: Maybe<Scalars['Int']>
}

export type KpiAggregateQueryResult = {
  __typename?: 'KpiAggregateQueryResult'
  count?: Maybe<Scalars['Int']>
  label?: Maybe<Scalars['String']>
}

export type IncidentsByTypeBetweenDateResult = {
  __typename?: 'IncidentsByTypeBetweenDateResult'
  incidentsTypeByDate?: Maybe<Array<Maybe<IncidentsTypesByDate>>>
  totalCount?: Maybe<Scalars['Int']>
}

export type IncidentsTypesByDate = {
  __typename?: 'IncidentsTypesByDate'
  date?: Maybe<Scalars['String']>
  day?: Maybe<Scalars['String']>
  incidentsTypes?: Maybe<Array<Maybe<IncidentsByTypeCount>>>
}

export type IncidentsByTypeCount = {
  __typename?: 'IncidentsByTypeCount'
  count?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['String']>
}

export type DatabaseReset = {
  __typename?: 'DatabaseReset'
  createdAt: Scalars['String']
  createdBy: Scalars['String']
}

export type ManualIncidentCategoryFilterInput = {
  AND?: InputMaybe<Array<ManualIncidentCategoryFilterInput>>
  archived?: InputMaybe<Scalars['Boolean']>
  isQuickReportCategory?: InputMaybe<Scalars['Boolean']>
  mutable?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<ManualIncidentCategoryFilterInput>>
}

export type ManualIncidentCategoryConnection = {
  __typename?: 'ManualIncidentCategoryConnection'
  edges?: Maybe<Array<Maybe<ManualIncidentCategoryEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type ManualIncidentCategoryEdge = {
  __typename?: 'ManualIncidentCategoryEdge'
  cursor?: Maybe<Scalars['String']>
  node?: Maybe<ManualIncidentCategory>
}

export type Rule = {
  __typename?: 'Rule'
  /** Action to perform. In the future, we may want a multi-selectable list. */
  action: Action
  aiOperatorResponseRules?: Maybe<Array<AiOperatorResponseRule>>
  aiOperatorRuleDetails?: Maybe<AiOperatorRuleDetails>
  allDayOverride: Scalars['Boolean']
  archived: Scalars['Boolean']
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId: Scalars['ID']
  /**
   * Combo of the days of the week. Su = Sunday, Mo = Monday, Tu = Tuesday,
   * We = Wednesday, Th = Thursday, Fr = Friday, Sa = Saturday. Days must be in this
   * order and should not repeat. e.g. "MoTu", "SuMoTuWeThFrSa", "TuTh", "SuSa"
   */
  day?: Maybe<Scalars['String']>
  /**
   * Last local calendar date (in the incident's originating facility) a repeating rule applies. No
   * timezone is applied to this value; it is a plain calendar date.
   */
  endDate?: Maybe<Scalars['String']>
  /**
   * Local wall-clock end of the schedule window (timezone-agnostic, no offset), sent directly by the
   * client at rule creation and applied against the incident's own facility timezone at evaluation time.
   * Null when the rule has no end time (open-ended schedule, e.g. all-day), and also for rules created
   * before the ENG-30856 cutover whose facility scope couldn't be resolved to a single timezone. This is
   * the authoritative schedule field; endTimeOfDay is legacy.
   */
  endTimeLocal?: Maybe<Scalars['String']>
  /**
   * Legacy field. For rules created before the ENG-30856 local-time cutover this is the original UTC
   * instant (ISO-8601); for rules created after, it is a non-authoritative value derived from
   * endTimeLocal (the local wall-clock time stamped at UTC) kept only for backward compatibility. Use
   * endTimeLocal for the schedule; this field is slated for removal once legacy consumers migrate.
   */
  endTimeOfDay?: Maybe<Scalars['String']>
  id: Scalars['ID']
  incidentTypeDefinitions: Array<IncidentTypeDefinition>
  incidentTypeScope: IncidentTypeScope
  /** True if this rule was created with the v2 Rules Engine. */
  isV2: Scalars['Boolean']
  lastMatched?: Maybe<Scalars['String']>
  manualIncidentCategories?: Maybe<Array<ManualIncidentCategory>>
  manualIncidentCategoryIds?: Maybe<Array<Scalars['ID']>>
  name: Scalars['String']
  /**
   * The priority a SET_PRIORITY rule assigns. Non-null exactly when action is SET_PRIORITY; null for
   * every other action.
   */
  priority?: Maybe<IncidentPriority>
  repeatInterval?: Maybe<RepeatInterval>
  repeatIntervalNum?: Maybe<Scalars['Int']>
  ruleEventType: Array<RuleEventType>
  ruleLogics?: Maybe<RuleLogicConnection>
  /**
   * Legacy field. For rules created before the ENG-30856 local-time cutover this is the original UTC
   * instant (ISO-8601); for rules created after, it is a non-authoritative value derived from
   * startTimeLocal (the local wall-clock time stamped at UTC) kept only for backward compatibility. Use
   * startTimeLocal for the schedule; this field is slated for removal once legacy consumers migrate.
   */
  startTime: Scalars['String']
  /**
   * Local wall-clock start of the schedule window (timezone-agnostic, no offset), sent directly by the
   * client at rule creation and applied against the incident's own facility timezone at evaluation time.
   * Null only for rules created before the ENG-30856 cutover whose facility scope couldn't be resolved
   * to a single timezone. This is the authoritative schedule field; startTime is legacy.
   */
  startTimeLocal?: Maybe<Scalars['String']>
  /** True = active, False = deactivated */
  status: Scalars['Boolean']
  triggerType?: Maybe<RuleTriggerType>
  updatedAt: Scalars['String']
  updatedBy?: Maybe<User>
  updatedById?: Maybe<Scalars['ID']>
}

export type RuleRuleLogicsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<RuleLogicFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<RuleLogicOrderInput>>>
}

export enum IncidentTypeScope {
  AllDevice = 'ALL_DEVICE',
  AllManual = 'ALL_MANUAL',
  Listed = 'LISTED',
}

export enum RepeatInterval {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
}

export enum RuleEventType {
  Alarm = 'ALARM',
  /** 'ALL' means all current and future event types */
  All = 'ALL',
  DoorForcedOpen = 'DOOR_FORCED_OPEN',
  DoorHeldOpen = 'DOOR_HELD_OPEN',
  DoorOpenAlarm = 'DOOR_OPEN_ALARM',
  LineCrossing = 'LINE_CROSSING',
  Manual = 'MANUAL',
  Tailgating = 'TAILGATING',
}

export type RuleLogicFilterInput = {
  ruleId?: InputMaybe<Scalars['ID']>
}

export type RuleLogicOrderInput = {
  direction: OrderDirection
  field: RuleLogicOrderField
}

export enum RuleLogicOrderField {
  Id = 'ID',
}

export type RuleLogicConnection = {
  __typename?: 'RuleLogicConnection'
  edges?: Maybe<Array<Maybe<RuleLogicEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type RuleLogicEdge = {
  __typename?: 'RuleLogicEdge'
  cursor: Scalars['String']
  node?: Maybe<RuleLogic>
}

export type RuleLogic = {
  __typename?: 'RuleLogic'
  children?: Maybe<RuleLogicConnection>
  comparator: Comparator
  /** In the future, entity may become a String type */
  entity?: Maybe<Entity>
  entityAttribute?: Maybe<Scalars['String']>
  /** This is an integer represented as a string */
  id?: Maybe<Scalars['String']>
  operator?: Maybe<Operator>
  ruleId?: Maybe<Scalars['ID']>
  value?: Maybe<Scalars['String']>
}

export enum Comparator {
  Equals = 'EQUALS',
}

export enum Entity {
  AllDevices = 'ALL_DEVICES',
  Device = 'DEVICE',
  Facility = 'FACILITY',
  Floor = 'FLOOR',
  Label = 'LABEL',
}

export enum Operator {
  And = 'AND',
  Or = 'OR',
}

export enum RuleTriggerType {
  Device = 'DEVICE',
  Manual = 'MANUAL',
}

/** *Automatically generated.* */
export type SubscriberMessageFilterInput = {
  AND?: InputMaybe<Array<SubscriberMessageFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<SubscriberMessageFilterInput>>
}

/** *Automatically generated.* */
export type SubscriberMessageOrderInput = {
  direction: OrderDirection
  field: SubscriberMessageOrderField
}

/** *Automatically generated.* */
export enum SubscriberMessageOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
}

/** *Automatically generated.* */
export type SubscriberMessageConnection = {
  __typename?: 'SubscriberMessageConnection'
  edges?: Maybe<Array<Maybe<SubscriberMessageEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type SubscriberMessageEdge = {
  __typename?: 'SubscriberMessageEdge'
  cursor: Scalars['String']
  node?: Maybe<SubscriberMessage>
}

export type UserSetting = {
  __typename?: 'UserSetting'
  audibleAlertsEnabled: Scalars['Boolean']
  /** Ids of the first-time-use guides the user has completed, in completion order. */
  completedFtus: Array<Scalars['String']>
}

export type PacsSourceInstanceConnection = {
  __typename?: 'PacsSourceInstanceConnection'
  edges?: Maybe<Array<Maybe<PacsSourceInstanceEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PacsSourceInstanceEdge = {
  __typename?: 'PacsSourceInstanceEdge'
  cursor: Scalars['String']
  node?: Maybe<PacsSourceInstance>
}

export type PacsSourceConnection = {
  __typename?: 'PacsSourceConnection'
  edges?: Maybe<Array<Maybe<PacsSourceEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PacsSourceEdge = {
  __typename?: 'PacsSourceEdge'
  cursor: Scalars['String']
  node?: Maybe<PacsSource>
}

export type PartialCreditCard = {
  __typename?: 'PartialCreditCard'
  address?: Maybe<Array<Scalars['String']>>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  endOfNumber?: Maybe<Scalars['String']>
  expiryMonth?: Maybe<Scalars['Int']>
  expiryYear?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** Filter for pending user invitations. */
export enum InviteStatus {
  /** Active invites - link still valid (createdAt + 24h >= now). */
  Active = 'ACTIVE',
  /** All pending invites (default). */
  All = 'ALL',
  /** Expired invites - link no longer valid (createdAt + 24h < now). */
  Expired = 'EXPIRED',
}

export type PersonOfInterestConnection = {
  __typename?: 'PersonOfInterestConnection'
  edges?: Maybe<Array<PersonOfInterestEdge>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PersonOfInterestEdge = {
  __typename?: 'PersonOfInterestEdge'
  cursor: Scalars['String']
  node?: Maybe<PersonOfInterest>
}

/**
 * Read-only preview of what archiveFloor would do to guard tour plans, computed
 * over the same lookup the mutation uses. Intended for the archive confirmation
 * dialog; nothing is changed.
 */
export type ArchiveFloorPreview = {
  __typename?: 'ArchiveFloorPreview'
  /**
   * In-progress guard tours on affected plans. While this is non-zero the archive
   * is rejected — tours must be finished or submitted by their guards first.
   */
  inProgressGuardTourCount: Scalars['Int']
  /**
   * Active tour plans whose checkpoints are all on this floor: archiving the floor
   * archives these plans outright, with no replacement version.
   */
  tourPlansToArchiveCount: Scalars['Int']
  /**
   * Active tour plans that also span other floors: archiving the floor creates a
   * new plan version without this floor's checkpoints. Unarchiving the floor does
   * not restore them.
   */
  tourPlansToUpdateCount: Scalars['Int']
}

/** Structured outcome of sending (or previewing a send of) an incident to an integration */
export type IntegrationSendResult = {
  __typename?: 'IntegrationSendResult'
  externalId?: Maybe<Scalars['String']>
  fieldsSent: Array<Scalars['String']>
  mediaResult?: Maybe<IntegrationMediaResult>
  omissions: Array<IntegrationSendOmission>
  tzFallback: Scalars['Boolean']
}

/** Outcome of the media portion of an integration send */
export enum IntegrationMediaResult {
  Failed = 'FAILED',
  None = 'NONE',
  Planned = 'PLANNED',
  Sent = 'SENT',
}

/** One field omitted from an integration send and why */
export type IntegrationSendOmission = {
  __typename?: 'IntegrationSendOmission'
  field: Scalars['String']
  reason: Scalars['String']
}

export type ProductMessageFilterInput = {
  AND?: InputMaybe<Array<ProductMessageFilterInput>>
  archived?: InputMaybe<Scalars['Boolean']>
  isActive?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<ProductMessageFilterInput>>
}

export type ProductMessage = {
  __typename?: 'ProductMessage'
  archived: Scalars['Boolean']
  createdAt: Scalars['String']
  endDateTime: Scalars['String']
  id: Scalars['ID']
  message: Scalars['String']
  messageType: ProductMessageType
  startDateTime: Scalars['String']
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

/** The severity styling applied to a product announcement banner */
export enum ProductMessageType {
  /** Critical notice, e.g. an active outage */
  Error = 'ERROR',
  /** Neutral informational notice (default for newly authored messages) */
  Info = 'INFO',
  /** Positive confirmation, e.g. a completed migration */
  Success = 'SUCCESS',
  /** Advisory notice, e.g. upcoming scheduled downtime */
  Warning = 'WARNING',
}

export type ProgramRecommendationCounts = {
  __typename?: 'ProgramRecommendationCounts'
  archived: Scalars['Int']
  completed: Scalars['Int']
  inProgress: Scalars['Int']
  pending: Scalars['Int']
  rejected: Scalars['Int']
}

export type ProgramRecommendationFilterInput = {
  AND?: InputMaybe<Array<ProgramRecommendationFilterInput>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  isArchived?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<ProgramRecommendationFilterInput>>
  owner?: InputMaybe<ProgramRecommendationOwner>
  ownerIn?: InputMaybe<Array<ProgramRecommendationOwner>>
  ownerNot?: InputMaybe<ProgramRecommendationOwner>
  ownerNotIn?: InputMaybe<Array<ProgramRecommendationOwner>>
  status?: InputMaybe<ProgramRecommendationStatus>
  statusIn?: InputMaybe<Array<ProgramRecommendationStatus>>
  statusNot?: InputMaybe<ProgramRecommendationStatus>
  statusNotIn?: InputMaybe<Array<ProgramRecommendationStatus>>
}

export enum ProgramRecommendationOwner {
  Customer = 'CUSTOMER',
  Hivewatch = 'HIVEWATCH',
}

export enum ProgramRecommendationStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export type ProgramRecommendationOrderInput = {
  direction: OrderDirection
  field: ProgramRecommendationOrderField
}

export enum ProgramRecommendationOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type ProgramRecommendationConnection = {
  __typename?: 'ProgramRecommendationConnection'
  edges?: Maybe<Array<Maybe<ProgramRecommendationEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type ProgramRecommendationEdge = {
  __typename?: 'ProgramRecommendationEdge'
  cursor: Scalars['String']
  node?: Maybe<ProgramRecommendation>
}

export type ProgramRecommendation = {
  __typename?: 'ProgramRecommendation'
  /** Lifecycle actions (accept, reject, complete, archive). */
  actions: Array<ProgramRecommendationAction>
  actualImpact?: Maybe<Scalars['String']>
  category: ProgramRecommendationCategory
  createdAt: Scalars['String']
  description?: Maybe<Scalars['String']>
  estimatedImpact?: Maybe<Scalars['String']>
  id: Scalars['ID']
  internalNote?: Maybe<Scalars['String']>
  isArchived: Scalars['Boolean']
  owner: Scalars['String']
  publishedBy?: Maybe<User>
  publishedById: Scalars['ID']
  status: ProgramRecommendationStatus
  title: Scalars['String']
  updatedAt: Scalars['String']
}

export type ProgramRecommendationAction = {
  __typename?: 'ProgramRecommendationAction'
  actionType: ProgramRecommendationActionType
  id: Scalars['ID']
  note?: Maybe<Scalars['String']>
  performedAt: Scalars['String']
  performedBy?: Maybe<User>
  performedById: Scalars['ID']
}

export enum ProgramRecommendationActionType {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Rejected = 'REJECTED',
}

export enum ProgramRecommendationCategory {
  Automation = 'AUTOMATION',
  DeviceHealth = 'DEVICE_HEALTH',
  Optimization = 'OPTIMIZATION',
}

export type QuickReport = {
  __typename?: 'QuickReport'
  createdAt: Scalars['String']
  formDescription: Scalars['String']
  formTitle: Scalars['String']
  id: Scalars['ID']
  incidentCategories?: Maybe<ManualIncidentCategoryConnection>
  logoAssetId: Scalars['ID']
  logoUrl?: Maybe<Scalars['String']>
  qrCodeUrl?: Maybe<Scalars['String']>
  /** The type of quick report form: CANNED (default hardcoded form) or CUSTOM (dynamic form) */
  reportType: QuickReportType
  updatedAt: Scalars['String']
}

export type QuickReportCode = {
  __typename?: 'QuickReportCode'
  createdAt: Scalars['String']
  id: Scalars['ID']
  isCurrent: Scalars['Boolean']
  qrCodeUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
  updatedBy: Scalars['ID']
}

export type QuickReportCodeOrderInput = {
  direction: OrderDirection
  field: QuickReportCodeOrderField
}

export enum QuickReportCodeOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedBy = 'UPDATED_BY',
}

export type QuickReportCodeConnection = {
  __typename?: 'QuickReportCodeConnection'
  edges?: Maybe<Array<Maybe<QuickReportCodeEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type QuickReportCodeEdge = {
  __typename?: 'QuickReportCodeEdge'
  cursor: Scalars['String']
  node?: Maybe<QuickReportCode>
}

export type EmailRecipientFilterInput = {
  AND?: InputMaybe<Array<EmailRecipientFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  emailIn?: InputMaybe<Array<Scalars['String']>>
  emailLike?: InputMaybe<Scalars['String']>
  emailNot?: InputMaybe<Scalars['String']>
  emailNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<EmailRecipientFilterInput>>
  ruleId?: InputMaybe<Scalars['ID']>
  ruleIdIn?: InputMaybe<Array<Scalars['ID']>>
  ruleIdNot?: InputMaybe<Scalars['ID']>
  ruleIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<EmailRecipientStatus>
  statusIn?: InputMaybe<Array<EmailRecipientStatus>>
  statusNot?: InputMaybe<EmailRecipientStatus>
  statusNotIn?: InputMaybe<Array<EmailRecipientStatus>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['ID']>
  userIdIn?: InputMaybe<Array<Scalars['ID']>>
  userIdNot?: InputMaybe<Scalars['ID']>
  userIdNotIn?: InputMaybe<Array<Scalars['ID']>>
}

export type EmailRecipientOrderInput = {
  direction: OrderDirection
  field: EmailRecipientOrderField
}

export enum EmailRecipientOrderField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  Id = 'ID',
  RuleId = 'RULE_ID',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID',
}

export type EmailRecipientConnection = {
  __typename?: 'EmailRecipientConnection'
  edges?: Maybe<Array<Maybe<EmailRecipientEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type EmailRecipientEdge = {
  __typename?: 'EmailRecipientEdge'
  cursor: Scalars['String']
  node?: Maybe<EmailRecipient>
}

/** *Automatically generated.* */
export type RoleFilterInput = {
  AND?: InputMaybe<Array<RoleFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<RoleFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type RoleOrderInput = {
  direction: OrderDirection
  field: RoleOrderField
}

/** *Automatically generated.* */
export enum RoleOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type RoleConnection = {
  __typename?: 'RoleConnection'
  edges?: Maybe<Array<Maybe<RoleEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type RoleEdge = {
  __typename?: 'RoleEdge'
  cursor: Scalars['String']
  node?: Maybe<Role>
}

export type RuleFilterInput = {
  action?: InputMaybe<Action>
  actionIn?: InputMaybe<Array<Action>>
  actionNot?: InputMaybe<Action>
  actionNotIn?: InputMaybe<Array<Action>>
  AND?: InputMaybe<Array<RuleFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  day?: InputMaybe<Scalars['String']>
  deviceIdIn?: InputMaybe<Array<Scalars['ID']>>
  deviceNameLike?: InputMaybe<Scalars['String']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<RuleFilterInput>>
  repeatInterval?: InputMaybe<Scalars['ID']>
  repeatIntervalIn?: InputMaybe<Array<Scalars['ID']>>
  repeatIntervalNot?: InputMaybe<Scalars['ID']>
  repeatIntervalNotIn?: InputMaybe<Array<Scalars['ID']>>
  ruleEventType?: InputMaybe<Array<InputMaybe<RuleEventType>>>
  ruleEventTypeContain?: InputMaybe<RuleEventType>
  ruleEventTypeDoNotContain?: InputMaybe<RuleEventType>
  ruleLogicIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  status?: InputMaybe<Scalars['Boolean']>
  triggerTypeIn?: InputMaybe<Array<RuleTriggerType>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

export type RuleOrderInput = {
  direction: OrderDirection
  field: RuleOrderField
}

export enum RuleOrderField {
  Action = 'ACTION',
  CreatedAt = 'CREATED_AT',
  EndDate = 'END_DATE',
  LastMatched = 'LAST_MATCHED',
  Name = 'NAME',
  RepeatInterval = 'REPEAT_INTERVAL',
  RuleEventType = 'RULE_EVENT_TYPE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
}

export type RuleConnection = {
  __typename?: 'RuleConnection'
  edges?: Maybe<Array<Maybe<RuleEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type RuleEdge = {
  __typename?: 'RuleEdge'
  cursor: Scalars['String']
  node?: Maybe<Rule>
}

export type SavedFilterConnection = {
  __typename?: 'SavedFilterConnection'
  edges?: Maybe<Array<Maybe<SavedFilterEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type SavedFilterEdge = {
  __typename?: 'SavedFilterEdge'
  cursor: Scalars['String']
  node?: Maybe<SavedFilter>
}

/** A JSON template describing the shape of a webhook payload. */
export type SavedPayload = {
  __typename?: 'SavedPayload'
  createdAt: Scalars['String']
  id: Scalars['ID']
  /** A JSON object. Its content is not interpreted by the backend. */
  payload: Scalars['JSON']
  updatedAt: Scalars['String']
}

export type SavedPayloadConnection = {
  __typename?: 'SavedPayloadConnection'
  edges?: Maybe<Array<Maybe<SavedPayloadEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type SavedPayloadEdge = {
  __typename?: 'SavedPayloadEdge'
  cursor: Scalars['String']
  node?: Maybe<SavedPayload>
}

export type Session = {
  __typename?: 'Session'
  user?: Maybe<User>
}

export type StaleIncidentGroupConnection = {
  __typename?: 'StaleIncidentGroupConnection'
  edges?: Maybe<Array<StaleIncidentGroupEdge>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type StaleIncidentGroupEdge = {
  __typename?: 'StaleIncidentGroupEdge'
  cursor: Scalars['String']
  node?: Maybe<StaleIncidentGroup>
}

export type StaleIncidentGroup = {
  __typename?: 'StaleIncidentGroup'
  incidentCount: Scalars['Int']
  /** The attributed user, resolved from userId. Null when userId is null (Unassigned) or the user no longer exists. */
  user?: Maybe<User>
  /**
   * The attribution key (COALESCE(ownerId, guardId)). Null identifies the Unassigned bucket.
   * Use it with IncidentFilterInput.attributedToIdIn / attributedToIsNull to page this group's incidents.
   */
  userId?: Maybe<Scalars['ID']>
}

export type StandardOperatingProcedure = {
  __typename?: 'StandardOperatingProcedure'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId?: Maybe<Scalars['ID']>
  /**
   * The client creates the StandardOperatingProcedure with some external
   * service, receiving a unique ID, then uses that ID for this
   * field.
   */
  externalId: Scalars['String']
  facilities?: Maybe<FacilityConnection>
  facilityIds?: Maybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  status?: Maybe<VirusScanStatus>
  type: SopType
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  /** A file in a format such as PDF. */
  url?: Maybe<Scalars['String']>
}

export type StandardOperatingProcedureFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<FacilityFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<FacilityOrderInput>>>
}

export enum VirusScanStatus {
  Clean = 'CLEAN',
  Infected = 'INFECTED',
  Unscanned = 'UNSCANNED',
}

export enum SopType {
  Guard = 'GUARD',
  Operator = 'OPERATOR',
}

/** *Automatically generated.* */
export type StandardOperatingProcedureFilterInput = {
  AND?: InputMaybe<Array<StandardOperatingProcedureFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  externalId?: InputMaybe<Scalars['String']>
  externalIdGt?: InputMaybe<Scalars['String']>
  externalIdGte?: InputMaybe<Scalars['String']>
  externalIdIn?: InputMaybe<Array<Scalars['String']>>
  externalIdLike?: InputMaybe<Scalars['String']>
  externalIdLt?: InputMaybe<Scalars['String']>
  externalIdLte?: InputMaybe<Scalars['String']>
  externalIdNot?: InputMaybe<Scalars['String']>
  externalIdNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdsContain?: InputMaybe<Scalars['ID']>
  facilityIdsDoNotContain?: InputMaybe<Scalars['ID']>
  facilityIdsNull?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<StandardOperatingProcedureFilterInput>>
  type?: InputMaybe<SopType>
  typeIn?: InputMaybe<Array<SopType>>
  typeNot?: InputMaybe<SopType>
  typeNotIn?: InputMaybe<Array<SopType>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  url?: InputMaybe<Scalars['String']>
  urlGt?: InputMaybe<Scalars['String']>
  urlGte?: InputMaybe<Scalars['String']>
  urlIn?: InputMaybe<Array<Scalars['String']>>
  urlLike?: InputMaybe<Scalars['String']>
  urlLt?: InputMaybe<Scalars['String']>
  urlLte?: InputMaybe<Scalars['String']>
  urlNot?: InputMaybe<Scalars['String']>
  urlNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type StandardOperatingProcedureOrderInput = {
  direction: OrderDirection
  field: StandardOperatingProcedureOrderField
}

/** *Automatically generated.* */
export enum StandardOperatingProcedureOrderField {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  ExternalId = 'EXTERNAL_ID',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  Url = 'URL',
}

/** *Automatically generated.* */
export type StandardOperatingProcedureConnection = {
  __typename?: 'StandardOperatingProcedureConnection'
  edges?: Maybe<Array<Maybe<StandardOperatingProcedureEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type StandardOperatingProcedureEdge = {
  __typename?: 'StandardOperatingProcedureEdge'
  cursor: Scalars['String']
  node?: Maybe<StandardOperatingProcedure>
}

export type IntervalInput = {
  endTime?: InputMaybe<Scalars['String']>
  startTime?: InputMaybe<Scalars['String']>
}

export type TagFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  enabled?: InputMaybe<Scalars['Boolean']>
  nameLike?: InputMaybe<Scalars['String']>
}

/** Backend dry-run of the Tailgating Evaluator against a candidate grid for a past tailgate incident. */
export type TailgateGridTestJob = {
  __typename?: 'TailgateGridTestJob'
  badgeCount: Scalars['Int']
  /** Static disclosure: badge count/list is not diffed against any create-time-logged value. */
  badgeCountCaveat: Scalars['String']
  badgeEvents: Array<TailgateBadgeEvent>
  createdAt: Scalars['String']
  evaluatorVersion?: Maybe<Scalars['String']>
  failureReason?: Maybe<TailgateGridTestFailureReason>
  id: Scalars['ID']
  incidentId: Scalars['ID']
  resolutionUsedHeight?: Maybe<Scalars['Int']>
  resolutionUsedWidth?: Maybe<Scalars['Int']>
  scalingMode?: Maybe<TailgateScalingMode>
  securedBox: Box
  /** Presigned GET URL for the geometry sidecar asset, populated only once status is COMPLETED. */
  sidecarAssetUrl?: Maybe<Scalars['String']>
  status: TailgateGridTestJobStatus
  streamingResolutionHeight?: Maybe<Scalars['Int']>
  streamingResolutionWidth?: Maybe<Scalars['Int']>
  unsecuredBox: Box
  updatedAt: Scalars['String']
  verdictBadgeCount?: Maybe<Scalars['Int']>
  verdictPersonCount?: Maybe<Scalars['Int']>
  verdictType?: Maybe<TailgateVerdictType>
}

export type TailgateBadgeEvent = {
  __typename?: 'TailgateBadgeEvent'
  badgeNumber?: Maybe<Scalars['String']>
  cardHolderName?: Maybe<Scalars['String']>
  detectedAt: Scalars['String']
  id: Scalars['ID']
}

export enum TailgateGridTestFailureReason {
  ClipDownloadFailed = 'CLIP_DOWNLOAD_FAILED',
  EvaluationFailed = 'EVALUATION_FAILED',
  /** Backend-set (like TIMEOUT): a result arrived but could not be decoded (ENG-34042). */
  ResultDecodeFailed = 'RESULT_DECODE_FAILED',
  SidecarTooLarge = 'SIDECAR_TOO_LARGE',
  SidecarUploadFailed = 'SIDECAR_UPLOAD_FAILED',
  Timeout = 'TIMEOUT',
}

export enum TailgateScalingMode {
  DecodedFallback = 'DECODED_FALLBACK',
  None = 'NONE',
  StoredResolution = 'STORED_RESOLUTION',
}

export enum TailgateGridTestJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export enum TailgateVerdictType {
  Ntl = 'NTL',
  Tl = 'TL',
}

/** *Automatically generated.* */
export type TechnicianFilterInput = {
  AND?: InputMaybe<Array<TechnicianFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  deviceTypesContain?: InputMaybe<DeviceType>
  deviceTypesDoNotContain?: InputMaybe<DeviceType>
  deviceTypesNull?: InputMaybe<Scalars['Boolean']>
  email?: InputMaybe<Scalars['String']>
  emailGt?: InputMaybe<Scalars['String']>
  emailGte?: InputMaybe<Scalars['String']>
  emailIn?: InputMaybe<Array<Scalars['String']>>
  emailLike?: InputMaybe<Scalars['String']>
  emailLt?: InputMaybe<Scalars['String']>
  emailLte?: InputMaybe<Scalars['String']>
  emailNot?: InputMaybe<Scalars['String']>
  emailNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityIdsContain?: InputMaybe<Scalars['ID']>
  facilityIdsDoNotContain?: InputMaybe<Scalars['ID']>
  facilityIdsNull?: InputMaybe<Scalars['Boolean']>
  firstName?: InputMaybe<Scalars['String']>
  firstNameGt?: InputMaybe<Scalars['String']>
  firstNameGte?: InputMaybe<Scalars['String']>
  firstNameIn?: InputMaybe<Array<Scalars['String']>>
  firstNameLike?: InputMaybe<Scalars['String']>
  firstNameLt?: InputMaybe<Scalars['String']>
  firstNameLte?: InputMaybe<Scalars['String']>
  firstNameNot?: InputMaybe<Scalars['String']>
  firstNameNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  lastName?: InputMaybe<Scalars['String']>
  lastNameGt?: InputMaybe<Scalars['String']>
  lastNameGte?: InputMaybe<Scalars['String']>
  lastNameIn?: InputMaybe<Array<Scalars['String']>>
  lastNameLike?: InputMaybe<Scalars['String']>
  lastNameLt?: InputMaybe<Scalars['String']>
  lastNameLte?: InputMaybe<Scalars['String']>
  lastNameNot?: InputMaybe<Scalars['String']>
  lastNameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<TechnicianFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type TechnicianOrderInput = {
  direction: OrderDirection
  field: TechnicianOrderField
}

/** *Automatically generated.* */
export enum TechnicianOrderField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** *Automatically generated.* */
export type TechnicianConnection = {
  __typename?: 'TechnicianConnection'
  edges?: Maybe<Array<Maybe<TechnicianEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type TechnicianEdge = {
  __typename?: 'TechnicianEdge'
  cursor: Scalars['String']
  node?: Maybe<Technician>
}

export type UserViewedFeature = {
  __typename?: 'UserViewedFeature'
  createdAt: Scalars['String']
  featureId: Scalars['ID']
  id: Scalars['ID']
  userId: Scalars['ID']
}

/**
 * A destination an incident can be sent to by hand: where to send it, how, and which saved payload template to
 * render the incident into.
 */
export type Webhook = {
  __typename?: 'Webhook'
  /** Sent as-is on every request. Stored in plaintext in this first version. */
  authHeader?: Maybe<HttpHeader>
  createdAt: Scalars['String']
  /** Where the request is sent. Any non-empty string. */
  destination: Scalars['String']
  httpMethod: WebhookHttpMethod
  id: Scalars['ID']
  /** User-defined and unique, at most 100 characters. */
  name: Scalars['String']
  savedPayload?: Maybe<SavedPayload>
  savedPayloadId: Scalars['ID']
  updatedAt: Scalars['String']
}

export enum WebhookHttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
}

export type WebhookConnection = {
  __typename?: 'WebhookConnection'
  edges?: Maybe<Array<Maybe<WebhookEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type WebhookEdge = {
  __typename?: 'WebhookEdge'
  cursor: Scalars['String']
  node?: Maybe<Webhook>
}

export type Mutation = {
  __typename?: 'Mutation'
  /**
   * Associate a video with an event.
   * The event must already exist in the database.
   *
   * It's an error to use this mutation if a
   * different video has already been associated with the event.
   * However, it's OK to use this mutation with an event
   * and video that have already been associated with
   * each other.
   */
  activateEmailRecipient?: Maybe<UpdateEmailRecipientPayload>
  addCustomFormQuestionOption: AddCustomFormQuestionOptionPayload
  addTagsToDevice: AddTagsToDevicePayload
  /**
   * Adds every specified tag to every specified device in a single atomic operation.
   *
   * Idempotent: tags already assigned to a device are skipped. The whole operation
   * fails (and rolls back) if any tag or device does not exist, any tag is archived,
   * or any device would exceed the maximum number of tags.
   */
  addTagsToDevices: AddTagsToDevicesPayload
  appendDevicesToEdgeDevice?: Maybe<AppendDevicesToEdgeDevicePayload>
  appendEventVideo?: Maybe<AppendEventVideoPayload>
  appendIncidentVideo?: Maybe<AppendIncidentVideoPayload>
  archiveCustomForm: ArchiveCustomFormPayload
  /**
   * Rejected while unresolved incidents exist on the floor, or while guard tours
   * using the floor's checkpoints are in progress. Guard tour plans referencing the
   * floor are reconciled: spanning plans get a new version without this floor's
   * checkpoints, plans left empty are archived. Use previewArchiveFloor to show the
   * impact before committing.
   */
  archiveFloor?: Maybe<ArchiveFloorPayload>
  archiveIncidentWorkflow: ArchiveIncidentWorkflowPayload
  archiveRule?: Maybe<ArchiveRulePayload>
  archiveTag: ArchiveTagPayload
  associateEmailRecipients?: Maybe<AssociateEmailRecipientsPayload>
  associateMultipleIncidentsToSingleCase?: Maybe<UpdateCasePayload>
  associatePersonOfInterestToCase?: Maybe<UpdateCasePayload>
  associateSingleIncidentToMultipleCases?: Maybe<UpdateIncidentPayload>
  /**
   * Resolves stale incidents in bulk with skip-and-report semantics: RESOLVED,
   * unknown, or QuickReport-whitelist-inaccessible incidents are skipped and
   * reported, the rest (ACTIVE or IN_PROGRESS) are resolved. Unlike
   * createBulkIncidentAction, this never fails the whole batch.
   * PROGRAM scope requires the PROGRAM_MANAGER or IMPLEMENTER role.
   */
  bulkResolveStaleIncidents?: Maybe<BulkResolveStaleIncidentsPayload>
  changePassword?: Maybe<ChangePasswordPayload>
  createAcknowledgement?: Maybe<CreateAcknowledgementPayload>
  createAiOperatorFeedback?: Maybe<CreateAiOperatorFeedbackPayload>
  createAiOperatorHumanLabel: CreateAiOperatorHumanLabelPayload
  createAiOperatorRuleEvaluations?: Maybe<CreateAiOperatorRuleEvaluationsPayload>
  createAlarm?: Maybe<CreateAlarmPayload>
  /** *Automatically generated.* */
  createAlert?: Maybe<CreateAlertPayload>
  /** *Automatically generated.* */
  createAudioClip?: Maybe<CreateAudioClipPayload>
  /** *Automatically generated.* */
  createAudioMessage?: Maybe<CreateAudioMessagePayload>
  createBulkIncidentAction?: Maybe<CreateBulkIncidentActionPayload>
  createCamera?: Maybe<CreateCameraPayload>
  createCase?: Maybe<CreateCasePayload>
  createCaseComment?: Maybe<CreateCaseCommentPayload>
  /** *Automatically generated.* */
  createCharge?: Maybe<CreateChargePayload>
  /** *Automatically generated.* */
  createCheckIn?: Maybe<CreateCheckInPayload>
  createCheckIns?: Maybe<CheckInConnection>
  /** *Automatically generated.* */
  createCheckOut?: Maybe<CreateCheckOutPayload>
  createCheckOuts?: Maybe<CheckOutConnection>
  createCheckpoint?: Maybe<CreateDevicePayload>
  createCheckpointTask?: Maybe<CreateCheckpointTaskPayload>
  /** *Automatically generated.* */
  createCreditCard?: Maybe<CreateCreditCardPayload>
  createCustomerSecretProvider?: Maybe<CreateCustomerSecretProviderPayload>
  createCustomForm: CreateCustomFormPayload
  /** Create an incident from a custom form submission (Quick Report) */
  createCustomFormIncident?: Maybe<CreateCustomFormIncidentPayload>
  createCustomFormQuestion: CreateCustomFormQuestionPayload
  createCustomFormSection: CreateCustomFormSectionPayload
  createDatabaseReset?: Maybe<CreateDatabaseResetPayload>
  /** *Automatically generated.* */
  createDevice?: Maybe<CreateDevicePayload>
  createDeviceNote?: Maybe<CreateDeviceNotePayload>
  /** *Automatically generated.* */
  createDeviceRepairOrder?: Maybe<CreateDeviceRepairOrderPayload>
  createDevices?: Maybe<Array<Maybe<CreateDevicePayload>>>
  /** *Automatically generated.* */
  createDoor?: Maybe<CreateDoorPayload>
  createEdgeDevice?: Maybe<CreateEdgeDevicePayload>
  createEmailRecipient?: Maybe<CreateEmailRecipientPayload>
  createEmailSource?: Maybe<CreateEmailSourcePayload>
  /** *Automatically generated.* */
  createEmergencyCall?: Maybe<CreateEmergencyCallPayload>
  /** *Automatically generated.* */
  createEmergencyCalling?: Maybe<CreateEmergencyCallingPayload>
  /** *Automatically generated.* */
  createEvent?: Maybe<CreateEventPayload>
  createEventPresentation?: Maybe<CreateEventPresentationPayload>
  createExternalAccount?: Maybe<CreateExternalAccountPayload>
  createExternalAccountApiKey?: Maybe<CreateExternalAccountApiKeyPayload>
  createExternalAccountIdp?: Maybe<CreateExternalAccountIdpPayload>
  createExternalAccountProperties?: Maybe<CreateExternalAccountPropertiesPayload>
  createExternalIncident?: Maybe<CreateExternalIncidentPayload>
  /** *Automatically generated.* */
  createFacility?: Maybe<CreateFacilityPayload>
  /** *Automatically generated.* */
  createFloor?: Maybe<CreateFloorPayload>
  /** *Automatically generated.* */
  createFloorPlan?: Maybe<CreateFloorPlanPayload>
  createFormForIncidentCategory: CreateFormForIncidentCategoryPayload
  /** *Automatically generated.* */
  createGateway?: Maybe<CreateGatewayPayload>
  createGridAnalysisJob?: Maybe<CreateGridAnalysisJobPayload>
  /** *Automatically generated.* */
  createGuardTour?: Maybe<CreateGuardTourPayload>
  /** *Automatically generated.* */
  createIncident?: Maybe<CreateIncidentPayload>
  /** *Automatically generated.* */
  createIncidentAction?: Maybe<CreateIncidentActionPayload>
  createIncidentCategoryWhitelist?: Maybe<IncidentCategoryWhitelistConnection>
  /** *Automatically generated.* */
  createIncidentDeviceMedia?: Maybe<CreateIncidentDeviceMediaPayload>
  /** *Automatically generated.* */
  createIncidentInformationSolicitation?: Maybe<CreateIncidentInformationSolicitationPayload>
  /** *Automatically generated.* */
  createIncidentNote?: Maybe<CreateIncidentNotePayload>
  createIncidentNoteMedia?: Maybe<CreateIncidentNoteMediaPayload>
  /** *Automatically generated.* */
  createIncidentOccurrence?: Maybe<CreateIncidentOccurrencePayload>
  /** *Automatically generated.* */
  createIncidentOffer?: Maybe<CreateIncidentOfferPayload>
  /** *Automatically generated.* */
  createIncidentOfferAcceptance?: Maybe<CreateIncidentOfferAcceptancePayload>
  /** *Automatically generated.* */
  createIncidentOfferToGuard?: Maybe<CreateIncidentOfferToGuardPayload>
  /** *Automatically generated.* */
  createIncidentOfferToGuardAcceptance?: Maybe<CreateIncidentOfferToGuardAcceptancePayload>
  /** *Automatically generated.* */
  createIncidentShare?: Maybe<CreateIncidentSharePayload>
  createIncidentTypeDefinition?: Maybe<CreateIncidentTypeDefinitionPayload>
  createIncidentWorkflow: CreateIncidentWorkflowPayload
  /** *Automatically generated.* */
  createInvoice?: Maybe<CreateInvoicePayload>
  createLlmIncidents?: Maybe<CreateLlmIncidentsPayload>
  createManualIncidentCategory?: Maybe<CreateManualIncidentCategoryPayload>
  /** *Automatically generated.* */
  createOrganization?: Maybe<CreateOrganizationPayload>
  /** *Automatically generated.* */
  createOrganizationSettings?: Maybe<CreateOrganizationSettingsPayload>
  createPacsSourceInstance?: Maybe<CreatePacsSourceInstancePayload>
  /** *Automatically generated.* */
  createPartialCreditCard?: Maybe<CreatePartialCreditCardPayload>
  /** *Automatically generated.* */
  createPermission?: Maybe<CreatePermissionPayload>
  /**
   * Creating a person of interest occurs in the context of a case.
   * Creation associates the person with the case.
   * Behind the scenes, this involves 2 operations:
   * 1. PersonOfInterest creation.
   * 2. Association of the newly created PersonOfInterest to the case.
   * Creation is a partially auditable operation, i.e: operation 2 will be audited.
   */
  createPersonOfInterest?: Maybe<CreatePersonOfInterestPayload>
  createProductMessage?: Maybe<CreateProductMessagePayload>
  createProgramRecommendation?: Maybe<CreateProgramRecommendationPayload>
  createQuickReport?: Maybe<CreateQuickReportPayload>
  /** *Automatically generated.* */
  createRole?: Maybe<CreateRolePayload>
  /** *Automatically generated.* */
  createRule?: Maybe<CreateRulePayload>
  createSavedFilter?: Maybe<CreateSavedFilterPayload>
  createSavedPayload?: Maybe<CreateSavedPayloadPayload>
  createStandardOperatingProcedure?: Maybe<CreateStandardOperatingProcedurePayload>
  /** *Automatically generated.* */
  createSubscriberMessage?: Maybe<CreateSubscriberMessagePayload>
  createTag: CreateTagPayload
  createTagAndAddToDevice: CreateTagAndAddToDevicePayload
  /** *Automatically generated.* */
  createTailgateConn?: Maybe<CreateTailgateConnPayload>
  createTailgateGridTestJob?: Maybe<CreateTailgateGridTestJobPayload>
  /** *Automatically generated.* */
  createTechnician?: Maybe<CreateTechnicianPayload>
  createThreat?: Maybe<CreateThreatPayload>
  /** *Automatically generated.* */
  createTourPlan?: Maybe<CreateTourPlanPayload>
  /**
   * Creates a user without sending an invitation email.
   * @deprecated Use inviteUser instead. Will be removed when user management is fully rolled out.
   */
  createUser?: Maybe<CreateUserPayload>
  createUserFeedback?: Maybe<CreateUserFeedbackPayload>
  createWebhook?: Maybe<CreateWebhookPayload>
  createWorkflowAction: Incident
  deactivateEmailRecipient?: Maybe<UpdateEmailRecipientPayload>
  deleteAcknowledgement?: Maybe<DeleteAcknowledgementPayload>
  /** *Automatically generated.* */
  deleteAiOperatorDeviceConfiguration: DeleteAiOperatorDeviceConfigurationPayload
  deleteAiOperatorResponseRules?: Maybe<DeleteAiOperatorResponseRulesPayload>
  deleteAlarm?: Maybe<DeleteAlarmPayload>
  /** *Automatically generated.* */
  deleteAlert?: Maybe<DeleteAlertPayload>
  /** *Automatically generated.* */
  deleteAudioClip?: Maybe<DeleteAudioClipPayload>
  /** *Automatically generated.* */
  deleteAudioMessage?: Maybe<DeleteAudioMessagePayload>
  /** *Automatically generated.* */
  deleteCamera?: Maybe<DeleteCameraPayload>
  /** *Automatically generated.* */
  deleteCameraLiveFeedDetail?: Maybe<DeleteCameraLiveFeedDetailPayload>
  /** *Automatically generated.* */
  deleteCharge?: Maybe<DeleteChargePayload>
  /** *Automatically generated.* */
  deleteCheckIn?: Maybe<DeleteCheckInPayload>
  /** *Automatically generated.* */
  deleteCheckOut?: Maybe<DeleteCheckOutPayload>
  deleteCheckpointTask?: Maybe<DeleteCheckpointTaskPayload>
  /** *Automatically generated.* */
  deleteCreditCard?: Maybe<DeleteCreditCardPayload>
  deleteCustomerSecretProvider?: Maybe<DeleteCustomerSecretProviderPayload>
  deleteCustomFormQuestion: DeleteCustomFormQuestionPayload
  deleteCustomFormQuestionOption: DeleteCustomFormQuestionOptionPayload
  deleteCustomFormSection: DeleteCustomFormSectionPayload
  /** *Automatically generated.* */
  deleteDevice?: Maybe<DeleteDevicePayload>
  /** *Automatically generated.* */
  deleteDeviceRepairOrder?: Maybe<DeleteDeviceRepairOrderPayload>
  /** *Automatically generated.* */
  deleteDoor?: Maybe<DeleteDoorPayload>
  deleteEdgeDevice?: Maybe<DeleteEdgeDevicePayload>
  /** *Automatically generated.* */
  deleteEmergencyCall?: Maybe<DeleteEmergencyCallPayload>
  /** *Automatically generated.* */
  deleteEmergencyCalling?: Maybe<DeleteEmergencyCallingPayload>
  /** *Automatically generated.* */
  deleteEvent?: Maybe<DeleteEventPayload>
  deleteExternalAccount?: Maybe<DeleteExternalAccountPayload>
  deleteExternalAccountApiKey?: Maybe<DeleteExternalAccountApiKeyPayload>
  deleteExternalAccountIdp?: Maybe<DeleteExternalAccountIdpPayload>
  deleteExternalAccountProperties?: Maybe<DeleteExternalAccountPropertiesPayload>
  /** *Automatically generated.* */
  deleteFacility?: Maybe<DeleteFacilityPayload>
  /** *Automatically generated.* */
  deleteFloor?: Maybe<DeleteFloorPayload>
  /** *Automatically generated.* */
  deleteFloorPlan?: Maybe<DeleteFloorPlanPayload>
  /** *Automatically generated.* */
  deleteGateway?: Maybe<DeleteGatewayPayload>
  /** *Automatically generated.* */
  deleteGuardTour?: Maybe<DeleteGuardTourPayload>
  /** *Automatically generated.* */
  deleteIncident?: Maybe<DeleteIncidentPayload>
  /** *Automatically generated.* */
  deleteIncidentAction?: Maybe<DeleteIncidentActionPayload>
  /** *Automatically generated.* */
  deleteIncidentDeviceMedia?: Maybe<DeleteIncidentDeviceMediaPayload>
  /** *Automatically generated.* */
  deleteIncidentInformationSolicitation?: Maybe<DeleteIncidentInformationSolicitationPayload>
  /** *Automatically generated.* */
  deleteIncidentNote?: Maybe<DeleteIncidentNotePayload>
  /** *Automatically generated.* */
  deleteIncidentOccurrence?: Maybe<DeleteIncidentOccurrencePayload>
  /** *Automatically generated.* */
  deleteIncidentOffer?: Maybe<DeleteIncidentOfferPayload>
  /** *Automatically generated.* */
  deleteIncidentOfferAcceptance?: Maybe<DeleteIncidentOfferAcceptancePayload>
  /** *Automatically generated.* */
  deleteIncidentOfferToGuard?: Maybe<DeleteIncidentOfferToGuardPayload>
  /** *Automatically generated.* */
  deleteIncidentOfferToGuardAcceptance?: Maybe<DeleteIncidentOfferToGuardAcceptancePayload>
  /** *Automatically generated.* */
  deleteIncidentShare?: Maybe<DeleteIncidentSharePayload>
  deleteIncidentTypeDefinition?: Maybe<DeleteIncidentTypeDefinitionPayload>
  deleteIntegrationFieldMapping: DeleteIntegrationFieldMappingPayload
  deleteIntegrationQuestionMapping: DeleteIntegrationQuestionMappingPayload
  /** *Automatically generated.* */
  deleteInvoice?: Maybe<DeleteInvoicePayload>
  deleteManualIncidentCategory?: Maybe<DeleteManualIncidentCategoryPayload>
  /** *Automatically generated.* */
  deleteOrganization?: Maybe<DeleteOrganizationPayload>
  /** *Automatically generated.* */
  deleteOrganizationSettings?: Maybe<DeleteOrganizationSettingsPayload>
  /** *Automatically generated.* */
  deletePartialCreditCard?: Maybe<DeletePartialCreditCardPayload>
  /** *Automatically generated.* */
  deletePermission?: Maybe<DeletePermissionPayload>
  deleteProductMessage?: Maybe<DeleteProductMessagePayload>
  /** *Automatically generated.* */
  deleteRole?: Maybe<DeleteRolePayload>
  deleteSavedFilter?: Maybe<DeleteSavedFilterPayload>
  deleteSavedPayload?: Maybe<DeleteSavedPayloadPayload>
  /** *Automatically generated.* */
  deleteStandardOperatingProcedure?: Maybe<DeleteStandardOperatingProcedurePayload>
  /** *Automatically generated.* */
  deleteSubscriberMessage?: Maybe<DeleteSubscriberMessagePayload>
  deleteTag: DeleteTagPayload
  /** *Automatically generated.* */
  deleteTailgateConn?: Maybe<DeleteTailgateConnPayload>
  deleteTailgateGrid?: Maybe<DeleteTailgateGridPayload>
  /** *Automatically generated.* */
  deleteTechnician?: Maybe<DeleteTechnicianPayload>
  /** *Automatically generated.* */
  deleteTourPlan?: Maybe<DeleteTourPlanPayload>
  /**
   * Soft-deletes a user by disabling their account.
   * **Deprecated**: Use `offboardUser` instead. This mutation only disables the user without
   * revoking sessions or stripping roles, which is a security risk.
   * @deprecated Use offboardUser instead. This only disables the user without revoking sessions or roles.
   */
  deleteUser?: Maybe<DeleteUserPayload>
  deleteWebhook?: Maybe<DeleteWebhookPayload>
  /** Stops the source creating new incidents. Its Ingest Address and ID are kept. Does nothing if it is already disabled. */
  disableEmailSource?: Maybe<DisableEmailSourcePayload>
  disassociateMultipleIncidentsFromSingleCase?: Maybe<UpdateCasePayload>
  disassociatePersonOfInterestFromCase?: Maybe<UpdateCasePayload>
  /**
   * Return information for embedding QuickSight content
   * (a dashboard)
   * in a web page.
   */
  embedQuickSightContent?: Maybe<EmbedQuickSightContentPayload>
  /** Lets a disabled source create incidents again, with the same Ingest Address. Does nothing if it is already enabled. */
  enableEmailSource?: Maybe<EnableEmailSourcePayload>
  enableManualIncidentCategoriesForQuickReport?: Maybe<ManualIncidentCategoryConnection>
  generateFileUploadUrl?: Maybe<GenerateFileUploadUrlPayload>
  generateIncidentSummary: GenerateIncidentSummaryPayload
  /** Creates a new user and sends an email invitation to set their password. */
  inviteUser?: Maybe<InviteUserPayload>
  linkCustomerSecretProvider?: Maybe<LinkCustomerSecretProviderPayload>
  logGuardTourCheckpoint?: Maybe<UpdateGuardTourPayload>
  markFeatureAsViewed: Scalars['Boolean']
  /** Records that the current user completed a first-time-use guide. Idempotent. */
  markFtuCompleted: MarkFtuCompletedPayload
  modifyTailgateConn?: Maybe<ModifyTailgateConnPayload>
  /** *Automatically generated.* */
  offboardUser?: Maybe<OffboardUserPayload>
  publishCustomForm: PublishCustomFormPayload
  refreshQuickReportCode?: Maybe<RefreshQuickReportCodePayload>
  registerPushNotificationQuery?: Maybe<RegisterPushNotificationQueryPayload>
  removeTagsFromDevice: RemoveTagsFromDevicePayload
  /**
   * Removes every specified tag from every specified device in a single atomic operation.
   *
   * Idempotent: removing a tag that a device does not have is a no-op. The whole
   * operation fails (and rolls back) if any specified device does not exist.
   */
  removeTagsFromDevices: RemoveTagsFromDevicesPayload
  reorderFloors?: Maybe<ReorderFloorsPayload>
  /** Resends an invitation email to an existing user. Invalidates any previous invite links. */
  resendUserInvite?: Maybe<ResendUserInvitePayload>
  restartEdgeDevice?: Maybe<RestartEdgeDevicePayload>
  /**
   * Replaces the Ingest Address with a new one. The old address stops creating incidents straight away, so the alarm
   * system must be reconfigured with the new one.
   */
  rotateEmailSourceIngestAddress?: Maybe<RotateEmailSourceIngestAddressPayload>
  /**
   * Sends the incident to the webhook's destination, rendered through the webhook's saved payload. Returns the
   * destination's response as-is, whatever its status; fails only when no response is received.
   */
  sendWebhook?: Maybe<SendWebhookPayload>
  setUserPhoto?: Maybe<SetUserPhotoPayload>
  submitGuardTour?: Maybe<UpdateGuardTourPayload>
  transitionProgramRecommendation?: Maybe<TransitionProgramRecommendationPayload>
  unarchiveFloor?: Maybe<UnarchiveFloorPayload>
  unlinkCustomerSecretProvider?: Maybe<UnlinkCustomerSecretProviderPayload>
  unpublishCustomForm: UnpublishCustomFormPayload
  /** *Automatically generated.* */
  updateAcknowledgement?: Maybe<UpdateAcknowledgementPayload>
  updateAiOperatorHumanLabel: UpdateAiOperatorHumanLabelPayload
  updateAiOperatorLimit?: Maybe<UpdateAiOperatorSettingsPayload>
  updateAiOperatorModel?: Maybe<UpdateAiOperatorModelPayload>
  updateAiOperatorResponseRules?: Maybe<UpdateAiOperatorResponseRulesPayload>
  updateAiOperatorThresholds?: Maybe<UpdateAiOperatorThresholdsPayload>
  updateAlarm?: Maybe<UpdateAlarmPayload>
  /** *Automatically generated.* */
  updateAlert?: Maybe<UpdateAlertPayload>
  /** *Automatically generated.* */
  updateAudioClip?: Maybe<UpdateAudioClipPayload>
  /** *Automatically generated.* */
  updateAudioMessage?: Maybe<UpdateAudioMessagePayload>
  /** *Automatically generated.* */
  updateCamera?: Maybe<UpdateCameraPayload>
  updateCase?: Maybe<UpdateCasePayload>
  updateCaseOwner?: Maybe<UpdateCasePayload>
  updateCaseStatus?: Maybe<UpdateCasePayload>
  /** *Automatically generated.* */
  updateCharge?: Maybe<UpdateChargePayload>
  /** *Automatically generated.* */
  updateCheckIn?: Maybe<UpdateCheckInPayload>
  updateCheckpoint?: Maybe<Checkpoint>
  updateCheckpointTask?: Maybe<UpdateCheckpointTaskPayload>
  /** *Automatically generated.* */
  updateCreditCard?: Maybe<UpdateCreditCardPayload>
  updateCustomerSecretProvider?: Maybe<UpdateCustomerSecretProviderPayload>
  updateCustomForm: UpdateCustomFormPayload
  updateCustomFormQuestion: UpdateCustomFormQuestionPayload
  updateCustomFormQuestionOption: UpdateCustomFormQuestionOptionPayload
  updateCustomFormSection: UpdateCustomFormSectionPayload
  /** *Automatically generated.* */
  updateDevice?: Maybe<UpdateDevicePayload>
  /** *Automatically generated.* */
  updateDeviceRepairOrder?: Maybe<UpdateDeviceRepairOrderPayload>
  /** *Automatically generated.* */
  updateDoor?: Maybe<UpdateDoorPayload>
  updateEdgeDevice?: Maybe<UpdateEdgeDevicePayload>
  updateEmailRecipient?: Maybe<UpdateEmailRecipientPayload>
  updateEmailSource?: Maybe<UpdateEmailSourcePayload>
  /** *Automatically generated.* */
  updateEmergencyCall?: Maybe<UpdateEmergencyCallPayload>
  /** *Automatically generated.* */
  updateEmergencyCalling?: Maybe<UpdateEmergencyCallingPayload>
  /** *Automatically generated.* */
  updateEvent?: Maybe<UpdateEventPayload>
  updateExternalAccount?: Maybe<UpdateExternalAccountPayload>
  updateExternalAccountApiKey?: Maybe<UpdateExternalAccountApiKeyPayload>
  updateExternalAccountIdp?: Maybe<UpdateExternalAccountIdpPayload>
  updateExternalAccountProperties?: Maybe<UpdateExternalAccountPropertiesPayload>
  /** *Automatically generated.* */
  updateFacility?: Maybe<UpdateFacilityPayload>
  /** *Automatically generated.* */
  updateFloor?: Maybe<UpdateFloorPayload>
  /** *Automatically generated.* */
  updateFloorPlan?: Maybe<UpdateFloorPlanPayload>
  /** *Automatically generated.* */
  updateGateway?: Maybe<UpdateGatewayPayload>
  /** *Automatically generated.* */
  updateGuardTour?: Maybe<UpdateGuardTourPayload>
  /** *Automatically generated.* */
  updateIncident?: Maybe<UpdateIncidentPayload>
  /** *Automatically generated.* */
  updateIncidentAction?: Maybe<UpdateIncidentActionPayload>
  /** *Automatically generated.* */
  updateIncidentDeviceMedia?: Maybe<UpdateIncidentDeviceMediaPayload>
  /** *Automatically generated.* */
  updateIncidentInformationSolicitation?: Maybe<UpdateIncidentInformationSolicitationPayload>
  /** *Automatically generated.* */
  updateIncidentNote?: Maybe<UpdateIncidentNotePayload>
  /** *Automatically generated.* */
  updateIncidentOccurrence?: Maybe<UpdateIncidentOccurrencePayload>
  /** *Automatically generated.* */
  updateIncidentOffer?: Maybe<UpdateIncidentOfferPayload>
  /** *Automatically generated.* */
  updateIncidentOfferToGuard?: Maybe<UpdateIncidentOfferToGuardPayload>
  /** *Automatically generated.* */
  updateIncidentShare?: Maybe<UpdateIncidentSharePayload>
  updateIncidentTypeDefinition?: Maybe<UpdateIncidentTypeDefinitionPayload>
  updateIncidentWorkflow: UpdateIncidentWorkflowPayload
  updateManualIncidentCategory?: Maybe<UpdateManualIncidentCategoryPayload>
  updateMySetting: UpdateUserSettingPayload
  /** *Automatically generated.* */
  updateOrganization?: Maybe<UpdateOrganizationPayload>
  /** *Automatically generated.* */
  updateOrganizationSettings?: Maybe<UpdateOrganizationSettingsPayload>
  /**
   * Changes the organization's sound policy. Only the fields in the input are
   * changed. Program managers and implementers only.
   */
  updateOrganizationSoundPolicy: UpdateOrganizationSoundPolicyPayload
  updatePacsSourceInstance?: Maybe<UpdatePacsSourceInstancePayload>
  /** *Automatically generated.* */
  updatePartialCreditCard?: Maybe<UpdatePartialCreditCardPayload>
  /** *Automatically generated.* */
  updatePermission?: Maybe<UpdatePermissionPayload>
  updatePersonOfInterest?: Maybe<UpdatePersonOfInterestPayload>
  updatePersonOfInterestRole?: Maybe<UpdateCasePayload>
  updateProgramRecommendation?: Maybe<UpdateProgramRecommendationPayload>
  updateQuickReport?: Maybe<UpdateQuickReportPayload>
  /** *Automatically generated.* */
  updateRole?: Maybe<UpdateRolePayload>
  updateRule?: Maybe<UpdateRulePayload>
  updateSavedFilter?: Maybe<UpdateSavedFilterPayload>
  updateSavedPayload?: Maybe<UpdateSavedPayloadPayload>
  /** *Automatically generated.* */
  updateStandardOperatingProcedure?: Maybe<UpdateStandardOperatingProcedurePayload>
  /** *Automatically generated.* */
  updateSubscriberMessage?: Maybe<UpdateSubscriberMessagePayload>
  updateTag: UpdateTagPayload
  updateTailgateEnabled?: Maybe<TailgateGrid>
  updateTailgateGrid?: Maybe<UpdateTailgateGridPayload>
  /** *Automatically generated.* */
  updateTechnician?: Maybe<UpdateTechnicianPayload>
  /** *Automatically generated.* */
  updateTourPlan?: Maybe<UpdateTourPlanPayload>
  /** *Automatically generated.* */
  updateUser?: Maybe<UpdateUserPayload>
  /** *Automatically generated.* */
  updateUserRoles?: Maybe<UpdateUserRolesPayload>
  updateWebhook?: Maybe<UpdateWebhookPayload>
  upsertAiOperatorDeviceConfiguration: UpsertAiOperatorDeviceConfigurationPayload
  upsertIntegrationFieldMapping: UpsertIntegrationFieldMappingPayload
  upsertIntegrationQuestionMapping: UpsertIntegrationQuestionMappingPayload
  verifyIntegrationMapping: VerifyIntegrationMappingPayload
}

export type MutationActivateEmailRecipientArgs = {
  input: ActivateEmailRecipientInput
}

export type MutationAddCustomFormQuestionOptionArgs = {
  input: AddCustomFormQuestionOptionInput
}

export type MutationAddTagsToDeviceArgs = {
  input: AddTagsToDeviceInput
}

export type MutationAddTagsToDevicesArgs = {
  input: AddTagsToDevicesInput
}

export type MutationAppendDevicesToEdgeDeviceArgs = {
  input: AppendDevicesToEdgeDeviceInput
}

export type MutationAppendEventVideoArgs = {
  input?: InputMaybe<AppendEventVideoInput>
}

export type MutationAppendIncidentVideoArgs = {
  input?: InputMaybe<AppendIncidentVideoInput>
}

export type MutationArchiveCustomFormArgs = {
  input: ArchiveCustomFormInput
}

export type MutationArchiveFloorArgs = {
  input: ArchiveFloorInput
}

export type MutationArchiveIncidentWorkflowArgs = {
  input: ArchiveIncidentWorkflowInput
}

export type MutationArchiveRuleArgs = {
  input: ArchiveRuleInput
}

export type MutationArchiveTagArgs = {
  input: ArchiveTagInput
}

export type MutationAssociateEmailRecipientsArgs = {
  input: AssociateEmailRecipientsInput
}

export type MutationAssociateMultipleIncidentsToSingleCaseArgs = {
  input: AssociateIncidentsToCaseInput
}

export type MutationAssociatePersonOfInterestToCaseArgs = {
  input: AssociatePersonOfInterestInput
}

export type MutationAssociateSingleIncidentToMultipleCasesArgs = {
  input: AssociateIncidentToCasesInput
}

export type MutationBulkResolveStaleIncidentsArgs = {
  input: BulkResolveStaleIncidentsInput
}

export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>
}

export type MutationCreateAcknowledgementArgs = {
  input: CreateAcknowledgementInput
}

export type MutationCreateAiOperatorFeedbackArgs = {
  input: CreateAiOperatorFeedbackInput
}

export type MutationCreateAiOperatorHumanLabelArgs = {
  input: CreateAiOperatorHumanLabelInput
}

export type MutationCreateAiOperatorRuleEvaluationsArgs = {
  input: CreateAiOperatorRuleEvaluationsInput
}

export type MutationCreateAlarmArgs = {
  input: CreateAlarmInput
}

export type MutationCreateAlertArgs = {
  input: CreateAlertInput
}

export type MutationCreateAudioClipArgs = {
  input: CreateAudioClipInput
}

export type MutationCreateAudioMessageArgs = {
  input: CreateAudioMessageInput
}

export type MutationCreateBulkIncidentActionArgs = {
  input: CreateBulkIncidentActionInput
}

export type MutationCreateCameraArgs = {
  input: CreateCameraInput
}

export type MutationCreateCaseArgs = {
  input: CreateCaseInput
}

export type MutationCreateCaseCommentArgs = {
  input?: InputMaybe<CreateCaseCommentInput>
}

export type MutationCreateChargeArgs = {
  input: CreateChargeInput
}

export type MutationCreateCheckInArgs = {
  input: CreateCheckInInput
}

export type MutationCreateCheckInsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CheckInFilterInput>
  first?: InputMaybe<Scalars['Int']>
  input: CreateCheckInsInput
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<CheckInOrderInput>>>
}

export type MutationCreateCheckOutsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CheckOutFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<InputMaybe<CheckOutOrderInput>>>
}

export type MutationCreateCheckpointArgs = {
  input: CreateDeviceInput
}

export type MutationCreateCheckpointTaskArgs = {
  input: CreateCheckpointTaskInput
}

export type MutationCreateCreditCardArgs = {
  input: CreateCreditCardInput
}

export type MutationCreateCustomerSecretProviderArgs = {
  input: CreateCustomerSecretProviderInput
}

export type MutationCreateCustomFormArgs = {
  input: CreateCustomFormInput
}

export type MutationCreateCustomFormIncidentArgs = {
  input: CreateCustomFormIncidentInput
}

export type MutationCreateCustomFormQuestionArgs = {
  input: CreateCustomFormQuestionInput
}

export type MutationCreateCustomFormSectionArgs = {
  input: CreateCustomFormSectionInput
}

export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput
}

export type MutationCreateDeviceNoteArgs = {
  input: CreateDeviceNoteInput
}

export type MutationCreateDeviceRepairOrderArgs = {
  input: CreateDeviceRepairOrderInput
}

export type MutationCreateDevicesArgs = {
  input: CreateDevicesInput
}

export type MutationCreateDoorArgs = {
  input: CreateDoorInput
}

export type MutationCreateEdgeDeviceArgs = {
  input: CreateEdgeDeviceInput
}

export type MutationCreateEmailRecipientArgs = {
  input: CreateEmailRecipientInput
}

export type MutationCreateEmailSourceArgs = {
  input: CreateEmailSourceInput
}

export type MutationCreateEmergencyCallArgs = {
  input: CreateEmergencyCallInput
}

export type MutationCreateEmergencyCallingArgs = {
  input: CreateEmergencyCallingInput
}

export type MutationCreateEventArgs = {
  input: CreateEventInput
}

export type MutationCreateEventPresentationArgs = {
  input: CreateEventPresentationInput
}

export type MutationCreateExternalAccountArgs = {
  input?: InputMaybe<CreateExternalAccountInput>
}

export type MutationCreateExternalAccountApiKeyArgs = {
  input: CreateExternalAccountApiKeyInput
}

export type MutationCreateExternalAccountIdpArgs = {
  input: CreateExternalAccountIdpInput
}

export type MutationCreateExternalAccountPropertiesArgs = {
  input: CreateExternalAccountPropertiesInput
}

export type MutationCreateExternalIncidentArgs = {
  input?: InputMaybe<CreateExternalIncidentInput>
}

export type MutationCreateFacilityArgs = {
  input: CreateFacilityInput
}

export type MutationCreateFloorArgs = {
  input: CreateFloorInput
}

export type MutationCreateFloorPlanArgs = {
  input: CreateFloorPlanInput
}

export type MutationCreateFormForIncidentCategoryArgs = {
  input: CreateFormForIncidentCategoryInput
}

export type MutationCreateGatewayArgs = {
  input: CreateGatewayInput
}

export type MutationCreateGridAnalysisJobArgs = {
  input: CreateGridAnalysisJobInput
}

export type MutationCreateGuardTourArgs = {
  input: CreateGuardTourInput
}

export type MutationCreateIncidentArgs = {
  input: CreateIncidentInput
}

export type MutationCreateIncidentActionArgs = {
  input: CreateIncidentActionInput
}

export type MutationCreateIncidentCategoryWhitelistArgs = {
  input: CreateIncidentCategoryWhitelistInput
}

export type MutationCreateIncidentDeviceMediaArgs = {
  input: CreateIncidentDeviceMediaInput
}

export type MutationCreateIncidentInformationSolicitationArgs = {
  input: CreateIncidentInformationSolicitationInput
}

export type MutationCreateIncidentNoteArgs = {
  input: CreateIncidentNoteInput
}

export type MutationCreateIncidentNoteMediaArgs = {
  input: CreateIncidentNoteMediaInput
}

export type MutationCreateIncidentOccurrenceArgs = {
  input: CreateIncidentOccurrenceInput
}

export type MutationCreateIncidentOfferArgs = {
  input: CreateIncidentOfferInput
}

export type MutationCreateIncidentOfferToGuardArgs = {
  input: CreateIncidentOfferToGuardInput
}

export type MutationCreateIncidentShareArgs = {
  input: CreateIncidentShareInput
}

export type MutationCreateIncidentTypeDefinitionArgs = {
  input: CreateIncidentTypeDefinitionInput
}

export type MutationCreateIncidentWorkflowArgs = {
  input: CreateIncidentWorkflowInput
}

export type MutationCreateLlmIncidentsArgs = {
  input: CreateLlmIncidentsInput
}

export type MutationCreateManualIncidentCategoryArgs = {
  input: CreateManualIncidentCategoryInput
}

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput
}

export type MutationCreateOrganizationSettingsArgs = {
  input: CreateOrganizationSettingsInput
}

export type MutationCreatePacsSourceInstanceArgs = {
  input?: InputMaybe<CreatePacsSourceInstanceInput>
}

export type MutationCreatePartialCreditCardArgs = {
  input: CreatePartialCreditCardInput
}

export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput
}

export type MutationCreatePersonOfInterestArgs = {
  input?: InputMaybe<CreatePersonOfInterestInput>
}

export type MutationCreateProductMessageArgs = {
  input: CreateProductMessageInput
}

export type MutationCreateProgramRecommendationArgs = {
  input: CreateProgramRecommendationInput
}

export type MutationCreateQuickReportArgs = {
  input: CreateQuickReportInput
}

export type MutationCreateRoleArgs = {
  input: CreateRoleInput
}

export type MutationCreateRuleArgs = {
  input: CreateRuleInput
}

export type MutationCreateSavedFilterArgs = {
  input: CreateSavedFilterInput
}

export type MutationCreateSavedPayloadArgs = {
  input: CreateSavedPayloadInput
}

export type MutationCreateStandardOperatingProcedureArgs = {
  input: CreateStandardOperatingProcedureInput
}

export type MutationCreateSubscriberMessageArgs = {
  input: CreateSubscriberMessageInput
}

export type MutationCreateTagArgs = {
  input: CreateTagInput
}

export type MutationCreateTagAndAddToDeviceArgs = {
  input: CreateTagAndAddToDeviceInput
}

export type MutationCreateTailgateConnArgs = {
  input: CreateTailgateConnInput
}

export type MutationCreateTailgateGridTestJobArgs = {
  input: CreateTailgateGridTestJobInput
}

export type MutationCreateTechnicianArgs = {
  input: CreateTechnicianInput
}

export type MutationCreateThreatArgs = {
  input: CreateThreatInput
}

export type MutationCreateTourPlanArgs = {
  input: CreateTourPlanInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUserFeedbackArgs = {
  input: CreateUserFeedbackInput
}

export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput
}

export type MutationCreateWorkflowActionArgs = {
  input: CreateWorkflowActionInput
}

export type MutationDeactivateEmailRecipientArgs = {
  input: DeactivateEmailRecipientInput
}

export type MutationDeleteAcknowledgementArgs = {
  input: DeleteAcknowledgementInput
}

export type MutationDeleteAiOperatorDeviceConfigurationArgs = {
  input: DeleteAiOperatorDeviceConfigurationInput
}

export type MutationDeleteAiOperatorResponseRulesArgs = {
  input?: InputMaybe<DeleteAiOperatorResponseRulesInput>
}

export type MutationDeleteAlarmArgs = {
  input: DeleteAlarmInput
}

export type MutationDeleteAlertArgs = {
  input: DeleteAlertInput
}

export type MutationDeleteAudioClipArgs = {
  input: DeleteAudioClipInput
}

export type MutationDeleteAudioMessageArgs = {
  input: DeleteAudioMessageInput
}

export type MutationDeleteCameraArgs = {
  input: DeleteCameraInput
}

export type MutationDeleteCameraLiveFeedDetailArgs = {
  input: DeleteCameraLiveFeedDetailInput
}

export type MutationDeleteChargeArgs = {
  input: DeleteChargeInput
}

export type MutationDeleteCheckInArgs = {
  input: DeleteCheckInInput
}

export type MutationDeleteCheckOutArgs = {
  input: DeleteCheckOutInput
}

export type MutationDeleteCheckpointTaskArgs = {
  input: DeleteCheckpointTaskInput
}

export type MutationDeleteCreditCardArgs = {
  input: DeleteCreditCardInput
}

export type MutationDeleteCustomerSecretProviderArgs = {
  id: Scalars['ID']
}

export type MutationDeleteCustomFormQuestionArgs = {
  input: DeleteCustomFormQuestionInput
}

export type MutationDeleteCustomFormQuestionOptionArgs = {
  input: DeleteCustomFormQuestionOptionInput
}

export type MutationDeleteCustomFormSectionArgs = {
  input: DeleteCustomFormSectionInput
}

export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput
}

export type MutationDeleteDeviceRepairOrderArgs = {
  input: DeleteDeviceRepairOrderInput
}

export type MutationDeleteDoorArgs = {
  input: DeleteDoorInput
}

export type MutationDeleteEdgeDeviceArgs = {
  input: DeleteEdgeDeviceInput
}

export type MutationDeleteEmergencyCallArgs = {
  input: DeleteEmergencyCallInput
}

export type MutationDeleteEmergencyCallingArgs = {
  input: DeleteEmergencyCallingInput
}

export type MutationDeleteEventArgs = {
  input: DeleteEventInput
}

export type MutationDeleteExternalAccountArgs = {
  input: DeleteExternalAccountInput
}

export type MutationDeleteExternalAccountApiKeyArgs = {
  input: DeleteExternalAccountApiKeyInput
}

export type MutationDeleteExternalAccountIdpArgs = {
  input: DeleteExternalAccountIdpInput
}

export type MutationDeleteExternalAccountPropertiesArgs = {
  input: DeleteExternalAccountPropertiesInput
}

export type MutationDeleteFacilityArgs = {
  input: DeleteFacilityInput
}

export type MutationDeleteFloorArgs = {
  input: DeleteFloorInput
}

export type MutationDeleteFloorPlanArgs = {
  input: DeleteFloorPlanInput
}

export type MutationDeleteGatewayArgs = {
  input: DeleteGatewayInput
}

export type MutationDeleteGuardTourArgs = {
  input: DeleteGuardTourInput
}

export type MutationDeleteIncidentArgs = {
  input: DeleteIncidentInput
}

export type MutationDeleteIncidentActionArgs = {
  input: DeleteIncidentActionInput
}

export type MutationDeleteIncidentDeviceMediaArgs = {
  input: DeleteIncidentDeviceMediaInput
}

export type MutationDeleteIncidentInformationSolicitationArgs = {
  input: DeleteIncidentInformationSolicitationInput
}

export type MutationDeleteIncidentNoteArgs = {
  input: DeleteIncidentNoteInput
}

export type MutationDeleteIncidentOccurrenceArgs = {
  input: DeleteIncidentOccurrenceInput
}

export type MutationDeleteIncidentOfferArgs = {
  input: DeleteIncidentOfferInput
}

export type MutationDeleteIncidentOfferAcceptanceArgs = {
  input: DeleteIncidentOfferAcceptanceInput
}

export type MutationDeleteIncidentOfferToGuardArgs = {
  input: DeleteIncidentOfferToGuardInput
}

export type MutationDeleteIncidentOfferToGuardAcceptanceArgs = {
  input: DeleteIncidentOfferToGuardAcceptanceInput
}

export type MutationDeleteIncidentShareArgs = {
  input: DeleteIncidentShareInput
}

export type MutationDeleteIncidentTypeDefinitionArgs = {
  id: Scalars['ID']
}

export type MutationDeleteIntegrationFieldMappingArgs = {
  input: DeleteIntegrationFieldMappingInput
}

export type MutationDeleteIntegrationQuestionMappingArgs = {
  input: DeleteIntegrationQuestionMappingInput
}

export type MutationDeleteInvoiceArgs = {
  input: DeleteInvoiceInput
}

export type MutationDeleteManualIncidentCategoryArgs = {
  input: DeleteManualIncidentCategoryInput
}

export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput
}

export type MutationDeleteOrganizationSettingsArgs = {
  input: DeleteOrganizationSettingsInput
}

export type MutationDeletePartialCreditCardArgs = {
  input: DeletePartialCreditCardInput
}

export type MutationDeletePermissionArgs = {
  input: DeletePermissionInput
}

export type MutationDeleteProductMessageArgs = {
  input: DeleteProductMessageInput
}

export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput
}

export type MutationDeleteSavedFilterArgs = {
  input: DeleteSavedFilterInput
}

export type MutationDeleteSavedPayloadArgs = {
  input: DeleteSavedPayloadInput
}

export type MutationDeleteStandardOperatingProcedureArgs = {
  input: DeleteStandardOperatingProcedureInput
}

export type MutationDeleteSubscriberMessageArgs = {
  input: DeleteSubscriberMessageInput
}

export type MutationDeleteTagArgs = {
  input: DeleteTagInput
}

export type MutationDeleteTailgateConnArgs = {
  input: DeleteTailgateConnInput
}

export type MutationDeleteTailgateGridArgs = {
  input: DeleteTailgateGridInput
}

export type MutationDeleteTechnicianArgs = {
  input: DeleteTechnicianInput
}

export type MutationDeleteTourPlanArgs = {
  input: DeleteTourPlanInput
}

export type MutationDeleteUserArgs = {
  input: DeleteUserInput
}

export type MutationDeleteWebhookArgs = {
  input: DeleteWebhookInput
}

export type MutationDisableEmailSourceArgs = {
  input: DisableEmailSourceInput
}

export type MutationDisassociateMultipleIncidentsFromSingleCaseArgs = {
  input: DisassociateIncidentsFromCaseInput
}

export type MutationDisassociatePersonOfInterestFromCaseArgs = {
  input: DisassociatePersonOfInterestInput
}

export type MutationEmbedQuickSightContentArgs = {
  input?: InputMaybe<EmbedQuickSightContentInput>
}

export type MutationEnableEmailSourceArgs = {
  input: EnableEmailSourceInput
}

export type MutationEnableManualIncidentCategoriesForQuickReportArgs = {
  input: EnableManualIncidentCategoriesForQuickReportInput
}

export type MutationGenerateFileUploadUrlArgs = {
  input?: InputMaybe<GenerateFileUploadUrlInput>
}

export type MutationGenerateIncidentSummaryArgs = {
  input: GenerateIncidentSummaryInput
}

export type MutationInviteUserArgs = {
  input: InviteUserInput
}

export type MutationLinkCustomerSecretProviderArgs = {
  input: LinkCustomerSecretProviderInput
}

export type MutationLogGuardTourCheckpointArgs = {
  input: LogGuardTourCheckpointInput
}

export type MutationMarkFeatureAsViewedArgs = {
  featureId: Scalars['ID']
}

export type MutationMarkFtuCompletedArgs = {
  input: MarkFtuCompletedInput
}

export type MutationModifyTailgateConnArgs = {
  input: ModifyTailgateConnInput
}

export type MutationOffboardUserArgs = {
  input: OffboardUserInput
}

export type MutationPublishCustomFormArgs = {
  input: PublishCustomFormInput
}

export type MutationRegisterPushNotificationQueryArgs = {
  input: RegisterPushNotificationQueryInput
}

export type MutationRemoveTagsFromDeviceArgs = {
  input: RemoveTagsFromDeviceInput
}

export type MutationRemoveTagsFromDevicesArgs = {
  input: RemoveTagsFromDevicesInput
}

export type MutationReorderFloorsArgs = {
  input: ReorderFloorsInput
}

export type MutationResendUserInviteArgs = {
  input: ResendUserInviteInput
}

export type MutationRestartEdgeDeviceArgs = {
  input: RestartEdgeDeviceInput
}

export type MutationRotateEmailSourceIngestAddressArgs = {
  input: RotateEmailSourceIngestAddressInput
}

export type MutationSendWebhookArgs = {
  input: SendWebhookInput
}

export type MutationSetUserPhotoArgs = {
  input?: InputMaybe<SetUserPhotoInput>
}

export type MutationSubmitGuardTourArgs = {
  id: Scalars['ID']
}

export type MutationTransitionProgramRecommendationArgs = {
  input: TransitionProgramRecommendationInput
}

export type MutationUnarchiveFloorArgs = {
  input: UnarchiveFloorInput
}

export type MutationUnlinkCustomerSecretProviderArgs = {
  input: UnlinkCustomerSecretProviderInput
}

export type MutationUnpublishCustomFormArgs = {
  input: UnpublishCustomFormInput
}

export type MutationUpdateAcknowledgementArgs = {
  input: UpdateAcknowledgementInput
}

export type MutationUpdateAiOperatorHumanLabelArgs = {
  input: UpdateAiOperatorHumanLabelInput
}

export type MutationUpdateAiOperatorLimitArgs = {
  input: UpdateAiOperatorLimitInput
}

export type MutationUpdateAiOperatorModelArgs = {
  input: UpdateAiOperatorModelInput
}

export type MutationUpdateAiOperatorResponseRulesArgs = {
  input?: InputMaybe<UpdateAiOperatorResponseRulesInput>
}

export type MutationUpdateAiOperatorThresholdsArgs = {
  input: UpdateAiOperatorThresholdsInput
}

export type MutationUpdateAlarmArgs = {
  input: UpdateAlarmInput
}

export type MutationUpdateAlertArgs = {
  input: UpdateAlertInput
}

export type MutationUpdateAudioClipArgs = {
  input: UpdateAudioClipInput
}

export type MutationUpdateAudioMessageArgs = {
  input: UpdateAudioMessageInput
}

export type MutationUpdateCameraArgs = {
  input: UpdateCameraInput
}

export type MutationUpdateCaseArgs = {
  input: UpdateCaseInput
}

export type MutationUpdateCaseOwnerArgs = {
  input?: InputMaybe<UpdateCaseOwnerInput>
}

export type MutationUpdateCaseStatusArgs = {
  input: UpdateCaseStatusInput
}

export type MutationUpdateChargeArgs = {
  input: UpdateChargeInput
}

export type MutationUpdateCheckInArgs = {
  input: UpdateCheckInInput
}

export type MutationUpdateCheckpointArgs = {
  input?: InputMaybe<UpdateCheckpointInput>
}

export type MutationUpdateCheckpointTaskArgs = {
  input: UpdateCheckpointTaskInput
}

export type MutationUpdateCreditCardArgs = {
  input: UpdateCreditCardInput
}

export type MutationUpdateCustomerSecretProviderArgs = {
  input: UpdateCustomerSecretProviderInput
}

export type MutationUpdateCustomFormArgs = {
  input: UpdateCustomFormInput
}

export type MutationUpdateCustomFormQuestionArgs = {
  input: UpdateCustomFormQuestionInput
}

export type MutationUpdateCustomFormQuestionOptionArgs = {
  input: UpdateCustomFormQuestionOptionInput
}

export type MutationUpdateCustomFormSectionArgs = {
  input: UpdateCustomFormSectionInput
}

export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput
}

export type MutationUpdateDeviceRepairOrderArgs = {
  input: UpdateDeviceRepairOrderInput
}

export type MutationUpdateDoorArgs = {
  input: UpdateDoorInput
}

export type MutationUpdateEdgeDeviceArgs = {
  input: UpdateEdgeDeviceInput
}

export type MutationUpdateEmailRecipientArgs = {
  input: UpdateEmailRecipientInput
}

export type MutationUpdateEmailSourceArgs = {
  input: UpdateEmailSourceInput
}

export type MutationUpdateEmergencyCallArgs = {
  input: UpdateEmergencyCallInput
}

export type MutationUpdateEmergencyCallingArgs = {
  input: UpdateEmergencyCallingInput
}

export type MutationUpdateEventArgs = {
  input: UpdateEventInput
}

export type MutationUpdateExternalAccountArgs = {
  input: UpdateExternalAccountInput
}

export type MutationUpdateExternalAccountApiKeyArgs = {
  input: UpdateExternalAccountApiKeyInput
}

export type MutationUpdateExternalAccountIdpArgs = {
  input: UpdateExternalAccountIdpInput
}

export type MutationUpdateExternalAccountPropertiesArgs = {
  input: UpdateExternalAccountPropertiesInput
}

export type MutationUpdateFacilityArgs = {
  input: UpdateFacilityInput
}

export type MutationUpdateFloorArgs = {
  input: UpdateFloorInput
}

export type MutationUpdateFloorPlanArgs = {
  input: UpdateFloorPlanInput
}

export type MutationUpdateGatewayArgs = {
  input: UpdateGatewayInput
}

export type MutationUpdateGuardTourArgs = {
  input: UpdateGuardTourInput
}

export type MutationUpdateIncidentArgs = {
  input: UpdateIncidentInput
}

export type MutationUpdateIncidentActionArgs = {
  input: UpdateIncidentActionInput
}

export type MutationUpdateIncidentDeviceMediaArgs = {
  input: UpdateIncidentDeviceMediaInput
}

export type MutationUpdateIncidentInformationSolicitationArgs = {
  input: UpdateIncidentInformationSolicitationInput
}

export type MutationUpdateIncidentNoteArgs = {
  input: UpdateIncidentNoteInput
}

export type MutationUpdateIncidentOccurrenceArgs = {
  input: UpdateIncidentOccurrenceInput
}

export type MutationUpdateIncidentOfferArgs = {
  input: UpdateIncidentOfferInput
}

export type MutationUpdateIncidentOfferToGuardArgs = {
  input: UpdateIncidentOfferToGuardInput
}

export type MutationUpdateIncidentShareArgs = {
  input: UpdateIncidentShareInput
}

export type MutationUpdateIncidentTypeDefinitionArgs = {
  input: UpdateIncidentTypeDefinitionInput
}

export type MutationUpdateIncidentWorkflowArgs = {
  input: UpdateIncidentWorkflowInput
}

export type MutationUpdateManualIncidentCategoryArgs = {
  input: UpdateManualIncidentCategoryInput
}

export type MutationUpdateMySettingArgs = {
  input: UpdateUserSettingInput
}

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput
}

export type MutationUpdateOrganizationSettingsArgs = {
  input: UpdateOrganizationSettingsInput
}

export type MutationUpdateOrganizationSoundPolicyArgs = {
  input: UpdateOrganizationSoundPolicyInput
}

export type MutationUpdatePacsSourceInstanceArgs = {
  input?: InputMaybe<UpdatePacsSourceInstanceInput>
}

export type MutationUpdatePartialCreditCardArgs = {
  input: UpdatePartialCreditCardInput
}

export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput
}

export type MutationUpdatePersonOfInterestArgs = {
  input?: InputMaybe<UpdatePersonOfInterestInput>
}

export type MutationUpdatePersonOfInterestRoleArgs = {
  input?: InputMaybe<UpdatePersonOfInterestRoleInput>
}

export type MutationUpdateProgramRecommendationArgs = {
  input: UpdateProgramRecommendationInput
}

export type MutationUpdateQuickReportArgs = {
  input: UpdateQuickReportInput
}

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput
}

export type MutationUpdateRuleArgs = {
  input: UpdateRuleInput
}

export type MutationUpdateSavedFilterArgs = {
  input: UpdateSavedFilterInput
}

export type MutationUpdateSavedPayloadArgs = {
  input: UpdateSavedPayloadInput
}

export type MutationUpdateStandardOperatingProcedureArgs = {
  input: UpdateStandardOperatingProcedureInput
}

export type MutationUpdateSubscriberMessageArgs = {
  input: UpdateSubscriberMessageInput
}

export type MutationUpdateTagArgs = {
  input: UpdateTagInput
}

export type MutationUpdateTailgateEnabledArgs = {
  input: UpdateTailgateEnabledInput
}

export type MutationUpdateTailgateGridArgs = {
  input: UpdateTailgateGridInput
}

export type MutationUpdateTechnicianArgs = {
  input: UpdateTechnicianInput
}

export type MutationUpdateTourPlanArgs = {
  input: UpdateTourPlanInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserRolesArgs = {
  input: UpdateUserRolesInput
}

export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput
}

export type MutationUpsertAiOperatorDeviceConfigurationArgs = {
  input: UpsertAiOperatorDeviceConfigurationInput
}

export type MutationUpsertIntegrationFieldMappingArgs = {
  input: UpsertIntegrationFieldMappingInput
}

export type MutationUpsertIntegrationQuestionMappingArgs = {
  input: UpsertIntegrationQuestionMappingInput
}

export type MutationVerifyIntegrationMappingArgs = {
  input: VerifyIntegrationMappingInput
}

export type ActivateEmailRecipientInput = {
  email: Scalars['String']
}

export type UpdateEmailRecipientPayload = {
  __typename?: 'UpdateEmailRecipientPayload'
  emailRecipient?: Maybe<EmailRecipient>
}

export type AddCustomFormQuestionOptionInput = {
  label: Scalars['String']
  order: Scalars['Int']
  questionId: Scalars['ID']
}

export type AddCustomFormQuestionOptionPayload = {
  __typename?: 'AddCustomFormQuestionOptionPayload'
  option: CustomFormQuestionOption
}

export type AddTagsToDeviceInput = {
  deviceId: Scalars['ID']
  tagIds: Array<Scalars['ID']>
}

export type AddTagsToDevicePayload = {
  __typename?: 'AddTagsToDevicePayload'
  device: Device
}

export type AddTagsToDevicesInput = {
  deviceIds: Array<Scalars['ID']>
  tagIds: Array<Scalars['ID']>
}

export type AddTagsToDevicesPayload = {
  __typename?: 'AddTagsToDevicesPayload'
  devices: Array<Device>
}

export type AppendDevicesToEdgeDeviceInput = {
  deviceIds: Array<Scalars['ID']>
  edgeDeviceId: Scalars['ID']
}

export type AppendDevicesToEdgeDevicePayload = {
  __typename?: 'AppendDevicesToEdgeDevicePayload'
  edgeDevice?: Maybe<EdgeDevice>
}

export type AppendEventVideoInput = {
  eventExternalId: Scalars['ID']
  /**
   * The stored asset
   * must have been created as a `VIDEO_CLIP`
   * (see the `UploadedFileType` enum).
   */
  storedAssetId: Scalars['ID']
}

export type AppendEventVideoPayload = {
  __typename?: 'AppendEventVideoPayload'
  eventExternalId: Scalars['ID']
}

export type AppendIncidentVideoInput = {
  cameraExternalId?: InputMaybe<Scalars['String']>
  /** ISO-8601 clip end. Example: 2021-10-29T08:05:47.978Z. */
  clipEndTime?: InputMaybe<Scalars['String']>
  /** ISO-8601 clip start. Example: 2021-10-29T08:05:47.978Z. */
  clipStartTime?: InputMaybe<Scalars['String']>
  doorExternalId?: InputMaybe<Scalars['String']>
  eventExternalId: Scalars['ID']
  /** Clip kind. Defaults to ORIGINAL when omitted (backward compatible). */
  kind?: InputMaybe<ClipKind>
  storedAssetId: Scalars['ID']
}

export type AppendIncidentVideoPayload = {
  __typename?: 'AppendIncidentVideoPayload'
  incidentExisted?: Maybe<Scalars['Boolean']>
}

export type ArchiveCustomFormInput = {
  id: Scalars['ID']
}

export type ArchiveCustomFormPayload = {
  __typename?: 'ArchiveCustomFormPayload'
  customForm: CustomForm
}

export type ArchiveFloorInput = {
  id: Scalars['ID']
  /**
   * Required when archiving the facility's default floor: the floor that becomes
   * the new default. Must be an active floor in the same facility. Rejected when
   * the floor being archived is not the facility's current default.
   */
  newDefaultFloorId?: InputMaybe<Scalars['ID']>
}

export type ArchiveFloorPayload = {
  __typename?: 'ArchiveFloorPayload'
  floor?: Maybe<Floor>
}

export type ArchiveIncidentWorkflowInput = {
  id: Scalars['ID']
}

export type ArchiveIncidentWorkflowPayload = {
  __typename?: 'ArchiveIncidentWorkflowPayload'
  incidentWorkflow: IncidentWorkflow
}

export type ArchiveRuleInput = {
  id: Scalars['ID']
}

export type ArchiveRulePayload = {
  __typename?: 'ArchiveRulePayload'
  rule?: Maybe<Rule>
}

export type ArchiveTagInput = {
  id: Scalars['ID']
}

export type ArchiveTagPayload = {
  __typename?: 'ArchiveTagPayload'
  id: Scalars['ID']
}

export type AssociateEmailRecipientsInput = {
  emailRecipients: Array<EmailRecipientInput>
  ruleId: Scalars['ID']
}

export type EmailRecipientInput = {
  email?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['ID']>
}

export type AssociateEmailRecipientsPayload = {
  __typename?: 'AssociateEmailRecipientsPayload'
  emailRecipients?: Maybe<Array<Maybe<EmailRecipient>>>
}

export type AssociateIncidentsToCaseInput = {
  caseId: Scalars['ID']
  incidentIds: Array<Scalars['ID']>
}

export type UpdateCasePayload = {
  __typename?: 'UpdateCasePayload'
  case?: Maybe<Case>
}

export type AssociatePersonOfInterestInput = {
  caseId: Scalars['ID']
  caseRole: CaseRole
  customCaseRoleDescription?: InputMaybe<Scalars['String']>
  personOfInterestId: Scalars['ID']
}

export type AssociateIncidentToCasesInput = {
  caseIds: Array<Scalars['ID']>
  incidentId: Scalars['ID']
}

/** *Automatically generated.* */
export type UpdateIncidentPayload = {
  __typename?: 'UpdateIncidentPayload'
  incident?: Maybe<Incident>
}

export type BulkResolveStaleIncidentsInput = {
  incidentIds: Array<Scalars['ID']>
  message?: InputMaybe<Scalars['String']>
  scope: StaleResolveScope
}

export enum StaleResolveScope {
  Person = 'PERSON',
  Program = 'PROGRAM',
  Selected = 'SELECTED',
}

export type BulkResolveStaleIncidentsPayload = {
  __typename?: 'BulkResolveStaleIncidentsPayload'
  resolvedIncidentActions: Array<IncidentAction>
  skipped: Array<SkippedStaleIncident>
}

export type SkippedStaleIncident = {
  __typename?: 'SkippedStaleIncident'
  incidentId: Scalars['ID']
  reason: StaleResolveSkipReason
}

export enum StaleResolveSkipReason {
  AccessDenied = 'ACCESS_DENIED',
  AlreadyResolved = 'ALREADY_RESOLVED',
  NotFound = 'NOT_FOUND',
}

export type ChangePasswordInput = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
  /** Defaults to ID of authenticated user. */
  userId?: InputMaybe<Scalars['ID']>
}

export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload'
  /** The user whose password was changed. */
  user: User
}

/** *Automatically generated.* */
export type CreateAcknowledgementInput = {
  audioClipId?: InputMaybe<Scalars['ID']>
}

/** *Automatically generated.* */
export type CreateAcknowledgementPayload = {
  __typename?: 'CreateAcknowledgementPayload'
  acknowledgement?: Maybe<Acknowledgement>
}

export type CreateAiOperatorFeedbackInput = {
  incidentId: Scalars['ID']
  isPositive: Scalars['Boolean']
  message?: InputMaybe<Scalars['String']>
}

export type CreateAiOperatorFeedbackPayload = {
  __typename?: 'CreateAiOperatorFeedbackPayload'
  aiOperatorFeedback: AiOperatorFeedback
}

export type CreateAiOperatorHumanLabelInput = {
  fieldId: Scalars['ID']
  humanValue?: InputMaybe<Scalars['Boolean']>
  incidentId: Scalars['ID']
}

export type CreateAiOperatorHumanLabelPayload = {
  __typename?: 'CreateAiOperatorHumanLabelPayload'
  aiOperatorHumanLabel: AiOperatorHumanLabel
}

export type CreateAiOperatorRuleEvaluationsInput = {
  evaluations: Array<CreateAiOperatorRuleEvaluationInput>
}

export type CreateAiOperatorRuleEvaluationInput = {
  description?: InputMaybe<Scalars['String']>
  evalIsTrue?: InputMaybe<Scalars['Boolean']>
  evalPayload?: InputMaybe<Scalars['JSON']>
  incidentId: Scalars['ID']
  modelId?: InputMaybe<Scalars['ID']>
  processingTimeSeconds?: InputMaybe<Scalars['Float']>
  responseRuleId: Scalars['ID']
  videoClipS3Key?: InputMaybe<Scalars['String']>
  wasDryRun: Scalars['Boolean']
}

export type CreateAiOperatorRuleEvaluationsPayload = {
  __typename?: 'CreateAiOperatorRuleEvaluationsPayload'
  aiOperatorRuleEvaluations: Array<AiOperatorRuleEvaluation>
  count: Scalars['Int']
}

export type CreateAlarmInput = {
  alarmTypeId?: InputMaybe<Scalars['ID']>
  externalId?: InputMaybe<Scalars['String']>
  floorId: Scalars['ID']
  label?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type CreateAlarmPayload = {
  __typename?: 'CreateAlarmPayload'
  alarm?: Maybe<Alarm>
}

/** *Automatically generated.* */
export type CreateAlertInput = {
  incidentId: Scalars['ID']
  priority?: InputMaybe<AlertPriority>
}

/** *Automatically generated.* */
export type CreateAlertPayload = {
  __typename?: 'CreateAlertPayload'
  alert?: Maybe<Alert>
}

/** *Automatically generated.* */
export type CreateAudioClipInput = {
  endTime: Scalars['String']
  externalId: Scalars['String']
  facilityId?: InputMaybe<Scalars['ID']>
  incidentId?: InputMaybe<Scalars['ID']>
  startTime: Scalars['String']
}

/** *Automatically generated.* */
export type CreateAudioClipPayload = {
  __typename?: 'CreateAudioClipPayload'
  audioClip?: Maybe<AudioClip>
}

/** *Automatically generated.* */
export type CreateAudioMessageInput = {
  audioClipId: Scalars['ID']
  facilityId?: InputMaybe<Scalars['ID']>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentOwnerId?: InputMaybe<Scalars['ID']>
  source?: InputMaybe<AudioMessageSource>
  target?: InputMaybe<MessageTargetInput>
}

/** *Automatically generated.* */
export type MessageTargetInput = {
  AND?: InputMaybe<Array<MessageTargetInput>>
  facilityId?: InputMaybe<Scalars['ID']>
  incidentId?: InputMaybe<Scalars['ID']>
  onShift?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<MessageTargetInput>>
  recipientIds?: InputMaybe<Array<Scalars['ID']>>
}

/** *Automatically generated.* */
export type CreateAudioMessagePayload = {
  __typename?: 'CreateAudioMessagePayload'
  audioMessage?: Maybe<AudioMessage>
}

export type CreateBulkIncidentActionInput = {
  incidentIds: Array<Scalars['ID']>
  message?: InputMaybe<Scalars['String']>
  types: Array<IncidentActionType>
}

export type CreateBulkIncidentActionPayload = {
  __typename?: 'CreateBulkIncidentActionPayload'
  incidentActions: Array<IncidentAction>
}

export type CreateCameraInput = {
  externalId?: InputMaybe<Scalars['String']>
  floorId: Scalars['ID']
  ip?: InputMaybe<Scalars['String']>
  label?: InputMaybe<Scalars['String']>
  macAddress?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  rtspPath?: InputMaybe<Scalars['String']>
  rtspPort?: InputMaybe<Scalars['Int']>
  streamingProtocol?: InputMaybe<StreamingProtocol>
  streamingType?: InputMaybe<StreamingType>
}

export type CreateCameraPayload = {
  __typename?: 'CreateCameraPayload'
  camera?: Maybe<Camera>
}

export type CreateCaseInput = {
  description: Scalars['String']
  facilityIds: Array<Scalars['ID']>
  name: Scalars['String']
}

export type CreateCasePayload = {
  __typename?: 'CreateCasePayload'
  case: Case
}

export type CreateCaseCommentInput = {
  caseId: Scalars['ID']
  message: Scalars['String']
}

export type CreateCaseCommentPayload = {
  __typename?: 'CreateCaseCommentPayload'
  caseComment: CaseComment
}

/** *Automatically generated.* */
export type CreateChargeInput = {
  amount?: InputMaybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type CreateChargePayload = {
  __typename?: 'CreateChargePayload'
  charge?: Maybe<Charge>
}

/** *Automatically generated.* */
export type CreateCheckInInput = {
  deviceToken?: InputMaybe<Scalars['String']>
  facilityId: Scalars['ID']
  platform?: InputMaybe<Platform>
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
}

/** *Automatically generated.* */
export type CreateCheckInPayload = {
  __typename?: 'CreateCheckInPayload'
  checkIn?: Maybe<CheckIn>
}

/**
 * Create an object of this type
 * when the user wants to check in to a facility.
 * (Note: you can only check in the authenticated
 * user, not any arbitrary user.)
 *
 * If you create one object of this type,
 * then another,
 * without any intervening creation of
 * a `CheckOut` object, then the second
 * check-in replaces the first.
 */
export type CheckIn = {
  __typename?: 'CheckIn'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  deviceToken?: Maybe<Scalars['String']>
  facility?: Maybe<Facility>
  facilityId: Scalars['ID']
  id: Scalars['ID']
  platform?: Maybe<Platform>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

/** *Automatically generated.* */
export type CheckInFilterInput = {
  AND?: InputMaybe<Array<CheckInFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  deviceToken?: InputMaybe<Scalars['String']>
  deviceTokenGt?: InputMaybe<Scalars['String']>
  deviceTokenGte?: InputMaybe<Scalars['String']>
  deviceTokenIn?: InputMaybe<Array<Scalars['String']>>
  deviceTokenLike?: InputMaybe<Scalars['String']>
  deviceTokenLt?: InputMaybe<Scalars['String']>
  deviceTokenLte?: InputMaybe<Scalars['String']>
  deviceTokenNot?: InputMaybe<Scalars['String']>
  deviceTokenNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<CheckInFilterInput>>
  platform?: InputMaybe<Platform>
  platformIn?: InputMaybe<Array<Platform>>
  platformNot?: InputMaybe<Platform>
  platformNotIn?: InputMaybe<Array<Platform>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  userId?: InputMaybe<Scalars['ID']>
  userIdIn?: InputMaybe<Array<Scalars['ID']>>
  userIdNot?: InputMaybe<Scalars['ID']>
  userIdNotIn?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateCheckInsInput = {
  deviceToken?: InputMaybe<Scalars['String']>
  facilityIds: Array<Scalars['ID']>
  platform?: InputMaybe<Platform>
}

/** *Automatically generated.* */
export type CheckInOrderInput = {
  direction: OrderDirection
  field: CheckInOrderField
}

/** *Automatically generated.* */
export enum CheckInOrderField {
  CreatedAt = 'CREATED_AT',
  DeviceToken = 'DEVICE_TOKEN',
  FacilityId = 'FACILITY_ID',
  Id = 'ID',
  Platform = 'PLATFORM',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID',
}

/** *Automatically generated.* */
export type CheckInConnection = {
  __typename?: 'CheckInConnection'
  edges?: Maybe<Array<Maybe<CheckInEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type CheckInEdge = {
  __typename?: 'CheckInEdge'
  cursor: Scalars['String']
  node?: Maybe<CheckIn>
}

/** *Automatically generated.* */
export type CreateCheckOutPayload = {
  __typename?: 'CreateCheckOutPayload'
  checkOut?: Maybe<CheckOut>
}

/**
 * Create an object of this type
 * when the user wants to check out of a facility.
 * (Note: a GraphQL client can check out only the authenticated
 * user, not any arbitrary user.)
 */
export type CheckOut = {
  __typename?: 'CheckOut'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  facility?: Maybe<Facility>
  facilityId: Scalars['ID']
  id: Scalars['ID']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

/** *Automatically generated.* */
export type CheckOutFilterInput = {
  AND?: InputMaybe<Array<CheckOutFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<CheckOutFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
  userId?: InputMaybe<Scalars['ID']>
  userIdIn?: InputMaybe<Array<Scalars['ID']>>
  userIdNot?: InputMaybe<Scalars['ID']>
  userIdNotIn?: InputMaybe<Array<Scalars['ID']>>
}

/** *Automatically generated.* */
export type CheckOutOrderInput = {
  direction: OrderDirection
  field: CheckOutOrderField
}

/** *Automatically generated.* */
export enum CheckOutOrderField {
  CreatedAt = 'CREATED_AT',
  FacilityId = 'FACILITY_ID',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID',
}

/** *Automatically generated.* */
export type CheckOutConnection = {
  __typename?: 'CheckOutConnection'
  edges?: Maybe<Array<Maybe<CheckOutEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type CheckOutEdge = {
  __typename?: 'CheckOutEdge'
  cursor: Scalars['String']
  node?: Maybe<CheckOut>
}

/** *Automatically generated.* */
export type CreateDeviceInput = {
  alarmTypeId?: InputMaybe<Scalars['ID']>
  bearing?: InputMaybe<Scalars['Float']>
  facilityId?: InputMaybe<Scalars['ID']>
  fieldOfView?: InputMaybe<Scalars['Float']>
  floorId?: InputMaybe<Scalars['ID']>
  floorPlanId?: InputMaybe<Scalars['ID']>
  gatewayId?: InputMaybe<Scalars['ID']>
  macAddress?: InputMaybe<Scalars['String']>
  manufacturerName?: InputMaybe<Scalars['String']>
  modelName?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  /** Only used for Camera Devices */
  requiresAuthentication?: Scalars['Boolean']
  status?: InputMaybe<DeviceStatus>
  type?: InputMaybe<DeviceType>
  visibilityRange?: InputMaybe<Scalars['Float']>
  x?: InputMaybe<Scalars['Float']>
  y?: InputMaybe<Scalars['Float']>
}

/** *Automatically generated.* */
export type CreateDevicePayload = {
  __typename?: 'CreateDevicePayload'
  device?: Maybe<Device>
}

export type CreateCheckpointTaskInput = {
  checkpointId: Scalars['ID']
  description: Scalars['String']
  isRequired: Scalars['Boolean']
}

export type CreateCheckpointTaskPayload = {
  __typename?: 'CreateCheckpointTaskPayload'
  checkpointTask?: Maybe<CheckpointTask>
}

/** *Automatically generated.* */
export type CreateCreditCardInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  expiryMonth?: InputMaybe<Scalars['Int']>
  expiryYear?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  number?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreateCreditCardPayload = {
  __typename?: 'CreateCreditCardPayload'
  creditCard?: Maybe<CreditCard>
}

export type CreditCard = {
  __typename?: 'CreditCard'
  address?: Maybe<Array<Scalars['String']>>
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  expiryMonth?: Maybe<Scalars['Int']>
  expiryYear?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  number?: Maybe<Scalars['String']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type CreateCustomerSecretProviderInput = {
  kmsAlias?: InputMaybe<Scalars['String']>
  kmsKeyId?: InputMaybe<Scalars['String']>
  kmsRegion?: InputMaybe<Scalars['String']>
  providerAccountId: Scalars['String']
  providerName: Scalars['String']
  providerRegion: Scalars['String']
  providerType: SecretProviderType
  secretNamespace?: InputMaybe<Scalars['String']>
}

export type CreateCustomerSecretProviderPayload = {
  __typename?: 'CreateCustomerSecretProviderPayload'
  customerSecretProvider?: Maybe<CustomerSecretProvider>
}

export type CreateCustomFormInput = {
  description?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type CreateCustomFormPayload = {
  __typename?: 'CreateCustomFormPayload'
  customForm: CustomForm
}

export type CreateCustomFormIncidentInput = {
  /** Array of answers to the custom form questions */
  answers: Array<CustomFormAnswerInput>
  /** The custom form ID to use for this submission */
  customFormId: Scalars['ID']
  /** The facility where the incident occurred */
  facilityId: Scalars['ID']
  /** File upload metadata for any FILE_UPLOAD type questions */
  generateFileUploadUrlInputs: Array<GenerateFileUploadUrlInput>
  /** The incident category ID */
  incidentCategoryId: Scalars['ID']
}

export type CustomFormAnswerInput = {
  /** The answer type (should match the question's answerType) */
  answerType: CustomFormAnswerType
  /** The question ID being answered */
  questionId: Scalars['ID']
  /** The answer value as a JSON-encoded string */
  value: Scalars['String']
}

export type GenerateFileUploadUrlInput = {
  fileType: UploadedFileType
  /**
   * [Mime type](https://en.wikipedia.org/wiki/Media_type).
   *
   * Example: `image/jpeg`.
   */
  mimeType: Scalars['String']
  /**
   * The question ID this file upload answers.
   * Only used for custom form FILE_UPLOAD type questions.
   */
  questionId?: InputMaybe<Scalars['ID']>
  size: Scalars['Int']
}

/**
 * This type exists to allow the server to impose
 * different file-size limits and rate limits, depending on
 * the type of file being uploaded.
 * As an example of rate limits:
 * the server could set a maximum rate of 2 `VOICE_CLIP`
 * uploads per user per second.
 */
export enum UploadedFileType {
  /** The file is intended for images attached at checkpoints during guard tours */
  CheckpointImage = 'CHECKPOINT_IMAGE',
  /** The file is used for bulk create of different entities based on provided data. */
  CsvFile = 'CSV_FILE',
  /**
   * The file is intended for the
   * `s3Key` field of the `FloorPlan` type.
   */
  FloorPlan = 'FLOOR_PLAN',
  /** Annotated video generated by grid analysis */
  GridAnalysisVideo = 'GRID_ANALYSIS_VIDEO',
  /** Photo attached to a guard-generated incident. */
  IncidentImage = 'INCIDENT_IMAGE',
  /** Supporting media attached to an incident note */
  IncidentNoteMedia = 'INCIDENT_NOTE_MEDIA',
  /**
   * The file is intended for
   * `logo` of a quick report
   */
  QuickReportImage = 'QUICK_REPORT_IMAGE',
  /**
   * The file is intended for the
   * `url` field of the `StandardOperatingProcedure` type.
   */
  StandardOperatingProcedure = 'STANDARD_OPERATING_PROCEDURE',
  /**
   * The file is intended for the
   * `avatar` field of the `User` type.
   */
  UserAvatar = 'USER_AVATAR',
  /** Media attached to user feedback submissions */
  UserFeedbackMedia = 'USER_FEEDBACK_MEDIA',
  /**
   * The file is intended for the
   * `photo` field of the `User` type.
   */
  UserPhoto = 'USER_PHOTO',
  /**
   * The file contains video of an incident, or of a non-tailgating event,
   * or of some other event that has associated video.
   */
  VideoClip = 'VIDEO_CLIP',
  /**
   * The file is intended for the
   * `url` field of the `AudioClip` type.
   */
  VoiceClip = 'VOICE_CLIP',
}

export type CreateCustomFormIncidentPayload = {
  __typename?: 'CreateCustomFormIncidentPayload'
  /** Presigned URLs for file uploads */
  fileUploadUrls: Array<GenerateFileUploadUrlPayload>
  /** The created incident ID */
  incidentId: Scalars['ID']
}

export type GenerateFileUploadUrlPayload = {
  __typename?: 'GenerateFileUploadUrlPayload'
  /** Maximum length: 80 characters. */
  fileId?: Maybe<Scalars['ID']>
  /**
   * The question ID this file upload answers.
   * Echoed back from the input for client-side matching.
   */
  questionId?: Maybe<Scalars['ID']>
  url?: Maybe<Scalars['String']>
}

export type CreateCustomFormQuestionInput = {
  answerType: CustomFormAnswerType
  /** Required for STATIC type - the predefined immutable value */
  defaultValue?: InputMaybe<Scalars['String']>
  helpText?: InputMaybe<Scalars['String']>
  /** Designate this question's answer as the incident TITLE or DESCRIPTION (moves the role from any previous holder) */
  incidentRole?: InputMaybe<CustomFormIncidentRole>
  label: Scalars['String']
  options?: InputMaybe<Array<CreateCustomFormQuestionOptionInput>>
  order: Scalars['Int']
  required?: InputMaybe<Scalars['Boolean']>
  sectionId: Scalars['ID']
  visibleWhen?: InputMaybe<VisibilityRuleInput>
}

export type CreateCustomFormQuestionOptionInput = {
  label: Scalars['String']
  order: Scalars['Int']
}

export type VisibilityRuleInput = {
  anyOf: Array<ConditionGroupInput>
}

export type ConditionGroupInput = {
  allOf: Array<VisibilityConditionInput>
}

export type VisibilityConditionInput = {
  operator: ConditionOperator
  questionId: Scalars['ID']
  value?: InputMaybe<Scalars['String']>
}

export type CreateCustomFormQuestionPayload = {
  __typename?: 'CreateCustomFormQuestionPayload'
  question: CustomFormQuestion
}

export type CreateCustomFormSectionInput = {
  description?: InputMaybe<Scalars['String']>
  formId: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
}

export type CreateCustomFormSectionPayload = {
  __typename?: 'CreateCustomFormSectionPayload'
  section: CustomFormSection
}

export type CreateDatabaseResetPayload = {
  __typename?: 'CreateDatabaseResetPayload'
  createdAt?: Maybe<Scalars['String']>
  createdBy?: Maybe<Scalars['String']>
}

export type CreateDeviceNoteInput = {
  deviceId: Scalars['ID']
  message: Scalars['String']
}

export type CreateDeviceNotePayload = {
  __typename?: 'CreateDeviceNotePayload'
  deviceNote?: Maybe<DeviceLog>
}

/** *Automatically generated.* */
export type CreateDeviceRepairOrderInput = {
  message: Scalars['String']
}

/** *Automatically generated.* */
export type CreateDeviceRepairOrderPayload = {
  __typename?: 'CreateDeviceRepairOrderPayload'
  deviceRepairOrder?: Maybe<DeviceRepairOrder>
}

export type CreateDevicesInput = {
  deviceType: DeviceType
  sheetExternalId: Scalars['String']
}

/** *Automatically generated.* */
export type CreateDoorInput = {
  externalId?: InputMaybe<Scalars['String']>
  floorId: Scalars['ID']
  label?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

/** *Automatically generated.* */
export type CreateDoorPayload = {
  __typename?: 'CreateDoorPayload'
  door?: Maybe<Door>
}

export type CreateEdgeDeviceInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']>>
  name: Scalars['String']
}

export type CreateEdgeDevicePayload = {
  __typename?: 'CreateEdgeDevicePayload'
  edgeDevice?: Maybe<EdgeDevice>
}

export type CreateEmailRecipientInput = {
  email?: InputMaybe<Scalars['String']>
  ruleId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type CreateEmailRecipientPayload = {
  __typename?: 'CreateEmailRecipientPayload'
  emailRecipient?: Maybe<EmailRecipient>
}

export type CreateEmailSourceInput = {
  /**
   * At least one sender allowed to create incidents through this source: an exact address
   * (panel@alarm-vendor.com) or a whole domain (@alarm-vendor.com).
   */
  allowedSenders: Array<Scalars['String']>
  facilityId: Scalars['ID']
  name: Scalars['String']
}

export type CreateEmailSourcePayload = {
  __typename?: 'CreateEmailSourcePayload'
  emailSource?: Maybe<EmailSource>
}

/** *Automatically generated.* */
export type CreateEmergencyCallInput = {
  callEndTime?: InputMaybe<Scalars['String']>
  callStartTime: Scalars['String']
  externalCallId?: InputMaybe<Scalars['String']>
  incidentId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateEmergencyCallPayload = {
  __typename?: 'CreateEmergencyCallPayload'
  emergencyCall?: Maybe<EmergencyCall>
}

/** *Automatically generated.* */
export type CreateEmergencyCallingInput = {
  facilityId: Scalars['ID']
  outboundPhoneNumber: Scalars['String']
  outboundPhoneNumberSid: Scalars['String']
}

/** *Automatically generated.* */
export type CreateEmergencyCallingPayload = {
  __typename?: 'CreateEmergencyCallingPayload'
  emergencyCalling?: Maybe<EmergencyCalling>
}

/** *Automatically generated.* */
export type CreateEventInput = {
  acsEventType?: InputMaybe<Scalars['String']>
  badgeNumber?: InputMaybe<Scalars['String']>
  cardHolderName?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  detectedAt?: InputMaybe<Scalars['String']>
  deviceIds: Array<Scalars['ID']>
  eventExternalId: Scalars['ID']
  eventFeatures?: InputMaybe<Array<Scalars['String']>>
  facilityId: Scalars['ID']
  floorId?: InputMaybe<Scalars['ID']>
  incidentId?: InputMaybe<Scalars['ID']>
  normalizedType?: InputMaybe<Scalars['String']>
  type: EventType
}

/** *Automatically generated.* */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload'
  event?: Maybe<Event>
}

export type CreateEventPresentationInput = {
  acsEventType?: InputMaybe<Scalars['String']>
  badgeNumber?: InputMaybe<Scalars['String']>
  cardHolderName?: InputMaybe<Scalars['String']>
  detectedAt: Scalars['String']
  deviceExternalId: Scalars['String']
  eventExternalId: Scalars['ID']
  eventFeatures?: InputMaybe<Array<Scalars['String']>>
  normalizedType?: InputMaybe<Scalars['String']>
  /** The type. Reuses the EventType from Event. */
  type: EventType
}

export type CreateEventPresentationPayload = {
  __typename?: 'CreateEventPresentationPayload'
  event?: Maybe<EventPresentation>
}

export type CreateExternalAccountInput = {
  accountId: Scalars['String']
  accountName: Scalars['String']
  defaultAccount?: Scalars['Boolean']
  externalSystemType?: ExternalSystemType
}

export type CreateExternalAccountPayload = {
  __typename?: 'CreateExternalAccountPayload'
  externalAccount?: Maybe<ExternalAccount>
}

export type CreateExternalAccountApiKeyInput = {
  externalAccountId: Scalars['ID']
  permissionName: ApiKeyPermission
  secretName: Scalars['String']
}

export type CreateExternalAccountApiKeyPayload = {
  __typename?: 'CreateExternalAccountApiKeyPayload'
  externalAccountApiKey?: Maybe<ExternalAccountApiKey>
}

export type CreateExternalAccountIdpInput = {
  config?: InputMaybe<Scalars['JSON']>
  externalAccountId: Scalars['ID']
  type: IdpType
}

export type CreateExternalAccountIdpPayload = {
  __typename?: 'CreateExternalAccountIdpPayload'
  externalAccountIdp?: Maybe<ExternalAccountIdp>
}

export type CreateExternalAccountPropertiesInput = {
  data?: InputMaybe<Scalars['JSON']>
  externalAccountId: Scalars['ID']
}

export type CreateExternalAccountPropertiesPayload = {
  __typename?: 'CreateExternalAccountPropertiesPayload'
  externalAccountProperties?: Maybe<ExternalAccountProperties>
}

export type CreateExternalIncidentInput = {
  createExternalIncidentAdditionalDetailInput: CreateExternalIncidentAdditionalDetailInput
  createIncidentInput: CreateIncidentInput
  generateFileUploadUrlInputs: Array<GenerateFileUploadUrlInput>
}

export type CreateExternalIncidentAdditionalDetailInput = {
  additionalContactInformation?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  locationOfConcern?: InputMaybe<Scalars['String']>
  partiesInvolved?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  timeReported: Scalars['String']
}

export type CreateIncidentInput = {
  /** The "raw" event type. */
  acsEventType?: InputMaybe<Scalars['String']>
  address?: InputMaybe<Array<Scalars['String']>>
  /** External ids of events associated with this incident. Useful for tailgating. */
  associatedEventIds?: InputMaybe<Array<Scalars['ID']>>
  badgeNumber?: InputMaybe<Scalars['String']>
  cardHolderName?: InputMaybe<Scalars['String']>
  concernStartTime?: InputMaybe<Scalars['String']>
  creatorId?: InputMaybe<Scalars['ID']>
  description?: InputMaybe<Scalars['String']>
  detectedAt?: InputMaybe<Scalars['String']>
  deviceExternalId?: InputMaybe<Scalars['String']>
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  deviceTypes?: InputMaybe<Array<InputMaybe<DeviceType>>>
  eventExternalId?: InputMaybe<Scalars['String']>
  eventFeatures?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityName?: InputMaybe<Scalars['String']>
  facilityType?: InputMaybe<FacilityType>
  floorId?: InputMaybe<Scalars['ID']>
  floorName?: InputMaybe<Scalars['String']>
  guardId?: InputMaybe<Scalars['ID']>
  hasAudioMessages?: InputMaybe<Scalars['Boolean']>
  imageIds?: InputMaybe<Array<Scalars['ID']>>
  incidentTypeDisplayName?: InputMaybe<Scalars['String']>
  informationSolicited?: InputMaybe<Scalars['Boolean']>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  manualIncidentCategoryId?: InputMaybe<Scalars['ID']>
  /** Matches a Rule.id */
  matchedRule?: InputMaybe<Scalars['ID']>
  /**
   * The event metadata as received from the GEM. Must be a JSON object: any other literal (array,
   * string, number) fails the request and nothing is stored. Stored in event.details.metadata;
   * dropped when larger than 8 KB. The badgeNumber and cardHolderName keys are moved to the event
   * fields of the same name (unless those are set) rather than stored here.
   */
  metadata?: InputMaybe<Scalars['JSON']>
  /** Defaults to false */
  muted?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  normalizedType?: InputMaybe<Scalars['String']>
  offered?: InputMaybe<Scalars['Boolean']>
  ownerId?: InputMaybe<Scalars['ID']>
  priority?: InputMaybe<IncidentPriority>
  real?: InputMaybe<Scalars['Boolean']>
  sensor?: InputMaybe<DeviceType>
  source?: InputMaybe<IncidentSource>
  status?: InputMaybe<IncidentStatus>
  /** Deprecated. Use normalizedType. */
  type?: InputMaybe<IncidentType>
}

export type CreateExternalIncidentPayload = {
  __typename?: 'CreateExternalIncidentPayload'
  fileUploadUrls: Array<GenerateFileUploadUrlPayload>
  incidentId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateFacilityInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  defaultFloorId?: InputMaybe<Scalars['ID']>
  emergencyNumber?: InputMaybe<Scalars['String']>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  name: Scalars['String']
  shortName?: InputMaybe<Scalars['String']>
  timeZone?: InputMaybe<Scalars['String']>
  type?: InputMaybe<FacilityType>
}

/** *Automatically generated.* */
export type CreateFacilityPayload = {
  __typename?: 'CreateFacilityPayload'
  facility?: Maybe<Facility>
}

/** *Automatically generated.* */
export type CreateFloorInput = {
  facilityId: Scalars['ID']
  floorPlanId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
}

/** *Automatically generated.* */
export type CreateFloorPayload = {
  __typename?: 'CreateFloorPayload'
  floor?: Maybe<Floor>
}

/** *Automatically generated.* */
export type CreateFloorPlanInput = {
  floorId: Scalars['ID']
  name: Scalars['String']
  s3Key?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreateFloorPlanPayload = {
  __typename?: 'CreateFloorPlanPayload'
  floorPlan?: Maybe<FloorPlan>
}

export type CreateFormForIncidentCategoryInput = {
  formDescription?: InputMaybe<Scalars['String']>
  formName: Scalars['String']
  incidentCategoryId: Scalars['ID']
}

export type CreateFormForIncidentCategoryPayload = {
  __typename?: 'CreateFormForIncidentCategoryPayload'
  incidentCategory: ManualIncidentCategory
}

/** *Automatically generated.* */
export type CreateGatewayInput = {
  facilityIds?: InputMaybe<Array<Scalars['ID']>>
  floorIds?: InputMaybe<Array<Scalars['ID']>>
  physical: Scalars['Boolean']
}

/** *Automatically generated.* */
export type CreateGatewayPayload = {
  __typename?: 'CreateGatewayPayload'
  gateway?: Maybe<Gateway>
}

export type CreateGridAnalysisJobInput = {
  inBox: BoxInput
  incidentId: Scalars['ID']
  labeledIn: Scalars['Int']
  labeledOut: Scalars['Int']
  outBox: BoxInput
}

export type BoxInput = {
  bottomLeft: PointInput
  bottomRight: PointInput
  topLeft: PointInput
  topRight: PointInput
}

export type PointInput = {
  x: Scalars['Float']
  y: Scalars['Float']
}

export type CreateGridAnalysisJobPayload = {
  __typename?: 'CreateGridAnalysisJobPayload'
  gridAnalysisJob?: Maybe<GridAnalysisJob>
}

/** *Automatically generated.* */
export type CreateGuardTourInput = {
  tourPlanId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateGuardTourPayload = {
  __typename?: 'CreateGuardTourPayload'
  guardTour?: Maybe<GuardTour>
}

/** *Automatically generated.* */
export type CreateIncidentPayload = {
  __typename?: 'CreateIncidentPayload'
  incident?: Maybe<Incident>
}

/** *Automatically generated.* */
export type CreateIncidentActionInput = {
  audioClipId?: InputMaybe<Scalars['ID']>
  dispatchedGuardIds?: Array<Scalars['ID']>
  incidentId: Scalars['ID']
  message?: InputMaybe<Scalars['String']>
  /** The new priority for the incident. Required when type is PRIORITY_CHANGE. */
  priority?: InputMaybe<IncidentPriority>
  resolutionContent?: InputMaybe<Array<ResolutionSegmentInput>>
  technicianId?: InputMaybe<Scalars['ID']>
  type: IncidentActionType
}

export type ResolutionSegmentInput = {
  detectedAt?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  segmentType: ResolutionSegmentType
  text: Scalars['String']
}

/** *Automatically generated.* */
export type CreateIncidentActionPayload = {
  __typename?: 'CreateIncidentActionPayload'
  incidentAction?: Maybe<IncidentAction>
  /** Structured send outcome, set only when the action type is SEND_TO_ONTIC */
  integrationSendResult?: Maybe<IntegrationSendResult>
}

export type CreateIncidentCategoryWhitelistInput = {
  incidentCategoryId: Scalars['ID']
  userIds: Array<Scalars['ID']>
}

export type IncidentCategoryWhitelistConnection = {
  __typename?: 'IncidentCategoryWhitelistConnection'
  edges?: Maybe<Array<Maybe<IncidentCategoryWhitelistEdge>>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type IncidentCategoryWhitelistEdge = {
  __typename?: 'IncidentCategoryWhitelistEdge'
  cursor?: Maybe<Scalars['String']>
  node?: Maybe<IncidentCategoryWhitelist>
}

export type IncidentCategoryWhitelist = {
  __typename?: 'IncidentCategoryWhitelist'
  categoryId: Scalars['ID']
  createdAt: Scalars['String']
  id: Scalars['ID']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateIncidentDeviceMediaInput = {
  deviceId: Scalars['ID']
  incidentId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateIncidentDeviceMediaPayload = {
  __typename?: 'CreateIncidentDeviceMediaPayload'
  incidentDeviceMedia?: Maybe<IncidentDeviceMedia>
}

/** *Automatically generated.* */
export type CreateIncidentInformationSolicitationInput = {
  incidentId: Scalars['ID']
  message?: InputMaybe<Scalars['String']>
  recipientIds: Array<Scalars['ID']>
}

/** *Automatically generated.* */
export type CreateIncidentInformationSolicitationPayload = {
  __typename?: 'CreateIncidentInformationSolicitationPayload'
  incidentInformationSolicitation?: Maybe<IncidentInformationSolicitation>
}

export type IncidentInformationSolicitation = {
  __typename?: 'IncidentInformationSolicitation'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  creator?: Maybe<User>
  creatorId: Scalars['ID']
  id: Scalars['ID']
  incidentId: Scalars['ID']
  message?: Maybe<Scalars['String']>
  recipientIds: Array<Scalars['ID']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type CreateIncidentNoteInput = {
  incidentId: Scalars['ID']
  message: Scalars['String']
}

/** *Automatically generated.* */
export type CreateIncidentNotePayload = {
  __typename?: 'CreateIncidentNotePayload'
  incidentNote?: Maybe<IncidentNote>
}

export type CreateIncidentNoteMediaInput = {
  incidentNoteId: Scalars['ID']
  media: Array<IncidentNoteMediaInput>
}

export type IncidentNoteMediaInput = {
  name: Scalars['String']
  storedAssetId: Scalars['ID']
}

export type CreateIncidentNoteMediaPayload = {
  __typename?: 'CreateIncidentNoteMediaPayload'
  incidentNoteId: Scalars['ID']
  media?: Maybe<Array<Maybe<IncidentNoteMedia>>>
}

/** *Automatically generated.* */
export type CreateIncidentOccurrenceInput = {
  createdAt: Scalars['String']
}

/** *Automatically generated.* */
export type CreateIncidentOccurrencePayload = {
  __typename?: 'CreateIncidentOccurrencePayload'
  incidentOccurrence?: Maybe<IncidentOccurrence>
}

/** *Automatically generated.* */
export type CreateIncidentOfferInput = {
  incidentId: Scalars['ID']
  message?: InputMaybe<Scalars['String']>
  recipientIds: Array<Scalars['ID']>
}

/** *Automatically generated.* */
export type CreateIncidentOfferPayload = {
  __typename?: 'CreateIncidentOfferPayload'
  incidentOffer?: Maybe<IncidentOffer>
}

/**
 * ["Sharing"](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Glossary#Share-an-Incident-with-an-Operator)
 * of an incident by one Operator with another.
 */
export type IncidentOffer = IncidentOccurrence &
  SubscriberMessage & {
    __typename?: 'IncidentOffer'
    /** *Automatically generated.* */
    createdAt: Scalars['String']
    creator?: Maybe<User>
    creatorId: Scalars['ID']
    id: Scalars['ID']
    incident?: Maybe<Incident>
    incidentId: Scalars['ID']
    message?: Maybe<Scalars['String']>
    recipientIds: Array<Scalars['ID']>
    /**
     * There is
     * [exactly 1 recipient](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/718241793/Fragments+of+specification#%E2%80%9CSharing%E2%80%9D-has-1-recipient).
     *
     * *Despite that fact, we use a list type,
     * in order to future-proof the API.*
     */
    recipients?: Maybe<Array<Maybe<User>>>
    /** *Automatically generated.* */
    updatedAt: Scalars['String']
  }

/** *Automatically generated.* */
export type CreateIncidentOfferAcceptancePayload = {
  __typename?: 'CreateIncidentOfferAcceptancePayload'
  incidentOfferAcceptance?: Maybe<IncidentOfferAcceptance>
}

/**
 * Acceptance of an offer that was
 * made with the `IncidentOffer` type.
 */
export type IncidentOfferAcceptance = SubscriberMessage & {
  __typename?: 'IncidentOfferAcceptance'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id: Scalars['ID']
  incidentOffer?: Maybe<IncidentOffer>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type CreateIncidentOfferToGuardInput = {
  audioMessageId?: InputMaybe<Scalars['ID']>
  incidentId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateIncidentOfferToGuardPayload = {
  __typename?: 'CreateIncidentOfferToGuardPayload'
  incidentOfferToGuard?: Maybe<IncidentOfferToGuard>
}

/**
 * An offer of an incident to guards by an Operator.
 *
 * **Design note**
 *
 * There is no need to have a field for recipients, because the
 * recipients are determined largely by the facility.  To quote
 * ["Fragments of specification"](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/718241793/Fragments+of+specification?pageVersion=18#Incidents%3A-notes-on-assigning-to-guards%2C-etc.):
 *
 * > When an incident happens, an Operator offers it to every guard
 * > at the facility, optionally including a voice message with the
 * > offer. (A guard should probably be left out of this if he has
 * > already been assigned to an incident.)
 */
export type IncidentOfferToGuard = IncidentOccurrence &
  SubscriberMessage & {
    __typename?: 'IncidentOfferToGuard'
    audioMessage?: Maybe<AudioMessage>
    audioMessageId?: Maybe<Scalars['ID']>
    /** *Automatically generated.* */
    createdAt: Scalars['String']
    creator?: Maybe<User>
    creatorId: Scalars['ID']
    id: Scalars['ID']
    incident?: Maybe<Incident>
    incidentId: Scalars['ID']
    /** *Automatically generated.* */
    updatedAt: Scalars['String']
  }

/** *Automatically generated.* */
export type CreateIncidentOfferToGuardAcceptancePayload = {
  __typename?: 'CreateIncidentOfferToGuardAcceptancePayload'
  incidentOfferToGuardAcceptance?: Maybe<IncidentOfferToGuardAcceptance>
}

/**
 * Acceptance of an offer that was
 * made with the `IncidentOfferToGuard` type.
 */
export type IncidentOfferToGuardAcceptance = SubscriberMessage & {
  __typename?: 'IncidentOfferToGuardAcceptance'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id: Scalars['ID']
  incidentOfferToGuard?: Maybe<IncidentOfferToGuard>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

/** *Automatically generated.* */
export type CreateIncidentShareInput = {
  incidentId: Scalars['ID']
  target: MessageTargetInput
}

/** *Automatically generated.* */
export type CreateIncidentSharePayload = {
  __typename?: 'CreateIncidentSharePayload'
  incidentShare?: Maybe<IncidentShare>
}

/**
 * Create an object of this type to
 * ["Share an Incident with an Employee"](https://hivewatch.atlassian.net/wiki/spaces/EN/pages/166002738/Glossary#Share-an-Incident-with-an-Employee).
 */
export type IncidentShare = IncidentOccurrence &
  SubscriberMessage & {
    __typename?: 'IncidentShare'
    /** *Automatically generated.* */
    createdAt: Scalars['String']
    id: Scalars['ID']
    incidentId: Scalars['ID']
    target: MessageTarget
    /** *Automatically generated.* */
    updatedAt: Scalars['String']
  }

export type CreateIncidentTypeDefinitionInput = {
  archived?: Scalars['Boolean']
  defaultPriority?: InputMaybe<IncidentPriority>
  displayName: Scalars['String']
  icon?: InputMaybe<Scalars['String']>
  manual?: Scalars['Boolean']
  mutable?: Scalars['Boolean']
  quickReport?: Scalars['Boolean']
  slug: Scalars['String']
}

export type CreateIncidentTypeDefinitionPayload = {
  __typename?: 'CreateIncidentTypeDefinitionPayload'
  incidentTypeDefinition: IncidentTypeDefinition
}

export type CreateIncidentWorkflowInput = {
  graph: IncidentWorkflowGraphInput
  incidentTypeDefinitionId?: InputMaybe<Scalars['ID']>
  manualIncidentCategoryId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
}

export type IncidentWorkflowGraphInput = {
  nodes: Array<IncidentWorkflowNodeInput>
  startingStepId: Scalars['Int']
}

export type IncidentWorkflowNodeInput = {
  edges: Array<IncidentWorkflowEdgeInput>
  id: Scalars['Int']
  prompt: Scalars['String']
  stepType: WorkflowStepType
}

export type IncidentWorkflowEdgeInput = {
  label: Scalars['String']
  to?: InputMaybe<Scalars['Int']>
}

export type CreateIncidentWorkflowPayload = {
  __typename?: 'CreateIncidentWorkflowPayload'
  workflow: IncidentWorkflow
}

/** *Automatically generated.* */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload'
  invoice?: Maybe<Invoice>
}

export type Invoice = {
  __typename?: 'Invoice'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  id?: Maybe<Scalars['ID']>
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type CreateLlmIncidentsInput = {
  /** Delay between incident creation and AI Operator acknowledging the incident. */
  delayToAcknowledge?: Scalars['Int']
  /** Delay before incident creation. */
  delayToCreate?: Scalars['Int']
  /** Delay between AI Operator acknowledging the incident and flagging/resolving. Mimics the AI Operator processing. */
  delayToProcess?: Scalars['Int']
}

export type CreateLlmIncidentsPayload = {
  __typename?: 'CreateLlmIncidentsPayload'
  incidents?: Maybe<Array<Incident>>
}

export type CreateManualIncidentCategoryInput = {
  defaultPriority?: InputMaybe<IncidentPriority>
  isQuickReportCategory?: Scalars['Boolean']
  name: Scalars['String']
}

export type CreateManualIncidentCategoryPayload = {
  __typename?: 'CreateManualIncidentCategoryPayload'
  manualIncidentCategory: ManualIncidentCategory
}

/** *Automatically generated.* */
export type CreateOrganizationInput = {
  defaultCustomerSecretProviderId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
}

/** *Automatically generated.* */
export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload'
  organization?: Maybe<Organization>
}

/** *Automatically generated.* */
export type CreateOrganizationSettingsInput = {
  cameraOfflineDurationUnit: DurationUnit
  emailReplyToAddress?: InputMaybe<Scalars['String']>
  emailReplyToName?: InputMaybe<Scalars['String']>
  emailSenderName?: InputMaybe<Scalars['String']>
  minimumCameraOfflineDuration: Scalars['Int']
}

/** *Automatically generated.* */
export type CreateOrganizationSettingsPayload = {
  __typename?: 'CreateOrganizationSettingsPayload'
  organizationSettings?: Maybe<OrganizationSettings>
}

export type CreatePacsSourceInstanceInput = {
  fields: Array<PacsSourceFieldInput>
  name: Scalars['String']
  pacsSourceId: Scalars['ID']
}

export type PacsSourceFieldInput = {
  pacsSourceFieldId: Scalars['ID']
  value: Scalars['String']
}

export type CreatePacsSourceInstancePayload = {
  __typename?: 'CreatePacsSourceInstancePayload'
  pacsSourceInstance?: Maybe<PacsSourceInstance>
}

/** *Automatically generated.* */
export type CreatePartialCreditCardInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  endOfNumber?: InputMaybe<Scalars['String']>
  expiryMonth?: InputMaybe<Scalars['Int']>
  expiryYear?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreatePartialCreditCardPayload = {
  __typename?: 'CreatePartialCreditCardPayload'
  partialCreditCard?: Maybe<PartialCreditCard>
}

/** *Automatically generated.* */
export type CreatePermissionInput = {
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreatePermissionPayload = {
  __typename?: 'CreatePermissionPayload'
  permission?: Maybe<Permission>
}

export type CreatePersonOfInterestInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  caseId: Scalars['ID']
  caseRole: CaseRole
  companyAffiliation: CompanyAffiliation
  customCaseRoleDescription?: InputMaybe<Scalars['String']>
  customCompanyAffiliationDescription?: InputMaybe<Scalars['String']>
  dateOfBirth?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type CreatePersonOfInterestPayload = {
  __typename?: 'CreatePersonOfInterestPayload'
  personOfInterest?: Maybe<PersonOfInterest>
}

export type CreateProductMessageInput = {
  endDateTime: Scalars['String']
  message: Scalars['String']
  messageType?: InputMaybe<ProductMessageType>
  startDateTime: Scalars['String']
}

export type CreateProductMessagePayload = {
  __typename?: 'CreateProductMessagePayload'
  productMessage?: Maybe<ProductMessage>
}

export type CreateProgramRecommendationInput = {
  category: ProgramRecommendationCategory
  description?: InputMaybe<Scalars['String']>
  estimatedImpact?: InputMaybe<Scalars['String']>
  internalNote?: InputMaybe<Scalars['String']>
  owner: ProgramRecommendationOwner
  title: Scalars['String']
}

export type CreateProgramRecommendationPayload = {
  __typename?: 'CreateProgramRecommendationPayload'
  programRecommendation?: Maybe<ProgramRecommendation>
}

export type CreateQuickReportInput = {
  formDescription: Scalars['String']
  formTitle: Scalars['String']
  logoAssetId: Scalars['ID']
}

export type CreateQuickReportPayload = {
  __typename?: 'CreateQuickReportPayload'
  quickReport?: Maybe<QuickReport>
}

/** *Automatically generated.* */
export type CreateRoleInput = {
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreateRolePayload = {
  __typename?: 'CreateRolePayload'
  role?: Maybe<Role>
}

export type CreateRuleInput = {
  action: Action
  allDayOverride?: InputMaybe<Scalars['Boolean']>
  day?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['String']>
  endTimeOfDay?: InputMaybe<Scalars['String']>
  incidentTypeDefinitionIds?: InputMaybe<Array<Scalars['ID']>>
  incidentTypeScope?: InputMaybe<IncidentTypeScope>
  /** Whether this is a v2 Rules Engine rule. Requires the updated-rules feature flag. */
  isV2?: Scalars['Boolean']
  /** Only allowed if ruleEventType contains MANUAL */
  manualIncidentCategoryIds?: InputMaybe<Array<Scalars['ID']>>
  name: Scalars['String']
  /** Required when action is SET_PRIORITY, and must be omitted otherwise. */
  priority?: InputMaybe<IncidentPriority>
  repeatInterval?: InputMaybe<RepeatInterval>
  repeatIntervalNum?: InputMaybe<Scalars['Int']>
  ruleEventType?: InputMaybe<Array<RuleEventType>>
  ruleLogics: CreateRuleLogicInput
  startTime: Scalars['String']
  /** Default == active */
  status?: InputMaybe<Scalars['Boolean']>
  triggerType?: InputMaybe<RuleTriggerType>
}

export type CreateRuleLogicInput = {
  children?: InputMaybe<Array<InputMaybe<CreateRuleLogicInput>>>
  entity?: InputMaybe<Entity>
  /** Combinator for child nodes. Defaults to OR when omitted, for backward compatibility. */
  operator?: InputMaybe<Operator>
  value?: InputMaybe<Scalars['String']>
}

export type CreateRulePayload = {
  __typename?: 'CreateRulePayload'
  rule?: Maybe<Rule>
}

export type CreateSavedFilterInput = {
  context: FilterContext
  filterCriteria: FilterCriteriaInput
  isActive?: InputMaybe<Scalars['Boolean']>
  name: Scalars['String']
}

export type FilterCriteriaInput = {
  incident?: InputMaybe<IncidentFilterInput>
}

export type CreateSavedFilterPayload = {
  __typename?: 'CreateSavedFilterPayload'
  savedFilter?: Maybe<SavedFilter>
}

export type CreateSavedPayloadInput = {
  /** A JSON object. Any other JSON value is rejected. */
  payload: Scalars['JSON']
}

export type CreateSavedPayloadPayload = {
  __typename?: 'CreateSavedPayloadPayload'
  savedPayload?: Maybe<SavedPayload>
}

/** *Automatically generated.* */
export type CreateStandardOperatingProcedureInput = {
  externalId: Scalars['String']
  facilityIds?: InputMaybe<Array<Scalars['ID']>>
  name: Scalars['String']
  type: SopType
}

/** *Automatically generated.* */
export type CreateStandardOperatingProcedurePayload = {
  __typename?: 'CreateStandardOperatingProcedurePayload'
  standardOperatingProcedure?: Maybe<StandardOperatingProcedure>
}

/** *Automatically generated.* */
export type CreateSubscriberMessageInput = {
  createdAt: Scalars['String']
}

/** *Automatically generated.* */
export type CreateSubscriberMessagePayload = {
  __typename?: 'CreateSubscriberMessagePayload'
  subscriberMessage?: Maybe<SubscriberMessage>
}

export type CreateTagInput = {
  name: Scalars['String']
}

export type CreateTagPayload = {
  __typename?: 'CreateTagPayload'
  tag: Tag
}

export type CreateTagAndAddToDeviceInput = {
  deviceId: Scalars['ID']
  tagName: Scalars['String']
}

export type CreateTagAndAddToDevicePayload = {
  __typename?: 'CreateTagAndAddToDevicePayload'
  device: Device
  tag: Tag
}

export type CreateTailgateConnInput = {
  cameraIds: Array<Scalars['ID']>
  /** The id of a device that can be connected to cameras, not necessarily a door. */
  doorId: Scalars['ID']
}

/** *Automatically generated.* */
export type CreateTailgateConnPayload = {
  __typename?: 'CreateTailgateConnPayload'
  tailgateConn?: Maybe<TailgateConn>
}

export type CreateTailgateGridTestJobInput = {
  /**
   * The camera whose grid is being tested (ENG-34041). Every GTZ entry point has a concrete
   * camera in hand; passing it pins the streaming-resolution (grid-authoring space) lookup to
   * that camera on doors with multiple associated cameras. Optional for rollout compatibility:
   * when absent the backend selects deterministically (tailgate-enabled camera first).
   */
  cameraId?: InputMaybe<Scalars['ID']>
  incidentId: Scalars['ID']
  securedBox: BoxInput
  unsecuredBox: BoxInput
}

export type CreateTailgateGridTestJobPayload = {
  __typename?: 'CreateTailgateGridTestJobPayload'
  tailgateGridTestJob?: Maybe<TailgateGridTestJob>
}

/** *Automatically generated.* */
export type CreateTechnicianInput = {
  deviceTypes?: InputMaybe<Array<InputMaybe<DeviceType>>>
  email?: InputMaybe<Scalars['String']>
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreateTechnicianPayload = {
  __typename?: 'CreateTechnicianPayload'
  technician?: Maybe<Technician>
}

export type CreateThreatInput = {
  eventUuid: Scalars['String']
  payload: Scalars['JSON']
  receivedAt: Scalars['String']
}

export type CreateThreatPayload = {
  __typename?: 'CreateThreatPayload'
  threat?: Maybe<Threat>
}

export type Threat = {
  __typename?: 'Threat'
  createdAt: Scalars['String']
  eventUuid: Scalars['String']
  id: Scalars['ID']
  payload: Scalars['JSON']
  receivedAt: Scalars['String']
  updatedAt: Scalars['String']
}

export type CreateTourPlanInput = {
  checkpointIds: Array<Scalars['ID']>
  facilityId: Scalars['ID']
  name: Scalars['String']
}

/** *Automatically generated.* */
export type CreateTourPlanPayload = {
  __typename?: 'CreateTourPlanPayload'
  tourPlan?: Maybe<TourPlan>
}

/** *Automatically generated.* */
export type CreateUserInput = {
  designatedFacilityId?: InputMaybe<Scalars['ID']>
  email?: InputMaybe<Scalars['String']>
  facilityId?: InputMaybe<Scalars['ID']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  onDuty?: InputMaybe<Scalars['Boolean']>
  roleName?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload'
  user?: Maybe<User>
}

export type CreateUserFeedbackInput = {
  message: Scalars['String']
  storedAssetId?: InputMaybe<Scalars['ID']>
}

export type CreateUserFeedbackPayload = {
  __typename?: 'CreateUserFeedbackPayload'
  userFeedback?: Maybe<UserFeedback>
}

export type UserFeedback = {
  __typename?: 'UserFeedback'
  createdAt: Scalars['String']
  creatorId: Scalars['ID']
  id: Scalars['ID']
  message: Scalars['String']
  storedAssetId?: Maybe<Scalars['ID']>
  updatedAt: Scalars['String']
}

export type CreateWebhookInput = {
  /** Sent as-is on every request to the destination. */
  authHeader?: InputMaybe<HttpHeaderInput>
  destination: Scalars['String']
  httpMethod: WebhookHttpMethod
  /** At most 100 characters; surrounding whitespace is trimmed. */
  name: Scalars['String']
  savedPayloadId: Scalars['ID']
}

/** A header sent as-is on every request to a webhook's destination, e.g. Authorization: Bearer … */
export type HttpHeaderInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type CreateWebhookPayload = {
  __typename?: 'CreateWebhookPayload'
  webhook?: Maybe<Webhook>
}

export type CreateWorkflowActionInput = {
  edgeLabel: Scalars['String']
  incidentId: Scalars['ID']
  nodeId: Scalars['ID']
}

export type DeactivateEmailRecipientInput = {
  email: Scalars['String']
}

/** *Automatically generated.* */
export type DeleteAcknowledgementInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAcknowledgementPayload = {
  __typename?: 'DeleteAcknowledgementPayload'
  id: Scalars['ID']
}

export type DeleteAiOperatorDeviceConfigurationInput = {
  deviceId: Scalars['ID']
}

export type DeleteAiOperatorDeviceConfigurationPayload = {
  __typename?: 'DeleteAiOperatorDeviceConfigurationPayload'
  deviceId: Scalars['ID']
}

export type DeleteAiOperatorResponseRulesInput = {
  ruleId: Scalars['ID']
}

export type DeleteAiOperatorResponseRulesPayload = {
  __typename?: 'DeleteAiOperatorResponseRulesPayload'
  rule?: Maybe<Rule>
}

export type DeleteAlarmInput = {
  id: Scalars['ID']
}

export type DeleteAlarmPayload = {
  __typename?: 'DeleteAlarmPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAlertInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAlertPayload = {
  __typename?: 'DeleteAlertPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAudioClipInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAudioClipPayload = {
  __typename?: 'DeleteAudioClipPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAudioMessageInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteAudioMessagePayload = {
  __typename?: 'DeleteAudioMessagePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCameraInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCameraPayload = {
  __typename?: 'DeleteCameraPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCameraLiveFeedDetailInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCameraLiveFeedDetailPayload = {
  __typename?: 'DeleteCameraLiveFeedDetailPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteChargeInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteChargePayload = {
  __typename?: 'DeleteChargePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCheckInInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCheckInPayload = {
  __typename?: 'DeleteCheckInPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCheckOutInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCheckOutPayload = {
  __typename?: 'DeleteCheckOutPayload'
  id: Scalars['ID']
}

export type DeleteCheckpointTaskInput = {
  id: Scalars['ID']
}

export type DeleteCheckpointTaskPayload = {
  __typename?: 'DeleteCheckpointTaskPayload'
  checkpointTaskId: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCreditCardInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteCreditCardPayload = {
  __typename?: 'DeleteCreditCardPayload'
  id: Scalars['ID']
}

export type DeleteCustomerSecretProviderPayload = {
  __typename?: 'DeleteCustomerSecretProviderPayload'
  id?: Maybe<Scalars['ID']>
}

export type DeleteCustomFormQuestionInput = {
  id: Scalars['ID']
}

export type DeleteCustomFormQuestionPayload = {
  __typename?: 'DeleteCustomFormQuestionPayload'
  success: Scalars['Boolean']
}

export type DeleteCustomFormQuestionOptionInput = {
  id: Scalars['ID']
}

export type DeleteCustomFormQuestionOptionPayload = {
  __typename?: 'DeleteCustomFormQuestionOptionPayload'
  success: Scalars['Boolean']
}

export type DeleteCustomFormSectionInput = {
  id: Scalars['ID']
}

export type DeleteCustomFormSectionPayload = {
  __typename?: 'DeleteCustomFormSectionPayload'
  success: Scalars['Boolean']
}

/** *Automatically generated.* */
export type DeleteDeviceInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteDevicePayload = {
  __typename?: 'DeleteDevicePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteDeviceRepairOrderInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteDeviceRepairOrderPayload = {
  __typename?: 'DeleteDeviceRepairOrderPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteDoorInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteDoorPayload = {
  __typename?: 'DeleteDoorPayload'
  id: Scalars['ID']
}

export type DeleteEdgeDeviceInput = {
  id: Scalars['ID']
}

export type DeleteEdgeDevicePayload = {
  __typename?: 'DeleteEdgeDevicePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteEmergencyCallInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteEmergencyCallPayload = {
  __typename?: 'DeleteEmergencyCallPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteEmergencyCallingInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteEmergencyCallingPayload = {
  __typename?: 'DeleteEmergencyCallingPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteEventInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteEventPayload = {
  __typename?: 'DeleteEventPayload'
  id: Scalars['ID']
}

export type DeleteExternalAccountInput = {
  id: Scalars['ID']
}

export type DeleteExternalAccountPayload = {
  __typename?: 'DeleteExternalAccountPayload'
  id: Scalars['ID']
}

export type DeleteExternalAccountApiKeyInput = {
  id: Scalars['ID']
}

export type DeleteExternalAccountApiKeyPayload = {
  __typename?: 'DeleteExternalAccountApiKeyPayload'
  id: Scalars['ID']
}

export type DeleteExternalAccountIdpInput = {
  id: Scalars['ID']
}

export type DeleteExternalAccountIdpPayload = {
  __typename?: 'DeleteExternalAccountIdpPayload'
  id: Scalars['ID']
}

export type DeleteExternalAccountPropertiesInput = {
  id: Scalars['ID']
}

export type DeleteExternalAccountPropertiesPayload = {
  __typename?: 'DeleteExternalAccountPropertiesPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteFacilityInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteFacilityPayload = {
  __typename?: 'DeleteFacilityPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteFloorInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteFloorPayload = {
  __typename?: 'DeleteFloorPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteFloorPlanInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteFloorPlanPayload = {
  __typename?: 'DeleteFloorPlanPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteGatewayInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteGatewayPayload = {
  __typename?: 'DeleteGatewayPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteGuardTourInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteGuardTourPayload = {
  __typename?: 'DeleteGuardTourPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentPayload = {
  __typename?: 'DeleteIncidentPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentActionInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentActionPayload = {
  __typename?: 'DeleteIncidentActionPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentDeviceMediaInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentDeviceMediaPayload = {
  __typename?: 'DeleteIncidentDeviceMediaPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentInformationSolicitationInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentInformationSolicitationPayload = {
  __typename?: 'DeleteIncidentInformationSolicitationPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentNoteInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentNotePayload = {
  __typename?: 'DeleteIncidentNotePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOccurrenceInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOccurrencePayload = {
  __typename?: 'DeleteIncidentOccurrencePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferPayload = {
  __typename?: 'DeleteIncidentOfferPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferAcceptanceInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferAcceptancePayload = {
  __typename?: 'DeleteIncidentOfferAcceptancePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferToGuardInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferToGuardPayload = {
  __typename?: 'DeleteIncidentOfferToGuardPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferToGuardAcceptanceInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentOfferToGuardAcceptancePayload = {
  __typename?: 'DeleteIncidentOfferToGuardAcceptancePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentShareInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteIncidentSharePayload = {
  __typename?: 'DeleteIncidentSharePayload'
  id: Scalars['ID']
}

export type DeleteIncidentTypeDefinitionPayload = {
  __typename?: 'DeleteIncidentTypeDefinitionPayload'
  id: Scalars['ID']
}

export type DeleteIntegrationFieldMappingInput = {
  id: Scalars['ID']
}

export type DeleteIntegrationFieldMappingPayload = {
  __typename?: 'DeleteIntegrationFieldMappingPayload'
  success: Scalars['Boolean']
}

export type DeleteIntegrationQuestionMappingInput = {
  id: Scalars['ID']
}

export type DeleteIntegrationQuestionMappingPayload = {
  __typename?: 'DeleteIntegrationQuestionMappingPayload'
  success: Scalars['Boolean']
}

/** *Automatically generated.* */
export type DeleteInvoiceInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteInvoicePayload = {
  __typename?: 'DeleteInvoicePayload'
  id: Scalars['ID']
}

export type DeleteManualIncidentCategoryInput = {
  id: Scalars['ID']
}

export type DeleteManualIncidentCategoryPayload = {
  __typename?: 'DeleteManualIncidentCategoryPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteOrganizationInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteOrganizationSettingsInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteOrganizationSettingsPayload = {
  __typename?: 'DeleteOrganizationSettingsPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeletePartialCreditCardInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeletePartialCreditCardPayload = {
  __typename?: 'DeletePartialCreditCardPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeletePermissionInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeletePermissionPayload = {
  __typename?: 'DeletePermissionPayload'
  id: Scalars['ID']
}

export type DeleteProductMessageInput = {
  id: Scalars['ID']
}

export type DeleteProductMessagePayload = {
  __typename?: 'DeleteProductMessagePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteRoleInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteRolePayload = {
  __typename?: 'DeleteRolePayload'
  id: Scalars['ID']
}

export type DeleteSavedFilterInput = {
  id: Scalars['ID']
}

export type DeleteSavedFilterPayload = {
  __typename?: 'DeleteSavedFilterPayload'
  id: Scalars['ID']
}

export type DeleteSavedPayloadInput = {
  id: Scalars['ID']
}

export type DeleteSavedPayloadPayload = {
  __typename?: 'DeleteSavedPayloadPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteStandardOperatingProcedureInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteStandardOperatingProcedurePayload = {
  __typename?: 'DeleteStandardOperatingProcedurePayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteSubscriberMessageInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteSubscriberMessagePayload = {
  __typename?: 'DeleteSubscriberMessagePayload'
  id: Scalars['ID']
}

export type DeleteTagInput = {
  id: Scalars['ID']
}

export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteTailgateConnInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteTailgateConnPayload = {
  __typename?: 'DeleteTailgateConnPayload'
  id: Scalars['ID']
}

export type DeleteTailgateGridInput = {
  cameraId: Scalars['ID']
  doorId: Scalars['ID']
}

export type DeleteTailgateGridPayload = {
  __typename?: 'DeleteTailgateGridPayload'
  camera?: Maybe<Device>
  door?: Maybe<Device>
  inBox?: Maybe<Box>
  outBox?: Maybe<Box>
}

/** *Automatically generated.* */
export type DeleteTechnicianInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteTechnicianPayload = {
  __typename?: 'DeleteTechnicianPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteTourPlanInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteTourPlanPayload = {
  __typename?: 'DeleteTourPlanPayload'
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteUserInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload'
  id: Scalars['ID']
}

export type DeleteWebhookInput = {
  id: Scalars['ID']
}

export type DeleteWebhookPayload = {
  __typename?: 'DeleteWebhookPayload'
  id: Scalars['ID']
}

export type DisableEmailSourceInput = {
  id: Scalars['ID']
}

export type DisableEmailSourcePayload = {
  __typename?: 'DisableEmailSourcePayload'
  emailSource?: Maybe<EmailSource>
}

export type DisassociateIncidentsFromCaseInput = {
  caseId: Scalars['ID']
  incidentIds: Array<Scalars['ID']>
}

export type DisassociatePersonOfInterestInput = {
  caseId: Scalars['ID']
  personOfInterestId: Scalars['ID']
}

export type EmbedQuickSightContentInput = {
  /**
   * Corresponds to `SessionLifetimeInMinutes`
   * as briefly described in the QuickSight [documentation].
   *
   * The server adjusts the client's value
   * so that it falls within a minimum and maximum,
   * which are configured on the server.
   * They are both 15,
   * but this might change in future.
   *
   * [documentation]: https://docs.aws.amazon.com/quicksight/latest/APIReference/API_GenerateEmbedUrlForAnonymousUser.html#API_GenerateEmbedUrlForAnonymousUser_RequestBody
   */
  sessionLifetimeInMinutes?: Scalars['Int']
}

export type EmbedQuickSightContentPayload = {
  __typename?: 'EmbedQuickSightContentPayload'
  embeddedQuickSightContent?: Maybe<EmbeddedQuickSightContent>
}

export type EmbeddedQuickSightContent = {
  __typename?: 'EmbeddedQuickSightContent'
  /**
   * A time in ISO8601 format.
   * The time is `sessionLifetimeInMinutes` minutes
   * after the time of generation of the URL.
   *
   * ## Examples
   *
   * * 2025-01-07T13:25:54.432Z
   */
  expiryTime: Scalars['String']
  /**
   * Guaranteed to have the same value as
   * `EmbedQuickSightContentInput.sessionLifetimeInMinutes`,
   * after its adjustment by the server.
   */
  sessionLifetimeInMinutes: Scalars['Int']
  /**
   * A URL suitable for embedding
   * in an iframe in a web page.
   * See the [AWS documentation]
   * for information on how to embed the URL.
   *
   * [AWS documentation]: https://docs.aws.amazon.com/quicksight/latest/user/embedded-analytics-dashboards-for-everyone.html#embedded-analytics-dashboards-with-anonymous-users-step-3
   *
   * The URL must be requested
   * within 5 minutes of its generation
   * or it won't work.
   * It can only be requested once.
   *
   * The web page containing the embedded QuickSight content
   * must have the same domain as the HiveWatch web app.
   */
  url: Scalars['String']
}

export type EnableEmailSourceInput = {
  id: Scalars['ID']
}

export type EnableEmailSourcePayload = {
  __typename?: 'EnableEmailSourcePayload'
  emailSource?: Maybe<EmailSource>
}

export type EnableManualIncidentCategoriesForQuickReportInput = {
  ids: Array<Scalars['ID']>
}

export type GenerateIncidentSummaryInput = {
  incidentIds: Array<Scalars['ID']>
}

export type GenerateIncidentSummaryPayload = {
  __typename?: 'GenerateIncidentSummaryPayload'
  categoryBreakdown: Array<IncidentSummaryCategoryBreakdown>
  incidents: Array<IncidentSummaryItem>
  overview: IncidentSummaryOverview
  patterns: Array<IncidentSummaryPattern>
}

export type IncidentSummaryCategoryBreakdown = {
  __typename?: 'IncidentSummaryCategoryBreakdown'
  category: AiIncidentSeverityCategory
  count: Scalars['Int']
  narrative: Scalars['String']
  percentage: Scalars['Float']
}

export enum AiIncidentSeverityCategory {
  Critical = 'CRITICAL',
  Informational = 'INFORMATIONAL',
  Low = 'LOW',
  Moderate = 'MODERATE',
  Urgent = 'URGENT',
}

export type IncidentSummaryItem = {
  __typename?: 'IncidentSummaryItem'
  assignedCategory: AiIncidentSeverityCategory
  displayId: Scalars['String']
  incidentId: Scalars['String']
  summary: Scalars['String']
}

export type IncidentSummaryOverview = {
  __typename?: 'IncidentSummaryOverview'
  dateRange: IncidentSummaryDateRange
  incidentCount: Scalars['Int']
  narrative: Scalars['String']
  severityBreakdown: IncidentSummarySeverityBreakdown
  statusBreakdown: IncidentSummaryStatusBreakdown
  topDevices: Array<Scalars['String']>
  topFacilities: Array<Scalars['String']>
}

export type IncidentSummaryDateRange = {
  __typename?: 'IncidentSummaryDateRange'
  from: Scalars['String']
  to: Scalars['String']
}

export type IncidentSummarySeverityBreakdown = {
  __typename?: 'IncidentSummarySeverityBreakdown'
  critical: Scalars['Int']
  informational: Scalars['Int']
  low: Scalars['Int']
  moderate: Scalars['Int']
  urgent: Scalars['Int']
}

export type IncidentSummaryStatusBreakdown = {
  __typename?: 'IncidentSummaryStatusBreakdown'
  active: Scalars['Int']
  inProgress: Scalars['Int']
  resolved: Scalars['Int']
}

export type IncidentSummaryPattern = {
  __typename?: 'IncidentSummaryPattern'
  description: Scalars['String']
  incidentIds: Array<Scalars['String']>
}

/** Input for inviting a new user. Creates the user and sends an email invitation to set their password. */
export type InviteUserInput = {
  designatedFacilityId?: InputMaybe<Scalars['ID']>
  email: Scalars['String']
  firstName: Scalars['String']
  /** If true, sends VERIFY_EMAIL action (for SSO users). If false, sends UPDATE_PASSWORD action. */
  isSsoUser?: InputMaybe<Scalars['Boolean']>
  lastName: Scalars['String']
  roles: Array<Scalars['String']>
}

/** *Automatically generated.* */
export type InviteUserPayload = {
  __typename?: 'InviteUserPayload'
  user?: Maybe<User>
}

export type LinkCustomerSecretProviderInput = {
  customerSecretProviderId: Scalars['ID']
  entityId: Scalars['ID']
  entityType: CredentialLinkEntityType
}

export type LinkCustomerSecretProviderPayload = {
  __typename?: 'LinkCustomerSecretProviderPayload'
  customerSecretProviderLink?: Maybe<CustomerSecretProviderLink>
}

export type CustomerSecretProviderLink = {
  __typename?: 'CustomerSecretProviderLink'
  /** *Automatically generated.* */
  createdAt: Scalars['String']
  customerSecretProvider: CustomerSecretProvider
  customerSecretProviderId: Scalars['ID']
  entity?: Maybe<CredentialLinkEntity>
  entityId: Scalars['ID']
  entityType: CredentialLinkEntityType
  id: Scalars['ID']
  /** *Automatically generated.* */
  updatedAt: Scalars['String']
}

export type LogGuardTourCheckpointInput = {
  checkpointId: Scalars['ID']
  checkpointPhotoId?: InputMaybe<Scalars['ID']>
  guardTourId: Scalars['ID']
  note?: InputMaybe<Scalars['String']>
  status?: InputMaybe<GuardTourCompletedCheckpointStatus>
  tasks?: InputMaybe<Array<CheckpointTaskInput>>
}

export type CheckpointTaskInput = {
  description: Scalars['String']
  isCompleted: Scalars['Boolean']
  isRequired: Scalars['Boolean']
}

/** *Automatically generated.* */
export type UpdateGuardTourPayload = {
  __typename?: 'UpdateGuardTourPayload'
  guardTour?: Maybe<GuardTour>
}

export type MarkFtuCompletedInput = {
  /** String key of the guide as registered by the web app, e.g. dark-mode-v1. */
  ftuId: Scalars['String']
}

export type MarkFtuCompletedPayload = {
  __typename?: 'MarkFtuCompletedPayload'
  userSetting: UserSetting
}

export type ModifyTailgateConnInput = {
  cameraIdsToAdd: Array<Scalars['ID']>
  cameraIdsToRemove: Array<Scalars['ID']>
  id: Scalars['ID']
}

export type ModifyTailgateConnPayload = {
  __typename?: 'ModifyTailgateConnPayload'
  tailgateConn?: Maybe<TailgateConn>
}

export type OffboardUserInput = {
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type OffboardUserPayload = {
  __typename?: 'OffboardUserPayload'
  id: Scalars['ID']
}

export type PublishCustomFormInput = {
  id: Scalars['ID']
}

export type PublishCustomFormPayload = {
  __typename?: 'PublishCustomFormPayload'
  customForm: CustomForm
}

export type RefreshQuickReportCodePayload = {
  __typename?: 'RefreshQuickReportCodePayload'
  quickReportCode?: Maybe<QuickReportCode>
}

export type RegisterPushNotificationQueryInput = {
  query: Scalars['String']
}

export type RegisterPushNotificationQueryPayload = {
  __typename?: 'RegisterPushNotificationQueryPayload'
  success: Scalars['Boolean']
}

export type RemoveTagsFromDeviceInput = {
  deviceId: Scalars['ID']
  tagIds: Array<Scalars['ID']>
}

export type RemoveTagsFromDevicePayload = {
  __typename?: 'RemoveTagsFromDevicePayload'
  device: Device
}

export type RemoveTagsFromDevicesInput = {
  deviceIds: Array<Scalars['ID']>
  tagIds: Array<Scalars['ID']>
}

export type RemoveTagsFromDevicesPayload = {
  __typename?: 'RemoveTagsFromDevicesPayload'
  devices: Array<Device>
}

export type ReorderFloorsInput = {
  facilityId: Scalars['ID']
  floorIds: Array<Scalars['ID']>
}

export type ReorderFloorsPayload = {
  __typename?: 'ReorderFloorsPayload'
  floors: Array<Floor>
}

/** Input for resending an invitation email to an existing user. Invalidates any previous invite links. */
export type ResendUserInviteInput = {
  id: Scalars['ID']
  /** If true, sends VERIFY_EMAIL action (for SSO users). If false, sends UPDATE_PASSWORD action. If null (omitted), preserves the existing action from Keycloak; defaults to UPDATE_PASSWORD if no recognized invite action is found. */
  isSsoUser?: InputMaybe<Scalars['Boolean']>
}

/** *Automatically generated.* */
export type ResendUserInvitePayload = {
  __typename?: 'ResendUserInvitePayload'
  user?: Maybe<User>
}

export type RestartEdgeDeviceInput = {
  componentName: Scalars['String']
  edgeDeviceName: Scalars['String']
}

export type RestartEdgeDevicePayload = {
  __typename?: 'RestartEdgeDevicePayload'
  isRestartRequested: Scalars['Boolean']
}

export type RotateEmailSourceIngestAddressInput = {
  id: Scalars['ID']
}

export type RotateEmailSourceIngestAddressPayload = {
  __typename?: 'RotateEmailSourceIngestAddressPayload'
  emailSource?: Maybe<EmailSource>
}

export type SendWebhookInput = {
  incidentId: Scalars['ID']
  webhookId: Scalars['ID']
}

export type SendWebhookPayload = {
  __typename?: 'SendWebhookPayload'
  /** The response body, cut off at 1 MiB. Null when the destination sent none. */
  body?: Maybe<Scalars['String']>
  /** The HTTP status code the destination replied with. */
  statusCode: Scalars['Int']
}

export type SetUserPhotoInput = {
  /**
   * Must refer to an image having certain dimensions.
   * The permitted dimensions depend on the value of
   * `type`, as follows.
   *
   * | `type` | Width | Height |
   * | --- | --- | --- |
   * | `AVATAR` | 48 | 48 |
   * | `PHOTO` | 300-500 | `[width, 1.75 * width]` |
   *
   * *In a web browser, it appears that an image's dimensions
   * can be obtained using
   * [FileReader](https://developer.mozilla.org/en-US/docs/Web/API/FileReader).
   * See [this answer](https://stackoverflow.com/a/47786555) on Stack Overflow.*
   */
  fileId: Scalars['ID']
  type: UserPhotoType
}

export enum UserPhotoType {
  Avatar = 'AVATAR',
  Photo = 'PHOTO',
}

export type SetUserPhotoPayload = {
  __typename?: 'SetUserPhotoPayload'
  success?: Maybe<Scalars['Boolean']>
}

export type TransitionProgramRecommendationInput = {
  action: ProgramRecommendationActionType
  id: Scalars['ID']
  note?: InputMaybe<Scalars['String']>
}

export type TransitionProgramRecommendationPayload = {
  __typename?: 'TransitionProgramRecommendationPayload'
  programRecommendation?: Maybe<ProgramRecommendation>
}

export type UnarchiveFloorInput = {
  id: Scalars['ID']
}

export type UnarchiveFloorPayload = {
  __typename?: 'UnarchiveFloorPayload'
  floor?: Maybe<Floor>
}

export type UnlinkCustomerSecretProviderInput = {
  entityId: Scalars['ID']
  entityType: CredentialLinkEntityType
}

export type UnlinkCustomerSecretProviderPayload = {
  __typename?: 'UnlinkCustomerSecretProviderPayload'
  id?: Maybe<Scalars['ID']>
}

export type UnpublishCustomFormInput = {
  id: Scalars['ID']
}

export type UnpublishCustomFormPayload = {
  __typename?: 'UnpublishCustomFormPayload'
  customForm: CustomForm
}

/** *Automatically generated.* */
export type UpdateAcknowledgementInput = {
  audioClipId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type UpdateAcknowledgementPayload = {
  __typename?: 'UpdateAcknowledgementPayload'
  acknowledgement?: Maybe<Acknowledgement>
}

export type UpdateAiOperatorHumanLabelInput = {
  humanValue?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
}

export type UpdateAiOperatorHumanLabelPayload = {
  __typename?: 'UpdateAiOperatorHumanLabelPayload'
  aiOperatorHumanLabel: AiOperatorHumanLabel
}

export type UpdateAiOperatorLimitInput = {
  id: Scalars['ID']
  monthlyIncidentLimit: Scalars['Int']
}

/** *Automatically generated.* */
export type UpdateAiOperatorSettingsPayload = {
  __typename?: 'UpdateAiOperatorSettingsPayload'
  aiOperatorSettings?: Maybe<AiOperatorSettings>
}

export type UpdateAiOperatorModelInput = {
  canonicalName?: InputMaybe<Scalars['String']>
  default?: InputMaybe<Scalars['Boolean']>
  enabled?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  identifier?: InputMaybe<Scalars['String']>
  provider?: InputMaybe<AiOperatorModelProvider>
}

export type UpdateAiOperatorModelPayload = {
  __typename?: 'UpdateAiOperatorModelPayload'
  aiOperatorModel?: Maybe<AiOperatorModel>
}

export type UpdateAiOperatorResponseRulesInput = {
  aiOperatorDefaultAction?: InputMaybe<AiOperatorActionType>
  aiOperatorResponseRules?: InputMaybe<Array<AiOperatorResponseRuleInput>>
  isDryRun?: InputMaybe<Scalars['Boolean']>
  ruleId: Scalars['ID']
}

export type AiOperatorResponseRuleInput = {
  action: AiOperatorActionType
  detected: Scalars['Boolean']
  fieldId: Scalars['ID']
  modelId?: InputMaybe<Scalars['ID']>
}

export type UpdateAiOperatorResponseRulesPayload = {
  __typename?: 'UpdateAiOperatorResponseRulesPayload'
  rule?: Maybe<Rule>
}

export type UpdateAiOperatorThresholdsInput = {
  accessGrantedTimeThreshold?: InputMaybe<Scalars['Float']>
  doorCloseTimeThreshold?: InputMaybe<Scalars['Float']>
  doorForcedBounceTimeThreshold?: InputMaybe<Scalars['Float']>
  id: Scalars['ID']
}

export type UpdateAiOperatorThresholdsPayload = {
  __typename?: 'UpdateAiOperatorThresholdsPayload'
  aiOperatorSettings?: Maybe<AiOperatorSettings>
}

export type UpdateAlarmInput = {
  alarmTypeId?: InputMaybe<NullableId>
  externalId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

export type NullableId = {
  value?: InputMaybe<Scalars['ID']>
}

export type UpdateAlarmPayload = {
  __typename?: 'UpdateAlarmPayload'
  alarm?: Maybe<Alarm>
}

/** *Automatically generated.* */
export type UpdateAlertInput = {
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  priority?: InputMaybe<AlertPriority>
}

/** *Automatically generated.* */
export type UpdateAlertPayload = {
  __typename?: 'UpdateAlertPayload'
  alert?: Maybe<Alert>
}

/** *Automatically generated.* */
export type UpdateAudioClipInput = {
  endTime?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  startTime?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateAudioClipPayload = {
  __typename?: 'UpdateAudioClipPayload'
  audioClip?: Maybe<AudioClip>
}

/** *Automatically generated.* */
export type UpdateAudioMessageInput = {
  audioClipId?: InputMaybe<Scalars['ID']>
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  incidentOwnerId?: InputMaybe<Scalars['ID']>
  target?: InputMaybe<MessageTargetInput>
}

/** *Automatically generated.* */
export type UpdateAudioMessagePayload = {
  __typename?: 'UpdateAudioMessagePayload'
  audioMessage?: Maybe<AudioMessage>
}

/** *Automatically generated.* */
export type UpdateCameraInput = {
  externalAccountId?: InputMaybe<Scalars['ID']>
  externalId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  requiresAuthentication?: InputMaybe<Scalars['Boolean']>
  rtspIp?: InputMaybe<Scalars['String']>
  /** Orthogonal to Customer Secret Providers. */
  rtspPassword?: InputMaybe<Scalars['String']>
  rtspPath?: InputMaybe<Scalars['String']>
  rtspPort?: InputMaybe<Scalars['Int']>
  /** Orthogonal to Customer Secret Providers. */
  rtspUsername?: InputMaybe<Scalars['String']>
  streamingProtocol?: InputMaybe<StreamingProtocol>
  streamingResolutionHeight?: InputMaybe<Scalars['Int']>
  streamingResolutionWidth?: InputMaybe<Scalars['Int']>
  streamingType?: InputMaybe<StreamingType>
}

/** *Automatically generated.* */
export type UpdateCameraPayload = {
  __typename?: 'UpdateCameraPayload'
  camera?: Maybe<Camera>
}

export type UpdateCaseInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  detailedReport?: InputMaybe<Scalars['String']>
  facilityIds?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  status?: InputMaybe<CaseStatus>
}

export type UpdateCaseOwnerInput = {
  caseId: Scalars['ID']
  ownerId: Scalars['ID']
}

export type UpdateCaseStatusInput = {
  caseId: Scalars['ID']
  newStatus: CaseStatus
}

/** *Automatically generated.* */
export type UpdateChargeInput = {
  amount?: InputMaybe<Scalars['Int']>
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type UpdateChargePayload = {
  __typename?: 'UpdateChargePayload'
  charge?: Maybe<Charge>
}

/** *Automatically generated.* */
export type UpdateCheckInInput = {
  deviceToken?: InputMaybe<Scalars['String']>
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  platform?: InputMaybe<Platform>
}

/** *Automatically generated.* */
export type UpdateCheckInPayload = {
  __typename?: 'UpdateCheckInPayload'
  checkIn?: Maybe<CheckIn>
}

export type UpdateCheckpointInput = {
  id: Scalars['ID']
  isPhotoRequired: Scalars['Boolean']
}

export type UpdateCheckpointTaskInput = {
  description?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  isRequired?: InputMaybe<Scalars['Boolean']>
}

export type UpdateCheckpointTaskPayload = {
  __typename?: 'UpdateCheckpointTaskPayload'
  checkpointTask?: Maybe<CheckpointTask>
}

/** *Automatically generated.* */
export type UpdateCreditCardInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  expiryMonth?: InputMaybe<Scalars['Int']>
  expiryYear?: InputMaybe<Scalars['Int']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  number?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateCreditCardPayload = {
  __typename?: 'UpdateCreditCardPayload'
  creditCard?: Maybe<CreditCard>
}

export type UpdateCustomerSecretProviderInput = {
  id: Scalars['ID']
  kmsAlias?: InputMaybe<Scalars['String']>
  kmsKeyId?: InputMaybe<Scalars['String']>
  kmsRegion?: InputMaybe<Scalars['String']>
  providerAccountId?: InputMaybe<Scalars['String']>
  providerName?: InputMaybe<Scalars['String']>
  providerRegion?: InputMaybe<Scalars['String']>
  providerType?: InputMaybe<SecretProviderType>
  secretNamespace?: InputMaybe<Scalars['String']>
}

export type UpdateCustomerSecretProviderPayload = {
  __typename?: 'UpdateCustomerSecretProviderPayload'
  customerSecretProvider?: Maybe<CustomerSecretProvider>
}

export type UpdateCustomFormInput = {
  description?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type UpdateCustomFormPayload = {
  __typename?: 'UpdateCustomFormPayload'
  customForm: CustomForm
}

export type UpdateCustomFormQuestionInput = {
  answerType?: InputMaybe<CustomFormAnswerType>
  /** The predefined value for STATIC type */
  defaultValue?: InputMaybe<Scalars['String']>
  helpText?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  /** Tri-state: omit to leave untouched, { value: null } to clear, { value: TITLE } to set (moves the role from any previous holder) */
  incidentRole?: InputMaybe<NullableCustomFormIncidentRole>
  label?: InputMaybe<Scalars['String']>
  /**
   * When provided, upserts options for this question.
   * - If an option has an `id`, that existing option is updated (ID is preserved)
   * - If an option has no `id`, a new option is created with a new ID
   * - Existing options whose IDs are not included in this array are deleted
   * Pass an empty array to remove all options.
   */
  options?: InputMaybe<Array<UpsertCustomFormQuestionOptionInput>>
  order?: InputMaybe<Scalars['Int']>
  required?: InputMaybe<Scalars['Boolean']>
  visibleWhen?: InputMaybe<VisibilityRuleInput>
}

/** Tri-state wrapper: omit the field to leave the value untouched, pass { value: null } to clear, { value: X } to set */
export type NullableCustomFormIncidentRole = {
  value?: InputMaybe<CustomFormIncidentRole>
}

/** Input for upserting a question option during question update. If id is provided, updates existing option; otherwise creates new option. */
export type UpsertCustomFormQuestionOptionInput = {
  /** Optional - if provided, updates existing option preserving the ID. If omitted, creates a new option. */
  id?: InputMaybe<Scalars['ID']>
  label: Scalars['String']
  order: Scalars['Int']
}

export type UpdateCustomFormQuestionPayload = {
  __typename?: 'UpdateCustomFormQuestionPayload'
  question: CustomFormQuestion
}

export type UpdateCustomFormQuestionOptionInput = {
  id: Scalars['ID']
  label?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
}

export type UpdateCustomFormQuestionOptionPayload = {
  __typename?: 'UpdateCustomFormQuestionOptionPayload'
  option: CustomFormQuestionOption
}

export type UpdateCustomFormSectionInput = {
  description?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
}

export type UpdateCustomFormSectionPayload = {
  __typename?: 'UpdateCustomFormSectionPayload'
  section: CustomFormSection
}

/** *Automatically generated.* */
export type UpdateDeviceInput = {
  alarmTypeId?: InputMaybe<Scalars['ID']>
  bearing?: InputMaybe<Scalars['Float']>
  facilityId?: InputMaybe<Scalars['ID']>
  fieldOfView?: InputMaybe<Scalars['Float']>
  floorId?: InputMaybe<Scalars['ID']>
  floorPlanId?: InputMaybe<Scalars['ID']>
  gatewayId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  macAddress?: InputMaybe<Scalars['String']>
  manufacturerName?: InputMaybe<Scalars['String']>
  modelName?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DeviceStatus>
  type?: InputMaybe<DeviceType>
  visibilityRange?: InputMaybe<Scalars['Float']>
  x?: InputMaybe<Scalars['Float']>
  y?: InputMaybe<Scalars['Float']>
}

/** *Automatically generated.* */
export type UpdateDevicePayload = {
  __typename?: 'UpdateDevicePayload'
  device?: Maybe<Device>
}

/** *Automatically generated.* */
export type UpdateDeviceRepairOrderInput = {
  id: Scalars['ID']
  message?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateDeviceRepairOrderPayload = {
  __typename?: 'UpdateDeviceRepairOrderPayload'
  deviceRepairOrder?: Maybe<DeviceRepairOrder>
}

/** *Automatically generated.* */
export type UpdateDoorInput = {
  externalId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type UpdateDoorPayload = {
  __typename?: 'UpdateDoorPayload'
  door?: Maybe<Door>
}

export type UpdateEdgeDeviceInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type UpdateEdgeDevicePayload = {
  __typename?: 'UpdateEdgeDevicePayload'
  edgeDevice?: Maybe<EdgeDevice>
}

export type UpdateEmailRecipientInput = {
  id: Scalars['ID']
  status: EmailRecipientStatus
}

export type UpdateEmailSourceInput = {
  /** Replaces all allowed senders when given. Must not be empty. */
  allowedSenders?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type UpdateEmailSourcePayload = {
  __typename?: 'UpdateEmailSourcePayload'
  emailSource?: Maybe<EmailSource>
}

/** *Automatically generated.* */
export type UpdateEmergencyCallInput = {
  callEndTime?: InputMaybe<Scalars['String']>
  callStartTime?: InputMaybe<Scalars['String']>
  externalCallId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
}

/** *Automatically generated.* */
export type UpdateEmergencyCallPayload = {
  __typename?: 'UpdateEmergencyCallPayload'
  emergencyCall?: Maybe<EmergencyCall>
}

/** *Automatically generated.* */
export type UpdateEmergencyCallingInput = {
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  outboundPhoneNumber?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSid?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateEmergencyCallingPayload = {
  __typename?: 'UpdateEmergencyCallingPayload'
  emergencyCalling?: Maybe<EmergencyCalling>
}

/** *Automatically generated.* */
export type UpdateEventInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']>>
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  type?: InputMaybe<EventType>
}

/** *Automatically generated.* */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload'
  event?: Maybe<Event>
}

export type UpdateExternalAccountInput = {
  accountId?: InputMaybe<Scalars['String']>
  accountName?: InputMaybe<Scalars['String']>
  defaultAccount?: InputMaybe<Scalars['Boolean']>
  externalSystemType?: InputMaybe<ExternalSystemType>
  id: Scalars['ID']
}

export type UpdateExternalAccountPayload = {
  __typename?: 'UpdateExternalAccountPayload'
  externalAccount?: Maybe<ExternalAccount>
}

export type UpdateExternalAccountApiKeyInput = {
  externalAccountId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  permissionName?: InputMaybe<ApiKeyPermission>
  secretName?: InputMaybe<Scalars['String']>
}

export type UpdateExternalAccountApiKeyPayload = {
  __typename?: 'UpdateExternalAccountApiKeyPayload'
  externalAccountApiKey?: Maybe<ExternalAccountApiKey>
}

export type UpdateExternalAccountIdpInput = {
  config?: InputMaybe<Scalars['JSON']>
  externalAccountId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  type?: InputMaybe<IdpType>
}

export type UpdateExternalAccountIdpPayload = {
  __typename?: 'UpdateExternalAccountIdpPayload'
  externalAccountIdp?: Maybe<ExternalAccountIdp>
}

export type UpdateExternalAccountPropertiesInput = {
  data?: InputMaybe<Scalars['JSON']>
  externalAccountId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
}

export type UpdateExternalAccountPropertiesPayload = {
  __typename?: 'UpdateExternalAccountPropertiesPayload'
  externalAccountProperties?: Maybe<ExternalAccountProperties>
}

/** *Automatically generated.* */
export type UpdateFacilityInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  defaultFloorId?: InputMaybe<Scalars['ID']>
  emergencyNumber?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
  shortName?: InputMaybe<Scalars['String']>
  timeZone?: InputMaybe<Scalars['String']>
  type?: InputMaybe<FacilityType>
}

/** *Automatically generated.* */
export type UpdateFacilityPayload = {
  __typename?: 'UpdateFacilityPayload'
  facility?: Maybe<Facility>
}

export type UpdateFloorInput = {
  displayOrder?: InputMaybe<Scalars['Int']>
  facilityId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateFloorPayload = {
  __typename?: 'UpdateFloorPayload'
  floor?: Maybe<Floor>
}

/** *Automatically generated.* */
export type UpdateFloorPlanInput = {
  floorId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  s3Key?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateFloorPlanPayload = {
  __typename?: 'UpdateFloorPlanPayload'
  floorPlan?: Maybe<FloorPlan>
}

/** *Automatically generated.* */
export type UpdateGatewayInput = {
  facilityIds?: InputMaybe<Array<Scalars['ID']>>
  floorIds?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  physical?: InputMaybe<Scalars['Boolean']>
}

/** *Automatically generated.* */
export type UpdateGatewayPayload = {
  __typename?: 'UpdateGatewayPayload'
  gateway?: Maybe<Gateway>
}

/** *Automatically generated.* */
export type UpdateGuardTourInput = {
  id: Scalars['ID']
  tourPlanId?: InputMaybe<Scalars['ID']>
}

export type UpdateIncidentInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  concernStartTime?: InputMaybe<Scalars['String']>
  creatorId?: InputMaybe<Scalars['ID']>
  description?: InputMaybe<Scalars['String']>
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  deviceTypes?: InputMaybe<Array<InputMaybe<DeviceType>>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityName?: InputMaybe<Scalars['String']>
  facilityType?: InputMaybe<FacilityType>
  floorId?: InputMaybe<Scalars['ID']>
  floorName?: InputMaybe<Scalars['String']>
  guardId?: InputMaybe<Scalars['ID']>
  hasAudioMessages?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  informationSolicited?: InputMaybe<Scalars['Boolean']>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  manualIncidentCategoryId?: InputMaybe<Scalars['ID']>
  matchedRule?: InputMaybe<Scalars['ID']>
  muted?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  offered?: InputMaybe<Scalars['Boolean']>
  ownerId?: InputMaybe<Scalars['ID']>
  priority?: InputMaybe<IncidentPriority>
  real?: InputMaybe<Scalars['Boolean']>
  sensor?: InputMaybe<DeviceType>
  source?: InputMaybe<IncidentSource>
  status?: InputMaybe<IncidentStatus>
  type?: InputMaybe<IncidentType>
}

/** *Automatically generated.* */
export type UpdateIncidentActionInput = {
  audioClipId?: InputMaybe<Scalars['ID']>
  bulkOperationId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  message?: InputMaybe<Scalars['String']>
  resolutionContent?: InputMaybe<Array<ResolutionSegmentInput>>
  technicianId?: InputMaybe<Scalars['ID']>
  type?: InputMaybe<IncidentActionType>
}

/** *Automatically generated.* */
export type UpdateIncidentActionPayload = {
  __typename?: 'UpdateIncidentActionPayload'
  incidentAction?: Maybe<IncidentAction>
}

/** *Automatically generated.* */
export type UpdateIncidentDeviceMediaInput = {
  deviceId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
}

/** *Automatically generated.* */
export type UpdateIncidentDeviceMediaPayload = {
  __typename?: 'UpdateIncidentDeviceMediaPayload'
  incidentDeviceMedia?: Maybe<IncidentDeviceMedia>
}

/** *Automatically generated.* */
export type UpdateIncidentInformationSolicitationInput = {
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  message?: InputMaybe<Scalars['String']>
  recipientIds?: InputMaybe<Array<Scalars['ID']>>
}

/** *Automatically generated.* */
export type UpdateIncidentInformationSolicitationPayload = {
  __typename?: 'UpdateIncidentInformationSolicitationPayload'
  incidentInformationSolicitation?: Maybe<IncidentInformationSolicitation>
}

/** *Automatically generated.* */
export type UpdateIncidentNoteInput = {
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  message?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateIncidentNotePayload = {
  __typename?: 'UpdateIncidentNotePayload'
  incidentNote?: Maybe<IncidentNote>
}

/** *Automatically generated.* */
export type UpdateIncidentOccurrenceInput = {
  createdAt?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type UpdateIncidentOccurrencePayload = {
  __typename?: 'UpdateIncidentOccurrencePayload'
  incidentOccurrence?: Maybe<IncidentOccurrence>
}

/** *Automatically generated.* */
export type UpdateIncidentOfferInput = {
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
  message?: InputMaybe<Scalars['String']>
  recipientIds?: InputMaybe<Array<Scalars['ID']>>
}

/** *Automatically generated.* */
export type UpdateIncidentOfferPayload = {
  __typename?: 'UpdateIncidentOfferPayload'
  incidentOffer?: Maybe<IncidentOffer>
}

/** *Automatically generated.* */
export type UpdateIncidentOfferToGuardInput = {
  audioMessageId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  incidentId?: InputMaybe<Scalars['ID']>
}

/** *Automatically generated.* */
export type UpdateIncidentOfferToGuardPayload = {
  __typename?: 'UpdateIncidentOfferToGuardPayload'
  incidentOfferToGuard?: Maybe<IncidentOfferToGuard>
}

/** *Automatically generated.* */
export type UpdateIncidentShareInput = {
  incidentId?: InputMaybe<Scalars['ID']>
  target?: InputMaybe<MessageTargetInput>
}

/** *Automatically generated.* */
export type UpdateIncidentSharePayload = {
  __typename?: 'UpdateIncidentSharePayload'
  incidentShare?: Maybe<IncidentShare>
}

export type UpdateIncidentTypeDefinitionInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  /**
   * Wrapped so an explicit null can clear the default: omit the field to leave it
   * unchanged, pass { value: null } to clear, { value: HIGH } to set.
   */
  defaultPriority?: InputMaybe<NullableIncidentPriority>
  displayName?: InputMaybe<Scalars['String']>
  icon?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  manual?: InputMaybe<Scalars['Boolean']>
  mutable?: InputMaybe<Scalars['Boolean']>
  quickReport?: InputMaybe<Scalars['Boolean']>
  slug?: InputMaybe<Scalars['String']>
}

export type UpdateIncidentTypeDefinitionPayload = {
  __typename?: 'UpdateIncidentTypeDefinitionPayload'
  incidentTypeDefinition: IncidentTypeDefinition
}

export type UpdateIncidentWorkflowInput = {
  graph: IncidentWorkflowGraphInput
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type UpdateIncidentWorkflowPayload = {
  __typename?: 'UpdateIncidentWorkflowPayload'
  workflow: IncidentWorkflow
}

export type UpdateManualIncidentCategoryInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  defaultPriority?: InputMaybe<NullableIncidentPriority>
  id: Scalars['ID']
  isQuickReportCategory?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateManualIncidentCategoryPayload = {
  __typename?: 'UpdateManualIncidentCategoryPayload'
  manualIncidentCategory: ManualIncidentCategory
}

export type UpdateUserSettingInput = {
  audibleAlertsEnabled?: InputMaybe<Scalars['Boolean']>
}

export type UpdateUserSettingPayload = {
  __typename?: 'UpdateUserSettingPayload'
  userSetting: UserSetting
}

/** *Automatically generated.* */
export type UpdateOrganizationInput = {
  defaultCustomerSecretProviderId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload'
  organization?: Maybe<Organization>
}

/** *Automatically generated.* */
export type UpdateOrganizationSettingsInput = {
  cameraOfflineDurationUnit?: InputMaybe<DurationUnit>
  emailReplyToAddress?: InputMaybe<Scalars['String']>
  emailReplyToName?: InputMaybe<Scalars['String']>
  emailSenderName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  minimumCameraOfflineDuration?: InputMaybe<Scalars['Int']>
}

/** *Automatically generated.* */
export type UpdateOrganizationSettingsPayload = {
  __typename?: 'UpdateOrganizationSettingsPayload'
  organizationSettings?: Maybe<OrganizationSettings>
}

export type UpdateOrganizationSoundPolicyInput = {
  /** Optional: when omitted, the current value is left unchanged. */
  alwaysPlayCriticalIncidentSound?: InputMaybe<Scalars['Boolean']>
}

export type UpdateOrganizationSoundPolicyPayload = {
  __typename?: 'UpdateOrganizationSoundPolicyPayload'
  organizationSoundPolicy: OrganizationSoundPolicy
}

export type UpdatePacsSourceInstanceInput = {
  fields?: InputMaybe<Array<PacsSourceFieldInstanceInput>>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type PacsSourceFieldInstanceInput = {
  pacsSourceFieldInstanceId: Scalars['ID']
  value: Scalars['String']
}

export type UpdatePacsSourceInstancePayload = {
  __typename?: 'UpdatePacsSourceInstancePayload'
  pacsSourceInstance?: Maybe<PacsSourceInstance>
}

/** *Automatically generated.* */
export type UpdatePartialCreditCardInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  endOfNumber?: InputMaybe<Scalars['String']>
  expiryMonth?: InputMaybe<Scalars['Int']>
  expiryYear?: InputMaybe<Scalars['Int']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdatePartialCreditCardPayload = {
  __typename?: 'UpdatePartialCreditCardPayload'
  partialCreditCard?: Maybe<PartialCreditCard>
}

/** *Automatically generated.* */
export type UpdatePermissionInput = {
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdatePermissionPayload = {
  __typename?: 'UpdatePermissionPayload'
  permission?: Maybe<Permission>
}

export type UpdatePersonOfInterestInput = {
  address?: InputMaybe<Array<Scalars['String']>>
  companyAffiliation?: InputMaybe<CompanyAffiliation>
  customCompanyAffiliationDescription?: InputMaybe<Scalars['String']>
  dateOfBirth?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type UpdatePersonOfInterestPayload = {
  __typename?: 'UpdatePersonOfInterestPayload'
  personOfInterest?: Maybe<PersonOfInterest>
}

export type UpdatePersonOfInterestRoleInput = {
  caseId: Scalars['ID']
  caseRole: CaseRole
  customCaseRoleDescription?: InputMaybe<Scalars['String']>
  personOfInterestId: Scalars['ID']
}

export type UpdateProgramRecommendationInput = {
  actualImpact?: InputMaybe<Scalars['String']>
  estimatedImpact?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  internalNote?: InputMaybe<Scalars['String']>
}

export type UpdateProgramRecommendationPayload = {
  __typename?: 'UpdateProgramRecommendationPayload'
  programRecommendation?: Maybe<ProgramRecommendation>
}

export type UpdateQuickReportInput = {
  formDescription?: InputMaybe<Scalars['String']>
  formTitle?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  logoAssetId?: InputMaybe<Scalars['ID']>
  /** The type of quick report form (defaults to CANNED if not provided) */
  reportType?: InputMaybe<QuickReportType>
}

export type UpdateQuickReportPayload = {
  __typename?: 'UpdateQuickReportPayload'
  quickReport?: Maybe<QuickReport>
}

/** *Automatically generated.* */
export type UpdateRoleInput = {
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateRolePayload = {
  __typename?: 'UpdateRolePayload'
  role?: Maybe<Role>
}

export type UpdateRuleInput = {
  allDayOverride?: InputMaybe<Scalars['Boolean']>
  day?: InputMaybe<Scalars['String']>
  emailAddresses?: InputMaybe<Array<Scalars['String']>>
  endDate?: InputMaybe<Scalars['String']>
  endTimeOfDay?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  /** Omit to leave unchanged; { value: null } clears, { value: "Mo" } sets. Takes precedence over the deprecated day. */
  nullableDay?: InputMaybe<NullableString>
  /** Omit to leave unchanged; { value: null } clears, { value: "2026-10-11" } sets. Takes precedence over the deprecated endDate. */
  nullableEndDate?: InputMaybe<NullableString>
  /** Omit to leave unchanged; { value: null } clears, { value: "13:00" } sets. Takes precedence over the deprecated endTimeOfDay. */
  nullableEndTimeOfDay?: InputMaybe<NullableString>
  /** Omit to leave unchanged; { value: null } clears, { value: WEEKLY } sets. Takes precedence over the deprecated repeatInterval. */
  nullableRepeatInterval?: InputMaybe<NullableRepeatInterval>
  /** Omit to leave unchanged; { value: null } clears, { value: 2 } sets. Takes precedence over the deprecated repeatIntervalNum. */
  nullableRepeatIntervalNum?: InputMaybe<NullableInt>
  /**
   * Omit to leave the stored priority unchanged. Unlike the schedule fields this has no Nullable
   * wrapper: a SET_PRIORITY rule always has a priority, so there is nothing to clear.
   */
  priority?: InputMaybe<IncidentPriority>
  repeatInterval?: InputMaybe<RepeatInterval>
  repeatIntervalNum?: InputMaybe<Scalars['Int']>
  ruleLogics?: InputMaybe<CreateRuleLogicInput>
  startTime?: InputMaybe<Scalars['String']>
  /** True = active, False = deactivated */
  status?: InputMaybe<Scalars['Boolean']>
}

export type NullableString = {
  value?: InputMaybe<Scalars['String']>
}

export type NullableRepeatInterval = {
  value?: InputMaybe<RepeatInterval>
}

export type NullableInt = {
  value?: InputMaybe<Scalars['Int']>
}

export type UpdateRulePayload = {
  __typename?: 'UpdateRulePayload'
  rule?: Maybe<Rule>
}

export type UpdateSavedFilterInput = {
  context?: FilterContext
  filterCriteria?: InputMaybe<FilterCriteriaInput>
  id: Scalars['ID']
  isActive?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateSavedFilterPayload = {
  __typename?: 'UpdateSavedFilterPayload'
  savedFilter?: Maybe<SavedFilter>
}

export type UpdateSavedPayloadInput = {
  id: Scalars['ID']
  /** A JSON object. Any other JSON value is rejected. */
  payload: Scalars['JSON']
}

export type UpdateSavedPayloadPayload = {
  __typename?: 'UpdateSavedPayloadPayload'
  savedPayload?: Maybe<SavedPayload>
}

/** *Automatically generated.* */
export type UpdateStandardOperatingProcedureInput = {
  externalId?: InputMaybe<Scalars['String']>
  facilityIds?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  type?: InputMaybe<SopType>
}

/** *Automatically generated.* */
export type UpdateStandardOperatingProcedurePayload = {
  __typename?: 'UpdateStandardOperatingProcedurePayload'
  standardOperatingProcedure?: Maybe<StandardOperatingProcedure>
}

/** *Automatically generated.* */
export type UpdateSubscriberMessageInput = {
  createdAt?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
}

/** *Automatically generated.* */
export type UpdateSubscriberMessagePayload = {
  __typename?: 'UpdateSubscriberMessagePayload'
  subscriberMessage?: Maybe<SubscriberMessage>
}

export type UpdateTagInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload'
  tag: Tag
}

export type UpdateTailgateEnabledInput = {
  cameraId: Scalars['ID']
  doorId: Scalars['ID']
  isTailgateEnabled: Scalars['Boolean']
}

export type UpdateTailgateGridInput = {
  cameraId: Scalars['ID']
  doorId: Scalars['ID']
  inBox: BoxInput
  outBox: BoxInput
}

export type UpdateTailgateGridPayload = {
  __typename?: 'UpdateTailgateGridPayload'
  camera?: Maybe<Device>
  door?: Maybe<Device>
  inBox?: Maybe<Box>
  outBox?: Maybe<Box>
}

/** *Automatically generated.* */
export type UpdateTechnicianInput = {
  deviceTypes?: InputMaybe<Array<InputMaybe<DeviceType>>>
  email?: InputMaybe<Scalars['String']>
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  firstName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateTechnicianPayload = {
  __typename?: 'UpdateTechnicianPayload'
  technician?: Maybe<Technician>
}

/** *Automatically generated.* */
export type UpdateTourPlanInput = {
  checkpointIds?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateTourPlanPayload = {
  __typename?: 'UpdateTourPlanPayload'
  tourPlan?: Maybe<TourPlan>
}

/** *Automatically generated.* */
export type UpdateUserInput = {
  designatedFacilityId?: InputMaybe<Scalars['ID']>
  email?: InputMaybe<Scalars['String']>
  facilityId?: InputMaybe<Scalars['ID']>
  firstName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: InputMaybe<Scalars['String']>
  onDuty?: InputMaybe<Scalars['Boolean']>
  roleName?: InputMaybe<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload'
  user?: Maybe<User>
}

export type UpdateUserRolesInput = {
  id: Scalars['ID']
  roles: Array<Scalars['String']>
}

/** *Automatically generated.* */
export type UpdateUserRolesPayload = {
  __typename?: 'UpdateUserRolesPayload'
  user?: Maybe<User>
}

/** Every field but id is optional; omitted fields keep their current value. */
export type UpdateWebhookInput = {
  /** Replaces the current auth header. */
  authHeader?: InputMaybe<HttpHeaderInput>
  /** Removes the auth header. Ignored when authHeader is also given. */
  clearAuthHeader?: InputMaybe<Scalars['Boolean']>
  destination?: InputMaybe<Scalars['String']>
  httpMethod?: InputMaybe<WebhookHttpMethod>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  savedPayloadId?: InputMaybe<Scalars['ID']>
}

export type UpdateWebhookPayload = {
  __typename?: 'UpdateWebhookPayload'
  webhook?: Maybe<Webhook>
}

export type UpsertAiOperatorDeviceConfigurationInput = {
  accessGrantedTimeThreshold?: InputMaybe<Scalars['Float']>
  deviceId: Scalars['ID']
  doorCloseTimeThreshold?: InputMaybe<Scalars['Float']>
  doorForcedBounceTimeThreshold?: InputMaybe<Scalars['Float']>
}

export type UpsertAiOperatorDeviceConfigurationPayload = {
  __typename?: 'UpsertAiOperatorDeviceConfigurationPayload'
  aiOperatorDeviceConfiguration: AiOperatorDeviceConfiguration
}

/**
 * Upserts one (integrationId, sourceField) mapping. targetFieldId and
 * targetFieldName use replace semantics (an omitted value is set to null),
 * while optionMappings uses patch semantics (omit to leave children unchanged).
 * Each call is its own transaction: the settings card issues one per field, so a
 * multi-field save is not atomic across rows.
 */
export type UpsertIntegrationFieldMappingInput = {
  integrationId: Scalars['ID']
  /** When provided, replaces the full set of option mappings for this field. Omit to leave existing option mappings unchanged. */
  optionMappings?: InputMaybe<Array<UpsertIntegrationFieldOptionMappingInput>>
  sourceField: IntegrationSourceField
  targetFieldId?: InputMaybe<Scalars['String']>
  targetFieldName?: InputMaybe<Scalars['String']>
}

export type UpsertIntegrationFieldOptionMappingInput = {
  sourceValue: Scalars['String']
  targetOptionId: Scalars['String']
}

export type UpsertIntegrationFieldMappingPayload = {
  __typename?: 'UpsertIntegrationFieldMappingPayload'
  fieldMapping: IntegrationFieldMapping
}

export type UpsertIntegrationQuestionMappingInput = {
  /** When provided, replaces the full set of choice mappings for this question. Omit to leave existing choice mappings unchanged. */
  choiceMappings?: InputMaybe<
    Array<UpsertIntegrationQuestionChoiceMappingInput>
  >
  integrationId: Scalars['ID']
  questionId: Scalars['ID']
  targetFieldId: Scalars['String']
  targetFieldName?: InputMaybe<Scalars['String']>
}

/** Exactly one of optionId / syntheticChoice must be set */
export type UpsertIntegrationQuestionChoiceMappingInput = {
  optionId?: InputMaybe<Scalars['ID']>
  syntheticChoice?: InputMaybe<Scalars['String']>
  targetOptionId: Scalars['String']
}

export type UpsertIntegrationQuestionMappingPayload = {
  __typename?: 'UpsertIntegrationQuestionMappingPayload'
  questionMapping: IntegrationQuestionMapping
}

export type VerifyIntegrationMappingInput = {
  integrationId: Scalars['ID']
}

export type VerifyIntegrationMappingPayload = {
  __typename?: 'VerifyIntegrationMappingPayload'
  result: IntegrationVerifyResult
}

/** Outcome of verifying the mapped ids against the integration's live field definitions */
export type IntegrationVerifyResult = {
  __typename?: 'IntegrationVerifyResult'
  fieldMappingResults: Array<IntegrationVerifyRowResult>
  questionMappingResults: Array<IntegrationVerifyRowResult>
  valid: Scalars['Boolean']
}

/** Per-mapping-row verify outcome listing the mapped ids the integration does not know */
export type IntegrationVerifyRowResult = {
  __typename?: 'IntegrationVerifyRowResult'
  mappingId: Scalars['ID']
  unknownFieldIds: Array<Scalars['String']>
  unknownOptionIds: Array<Scalars['String']>
  valid: Scalars['Boolean']
}

export type Subscription = {
  __typename?: 'Subscription'
  /**
   * *The current idea is that
   * different users see different message streams.
   * However, that might have to be changed,
   * because the web service might have
   * insufficient information to know which messages
   * are suitable for which user.  This means that the GraphQL schema
   * may have to be changed so that the client uses
   * a filter to specify what messages it wants to get.*
   */
  message?: Maybe<SubscriberMessage>
  /**
   * A substitute for the `message` field.
   *
   * *This is a temporary hack.
   * It was
   * added because of a failure to get
   * our web service to correctly set `__typename`
   * for `message`.*
   */
  messageIncident?: Maybe<Incident>
  onStreamValidationError?: Maybe<Scalars['String']>
}

export type SubscriptionOnStreamValidationErrorArgs = {
  cameraId: Scalars['String']
}

/** *Automatically generated.* */
export type AcknowledgementFilterInput = {
  AND?: InputMaybe<Array<AcknowledgementFilterInput>>
  audioClipId?: InputMaybe<Scalars['ID']>
  audioClipIdIn?: InputMaybe<Array<Scalars['ID']>>
  audioClipIdNot?: InputMaybe<Scalars['ID']>
  audioClipIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<AcknowledgementFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type CreditCardFilterInput = {
  addressContain?: InputMaybe<Scalars['String']>
  addressDoNotContain?: InputMaybe<Scalars['String']>
  addressNull?: InputMaybe<Scalars['Boolean']>
  AND?: InputMaybe<Array<CreditCardFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  expiryMonth?: InputMaybe<Scalars['Int']>
  expiryMonthGt?: InputMaybe<Scalars['Int']>
  expiryMonthGte?: InputMaybe<Scalars['Int']>
  expiryMonthIn?: InputMaybe<Array<Scalars['Int']>>
  expiryMonthLike?: InputMaybe<Scalars['Int']>
  expiryMonthLt?: InputMaybe<Scalars['Int']>
  expiryMonthLte?: InputMaybe<Scalars['Int']>
  expiryMonthNot?: InputMaybe<Scalars['Int']>
  expiryMonthNotIn?: InputMaybe<Array<Scalars['Int']>>
  expiryYear?: InputMaybe<Scalars['Int']>
  expiryYearGt?: InputMaybe<Scalars['Int']>
  expiryYearGte?: InputMaybe<Scalars['Int']>
  expiryYearIn?: InputMaybe<Array<Scalars['Int']>>
  expiryYearLike?: InputMaybe<Scalars['Int']>
  expiryYearLt?: InputMaybe<Scalars['Int']>
  expiryYearLte?: InputMaybe<Scalars['Int']>
  expiryYearNot?: InputMaybe<Scalars['Int']>
  expiryYearNotIn?: InputMaybe<Array<Scalars['Int']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  number?: InputMaybe<Scalars['String']>
  numberGt?: InputMaybe<Scalars['String']>
  numberGte?: InputMaybe<Scalars['String']>
  numberIn?: InputMaybe<Array<Scalars['String']>>
  numberLike?: InputMaybe<Scalars['String']>
  numberLt?: InputMaybe<Scalars['String']>
  numberLte?: InputMaybe<Scalars['String']>
  numberNot?: InputMaybe<Scalars['String']>
  numberNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<CreditCardFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type DatabaseResetFilterInput = {
  AND?: InputMaybe<Array<DatabaseResetFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  createdBy?: InputMaybe<Scalars['String']>
  createdByGt?: InputMaybe<Scalars['String']>
  createdByGte?: InputMaybe<Scalars['String']>
  createdByIn?: InputMaybe<Array<Scalars['String']>>
  createdByLike?: InputMaybe<Scalars['String']>
  createdByLt?: InputMaybe<Scalars['String']>
  createdByLte?: InputMaybe<Scalars['String']>
  createdByNot?: InputMaybe<Scalars['String']>
  createdByNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<DatabaseResetFilterInput>>
}

export type DeviceConfigurationHistory = DeviceLog & {
  __typename?: 'DeviceConfigurationHistory'
  configurationKey: DeviceConfigurationKey
  createdAt: Scalars['String']
  device?: Maybe<Device>
  deviceId: Scalars['ID']
  id: Scalars['ID']
  message: Scalars['String']
  newValue?: Maybe<Scalars['String']>
  oldValue?: Maybe<Scalars['String']>
  title: Scalars['String']
  type: DeviceLogItemType
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

export enum DeviceConfigurationKey {
  Archived = 'ARCHIVED',
  ExternalId = 'EXTERNAL_ID',
  Name = 'NAME',
  RtspIp = 'RTSP_IP',
  RtspPath = 'RTSP_PATH',
  RtspPort = 'RTSP_PORT',
  RtspProtocol = 'RTSP_PROTOCOL',
}

export type DeviceNote = DeviceLog & {
  __typename?: 'DeviceNote'
  createdAt: Scalars['String']
  device?: Maybe<Device>
  deviceId: Scalars['ID']
  id: Scalars['ID']
  message: Scalars['String']
  type: DeviceLogItemType
  updatedAt: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['ID']
}

/** *Automatically generated.* */
export type DeviceRepairOrderFilterInput = {
  AND?: InputMaybe<Array<DeviceRepairOrderFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  message?: InputMaybe<Scalars['String']>
  messageGt?: InputMaybe<Scalars['String']>
  messageGte?: InputMaybe<Scalars['String']>
  messageIn?: InputMaybe<Array<Scalars['String']>>
  messageLike?: InputMaybe<Scalars['String']>
  messageLt?: InputMaybe<Scalars['String']>
  messageLte?: InputMaybe<Scalars['String']>
  messageNot?: InputMaybe<Scalars['String']>
  messageNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<DeviceRepairOrderFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type DoorFilterInput = {
  AND?: InputMaybe<Array<DoorFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  externalId?: InputMaybe<Scalars['String']>
  externalIdGt?: InputMaybe<Scalars['String']>
  externalIdGte?: InputMaybe<Scalars['String']>
  externalIdIn?: InputMaybe<Array<Scalars['String']>>
  externalIdLike?: InputMaybe<Scalars['String']>
  externalIdLt?: InputMaybe<Scalars['String']>
  externalIdLte?: InputMaybe<Scalars['String']>
  externalIdNot?: InputMaybe<Scalars['String']>
  externalIdNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<DoorFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type EmergencyCallingAccessTokenFilterInput = {
  AND?: InputMaybe<Array<EmergencyCallingAccessTokenFilterInput>>
  OR?: InputMaybe<Array<EmergencyCallingAccessTokenFilterInput>>
  token?: InputMaybe<Scalars['String']>
  tokenGt?: InputMaybe<Scalars['String']>
  tokenGte?: InputMaybe<Scalars['String']>
  tokenIn?: InputMaybe<Array<Scalars['String']>>
  tokenLike?: InputMaybe<Scalars['String']>
  tokenLt?: InputMaybe<Scalars['String']>
  tokenLte?: InputMaybe<Scalars['String']>
  tokenNot?: InputMaybe<Scalars['String']>
  tokenNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type EmergencyCallingFilterInput = {
  AND?: InputMaybe<Array<EmergencyCallingFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<EmergencyCallingFilterInput>>
  outboundPhoneNumber?: InputMaybe<Scalars['String']>
  outboundPhoneNumberGt?: InputMaybe<Scalars['String']>
  outboundPhoneNumberGte?: InputMaybe<Scalars['String']>
  outboundPhoneNumberIn?: InputMaybe<Array<Scalars['String']>>
  outboundPhoneNumberLike?: InputMaybe<Scalars['String']>
  outboundPhoneNumberLt?: InputMaybe<Scalars['String']>
  outboundPhoneNumberLte?: InputMaybe<Scalars['String']>
  outboundPhoneNumberNot?: InputMaybe<Scalars['String']>
  outboundPhoneNumberNotIn?: InputMaybe<Array<Scalars['String']>>
  outboundPhoneNumberSid?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidGt?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidGte?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidIn?: InputMaybe<Array<Scalars['String']>>
  outboundPhoneNumberSidLike?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidLt?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidLte?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidNot?: InputMaybe<Scalars['String']>
  outboundPhoneNumberSidNotIn?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** Named free-text character classes, each defined once in FreeTextConstraint (ENG-34671). All kinds accept Unicode space separators (category Zs). */
export enum FreeTextKind {
  /** Incident description/name text: letters, digits, spaces, straight and curly quotes, backtick, and common punctuation. */
  IncidentText = 'INCIDENT_TEXT',
  /** Letters, digits, spaces, and minimal punctuation. */
  Label = 'LABEL',
  /** Human names: letters, spaces, comma, period, apostrophe, hyphen. Requires at least one character. */
  PersonName = 'PERSON_NAME',
  /** Letters, digits, spaces, straight quotes, and common punctuation. */
  QuotedText = 'QUOTED_TEXT',
}

/** *Automatically generated.* */
export type GatewayFilterInput = {
  AND?: InputMaybe<Array<GatewayFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  facilityIdsContain?: InputMaybe<Scalars['ID']>
  facilityIdsDoNotContain?: InputMaybe<Scalars['ID']>
  facilityIdsNull?: InputMaybe<Scalars['Boolean']>
  floorIdsContain?: InputMaybe<Scalars['ID']>
  floorIdsDoNotContain?: InputMaybe<Scalars['ID']>
  floorIdsNull?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<GatewayFilterInput>>
  physical?: InputMaybe<Scalars['Boolean']>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentActionFilterInput = {
  AND?: InputMaybe<Array<IncidentActionFilterInput>>
  audioClipId?: InputMaybe<Scalars['ID']>
  audioClipIdIn?: InputMaybe<Array<Scalars['ID']>>
  audioClipIdNot?: InputMaybe<Scalars['ID']>
  audioClipIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  audioMessageId?: InputMaybe<Scalars['ID']>
  audioMessageIdIn?: InputMaybe<Array<Scalars['ID']>>
  audioMessageIdNot?: InputMaybe<Scalars['ID']>
  audioMessageIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  bulkOperationId?: InputMaybe<Scalars['ID']>
  bulkOperationIdIn?: InputMaybe<Array<Scalars['ID']>>
  bulkOperationIdNot?: InputMaybe<Scalars['ID']>
  bulkOperationIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  message?: InputMaybe<Scalars['String']>
  messageGt?: InputMaybe<Scalars['String']>
  messageGte?: InputMaybe<Scalars['String']>
  messageIn?: InputMaybe<Array<Scalars['String']>>
  messageLike?: InputMaybe<Scalars['String']>
  messageLt?: InputMaybe<Scalars['String']>
  messageLte?: InputMaybe<Scalars['String']>
  messageNot?: InputMaybe<Scalars['String']>
  messageNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentActionFilterInput>>
  technicianId?: InputMaybe<Scalars['ID']>
  technicianIdIn?: InputMaybe<Array<Scalars['ID']>>
  technicianIdNot?: InputMaybe<Scalars['ID']>
  technicianIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  type?: InputMaybe<IncidentActionType>
  typeIn?: InputMaybe<Array<IncidentActionType>>
  typeNot?: InputMaybe<IncidentActionType>
  typeNotIn?: InputMaybe<Array<IncidentActionType>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentCountMapFilterInput = {
  AND?: InputMaybe<Array<IncidentCountMapFilterInput>>
  camera?: InputMaybe<Scalars['Int']>
  cameraGt?: InputMaybe<Scalars['Int']>
  cameraGte?: InputMaybe<Scalars['Int']>
  cameraIn?: InputMaybe<Array<Scalars['Int']>>
  cameraLike?: InputMaybe<Scalars['Int']>
  cameraLt?: InputMaybe<Scalars['Int']>
  cameraLte?: InputMaybe<Scalars['Int']>
  cameraNot?: InputMaybe<Scalars['Int']>
  cameraNotIn?: InputMaybe<Array<Scalars['Int']>>
  door?: InputMaybe<Scalars['Int']>
  doorGt?: InputMaybe<Scalars['Int']>
  doorGte?: InputMaybe<Scalars['Int']>
  doorIn?: InputMaybe<Array<Scalars['Int']>>
  doorLike?: InputMaybe<Scalars['Int']>
  doorLt?: InputMaybe<Scalars['Int']>
  doorLte?: InputMaybe<Scalars['Int']>
  doorNot?: InputMaybe<Scalars['Int']>
  doorNotIn?: InputMaybe<Array<Scalars['Int']>>
  health?: InputMaybe<Scalars['Int']>
  healthGt?: InputMaybe<Scalars['Int']>
  healthGte?: InputMaybe<Scalars['Int']>
  healthIn?: InputMaybe<Array<Scalars['Int']>>
  healthLike?: InputMaybe<Scalars['Int']>
  healthLt?: InputMaybe<Scalars['Int']>
  healthLte?: InputMaybe<Scalars['Int']>
  healthNot?: InputMaybe<Scalars['Int']>
  healthNotIn?: InputMaybe<Array<Scalars['Int']>>
  OR?: InputMaybe<Array<IncidentCountMapFilterInput>>
  overall?: InputMaybe<Scalars['Int']>
  overallGt?: InputMaybe<Scalars['Int']>
  overallGte?: InputMaybe<Scalars['Int']>
  overallIn?: InputMaybe<Array<Scalars['Int']>>
  overallLike?: InputMaybe<Scalars['Int']>
  overallLt?: InputMaybe<Scalars['Int']>
  overallLte?: InputMaybe<Scalars['Int']>
  overallNot?: InputMaybe<Scalars['Int']>
  overallNotIn?: InputMaybe<Array<Scalars['Int']>>
}

/** *Automatically generated.* */
export type IncidentEventFilterInput = {
  AND?: InputMaybe<Array<IncidentEventFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentEventFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentInformationSolicitationFilterInput = {
  AND?: InputMaybe<Array<IncidentInformationSolicitationFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  message?: InputMaybe<Scalars['String']>
  messageGt?: InputMaybe<Scalars['String']>
  messageGte?: InputMaybe<Scalars['String']>
  messageIn?: InputMaybe<Array<Scalars['String']>>
  messageLike?: InputMaybe<Scalars['String']>
  messageLt?: InputMaybe<Scalars['String']>
  messageLte?: InputMaybe<Scalars['String']>
  messageNot?: InputMaybe<Scalars['String']>
  messageNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentInformationSolicitationFilterInput>>
  recipientIdsContain?: InputMaybe<Scalars['ID']>
  recipientIdsDoNotContain?: InputMaybe<Scalars['ID']>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentOccurrenceFilterInput = {
  AND?: InputMaybe<Array<IncidentOccurrenceFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<IncidentOccurrenceFilterInput>>
}

/** *Automatically generated.* */
export type IncidentOfferAcceptanceFilterInput = {
  AND?: InputMaybe<Array<IncidentOfferAcceptanceFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<IncidentOfferAcceptanceFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentOfferFilterInput = {
  AND?: InputMaybe<Array<IncidentOfferFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  message?: InputMaybe<Scalars['String']>
  messageGt?: InputMaybe<Scalars['String']>
  messageGte?: InputMaybe<Scalars['String']>
  messageIn?: InputMaybe<Array<Scalars['String']>>
  messageLike?: InputMaybe<Scalars['String']>
  messageLt?: InputMaybe<Scalars['String']>
  messageLte?: InputMaybe<Scalars['String']>
  messageNot?: InputMaybe<Scalars['String']>
  messageNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentOfferFilterInput>>
  recipientIdsContain?: InputMaybe<Scalars['ID']>
  recipientIdsDoNotContain?: InputMaybe<Scalars['ID']>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentOfferToGuardAcceptanceFilterInput = {
  AND?: InputMaybe<Array<IncidentOfferToGuardAcceptanceFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<IncidentOfferToGuardAcceptanceFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentOfferToGuardFilterInput = {
  AND?: InputMaybe<Array<IncidentOfferToGuardFilterInput>>
  audioMessageId?: InputMaybe<Scalars['ID']>
  audioMessageIdIn?: InputMaybe<Array<Scalars['ID']>>
  audioMessageIdNot?: InputMaybe<Scalars['ID']>
  audioMessageIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  creatorId?: InputMaybe<Scalars['ID']>
  creatorIdIn?: InputMaybe<Array<Scalars['ID']>>
  creatorIdNot?: InputMaybe<Scalars['ID']>
  creatorIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<IncidentOfferToGuardFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentsByFacilityResultFilterInput = {
  AND?: InputMaybe<Array<IncidentsByFacilityResultFilterInput>>
  count?: InputMaybe<Scalars['Int']>
  countGt?: InputMaybe<Scalars['Int']>
  countGte?: InputMaybe<Scalars['Int']>
  countIn?: InputMaybe<Array<Scalars['Int']>>
  countLike?: InputMaybe<Scalars['Int']>
  countLt?: InputMaybe<Scalars['Int']>
  countLte?: InputMaybe<Scalars['Int']>
  countNot?: InputMaybe<Scalars['Int']>
  countNotIn?: InputMaybe<Array<Scalars['Int']>>
  facilityName?: InputMaybe<Scalars['String']>
  facilityNameGt?: InputMaybe<Scalars['String']>
  facilityNameGte?: InputMaybe<Scalars['String']>
  facilityNameIn?: InputMaybe<Array<Scalars['String']>>
  facilityNameLike?: InputMaybe<Scalars['String']>
  facilityNameLt?: InputMaybe<Scalars['String']>
  facilityNameLte?: InputMaybe<Scalars['String']>
  facilityNameNot?: InputMaybe<Scalars['String']>
  facilityNameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentsByFacilityResultFilterInput>>
}

/** *Automatically generated.* */
export type IncidentsByTypeBetweenDateResultFilterInput = {
  AND?: InputMaybe<Array<IncidentsByTypeBetweenDateResultFilterInput>>
  OR?: InputMaybe<Array<IncidentsByTypeBetweenDateResultFilterInput>>
  totalCount?: InputMaybe<Scalars['Int']>
  totalCountGt?: InputMaybe<Scalars['Int']>
  totalCountGte?: InputMaybe<Scalars['Int']>
  totalCountIn?: InputMaybe<Array<Scalars['Int']>>
  totalCountLike?: InputMaybe<Scalars['Int']>
  totalCountLt?: InputMaybe<Scalars['Int']>
  totalCountLte?: InputMaybe<Scalars['Int']>
  totalCountNot?: InputMaybe<Scalars['Int']>
  totalCountNotIn?: InputMaybe<Array<Scalars['Int']>>
}

/** *Automatically generated.* */
export type IncidentsByTypeCountFilterInput = {
  AND?: InputMaybe<Array<IncidentsByTypeCountFilterInput>>
  count?: InputMaybe<Scalars['Int']>
  countGt?: InputMaybe<Scalars['Int']>
  countGte?: InputMaybe<Scalars['Int']>
  countIn?: InputMaybe<Array<Scalars['Int']>>
  countLike?: InputMaybe<Scalars['Int']>
  countLt?: InputMaybe<Scalars['Int']>
  countLte?: InputMaybe<Scalars['Int']>
  countNot?: InputMaybe<Scalars['Int']>
  countNotIn?: InputMaybe<Array<Scalars['Int']>>
  OR?: InputMaybe<Array<IncidentsByTypeCountFilterInput>>
  type?: InputMaybe<Scalars['String']>
  typeGt?: InputMaybe<Scalars['String']>
  typeGte?: InputMaybe<Scalars['String']>
  typeIn?: InputMaybe<Array<Scalars['String']>>
  typeLike?: InputMaybe<Scalars['String']>
  typeLt?: InputMaybe<Scalars['String']>
  typeLte?: InputMaybe<Scalars['String']>
  typeNot?: InputMaybe<Scalars['String']>
  typeNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentShareFilterInput = {
  AND?: InputMaybe<Array<IncidentShareFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<IncidentShareFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type IncidentsTypesByDateFilterInput = {
  AND?: InputMaybe<Array<IncidentsTypesByDateFilterInput>>
  date?: InputMaybe<Scalars['String']>
  dateGt?: InputMaybe<Scalars['String']>
  dateGte?: InputMaybe<Scalars['String']>
  dateIn?: InputMaybe<Array<Scalars['String']>>
  dateLike?: InputMaybe<Scalars['String']>
  dateLt?: InputMaybe<Scalars['String']>
  dateLte?: InputMaybe<Scalars['String']>
  dateNot?: InputMaybe<Scalars['String']>
  dateNotIn?: InputMaybe<Array<Scalars['String']>>
  day?: InputMaybe<Scalars['String']>
  dayGt?: InputMaybe<Scalars['String']>
  dayGte?: InputMaybe<Scalars['String']>
  dayIn?: InputMaybe<Array<Scalars['String']>>
  dayLike?: InputMaybe<Scalars['String']>
  dayLt?: InputMaybe<Scalars['String']>
  dayLte?: InputMaybe<Scalars['String']>
  dayNot?: InputMaybe<Scalars['String']>
  dayNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IncidentsTypesByDateFilterInput>>
}

/** *Automatically generated.* */
export type IncidentTimePeriodStatsFilterInput = {
  AND?: InputMaybe<Array<IncidentTimePeriodStatsFilterInput>>
  avgTimeToAcknowledge?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeGt?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeGte?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeIn?: InputMaybe<Array<Scalars['Float']>>
  avgTimeToAcknowledgeLike?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeLt?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeLte?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeNot?: InputMaybe<Scalars['Float']>
  avgTimeToAcknowledgeNotIn?: InputMaybe<Array<Scalars['Float']>>
  avgTimeToResolve?: InputMaybe<Scalars['Float']>
  avgTimeToResolveGt?: InputMaybe<Scalars['Float']>
  avgTimeToResolveGte?: InputMaybe<Scalars['Float']>
  avgTimeToResolveIn?: InputMaybe<Array<Scalars['Float']>>
  avgTimeToResolveLike?: InputMaybe<Scalars['Float']>
  avgTimeToResolveLt?: InputMaybe<Scalars['Float']>
  avgTimeToResolveLte?: InputMaybe<Scalars['Float']>
  avgTimeToResolveNot?: InputMaybe<Scalars['Float']>
  avgTimeToResolveNotIn?: InputMaybe<Array<Scalars['Float']>>
  fractionResolved?: InputMaybe<Scalars['Float']>
  fractionResolvedGt?: InputMaybe<Scalars['Float']>
  fractionResolvedGte?: InputMaybe<Scalars['Float']>
  fractionResolvedIn?: InputMaybe<Array<Scalars['Float']>>
  fractionResolvedLike?: InputMaybe<Scalars['Float']>
  fractionResolvedLt?: InputMaybe<Scalars['Float']>
  fractionResolvedLte?: InputMaybe<Scalars['Float']>
  fractionResolvedNot?: InputMaybe<Scalars['Float']>
  fractionResolvedNotIn?: InputMaybe<Array<Scalars['Float']>>
  numUnresolved?: InputMaybe<Scalars['Int']>
  numUnresolvedGt?: InputMaybe<Scalars['Int']>
  numUnresolvedGte?: InputMaybe<Scalars['Int']>
  numUnresolvedIn?: InputMaybe<Array<Scalars['Int']>>
  numUnresolvedLike?: InputMaybe<Scalars['Int']>
  numUnresolvedLt?: InputMaybe<Scalars['Int']>
  numUnresolvedLte?: InputMaybe<Scalars['Int']>
  numUnresolvedNot?: InputMaybe<Scalars['Int']>
  numUnresolvedNotIn?: InputMaybe<Array<Scalars['Int']>>
  OR?: InputMaybe<Array<IncidentTimePeriodStatsFilterInput>>
}

/** *Automatically generated.* */
export type IntervalFilterInput = {
  AND?: InputMaybe<Array<IntervalFilterInput>>
  endTime?: InputMaybe<Scalars['String']>
  endTimeGt?: InputMaybe<Scalars['String']>
  endTimeGte?: InputMaybe<Scalars['String']>
  endTimeIn?: InputMaybe<Array<Scalars['String']>>
  endTimeLike?: InputMaybe<Scalars['String']>
  endTimeLt?: InputMaybe<Scalars['String']>
  endTimeLte?: InputMaybe<Scalars['String']>
  endTimeNot?: InputMaybe<Scalars['String']>
  endTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<IntervalFilterInput>>
  startTime?: InputMaybe<Scalars['String']>
  startTimeGt?: InputMaybe<Scalars['String']>
  startTimeGte?: InputMaybe<Scalars['String']>
  startTimeIn?: InputMaybe<Array<Scalars['String']>>
  startTimeLike?: InputMaybe<Scalars['String']>
  startTimeLt?: InputMaybe<Scalars['String']>
  startTimeLte?: InputMaybe<Scalars['String']>
  startTimeNot?: InputMaybe<Scalars['String']>
  startTimeNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type InvoiceFilterInput = {
  AND?: InputMaybe<Array<InvoiceFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  OR?: InputMaybe<Array<InvoiceFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type KpiAggregateQueryResultFilterInput = {
  AND?: InputMaybe<Array<KpiAggregateQueryResultFilterInput>>
  count?: InputMaybe<Scalars['Int']>
  countGt?: InputMaybe<Scalars['Int']>
  countGte?: InputMaybe<Scalars['Int']>
  countIn?: InputMaybe<Array<Scalars['Int']>>
  countLike?: InputMaybe<Scalars['Int']>
  countLt?: InputMaybe<Scalars['Int']>
  countLte?: InputMaybe<Scalars['Int']>
  countNot?: InputMaybe<Scalars['Int']>
  countNotIn?: InputMaybe<Array<Scalars['Int']>>
  label?: InputMaybe<Scalars['String']>
  labelGt?: InputMaybe<Scalars['String']>
  labelGte?: InputMaybe<Scalars['String']>
  labelIn?: InputMaybe<Array<Scalars['String']>>
  labelLike?: InputMaybe<Scalars['String']>
  labelLt?: InputMaybe<Scalars['String']>
  labelLte?: InputMaybe<Scalars['String']>
  labelNot?: InputMaybe<Scalars['String']>
  labelNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<KpiAggregateQueryResultFilterInput>>
}

/** *Automatically generated.* */
export type KpiQueryResultFilterInput = {
  AND?: InputMaybe<Array<KpiQueryResultFilterInput>>
  current?: InputMaybe<Scalars['Int']>
  currentGt?: InputMaybe<Scalars['Int']>
  currentGte?: InputMaybe<Scalars['Int']>
  currentIn?: InputMaybe<Array<Scalars['Int']>>
  currentLike?: InputMaybe<Scalars['Int']>
  currentLt?: InputMaybe<Scalars['Int']>
  currentLte?: InputMaybe<Scalars['Int']>
  currentNot?: InputMaybe<Scalars['Int']>
  currentNotIn?: InputMaybe<Array<Scalars['Int']>>
  OR?: InputMaybe<Array<KpiQueryResultFilterInput>>
  past?: InputMaybe<Scalars['Int']>
  pastGt?: InputMaybe<Scalars['Int']>
  pastGte?: InputMaybe<Scalars['Int']>
  pastIn?: InputMaybe<Array<Scalars['Int']>>
  pastLike?: InputMaybe<Scalars['Int']>
  pastLt?: InputMaybe<Scalars['Int']>
  pastLte?: InputMaybe<Scalars['Int']>
  pastNot?: InputMaybe<Scalars['Int']>
  pastNotIn?: InputMaybe<Array<Scalars['Int']>>
}

/** *Automatically generated.* */
export type MessageTargetFilterInput = {
  AND?: InputMaybe<Array<MessageTargetFilterInput>>
  facilityId?: InputMaybe<Scalars['ID']>
  facilityIdIn?: InputMaybe<Array<Scalars['ID']>>
  facilityIdNot?: InputMaybe<Scalars['ID']>
  facilityIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  incidentId?: InputMaybe<Scalars['ID']>
  incidentIdIn?: InputMaybe<Array<Scalars['ID']>>
  incidentIdNot?: InputMaybe<Scalars['ID']>
  incidentIdNotIn?: InputMaybe<Array<Scalars['ID']>>
  onShift?: InputMaybe<Scalars['Boolean']>
  OR?: InputMaybe<Array<MessageTargetFilterInput>>
  recipientIdsContain?: InputMaybe<Scalars['ID']>
  recipientIdsDoNotContain?: InputMaybe<Scalars['ID']>
  recipientIdsNull?: InputMaybe<Scalars['Boolean']>
}

/** *Automatically generated.* */
export type MimeTypedObjectFilterInput = {
  AND?: InputMaybe<Array<MimeTypedObjectFilterInput>>
  base64Content?: InputMaybe<Scalars['String']>
  base64ContentGt?: InputMaybe<Scalars['String']>
  base64ContentGte?: InputMaybe<Scalars['String']>
  base64ContentIn?: InputMaybe<Array<Scalars['String']>>
  base64ContentLike?: InputMaybe<Scalars['String']>
  base64ContentLt?: InputMaybe<Scalars['String']>
  base64ContentLte?: InputMaybe<Scalars['String']>
  base64ContentNot?: InputMaybe<Scalars['String']>
  base64ContentNotIn?: InputMaybe<Array<Scalars['String']>>
  mimeType?: InputMaybe<Scalars['String']>
  mimeTypeGt?: InputMaybe<Scalars['String']>
  mimeTypeGte?: InputMaybe<Scalars['String']>
  mimeTypeIn?: InputMaybe<Array<Scalars['String']>>
  mimeTypeLike?: InputMaybe<Scalars['String']>
  mimeTypeLt?: InputMaybe<Scalars['String']>
  mimeTypeLte?: InputMaybe<Scalars['String']>
  mimeTypeNot?: InputMaybe<Scalars['String']>
  mimeTypeNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<MimeTypedObjectFilterInput>>
}

/** *Automatically generated.* */
export type OrganizationFilterInput = {
  AND?: InputMaybe<Array<OrganizationFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<OrganizationFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type OrganizationSettingsFilterInput = {
  AND?: InputMaybe<Array<OrganizationSettingsFilterInput>>
  cameraOfflineDurationUnit?: InputMaybe<DurationUnit>
  cameraOfflineDurationUnitIn?: InputMaybe<Array<DurationUnit>>
  cameraOfflineDurationUnitNot?: InputMaybe<DurationUnit>
  cameraOfflineDurationUnitNotIn?: InputMaybe<Array<DurationUnit>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  emailReplyToAddress?: InputMaybe<Scalars['String']>
  emailReplyToAddressGt?: InputMaybe<Scalars['String']>
  emailReplyToAddressGte?: InputMaybe<Scalars['String']>
  emailReplyToAddressIn?: InputMaybe<Array<Scalars['String']>>
  emailReplyToAddressLike?: InputMaybe<Scalars['String']>
  emailReplyToAddressLt?: InputMaybe<Scalars['String']>
  emailReplyToAddressLte?: InputMaybe<Scalars['String']>
  emailReplyToAddressNot?: InputMaybe<Scalars['String']>
  emailReplyToAddressNotIn?: InputMaybe<Array<Scalars['String']>>
  emailReplyToName?: InputMaybe<Scalars['String']>
  emailReplyToNameGt?: InputMaybe<Scalars['String']>
  emailReplyToNameGte?: InputMaybe<Scalars['String']>
  emailReplyToNameIn?: InputMaybe<Array<Scalars['String']>>
  emailReplyToNameLike?: InputMaybe<Scalars['String']>
  emailReplyToNameLt?: InputMaybe<Scalars['String']>
  emailReplyToNameLte?: InputMaybe<Scalars['String']>
  emailReplyToNameNot?: InputMaybe<Scalars['String']>
  emailReplyToNameNotIn?: InputMaybe<Array<Scalars['String']>>
  emailSenderName?: InputMaybe<Scalars['String']>
  emailSenderNameGt?: InputMaybe<Scalars['String']>
  emailSenderNameGte?: InputMaybe<Scalars['String']>
  emailSenderNameIn?: InputMaybe<Array<Scalars['String']>>
  emailSenderNameLike?: InputMaybe<Scalars['String']>
  emailSenderNameLt?: InputMaybe<Scalars['String']>
  emailSenderNameLte?: InputMaybe<Scalars['String']>
  emailSenderNameNot?: InputMaybe<Scalars['String']>
  emailSenderNameNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  inboundPhoneNumber?: InputMaybe<Scalars['String']>
  inboundPhoneNumberGt?: InputMaybe<Scalars['String']>
  inboundPhoneNumberGte?: InputMaybe<Scalars['String']>
  inboundPhoneNumberIn?: InputMaybe<Array<Scalars['String']>>
  inboundPhoneNumberLike?: InputMaybe<Scalars['String']>
  inboundPhoneNumberLt?: InputMaybe<Scalars['String']>
  inboundPhoneNumberLte?: InputMaybe<Scalars['String']>
  inboundPhoneNumberNot?: InputMaybe<Scalars['String']>
  inboundPhoneNumberNotIn?: InputMaybe<Array<Scalars['String']>>
  minimumCameraOfflineDuration?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationGt?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationGte?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationIn?: InputMaybe<Array<Scalars['Int']>>
  minimumCameraOfflineDurationLike?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationLt?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationLte?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationNot?: InputMaybe<Scalars['Int']>
  minimumCameraOfflineDurationNotIn?: InputMaybe<Array<Scalars['Int']>>
  OR?: InputMaybe<Array<OrganizationSettingsFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type PartialCreditCardFilterInput = {
  addressContain?: InputMaybe<Scalars['String']>
  addressDoNotContain?: InputMaybe<Scalars['String']>
  addressNull?: InputMaybe<Scalars['Boolean']>
  AND?: InputMaybe<Array<PartialCreditCardFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  endOfNumber?: InputMaybe<Scalars['String']>
  endOfNumberGt?: InputMaybe<Scalars['String']>
  endOfNumberGte?: InputMaybe<Scalars['String']>
  endOfNumberIn?: InputMaybe<Array<Scalars['String']>>
  endOfNumberLike?: InputMaybe<Scalars['String']>
  endOfNumberLt?: InputMaybe<Scalars['String']>
  endOfNumberLte?: InputMaybe<Scalars['String']>
  endOfNumberNot?: InputMaybe<Scalars['String']>
  endOfNumberNotIn?: InputMaybe<Array<Scalars['String']>>
  expiryMonth?: InputMaybe<Scalars['Int']>
  expiryMonthGt?: InputMaybe<Scalars['Int']>
  expiryMonthGte?: InputMaybe<Scalars['Int']>
  expiryMonthIn?: InputMaybe<Array<Scalars['Int']>>
  expiryMonthLike?: InputMaybe<Scalars['Int']>
  expiryMonthLt?: InputMaybe<Scalars['Int']>
  expiryMonthLte?: InputMaybe<Scalars['Int']>
  expiryMonthNot?: InputMaybe<Scalars['Int']>
  expiryMonthNotIn?: InputMaybe<Array<Scalars['Int']>>
  expiryYear?: InputMaybe<Scalars['Int']>
  expiryYearGt?: InputMaybe<Scalars['Int']>
  expiryYearGte?: InputMaybe<Scalars['Int']>
  expiryYearIn?: InputMaybe<Array<Scalars['Int']>>
  expiryYearLike?: InputMaybe<Scalars['Int']>
  expiryYearLt?: InputMaybe<Scalars['Int']>
  expiryYearLte?: InputMaybe<Scalars['Int']>
  expiryYearNot?: InputMaybe<Scalars['Int']>
  expiryYearNotIn?: InputMaybe<Array<Scalars['Int']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<PartialCreditCardFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type PermissionFilterInput = {
  AND?: InputMaybe<Array<PermissionFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['ID']>
  idIn?: InputMaybe<Array<Scalars['ID']>>
  idNot?: InputMaybe<Scalars['ID']>
  idNotIn?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  nameGt?: InputMaybe<Scalars['String']>
  nameGte?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameLike?: InputMaybe<Scalars['String']>
  nameLt?: InputMaybe<Scalars['String']>
  nameLte?: InputMaybe<Scalars['String']>
  nameNot?: InputMaybe<Scalars['String']>
  nameNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<PermissionFilterInput>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/**
 * A wrapper for a URL for HLS
 * ([HTTP Live Streaming](https://en.wikipedia.org/wiki/HTTP_Live_Streaming)).
 */
export type StreamingUrlWrapperHls = StreamingUrlWrapperInterface & {
  __typename?: 'StreamingUrlWrapperHls'
  /**
   * The time at which the URL will be invalid
   * and needs to be requested again.
   * Example: 2021-10-29T08:05:47.978Z.
   */
  expiryTime?: Maybe<Scalars['String']>
  headers?: Maybe<Array<HttpHeader>>
  url: Scalars['String']
}

/** *Automatically generated.* */
export type StreamingUrlWrapperHlsFilterInput = {
  AND?: InputMaybe<Array<StreamingUrlWrapperHlsFilterInput>>
  expiryTime?: InputMaybe<Scalars['String']>
  expiryTimeGt?: InputMaybe<Scalars['String']>
  expiryTimeGte?: InputMaybe<Scalars['String']>
  expiryTimeIn?: InputMaybe<Array<Scalars['String']>>
  expiryTimeLike?: InputMaybe<Scalars['String']>
  expiryTimeLt?: InputMaybe<Scalars['String']>
  expiryTimeLte?: InputMaybe<Scalars['String']>
  expiryTimeNot?: InputMaybe<Scalars['String']>
  expiryTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<StreamingUrlWrapperHlsFilterInput>>
  url?: InputMaybe<Scalars['String']>
  urlGt?: InputMaybe<Scalars['String']>
  urlGte?: InputMaybe<Scalars['String']>
  urlIn?: InputMaybe<Array<Scalars['String']>>
  urlLike?: InputMaybe<Scalars['String']>
  urlLt?: InputMaybe<Scalars['String']>
  urlLte?: InputMaybe<Scalars['String']>
  urlNot?: InputMaybe<Scalars['String']>
  urlNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type StreamingUrlWrapperInterfaceFilterInput = {
  AND?: InputMaybe<Array<StreamingUrlWrapperInterfaceFilterInput>>
  expiryTime?: InputMaybe<Scalars['String']>
  expiryTimeGt?: InputMaybe<Scalars['String']>
  expiryTimeGte?: InputMaybe<Scalars['String']>
  expiryTimeIn?: InputMaybe<Array<Scalars['String']>>
  expiryTimeLike?: InputMaybe<Scalars['String']>
  expiryTimeLt?: InputMaybe<Scalars['String']>
  expiryTimeLte?: InputMaybe<Scalars['String']>
  expiryTimeNot?: InputMaybe<Scalars['String']>
  expiryTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<StreamingUrlWrapperInterfaceFilterInput>>
  url?: InputMaybe<Scalars['String']>
  urlGt?: InputMaybe<Scalars['String']>
  urlGte?: InputMaybe<Scalars['String']>
  urlIn?: InputMaybe<Array<Scalars['String']>>
  urlLike?: InputMaybe<Scalars['String']>
  urlLt?: InputMaybe<Scalars['String']>
  urlLte?: InputMaybe<Scalars['String']>
  urlNot?: InputMaybe<Scalars['String']>
  urlNotIn?: InputMaybe<Array<Scalars['String']>>
}

/**
 * A wrapper for a LiveKit WebRTC connection grant (Lumana cloud live view).
 * The client connects directly with the LiveKit JS SDK:
 * `room.connect(url, token)`. Discriminate on `__typename`.
 */
export type StreamingUrlWrapperLiveKit = StreamingUrlWrapperInterface & {
  __typename?: 'StreamingUrlWrapperLiveKit'
  /**
   * The time by which streaming must have started; the grant is one-shot
   * and is invalidated afterwards. A new grant must be requested by
   * re-running the query — the URL/token pair cannot be refreshed.
   * Example: 2021-10-29T08:05:47.978Z.
   */
  expiryTime?: Maybe<Scalars['String']>
  headers?: Maybe<Array<HttpHeader>>
  /** The one-shot LiveKit access token for `url`. */
  token: Scalars['String']
  /** The LiveKit server URL to connect to. */
  url: Scalars['String']
}

/** *Automatically generated.* */
export type SystemActionFilterInput = {
  AND?: InputMaybe<Array<SystemActionFilterInput>>
  createdAt?: InputMaybe<Scalars['String']>
  createdAtGt?: InputMaybe<Scalars['String']>
  createdAtGte?: InputMaybe<Scalars['String']>
  createdAtIn?: InputMaybe<Array<Scalars['String']>>
  createdAtLike?: InputMaybe<Scalars['String']>
  createdAtLt?: InputMaybe<Scalars['String']>
  createdAtLte?: InputMaybe<Scalars['String']>
  createdAtNot?: InputMaybe<Scalars['String']>
  createdAtNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<SystemActionFilterInput>>
  systemMessage?: InputMaybe<Scalars['String']>
  systemMessageGt?: InputMaybe<Scalars['String']>
  systemMessageGte?: InputMaybe<Scalars['String']>
  systemMessageIn?: InputMaybe<Array<Scalars['String']>>
  systemMessageLike?: InputMaybe<Scalars['String']>
  systemMessageLt?: InputMaybe<Scalars['String']>
  systemMessageLte?: InputMaybe<Scalars['String']>
  systemMessageNot?: InputMaybe<Scalars['String']>
  systemMessageNotIn?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['String']>
  updatedAtGt?: InputMaybe<Scalars['String']>
  updatedAtGte?: InputMaybe<Scalars['String']>
  updatedAtIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtLike?: InputMaybe<Scalars['String']>
  updatedAtLt?: InputMaybe<Scalars['String']>
  updatedAtLte?: InputMaybe<Scalars['String']>
  updatedAtNot?: InputMaybe<Scalars['String']>
  updatedAtNotIn?: InputMaybe<Array<Scalars['String']>>
}

/** *Automatically generated.* */
export type UrlContentFilterInput = {
  AND?: InputMaybe<Array<UrlContentFilterInput>>
  minExpiryTime?: InputMaybe<Scalars['String']>
  minExpiryTimeGt?: InputMaybe<Scalars['String']>
  minExpiryTimeGte?: InputMaybe<Scalars['String']>
  minExpiryTimeIn?: InputMaybe<Array<Scalars['String']>>
  minExpiryTimeLike?: InputMaybe<Scalars['String']>
  minExpiryTimeLt?: InputMaybe<Scalars['String']>
  minExpiryTimeLte?: InputMaybe<Scalars['String']>
  minExpiryTimeNot?: InputMaybe<Scalars['String']>
  minExpiryTimeNotIn?: InputMaybe<Array<Scalars['String']>>
  OR?: InputMaybe<Array<UrlContentFilterInput>>
  url?: InputMaybe<Scalars['String']>
  urlGt?: InputMaybe<Scalars['String']>
  urlGte?: InputMaybe<Scalars['String']>
  urlIn?: InputMaybe<Array<Scalars['String']>>
  urlLike?: InputMaybe<Scalars['String']>
  urlLt?: InputMaybe<Scalars['String']>
  urlLte?: InputMaybe<Scalars['String']>
  urlNot?: InputMaybe<Scalars['String']>
  urlNotIn?: InputMaybe<Array<Scalars['String']>>
}
